<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex align-items-center justify-content-between">
					<div>
						<h4 class="mb-1">{{ title }}</h4>
						<small class="text-muted">{{ desc1 }}</small>
					</div>
					<div class="d-flex align-items-center">
						<b-button
							:variant="todayCollectionStatus.isCollected ? 'success' : 'danger'"
							class="mr-2 px-4 py-2"
							@click="collectGrowthSales"
							:title="todayCollectionStatus.tooltip">
							<i class="fas fa-download mr-1"></i>
							{{ todayCollectionStatus.buttonText }}
						</b-button>
						<b-button
							variant="outline-warning"
							size="sm"
							class="mr-2"
							@click="forceCollect30Days"
							title="30일 전체 데이터를 강제로 재수집합니다">
							<i class="fas fa-redo mr-1"></i>
							30일 재수집
						</b-button>
						<b-button
							variant="outline-info"
							size="sm"
							class="mr-2 d-none"
							@click="collectCustomDateRange"
							title="원하는 날짜 범위를 지정하여 데이터를 수집합니다">
							<i class="fas fa-calendar-alt mr-1"></i>
							날짜 지정 수집
						</b-button>
						<b-button variant="outline-secondary" size="sm" v-b-modal.datalabAPI>
							<i class="fas fa-cog mr-1"></i>
							API설정
						</b-button>
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<img v-if="showspinner" style="max-width:100%;"
					:src="require('../../../assets/images/small/spinner.gif')">
				<div v-if="showspinner1" class="d-flex justify-content-center">
					<div><img style="max-width:10%;" :src="require('../../../assets/images/small/loading.gif')">{{
						loadingtext }}</div>
				</div>
			</div>
		</div>

		<!-- 대시보드 섹션 -->
		<div class="row mt-2" v-if="showlist && saleslists.length > 0">
			<div class="col-lg-12">
				<div class="d-flex align-items-center mb-2 cursor-pointer" @click="showDashboard = !showDashboard">
					<i :class="showDashboard ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="mr-2 text-muted"></i>
					<h6 class="mb-0 text-muted">대시보드</h6>
				</div>
				<div v-show="showDashboard">
					<!-- KPI 카드 -->
					<div class="row mb-3">
						<div class="col-lg-3 col-md-6 mb-2">
							<div class="card mb-0" style="border-left: 4px solid #008FFB;">
								<div class="card-body py-2 px-3">
									<small class="text-muted" title="취소·반품을 뺀 순판매입니다">총 판매량 (어제) · 반품 차감 기준</small>
									<h4 class="mb-0">{{ dashboardKPI.todaySales.toLocaleString() }}개</h4>
									<small :class="dashboardKPI.salesChangeRate >= 0 ? 'text-success' : 'text-danger'">
										{{ dashboardKPI.salesChangeRate >= 0 ? '▲' : '▼' }}
										{{ Math.abs(dashboardKPI.salesChangeRate).toFixed(1) }}% 전일 대비
									</small>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 mb-2">
							<div class="card mb-0" style="border-left: 4px solid #00E396;">
								<div class="card-body py-2 px-3">
									<small class="text-muted">총 조회수 (어제)</small>
									<h4 class="mb-0">{{ dashboardKPI.todayViews.toLocaleString() }}회</h4>
									<small :class="dashboardKPI.viewsChangeRate >= 0 ? 'text-success' : 'text-danger'">
										{{ dashboardKPI.viewsChangeRate >= 0 ? '▲' : '▼' }}
										{{ Math.abs(dashboardKPI.viewsChangeRate).toFixed(1) }}% 전일 대비
									</small>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 mb-2">
							<div class="card mb-0" style="border-left: 4px solid #FEB019;">
								<div class="card-body py-2 px-3">
									<small class="text-muted">평균 전환율 (어제)</small>
									<h4 class="mb-0">{{ dashboardKPI.avgConversion.toFixed(1) }}%</h4>
									<small class="text-muted">조회 → 주문</small>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 mb-2">
							<div class="card mb-0" style="border-left: 4px solid #FF4560;">
								<div class="card-body py-2 px-3">
									<small class="text-muted">7일 평균 일판매</small>
									<h4 class="mb-0">{{ dashboardKPI.avg7daySales.toFixed(0) }}개</h4>
									<small class="text-muted">30일 평균 {{ dashboardKPI.avg30daySales.toFixed(0) }}개</small>
								</div>
							</div>
						</div>
					</div>

					<!-- 트렌드 차트 -->
					<div class="row mb-3">
						<div class="col-lg-12">
							<div class="card mb-0">
								<div class="card-body py-2">
									<div class="d-flex align-items-center mb-1">
										<h6 class="mb-0 mr-3" title="판매량은 취소·반품을 뺀 순판매입니다">판매량 / 조회수 트렌드 (30일) <small class="text-muted">· 판매량 반품 차감 기준</small></h6>
										<div class="btn-group btn-group-sm" role="group">
											<button type="button" class="btn" :class="trendMode === 'all' ? 'btn-primary' : 'btn-outline-primary'" @click="trendMode = 'all'">전체</button>
											<button type="button" class="btn" :class="trendMode === 'top5' ? 'btn-primary' : 'btn-outline-primary'" @click="trendMode = 'top5'">Top 5</button>
											<button type="button" class="btn" :class="trendMode === 'top1' ? 'btn-primary' : 'btn-outline-primary'" @click="trendMode = 'top1'">Top 1</button>
										</div>
									</div>
									<ApexChart
										ref="dashboardTrendChart"
										element="dashboard-trend-chart"
										:chartOption="dashboardTrendChartOption"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- 히트맵 차트 -->
					<div class="row mb-3">
						<div class="col-lg-12">
							<div class="card mb-0">
								<div class="card-body py-2">
									<div class="d-flex align-items-center mb-1">
										<h6 class="mb-0 mr-3">상품별 판매 히트맵 (30일)</h6>
										<div class="custom-control custom-switch custom-control-inline" style="font-size: 0.8rem;">
											<input type="checkbox" class="custom-control-input" id="heatmapViewsSwitch"
												v-model="heatmapShowViews">
											<label class="custom-control-label" for="heatmapViewsSwitch">조회수 보기</label>
										</div>
									</div>
									<div style="max-height: 400px; overflow-y: auto;">
										<ApexChart
											ref="dashboardHeatmapChart"
											element="dashboard-heatmap-chart"
											:chartOption="dashboardHeatmapOption"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 재고 대사 요약 — 확인 안 된 재고 / 90일 넘음 / 보상 확정·입금 대기. 숫자는 정확 모드 옵션만(summary.exact), 범위는 보여주지 않는다 -->
		<div class="row mt-2" v-if="reconSummary">
			<div class="col-lg-4 col-md-12 mb-2">
				<div class="card mb-0 recon-tile h-100" :class="{ 'recon-tile--crit': reconExact.miss > 0 }"
					role="button" tabindex="0" title="누르면 확인 안 된 재고가 있는 상품만 봅니다"
					@click="showReconOnly(false)" @keydown.enter="showReconOnly(false)">
					<div class="card-body py-2 px-3">
						<small class="text-muted">확인 안 된 재고 <span class="recon-tile__info" :title="reconInfoTitle">ⓘ</span></small>
						<template v-if="reconExact.count > 0">
							<h4 class="mb-0 recon-tile__value">{{ reconExact.miss.toLocaleString() }}개</h4>
							<small class="text-muted">
								원가 기준 <b>{{ reconExact.amount.toLocaleString() }}원</b>
								· {{ reconExact.missingProductCount.toLocaleString() }}개 상품
							</small>
						</template>
						<h4 v-else class="mb-0 recon-tile__value recon-tile__value--muted" :title="reconPreparingTitle">계산 준비 중</h4>
						<div v-if="reconExact.excludedCount > 0 || reconExact.preparingCount > 0" class="recon-tile__note">
							<span v-if="reconExact.excludedCount > 0" title="입고 기록 이전부터 있던 상품이라 계산에서 제외">계산 제외 {{ reconExact.excludedCount.toLocaleString() }}개 상품</span>
							<template v-if="reconExact.preparingCount > 0">
								<span v-if="reconExact.excludedCount > 0"> · </span>
								<span :title="reconPreparingTitle">계산 준비 중 {{ reconExact.preparingCount.toLocaleString() }}개</span>
								<router-link :to="{ name: 'growth.salesledger' }" @click.native.stop>정산현황 수집 ›</router-link>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-4 col-md-12 mb-2">
				<div class="card mb-0 recon-tile h-100" :class="{ 'recon-tile--warn': reconExact.over90 > 0 }"
					role="button" tabindex="0" title="누르면 90일 넘게 확인 안 된 상품만 봅니다"
					@click="showReconOnly(true)" @keydown.enter="showReconOnly(true)">
					<div class="card-body py-2 px-3">
						<small class="text-muted">90일 넘게 확인 안 됨</small>
						<h4 v-if="reconExact.count === 0" class="mb-0 recon-tile__value recon-tile__value--muted" :title="reconPreparingTitle">계산 준비 중</h4>
						<h4 v-else-if="reconExact.over90 > 0" class="mb-0 recon-tile__value">{{ reconExact.over90.toLocaleString() }}개</h4>
						<h4 v-else class="mb-0 recon-tile__value recon-tile__value--muted">없음</h4>
						<small v-if="reconExact.over90 > 0" class="text-muted recon-tile__name" :title="reconOver90TopName">
							쿠팡확인요청 대상<template v-if="reconOver90TopName"> · {{ reconOver90TopName }}</template>
						</small>
					</div>
				</div>
			</div>
			<div class="col-lg-4 col-md-12 mb-2">
				<div class="card mb-0 recon-tile h-100">
					<div class="card-body py-2 px-3">
						<small class="text-muted">보상 확정 · 입금 대기</small>
						<h4 class="mb-0 recon-tile__value">{{ reconSummary.compensationPending.toLocaleString() }}원</h4>
						<small class="text-muted">
							<template v-if="reconSummary.nextPayoutDate">{{ reconSummary.nextPayoutDate.slice(5).replace('-', '/') }} 정산에 포함 예정</template>
							<template v-else>입금 예정인 보상이 없어요</template>
						</small>
					</div>
				</div>
			</div>
		</div>

		<!-- 쿠팡 센터별 입고 진행(#50) -->
		<ScmInboundByCenter />

		<div class="row mt-0">
			<div class="col-lg-12" v-if="showlist">
				<div class="row d-flex justify-content-between">
					<div class="d-flex flex-column">
						<div>
							<b-button variant="outline-primary" size="sm" class="ml-3 mb-1 mr-1" @click="showAll">
								전체<b-badge variant="primary" class="ml-1">{{ totalCnt }}</b-badge>
							</b-button>
							<b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showNeedPo">
								구매 필요<b-badge variant="secondary" class="ml-1">{{ needPo }}</b-badge>
							</b-button>
							<b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showNeedOverseasOutbound">
								배대지출고 필요<b-badge variant="danger" class="ml-1">{{ needOverseasOutbound }}</b-badge>
							</b-button>
							<b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showNeedDomesticOutbound">
								국내출고 필요<b-badge variant="secondary" class="ml-1">{{ needDomesticOutbound }}</b-badge>
							</b-button>
							<b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showStockDanger">
								품절예고<b-badge variant="danger" class="ml-1">{{ stockDangerCnt }}</b-badge>
							</b-button>
							<b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showOverStock">
								과재고위험<b-badge variant="secondary" class="ml-1">{{ overStockCnt }}</b-badge>
							</b-button>
							<b-button variant="outline-success" size="sm" class="mb-1 mr-1" @click="showMonthlyCntOver0">
								월판매0이상<b-badge variant="success" class="ml-1">{{ monthlyCntOver0 }}</b-badge>
							</b-button>
							<!-- <b-button variant="outline-danger" class="mb-1 mr-2" @click="showNeedReturn">
							반출 필요<b-badge variant="danger" class="ml-2">{{needReturn}}</b-badge>
							</b-button>  -->
							<b-button variant="outline-warning" size="sm" class="mb-1 mr-1" @click="showReturn">
								반품제품<b-badge variant="warning" class="ml-1">{{ returnProducts }}</b-badge>
							</b-button>
							<b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showHidden">
								숨김상품<b-badge variant="danger" class="ml-1">{{ hiddenProducts }}</b-badge>
							</b-button>
							<b-button v-if="reconSummary && reconExact.count > 0" variant="outline-danger" size="sm" class="mb-1 mr-1"
								@click="showReconOnly(false)"
								title="입고·판매·반품·현재고를 맞춰 봤을 때 확인되지 않는 재고가 있는 상품만 봅니다">
								미확인만 보기<b-badge variant="danger" class="ml-1">{{ reconMissingCnt }}</b-badge>
							</b-button>
						</div>
						<div>
							<div class="custom-control custom-switch custom-control-inline ml-3" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="salesTrendSwitch"
									v-model="showSalesTrend">
								<label class="custom-control-label" for="salesTrendSwitch">판매트렌드</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="customSwitchsss"
									v-model="showReturnProducts">
								<label class="custom-control-label" for="customSwitchsss">반품상품보기</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="bundleDisplaySwitch"
									v-model="showBundleProducts">
								<label class="custom-control-label" for="bundleDisplaySwitch">번들보기</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="stockDisplaySwitch"
									v-model="showStockPeriodFirst">
								<label class="custom-control-label" for="stockDisplaySwitch">재고기간보기</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="stockAmountSwitch"
									v-model="showStockAmount">
								<label class="custom-control-label" for="stockAmountSwitch">재고금액보기</label>
							</div>
							<div v-if="showStockAmount" class="ml-2 d-inline-flex align-items-center" style="font-size: 0.85rem;">
								<span class="text-primary font-weight-bold">
									전체 재고금액: {{ getTotalStockAmount().toLocaleString() }}원
								</span>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1 d-none" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="coupassSyncSwitch"
									:checked="coupassSyncEnabled" @click="handleCoupassSyncClick" ref="coupassSyncSwitch">
								<label class="custom-control-label" for="coupassSyncSwitch">쿠패스연동</label>
							</div>
						</div>
					</div>
					<div>
						<!-- 첫 번째 행: 저장, 숨김, 순서, 일괄변경 -->
						<div class="mb-2">
							<button type="button" class="btn btn-primary btn-sm mr-1 ml-3" @click="saveSales">저장</button>
							<button type="button" class="btn btn-secondary btn-sm mr-1" @click="hideSelectedItems" v-if="!isShowingHidden">
								숨김
							</button>
							<button type="button" class="btn btn-success btn-sm mr-1" @click="restoreSelectedItems" v-if="isShowingHidden">
								복원
							</button>
							<button type="button" class="btn btn-primary btn-sm mr-1" @click="showOrderModal = true" v-if="!isShowingHidden">
								순서
							</button>
							<button type="button" class="btn btn-danger btn-sm mr-1" v-b-toggle.my-collapse>일괄변경</button>

							<button type="button" class="btn btn-secondary btn-sm mr-1 position-relative" v-b-modal.reqpurchase id="purchaseRequestBtn" v-if="showCoupass">
								구매요청
								<span v-if="purchaseCart.length > 0" class="badge badge-danger position-absolute"
									style="top: -8px; right: -8px; font-size: 0.7em;">
									{{ purchaseCart.length }}
								</span>
							</button>
							<button type="button" class="btn btn-success btn-sm mr-1" v-b-modal.excelupload>엑셀업로드</button>
							<button type="button" class="btn btn-outline-success btn-sm mr-1" @click="exportVisibleToExcel">
								<i class="fas fa-download mr-1"></i>엑셀다운로드
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-12 d-flex justify-content-end">
				<b-collapse id="my-collapse">
					<b-card title="">
						<div class="form-group">
							<input type="number" class="form-control" placeholder="입고기간" v-model="입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="배대지입고기간" v-model="배대지입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="통관중입고기간" v-model="통관중입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="국내입고기간" v-model="국내입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="안전재고기간" v-model="최소재고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="목표재고기간" v-model="최대재고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="MOQ수량" v-model="MOQ수량">
						</div>
						<button type="button" class="btn btn-success mr-2 mt-1" @click="editlists">적용</button>
					</b-card>
				</b-collapse>
			</div>


			<div class="col-lg-12 mt-0" v-if="showlist">
				<CDataTable
					storage-key="growthScmV0.1" :key="`${showReturnProducts}-${showBundleProducts}-${showStockAmount}-${showSalesTrend}`" :headers="headers" :items="saleslists" v-model="tableSelectedItem" :show-select="true"
					:fixedColumns="'옵션명'" itemKey="_id" style="margin-bottom: 10px" :items-per-page="100" :height="'750px'"
					:subheader="subheaderData" :headerTooltips="headerTooltips">
					<template v-slot:상품등급="{ item }">
						<!-- 최상위 행이 항상 새제품인 건 아니다 — 부모에 흡수되지 못한 반품등급은 최상위로 보존된다 -->
						<div><a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + item.vendorItemId"
								target="_blank"><b-badge
									:variant="item.skuGrade && item.skuGrade !== 'NEW' ? 'secondary' : 'success'">{{
										getSkuGradeLabel(item.skuGrade) }}</b-badge></a></div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">
								<a :href="'https://www.coupang.com/vp/products/' + a.listingDetails.productId + '?vendorItemId=' + a.listingDetails.vendorItemId"
									target="_blank">
									<b-badge variant="secondary">
										{{ a.skuGrade == 'PACKAGE_DAMAGED' ? '반품-미개봉' :
											a.skuGrade == 'RETURN_BEST' ? '반품-최상' :
												a.skuGrade == 'RETURN_GOOD' ? '반품-상' : '반품-중'
										}}
									</b-badge>
								</a>
							</div>
						</div>
					</template>
					<template v-slot:상품구분="{ item }">
						<div>
							<a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + item.vendorItemId"
								target="_blank">
								<b-badge :variant="item.skuGrade && item.skuGrade !== 'NEW' ? 'secondary' : 'success'">{{
									getSkuGradeLabel(item.skuGrade) }}</b-badge>
							</a>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i" class="mt-1">
								<a :href="'https://www.coupang.com/vp/products/' + a.productId + '?vendorItemId=' + a.vendorItemId"
									target="_blank">
									<b-badge variant="secondary">
										{{ a.skuGrade == 'PACKAGE_DAMAGED' ? '반품-미개봉' :
											a.skuGrade == 'RETURN_BEST' ? '반품-최상' :
												a.skuGrade == 'RETURN_GOOD' ? '반품-상' : '반품-중'
										}}
									</b-badge>
								</a>
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i" class="mt-1">
								<a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + a.vendorItemId"
									target="_blank">
									<b-badge variant="info">번들x{{ a.upBundlingSize || 1 }}</b-badge>
								</a>
							</div>
						</div>
					</template>
					<template v-slot:썸네일="{ item }">
						<a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + item.vendorItemId"
							target="_blank">
							<img :src="item.썸네일" class="img-fluid rounded avatar-40 mr-3" alt="image">
						</a>
					</template>
					<template v-slot:판매상품명="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId" style="max-width: 150px;">
							<div class="product-name-multiline font-weight-bold" :title="item.판매상품명">
								{{ item.판매상품명 }}
							</div>
							<small class="text-muted" :title="item.productId">
								{{ item.productId }}
							</small>
							<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
								<div v-for="a, i in item.upBundlingProducts" :key="'bundle-product-' + i" class="mt-1">
									<div class="product-name-multiline text-primary" :title="a.판매상품명">{{ a.판매상품명 }}</div>
									<small class="text-muted" :title="a.productId">{{ a.productId }}</small>
								</div>
							</div>
						</div>
					</template>
					<template v-slot:옵션명="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId" style="max-width: 100px;font-size:90%">
							<div class="option-name-wrap" :title="item.옵션명">
								{{ item.옵션명 }}
							</div>
							<small class="text-muted" :title="item.vendorItemId">
								{{ item.vendorItemId }}
							</small>
							<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
								<div v-for="a, i in item.returnProducts" :key="i" class="mt-1">
									<small class="text-muted" :title="a.vendorItemId">{{ a.vendorItemId }}</small>
								</div>
							</div>
							<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
								<div v-for="a, i in item.upBundlingProducts" :key="'bundle-option-' + i" class="mt-1">
									<div class="option-name-wrap text-primary" :title="a.옵션명">{{ a.옵션명 }}</div>
									<small class="text-muted" :title="a.vendorItemId">{{ a.vendorItemId }}</small>
								</div>
							</div>
						</div>
					</template>
					<template v-slot:타겟키워드="{ item }">
						<input type="text" class="form-control ml-1 text-center" placeholder="" v-model="item.타겟키워드"
							@keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:구매필요수량="{ item }">
						<div
							:class="['purchase-outbound-cell', { 'purchase-requested': hasPurchaseRequest(item) }]"
							@click="openPurchaseRequestModal(item)"
							style="cursor: pointer;">
							<div>{{ item.구매필요수량 === 0 ? '-' : item.구매필요수량 }}</div>
							<div v-if="hasPurchaseRequest(item)" class="stock-period-text text-primary font-weight-bold">
								{{ getPurchaseRequestQuantity(item) }}
							</div>
							<!-- <div v-else-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div> -->
						</div>
						<b-modal :id="'poQty' + item.vendorItemId" scrollable title="판매현황" ok-title="OK" size="xl"
							modal-class="scm-detail-modal" @show="onPoQtyModalShow(item)" ok-only
							@ok="closeModal($event, item)">
							<div class="row h-100">
								<div class="col-md-12">
									<card style="padding:10px;">
										<div class="d-flex align-items-center" style="margin:auto;padding:0px">
											<img :src="item.썸네일" class="img-fluid rounded avatar-120 mr-3" alt="image">
											<div>
												<p>판매상품명 : {{ item.판매상품명 }}</p>
												<p>노출ID : {{ item.productId }}</p>
												<p>옵션ID : {{ item.vendorItemId }}</p>
											</div>
										</div>
									</card>
								</div>
								<div class="col-md-8 h-100">
									<b-card no-body>
										<b-card-body class="p-3"> <!-- padding을 제거합니다 -->
											<div style="width: 100%; height:100%"> <!-- 100% 너비의 div로 감쌉니다 -->
												<ApexChart ref="mainChart" element="layout1-chart-5"
													:chartOption="getUpdatedChartOption(item)" />
											</div>
										</b-card-body>
										<b-card-footer>
											<div class="d-flex justify-content-between align-items-center row">
												<div class="col-6 d-flex justify-content-start align-items-center">
													<label class="w-50">판매인식기간:</label>
													<b-form-input class="w-50" type="date" v-model="item.startDate"
														@change="updateDateRange(item)"></b-form-input>
													<h5> ~ </h5>
													<b-form-input class="w-50" type="date" v-model="item.endDate"
														@change="updateDateRange(item)"></b-form-input>
												</div>
												<div class="col-4 d-flex justify-content-start align-items-center">
													<b-button variant="outline-primary" size="md"
														@click="setDateRange(item, 7)">최근 7일</b-button>
													<b-button variant="outline-primary" size="md"
														@click="setDateRange(item, 15)" class="ml-2">최근 15일</b-button>
												</div>
											</div>
										</b-card-footer>
									</b-card>

									<!-- 판매량 전용 차트 (메인 제품에만 표시) -->
									<b-card no-body class="mt-3" v-if="item.salesHistory && item.dates && !item.skuGrade">
										<b-card-header class="p-2">
											<h6 class="mb-0" title="판매량은 취소·반품을 뺀 순판매입니다">판매량 상세 분석 (메인/번들/반품 구분) <small class="text-muted">· 반품 차감 기준</small></h6>
										</b-card-header>
										<b-card-body class="p-3">
											<div style="width: 100%; height: 100%;" v-if="salesChartReady">
												<ApexChart ref="salesChart" :element="`sales-chart-${item.vendorItemId}`"
													:key="`sales-chart-${item.vendorItemId}`"
													:chartOption="getSalesChartOption(item)" />
											</div>
											<div v-else class="text-center p-4">
												<div class="spinner-border text-primary" role="status">
													<span class="sr-only">Loading...</span>
												</div>
												<p class="mt-2">차트 로딩 중...</p>
											</div>
										</b-card-body>
									</b-card>
								</div>
								<div class="col-md-4 h-100">
									<b-card>
										<b-list-group flush>
											<!-- 판매 정보 -->
											<b-list-group-item class="p-2">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-primary">판매 정보</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span title="취소·반품을 뺀 순판매 기준입니다">일평균판매량 <small class="text-muted">(반품 차감)</small></span>
													<span class="font-weight-bold">{{ item.일판매수량.toFixed(1) }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>현재재고수량</span>
													<span class="font-weight-bold">{{ item.재고 }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1">
												<div class="d-flex justify-content-between align-items-center">
													<span>남은 재고기간</span>
													<span class="font-weight-bold">{{ item.남은재고기간 }}</span>
												</div>
											</b-list-group-item>

											<!-- 예측 정보 -->
											<b-list-group-item class="p-2 mt-2">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-primary">예측 정보</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>향후 30일 예상 판매수량(series)</span>
													<span class="font-weight-bold">{{ parseInt(item.forecastSeriesQty)
													}}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1">
												<div class="d-flex justify-content-between align-items-center">
													<span>향후 30일 예상 판매수량(AI)</span>
													<span class="font-weight-bold">{{ parseInt(item.forecastAIQty)
													}}</span>
												</div>
											</b-list-group-item>

											<!-- Series 기준 구매 정보 -->
											<b-list-group-item class="p-2 mt-2">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-primary">구매 정보 (최근 30일 판매량 기준)
													</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>D-Day</span>
													<span class="font-weight-bold">{{ item.dday }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>구매필요수량</span>
													<span class="font-weight-bold">{{ item.구매필요수량 }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1">
												<div class="d-flex justify-content-between align-items-center">
													<span>필요재고 일수</span>
													<span class="font-weight-bold">{{ calculateNeededStockDays(item)
													}}</span>
												</div>
											</b-list-group-item>

											<!-- 판매인식기간 기반 구매 정보 추가 (기존 AI 기준 구매 정보 부분 대체) -->
											<b-list-group-item class="p-2 mt-2" v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-secondary">선택 기간 기준 구매 정보</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom"
												v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between align-items-center">
													<span>D-Day (선택 기간)</span>
													<span class="font-weight-bold">{{ item.customPeriodMetrics.dday
													}}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom"
												v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between align-items-center">
													<span>구매필요수량 (선택 기간)</span>
													<span class="font-weight-bold">{{ item.customPeriodMetrics.구매필요수량
													}}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1" v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between align-items-center">
													<span>필요재고 일수 (선택 기간)</span>
													<span class="font-weight-bold">{{
														item.customPeriodMetrics.neededStockDays }}</span>
												</div>
											</b-list-group-item>

											<!-- 구매 기준 설명 -->
											<b-list-group-item class="p-1 mt-2">
												<small class="text-secondary">
													※ 재고 기준:
													<br>- 안전재고(7일) 이하 → 20일치 주문
													<br>- 7~27일 사이 → 부족분 주문
													<br>- 27일 이상 → 주문 없음
												</small>
											</b-list-group-item>
										</b-list-group>
									</b-card>
								</div>
							</div>
						</b-modal>
					</template>
					<template v-slot:구매="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark position-relative"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.구매, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.구매 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.구매 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.구매 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
							<span v-if="coupassSyncEnabled && item.구매 > 0" class="coupass-detail-icon"
								@click.stop="openReqpurchaseDetailModal(item)"
								title="구매요청 상세보기">🔍</span>
						</div>
					</template>
					<template v-slot:배대지="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark position-relative"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.배대지, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.배대지 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.배대지 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.배대지 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
							<span v-if="coupassSyncEnabled && item.배대지 > 0" class="coupass-detail-icon"
								@click.stop="openReqpurchaseDetailModal(item)"
								title="구매요청 상세보기">🔍</span>
						</div>
					</template>
					<template v-slot:통관중="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark position-relative"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.통관중, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.통관중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.통관중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.통관중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
							<span v-if="coupassSyncEnabled && item.통관중 > 0" class="coupass-detail-icon"
								@click.stop="openReqpurchaseDetailModal(item)"
								title="구매요청 상세보기">🔍</span>
						</div>
					</template>
					<template v-slot:장기입고중="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.장기입고중, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.장기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:단기입고중="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.단기입고중, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.단기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:국내재고="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.국내재고, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.국내재고 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.국내재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.국내재고 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:입고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="입고기간"
							v-model="item.입고기간" @keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:배대지입고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="배대지입고기간"
							v-model="item.배대지입고기간" @keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:국내입고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="국내입고기간"
							v-model="item.국내입고기간" @keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:최대재고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="최대재고기간"
							v-model="item.최대재고기간" @keyup.enter="changePoEnter($event, item)"
							@input="onInputChange(item)" @blur="onInputComplete(item)">
					</template>
					<template v-slot:최소재고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="최소재고기간"
							v-model="item.최소재고기간" @keyup.enter="changePoEnter($event, item)"
							@input="onInputChange(item)" @blur="onInputComplete(item)">
					</template>
					<template v-slot:MOQ수량="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="MOQ수량"
							v-model="item.MOQ수량" @keyup.enter="changePoEnter($event, item)"
							@input="onInputChange(item)" @blur="onInputComplete(item)">
					</template>
					<template v-slot:재고="{ item }">
						<div @click="showInventoryModal(item)"
							:class="getCoupangStockBoxClass(item)"
							:title="getCoupangStockDangerTooltip(item)"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.재고, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.재고 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-stock-' + i">{{ a.orderableQuantity || 0 }}</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-stock-' + i">{{ a.orderableQuantity || 0 }}</div>
						</div>
					</template>

					<template v-slot:미확인="{ item }">
						<template v-if="!item.isSummaryRow && reconOf(item)">
							<span v-if="reconCalcOf(reconOf(item)) === 'excluded'" class="text-muted"
								title="입고 기록 이전부터 있던 상품이라 계산에서 제외">–</span>
							<span v-else-if="reconCalcOf(reconOf(item)) === 'preparing'" class="text-muted small"
								:title="reconPreparingTitle">계산 준비 중</span>
							<button v-else-if="reconExactMiss(reconOf(item)) > 0" type="button"
								class="recon-pill" :class="reconOf(item).ageDays >= 90 ? 'recon-pill--crit' : 'recon-pill--warn'"
								:title="reconCellTitle(reconOf(item))"
								@click="openReconDetail(item)">
								{{ reconExactMiss(reconOf(item)).toLocaleString() }}
							</button>
							<span v-else class="text-muted" title="입고·판매·반품·현재고가 맞습니다">0</span>
							<div v-if="reconExactMiss(reconOf(item)) > 0 && reconOf(item).ageDays !== null" class="recon-age"
								:class="{ 'recon-age--over': reconOf(item).ageDays >= 90 }"
								title="확인 안 된 재고가 처음 생긴 날은 알 수 없어, 마지막 입고일부터 센 날짜입니다">
								{{ reconOf(item).ageDays }}일
							</div>
						</template>
					</template>
					<template v-slot:남은재고기간="{ item }">
						<div
							@click="showInventoryModal(item)"
							:class="['inventory-box-vertical', 'bg-light', 'border', 'text-dark', getTotalStockDangerClass(item)]"
							:title="getTotalStockDangerTooltip(item)"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(getTotalAvailableStock(item), item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(getTotalAvailableStock(item), item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ getTotalAvailableStock(item) }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ getTotalAvailableStock(item) }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ getTotalAvailableStock(item) }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(getTotalAvailableStock(item), item.일판매수량, item) }}</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i"
								@click="showInventoryModal(item)"
								:class="getReturnStockDangerClass(a, item)"
								:title="getReturnStockDangerTooltip(a, item)">
								{{ a.남은재고기간 }}
							</div>
						</div>
					</template>
					<template v-slot:월판매수량="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ?
								getMainProductMonthlySales(item) : item.월판매수량 }}
							<div v-if="item.목표일판매수량 && item.목표일판매수량 > 0" class="text-secondary small">
								{{ item.목표일판매수량*30 }}
							</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">{{ getReturnProductMonthlySales(a) }}</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">
								{{ getBundleProductMonthlySales(a) }}
							</div>
						</div>
					</template>
					<template v-slot:7일판매수량="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ?
								getMainProduct7DaySales(item) : item['7일판매수량'] }}
							<div v-if="item.목표일판매수량 && item.목표일판매수량 > 0" class="text-secondary small">
								{{ Math.round(item.목표일판매수량*7) }}
							</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-7day-' + i">{{ getReturnProduct7DaySales(a) }}</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-7day-' + i">
								{{ getBundleProduct7DaySales(a) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay6="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 6) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-6-' + i">
								{{ getReturnProductDailySales(a, 6) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-6-' + i">
								{{ getBundleProductDailySales(a, 6) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay5="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 5) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-5-' + i">
								{{ getReturnProductDailySales(a, 5) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-5-' + i">
								{{ getBundleProductDailySales(a, 5) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay4="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 4) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-4-' + i">
								{{ getReturnProductDailySales(a, 4) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-4-' + i">
								{{ getBundleProductDailySales(a, 4) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay3="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 3) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-3-' + i">
								{{ getReturnProductDailySales(a, 3) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-3-' + i">
								{{ getBundleProductDailySales(a, 3) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay2="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 2) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-2-' + i">
								{{ getReturnProductDailySales(a, 2) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-2-' + i">
								{{ getBundleProductDailySales(a, 2) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay1="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 1) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-1-' + i">
								{{ getReturnProductDailySales(a, 1) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-1-' + i">
								{{ getBundleProductDailySales(a, 1) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay0="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 0) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-0-' + i">
								{{ getReturnProductDailySales(a, 0) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-0-' + i">
								{{ getBundleProductDailySales(a, 0) }}
							</div>
						</div>
					</template>

					<template v-slot:판매변화="{ item }">
						<div>
							<span :style="{ color: getSalesChangeStyle(showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ? getSalesChangeRate(item) : item.판매변화).color }">
								{{ Math.abs(showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ? getSalesChangeRate(item) : item.판매변화).toFixed(1) }}%
								{{ getSalesChangeStyle(showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ? getSalesChangeRate(item) : item.판매변화).icon }}
							</span>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-change-' + i">
								<span :style="{ color: getSalesChangeStyle(getReturnProductChangeRate(a)).color }">
									{{ Math.abs(getReturnProductChangeRate(a)).toFixed(1) }}%
									{{ getSalesChangeStyle(getReturnProductChangeRate(a)).icon }}
								</span>
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-change-' + i">
								<span :style="{ color: getSalesChangeStyle(getBundleProductChangeRate(a)).color }">
									{{ Math.abs(getBundleProductChangeRate(a)).toFixed(1) }}%
									{{ getSalesChangeStyle(getBundleProductChangeRate(a)).icon }}
								</span>
							</div>
						</div>
					</template>
					<template v-slot:일판매수량="{ item }">
						<div @click="openTargetSalesModal(item)" style="cursor: pointer;">
							<div>{{ showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ?
								getMainProductDailySales(item).toFixed(2) : item.일판매수량.toFixed(2) }}</div>
							<b-badge v-if="item.유효판매일 !== undefined && item.유효판매일 < 7" variant="danger" class="mt-1"
								:title="`유효 판매일 ${item.유효판매일}일 — 데이터가 적어 추정 신뢰도가 낮습니다`">데이터 부족</b-badge>
							<b-badge v-else-if="item.유효판매일 !== undefined && item.유효판매일 < 14" variant="warning" class="mt-1"
								:title="`유효 판매일 ${item.유효판매일}일 — 추정 신뢰도가 다소 낮습니다`">저신뢰</b-badge>
							<div v-if="item.목표일판매수량 && item.목표일판매수량 > 0" class="text-secondary small">
								{{ item.목표일판매수량 }}
							</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-daily-' + i">
								{{ (getReturnProductMonthlySales(a) / 30).toFixed(2) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-daily-' + i">
								{{ (a.일판매수량 || 0).toFixed(2) }}
							</div>
						</div>
					</template>
					<template v-slot:dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.dday) }}
						</div>
					</template>
					<template v-slot:배대지출고Dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.배대지출고Dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.배대지출고Dday) }}
						</div>
					</template>
					<template v-slot:배대지출고필요수량="{ item }">
						<div class="purchase-outbound-cell" v-if="item.배대지 <= 0" @click="showInventoryModal(item)">-</div>
						<div class="purchase-outbound-cell" v-else @click="showInventoryModal(item)">
							<div>{{ item.배대지출고필요수량 === 0 ? '-' : item.배대지출고필요수량 }}</div>
							<div v-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div>
						</div>
					</template>
					<template v-slot:통관중출고Dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.통관중출고Dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.통관중출고Dday) }}
						</div>
					</template>
					<template v-slot:통관중출고필요수량="{ item }">
						<div class="purchase-outbound-cell" v-if="item.통관중 <= 0" @click="showInventoryModal(item)">-</div>
						<div class="purchase-outbound-cell" v-else @click="showInventoryModal(item)">
							<div>{{ item.통관중출고필요수량 === 0 ? '-' : item.통관중출고필요수량 }}</div>
							<div v-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div>
						</div>
					</template>
					<template v-slot:국내출고Dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.국내출고Dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.국내출고Dday) }}
						</div>
					</template>
					<template v-slot:국내출고필요수량="{ item }">
						<div class="purchase-outbound-cell" v-if="item.국내재고 <= 0" @click="showInventoryModal(item)">-</div>
						<div class="purchase-outbound-cell" v-else @click="showInventoryModal(item)">
							<div>{{ item.국내출고필요수량 === 0 ? '-' : item.국내출고필요수량 }}</div>
							<div v-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div>
						</div>
					</template>
					<template v-slot:최대입고기간="{ item }">
						<div v-b-modal="'inboundDetails' + item.vendorItemId" style="cursor: pointer">{{ item.최대입고기간 }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">{{ a.최대입고기간 }}</div>
						</div>
					</template>
					<template v-slot:보관료="{ item }">
						<div v-b-modal="'inboundDetails' + item.vendorItemId" style="cursor: pointer">{{ item.보관료 }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">{{ a.보관료 }}</div>
						</div>

						<!-- 입고 상세 내역 모달 -->
						<b-modal :id="'inboundDetails' + item.vendorItemId" scrollable title="입고 상세 내역" ok-only
							modal-class="scm-detail-modal">
							<div class="overflow-x-auto">
								<!-- 입고 상세 테이블 -->
								<table class="table table-bordered">
									<thead>
										<tr>
											<th class="text-center">입고일자</th>
											<th class="text-center">남은수량</th>
											<th class="text-center">입고기간</th>
											<!-- <th class="text-center">보관료</th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(detail, index) in sortedInboundList(item.inboundInfo)" :key="index"
											:class="{ 'text-muted': detail.remainingSkuQty <= 0 }">
											<td class="text-center">{{ formatDate(detail.inboundDate) }}</td>
											<td class="text-right">{{ formatNumber(detail.remainingSkuQty) }}개</td>
											<td class="text-right">{{ calculateDaysAgo(detail.inboundDate) }}일</td>
											<!-- <td class="text-right">{{ formatCurrency(calculateStorageFee(detail.inboundDate, detail.remainingSkuQty, item.inboundInfo.storageFeeRates)) }}</td> -->
										</tr>
										<!-- 합계 행 -->
										<tr class="table-secondary font-weight-bold">
											<td>합계</td>
											<td class="text-right">{{ formatNumber(getTotalQuantity(item.inboundInfo))
											}}개</td>
											<td></td>
											<!-- <td class="text-right">{{ formatCurrency(getTotalStorageFee(item.inboundInfo)) }}</td> -->
										</tr>
									</tbody>
								</table>
							</div>
						</b-modal>

					</template>
					<!-- 설정 -->
					<template v-slot:설정="{ item }">
						<div class="text-center">
							<i v-if="item.isSummaryRow"
								class="fas fa-cogs text-primary cursor-pointer"
								@click="showSettingsModal()"
								title="전체 설정 관리"
								style="font-size: 16px;"></i>
							<i v-else
								class="fas fa-cog text-secondary cursor-pointer"
								@click="showSettingsModal(item)"
								:title="getSettingsTooltip(item)"
								style="font-size: 14px;"></i>
						</div>
					</template>

					<!-- 메모 -->
					<template v-slot:메모="{ item }">
						<!-- 종합 행인 경우 -->
						<div v-if="item.isSummaryRow" class="text-center">
							<i v-if="hasMemoInItems()"
								class="fas fa-sticky-note text-warning memo-simple-icon"
								:title="getSummaryMemoTooltip()"></i>
							<span v-else class="text-muted">-</span>
						</div>
						<!-- 일반 행인 경우 -->
						<div v-else class="text-center">
							<!-- 메모가 있는 경우 -->
							<div v-if="item.메모 && item.메모.toString().trim()">
								<i class="fas fa-sticky-note text-success memo-simple-icon"
									:title="item.메모"
									@click="editMemo(item)"></i>
							</div>
							<!-- 메모가 없는 경우: 빈 공간에 클릭하면 메모 추가 -->
							<div v-else class="memo-add-area" @click="editMemo(item)" title="메모 추가">
								<i class="fas fa-plus text-muted memo-add-icon"></i>
							</div>
						</div>
					</template>
				</CDataTable>

				<!-- 재고 대사 — 옵션을 펼쳤을 때: 어디서 비는지 -->
				<div v-if="reconDetail" ref="reconDetailCard" class="card recon-detail">
					<div class="card-body">
						<div class="d-flex align-items-start mb-2">
							<div class="flex-grow-1">
								<h6 class="mb-0">{{ reconDetail.name }}</h6>
								<small class="text-muted">옵션ID {{ reconDetail.vendorItemId }}</small>
							</div>
							<button type="button" class="close" aria-label="닫기" @click="reconDetailVid = null">&times;</button>
						</div>
						<div class="row">
							<div class="col-lg-7">
								<div class="recon-detail__strip" aria-hidden="true">
									<span class="recon-detail__strip-sold" :style="{ width: reconDetail.soldPct + '%' }"></span>
									<span class="recon-detail__strip-left" :style="{ width: (100 - reconDetail.soldPct) + '%' }"></span>
								</div>
								<div class="d-flex justify-content-between small text-muted mb-2">
									<span>입고 {{ reconDetail.r.inbound.toLocaleString() }} 중 판매 {{ reconDetail.sold.toLocaleString() }}</span>
									<span v-if="reconDetail.r.inbound - reconDetail.sold >= 0">남은 {{ (reconDetail.r.inbound - reconDetail.sold).toLocaleString() }}</span>
									<span v-else title="판매에 반품 후 다시 팔린 수량이나 입고 기록이 시작되기 전 재고의 판매가 섞여 있어 입고보다 많아요">입고 기록 이전 판매 포함</span>
								</div>
								<svg :viewBox="'0 0 ' + reconWaterfall.width + ' ' + reconWaterfall.height" width="100%" class="recon-detail__svg" role="img"
									aria-label="재고 흐름 폭포 그래프">
									<g v-for="(t, i) in reconWaterfall.ticks" :key="'t' + i">
										<line :x1="44" :x2="reconWaterfall.width - 8" :y1="t.y" :y2="t.y" stroke="#eef1f4" stroke-width="1" />
										<text :x="38" :y="t.y + 4" font-size="11" fill="#7f8c9a" text-anchor="end">{{ t.label }}</text>
									</g>
									<g v-for="(b, i) in reconWaterfall.bars" :key="'b' + i">
										<rect :x="b.x" :y="b.y" :width="b.w" :height="b.h" rx="2" :class="'recon-bar recon-bar--' + b.kind" />
										<text :x="b.x + b.w / 2" :y="b.y - 6" font-size="12" font-weight="600" text-anchor="middle"
											:class="b.kind === 'miss' ? 'recon-text--miss' : 'recon-text'">{{ b.lab }}</text>
										<text :x="b.x + b.w / 2" :y="reconWaterfall.bottom + 18" font-size="11.5" text-anchor="middle"
											:class="b.kind === 'miss' ? 'recon-text--miss' : 'recon-text--sub'">{{ b.l1 }}</text>
										<text v-if="b.l2" :x="b.x + b.w / 2" :y="reconWaterfall.bottom + 33" font-size="11" text-anchor="middle"
											class="recon-text--sub">{{ b.l2 }}</text>
										<text v-if="b.l3" :x="b.x + b.w / 2" :y="reconWaterfall.bottom + 48" font-size="10.5" text-anchor="middle"
											class="recon-text--sub">{{ b.l3 }}</text>
										<line v-if="b.link !== null" :x1="b.x + b.w" :x2="b.x + b.w + reconWaterfall.gap" :y1="b.link" :y2="b.link"
											stroke="#9aa6b4" stroke-width="1" stroke-dasharray="2 3" />
									</g>
								</svg>
								<div class="small text-muted mt-1">
									확인 안 된 재고 = 입고 − 판매 + 반품 재입고 − 반출·폐기 − 보상 확정 − 현재고.
									<template v-if="reconPendingSettle(reconDetail.r) > 0">
										판매에 정산 반영 전 판매 {{ reconPendingSettle(reconDetail.r).toLocaleString() }}개<template v-if="reconDetail.r.pendingSettleEstimated">(추정)</template> 포함 —
										정산은 최근 1~2일이 늦게 채워져서<template v-if="reconSummary && reconSummary.settleCompleteDate"> {{ reconSummary.settleCompleteDate.slice(5).replace('-', '/') }} 이후는</template>
										일별 판매로 채웠어요.
										<template v-if="reconDetail.r.pendingSettleEstimated">일별 판매는 반품을 뺀 수치라, 정산이 아직 없는 날은 최근 30일 반품률로 되돌려 추정했어요.</template>
									</template>
								</div>
								<div v-if="reconDetail.r.flags.bundleUncertain" class="small recon-detail__note">
									번들 포함 — 정확하지 않을 수 있어요(구성 수량을 모르는 묶음이 있습니다).
								</div>
							</div>
							<div class="col-lg-5">
								<h6 class="mb-2">이력</h6>
								<ul class="recon-summary">
									<li v-for="(line, i) in reconDetail.summaryLines" :key="'s' + i">{{ line }}</li>
								</ul>
								<ul class="recon-timeline">
									<li v-for="(h, i) in reconDetail.tail" :key="'h' + i">
										<span class="recon-timeline__date">{{ h.date }}</span>
										<span :class="{ 'recon-timeline__hl': h.hl }">{{ h.text }}</span>
									</li>
								</ul>
								<a v-if="reconDetail.full.length" href="javascript:void(0)" class="small"
									@click="reconShowFullHistory = !reconShowFullHistory">
									{{ reconShowFullHistory ? '전체 이력 접기' : '전체 이력 보기 (' + reconDetail.full.length + '건)' }}
								</a>
								<ul v-if="reconShowFullHistory" class="recon-timeline recon-timeline--full mt-1">
									<li v-for="(h, i) in reconDetail.full" :key="'f' + i">
										<span class="recon-timeline__date">{{ h.date }}</span>
										<span>{{ h.text }}</span>
									</li>
								</ul>
								<div class="mt-2">
									<button type="button" class="btn btn-outline-primary btn-sm" @click="copyReconRequest">쿠팡확인요청 문구 복사</button>
									<small v-if="reconCopyMsg" class="text-success ml-2">{{ reconCopyMsg }}</small>
								</div>
								<template v-if="reconCopyFallback">
									<textarea class="form-control form-control-sm mt-2" rows="4" readonly
										:value="reconCopyFallback" @focus="$event.target.select()"></textarea>
									<small class="text-muted d-block mt-1">
										복사가 안 됐어요. 위 칸의 문구를 직접 선택해 복사하세요.
									</small>
								</template>
							</div>
						</div>
					</div>
				</div>



				<b-modal size="xl" id="excelupload" scrollable title="일괄업로드" ok-only>
					<div class="row">
						<div class="col-md-12">
							<p><strong>[업로드 방법]</strong></p>
							<p>1. 엑셀업로드 포맷 다운로드 → 2. 엑셀 파일에서 필요한 필드 업데이트 → 3. 업데이트된 엑셀 파일 업로드</p>
							<p><small class="text-muted">* 상품명, 옵션명은 수정할 수 없습니다. 변경된 데이터만 업데이트됩니다.</small></p>
						</div>
					</div>

					<!-- 옵션ID 매칭 방식 -->
					<div class="card mb-3">
						<div class="card-header bg-primary text-white">
							<h6 class="mb-0"><i class="fa fa-barcode mr-2"></i>옵션ID(vendorItemId)로 매칭</h6>
						</div>
						<div class="card-body">
							<div class="row align-items-end">
								<div class="col-md-4">
									<label class="form-label">엑셀 포맷 다운로드</label>
									<div>
										<button type="button" @click="formatDownload('vendorItemId')"
											class="btn btn-outline-primary btn-block">
											<i class="fa fa-download mr-1"></i>옵션ID 포맷 다운로드
										</button>
									</div>
								</div>
								<div class="col-md-6">
									<label class="form-label">엑셀 파일 업로드</label>
									<div class="custom-file">
										<input ref="vendorItemIdUpload" type="file" @change="uploadfile($event, 'vendorItemId')"
											class="custom-file-input" id="vendorItemIdFile" accept=".xlsx,.xls">
										<label class="custom-file-label" for="vendorItemIdFile">{{ uploadstatus }}</label>
									</div>
								</div>
								<div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'vendorItemId'">
									<img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
								</div>
							</div>
						</div>
					</div>

					<!-- 바코드 매칭 방식 -->
					<div class="card">
						<div class="card-header bg-success text-white">
							<h6 class="mb-0"><i class="fa fa-qrcode mr-2"></i>바코드(barcode)로 매칭</h6>
						</div>
						<div class="card-body">
							<div class="row align-items-end">
								<div class="col-md-4">
									<label class="form-label">엑셀 포맷 다운로드</label>
									<div>
										<button type="button" @click="formatDownload('barcode')"
											class="btn btn-outline-success btn-block">
											<i class="fa fa-download mr-1"></i>바코드 포맷 다운로드
										</button>
									</div>
								</div>
								<div class="col-md-6">
									<label class="form-label">엑셀 파일 업로드</label>
									<div class="custom-file">
										<input ref="barcodeUpload" type="file" @change="uploadfile($event, 'barcode')"
											class="custom-file-input" id="barcodeFile" accept=".xlsx,.xls">
										<label class="custom-file-label" for="barcodeFile">{{ uploadstatus2 }}</label>
									</div>
								</div>
								<div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'barcode'">
									<img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
								</div>
							</div>
						</div>
					</div>
				</b-modal>

				<b-modal id="reqpurchase" size="xl" scrollable title="구매대행요청" ok-title="구매대행요청추가" cancel-title="취소"
					modal-class="scm-detail-modal" @ok="requestpurchase($event)" @show="initReqLists">
					<div class="mb-3">
						<button type="button" class="btn btn-warning btn-sm" @click="clearPurchaseCart">
							장바구니 초기화 ({{ purchaseCart.length }}개 상품)
						</button>
					</div>
					<CDataTable
						storage-key="growthScmV0.2" :headers="reqHeaders" :items="reqlists" v-model="reqTableSelectedItem"
						:show-select="true" itemKey="vendorItemId" style="margin-bottom: 10px" :headerTooltips="headerTooltips">
						<template v-slot:상품명="{ item }">
							<div class="d-flex align-items-center">
								<img :src="item.썸네일" class="img-fluid rounded avatar-40 mr-3" alt="image">
								<div class="text-wrap">{{ item.판매상품명 }}</div>
							</div>
						</template>
						<template v-slot:MOQ수량="{ item }">
							<span class="text-center font-weight-bold">{{ item.MOQ수량 || 2 }}</span>
						</template>
						<template v-slot:구매요청수량="{ item }">
							<input type="number" class="form-control text-center" v-model="item.구매요청수량" min="0" @input="updatePurchasePreview">
						</template>
						<template v-slot:예상재고량="{ item }">
							<div class="text-center font-weight-bold text-primary">
								{{ getPurchasePreviewTotalStockForItem(item) }}개
							</div>
						</template>
						<template v-slot:예상재고일="{ item }">
							<div class="text-center font-weight-bold text-success">
								{{ getPurchasePreviewStockPeriodForItem(item) }}일
							</div>
						</template>
					</CDataTable>
				</b-modal>

				<b-modal id="waitreqpurchase" size="sm" hide-footer>
					<div class="text-center">
						구매요청 내역을 저장 중입니다. 잠시만 기다려 주세요.
					</div>
					<div class=text-center>
						<img style="max-width:100%;" :src="require('../../../assets/images/small/spinner.gif')">
					</div>
				</b-modal>


			</div>
		</div>

		<!-- 입고중 상태 모달 -->
		<b-modal id="inventoryModal" size="xl" scrollable title="재고 관리" hide-footer
			modal-class="scm-detail-modal" @shown="onInventoryModalShown" @hidden="onModalHidden">
			<div class="inventory-modal-content">
				<b-tabs pills content-class="mt-2" v-model="inventoryModalTab">
				<!-- 탭1: 재고현황 -->
				<b-tab title="📊 재고현황" active>
				<!-- 색상 범례 및 정렬 초기화 -->
				<div class="legend-container mb-3">
					<div class="d-flex justify-content-between align-items-center">
						<!-- 일괄 관리 버튼 그룹 -->
						<div class="d-flex align-items-center">
							<b-button variant="outline-primary" size="sm" class="mr-2" v-b-toggle.inventory-collapse>
								<i class="fas fa-edit mr-1"></i>일괄변경
							</b-button>
							<b-button variant="outline-success" size="sm" v-b-modal.excelupload>
								<i class="fas fa-upload mr-1"></i>엑셀업로드
							</b-button>
						</div>
						<!-- 우측 컨트롤 그룹 -->
						<div class="d-flex align-items-center">
							<!-- 쿠패스연동 상태 표시 -->
							<div v-if="coupassSyncEnabled" class="mr-3">
								<span class="badge badge-success d-flex align-items-center" style="font-size: 0.75rem; padding: 4px 8px;">
									<i class="fas fa-link mr-1" style="color: #28a745;"></i>
									쿠패스연동중
								</span>
							</div>
							<!-- 정렬 초기화 버튼 -->
							<button class="btn btn-sm btn-outline-secondary mr-3" @click="resetSort" title="기본 정렬로 초기화">
								<i class="fas fa-undo"></i> 정렬 초기화
							</button>
							<!-- 색상 범례 그룹 -->
							<div class="d-flex align-items-center">
								<div class="legend-item mr-3">
									<span class="legend-box bg-success"></span>
									<small>입고 완료</small>
								</div>
								<div class="legend-item mr-3">
									<span class="legend-box bg-warning"></span>
									<small>부분 입고</small>
								</div>
								<div class="legend-item">
									<span class="legend-box bg-danger"></span>
									<small>입고 전</small>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 일괄변경 collapse -->
				<div class="col-lg-12 d-flex justify-content-end mb-3">
					<b-collapse id="inventory-collapse">
						<b-card title="">
							<div class="form-group">
								<input type="number" class="form-control" placeholder="구매완료재고" v-model="재고일괄변경.구매"
									:disabled="coupassSyncEnabled" :class="{ 'bg-light text-muted': coupassSyncEnabled }">
								<small v-if="coupassSyncEnabled" class="text-muted">쿠패스연동으로 비활성화됨</small>
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="배대지재고" v-model="재고일괄변경.배대지"
									:disabled="coupassSyncEnabled" :class="{ 'bg-light text-muted': coupassSyncEnabled }">
								<small v-if="coupassSyncEnabled" class="text-muted">쿠패스연동으로 비활성화됨</small>
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="통관중재고" v-model="재고일괄변경.통관중"
									:disabled="coupassSyncEnabled" :class="{ 'bg-light text-muted': coupassSyncEnabled }">
								<small v-if="coupassSyncEnabled" class="text-muted">쿠패스연동으로 비활성화됨</small>
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="국내재고" v-model="재고일괄변경.국내재고"
									:disabled="coupassSyncEnabled" :class="{ 'bg-light text-muted': coupassSyncEnabled }">
								<small v-if="coupassSyncEnabled" class="text-muted">쿠패스연동으로 비활성화됨</small>
							</div>
							<button type="button" class="btn btn-success mr-2 mt-1" @click="applyBulkInventory">적용</button>
						</b-card>
					</b-collapse>
				</div>

				<!-- 전체 상품 재고 관리 테이블 (종합 데이터 포함) -->
				<CDataTable
					storage-key="growthScmV0.3" :key="`inventory-${showStockAmount}-${inventoryFilteredVendorItemId}`" :headers="inventoryModalHeaders" :items="filteredInventoryList" itemKey="vendorItemId"
					style="margin-bottom: 10px" :show-select="true" v-model="inventorySelectedItems" :row-class="getRowClass" ref="inventoryTable" :items-per-page="100"
					:subheader="inventoryFilteredVendorItemId ? null : inventorySubheaderData" :headerTooltips="headerTooltips">

					<!-- Subheader 썸네일 -->
					<template v-slot:subheader-썸네일>
						<div class="text-center">
							<i class="fas fa-chart-bar text-primary" style="font-size: 20px;"></i>
						</div>
					</template>

					<!-- 상품 이미지 -->
					<template v-slot:썸네일="{ item }">
						<img :src="item.썸네일" class="img-thumbnail" style="width: 50px; height: 50px;" />
					</template>

					<!-- Subheader 상품명 -->
					<template v-slot:subheader-판매상품명>
						<div class="text-center font-weight-bold text-primary">
							전체 종합
						</div>
					</template>

					<!-- 상품명 + 옵션명 -->
					<template v-slot:판매상품명="{ item }">
						<div style="max-width: 200px;">
							<div class="text-truncate font-weight-bold" :title="item.판매상품명">
								{{ item.판매상품명 }}
							</div>
							<div class="text-truncate text-muted small" :title="item.옵션명">
								{{ item.옵션명 }}
							</div>
						</div>
					</template>

					<!-- Subheader 개별 재고 컬럼들 -->
					<template v-slot:subheader-구매>
						<div class="text-center font-weight-bold">{{ totalSummary.구매 }}</div>
					</template>
					<template v-slot:subheader-배대지>
						<div class="text-center font-weight-bold">{{ totalSummary.배대지 }}</div>
					</template>
					<template v-slot:subheader-장기입고중>
						<div class="text-center font-weight-bold">{{ totalSummary.장기입고중 }}</div>
					</template>
					<template v-slot:subheader-통관중>
						<div class="text-center font-weight-bold">{{ totalSummary.통관중 }}</div>
					</template>
					<template v-slot:subheader-국내재고>
						<div class="text-center font-weight-bold">{{ totalSummary.국내재고 }}</div>
					</template>
					<template v-slot:subheader-단기입고중>
						<div class="text-center font-weight-bold">{{ totalSummary.단기입고중 }}</div>
					</template>
					<template v-slot:subheader-재고>
						<div class="text-center font-weight-bold text-danger">{{ totalSummary.재고 }}</div>
					</template>

					<!-- 개별 재고 컬럼들 -->
					<template v-slot:구매="{ item }">
						<div class="inventory-box-vertical bg-light border text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.구매, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
							<div v-else>
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.구매" @blur="updateInventoryInModal(item, '구매', item.구매)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.구매 }}</div>
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.구매 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.구매" @blur="updateInventoryInModal(item, '구매', item.구매)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.구매 }}</div>
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:배대지="{ item }">
						<div class="inventory-box-vertical bg-light text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.배대지, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
							<div v-else>
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.배대지" @blur="updateInventoryInModal(item, '배대지', item.배대지)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.배대지 }}</div>
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.배대지 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.배대지" @blur="updateInventoryInModal(item, '배대지', item.배대지)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.배대지 }}</div>
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:통관중="{ item }">
						<div class="inventory-box-vertical bg-light text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.통관중, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
							<div v-else>
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.통관중" @blur="updateInventoryInModal(item, '통관중', item.통관중)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.통관중 }}</div>
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.통관중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.통관중" @blur="updateInventoryInModal(item, '통관중', item.통관중)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.통관중 }}</div>
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:장기입고중="{ item }">
						<div class="inventory-box-vertical bg-primary text-white text-center">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.장기입고중, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.장기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:국내재고="{ item }">
						<div class="inventory-box-vertical bg-light text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.국내재고, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
							<div v-else>
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.국내재고" @blur="updateInventoryInModal(item, '국내재고', item.국내재고)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.국내재고 }}</div>
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.국내재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input v-if="!coupassSyncEnabled" type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.국내재고" @blur="updateInventoryInModal(item, '국내재고', item.국내재고)" style="width: 100%;">
								<div v-else class="text-center py-1">{{ item.국내재고 }}</div>
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:단기입고중="{ item }">
						<div class="inventory-box-vertical bg-primary text-white text-center">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.단기입고중, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.단기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:재고="{ item }">
						<div class="inventory-box-vertical bg-danger text-white text-center">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.재고, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.재고 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
						</div>
					</template>

					<!-- 설정 -->
					<template v-slot:설정="{ item }">
						<div class="text-center">
							<button v-if="item.isSummaryRow"
								class="btn btn-sm btn-outline-primary"
								@click="showSettingsModal()"
								title="전체 설정 관리">
								<i class="fas fa-cogs"></i>
							</button>
							<button v-else
								class="btn btn-sm btn-outline-secondary"
								@click="showSettingsModal(item)"
								:title="getSettingsTooltip(item)">
								<i class="fas fa-cog"></i>
							</button>
						</div>
					</template>

					<!-- Subheader 메모 -->
					<template v-slot:subheader-메모>
						<div class="text-center">
							<i v-if="hasMemoInItems()"
								class="fas fa-sticky-note text-warning memo-simple-icon"
								:title="getSummaryMemoTooltip()"></i>
							<span v-else class="text-muted">-</span>
						</div>
					</template>

					<!-- 재고메모 (재고관리 모달용) -->
					<template v-slot:메모="{ item }">
						<!-- 일반 행인 경우 -->
						<div class="text-center">
							<!-- 메모가 있는 경우 -->
							<div v-if="item.메모 && item.메모.toString().trim()">
								<i class="fas fa-sticky-note text-success memo-simple-icon"
									:title="item.메모"
									@click="editMemo(item)"></i>
							</div>
							<!-- 메모가 없는 경우: 빈 공간에 클릭하면 메모 추가 -->
							<div v-else class="memo-add-area" @click="editMemo(item)" title="메모 추가">
								<i class="fas fa-plus text-muted memo-add-icon"></i>
							</div>
						</div>
					</template>

					<!-- Subheader 동적 날짜별 입고 수량 -->
					<template v-for="date in inboundDates" v-slot:[`subheader-inbound_${date}`]>
						<div :key="`subheader-${date}`" class="text-center p-1 rounded" :class="getInboundStyleByValue(getSummaryForDate(date), true)">
							<span @click="sortByDateColumn(date)"
								class="clickable-summary"
								:title="getSummaryTooltip(date)">
								{{ getSummaryForDate(date) }}
							</span>
						</div>
					</template>

					<!-- 동적 날짜별 입고 수량 템플릿 -->
					<template v-for="date in inboundDates" v-slot:[`inbound_${date}`]="{ item }">
						<div :key="`${date}-${item.vendorItemId}`" class="text-center p-1 rounded" :class="getInboundStyleByValue(item[`inbound_${date}`], false)">
							<!-- 일반 행인 경우 -->
							<span :title="getInboundTooltip(item, date)"
								class="inbound-cell">
								{{ item[`inbound_${date}`] }}
							</span>
						</div>
					</template>

				</CDataTable>
				</b-tab>

				<!-- 탭2: 입출고이력 -->
				<b-tab title="📋 입출고이력">
					<div class="p-3">
						<!-- 필터 영역 -->
						<div class="d-flex flex-wrap align-items-center mb-3">
							<input type="text" class="form-control mr-2" style="max-width:250px;"
								placeholder="상품명 / 바코드 검색" v-model="historySearch">
							<input type="date" class="form-control mr-2" style="max-width:160px;" v-model="historyStartDate">
							<span class="mr-2">~</span>
							<input type="date" class="form-control mr-2" style="max-width:160px;" v-model="historyEndDate">
							<b-button variant="primary" size="sm" @click="loadProcessHistory">
								<i class="fas fa-search mr-1"></i>조회
							</b-button>
						</div>

						<!-- 로딩 -->
						<div v-if="historyLoading" class="text-center py-5">
							<b-spinner small></b-spinner> 로딩 중...
						</div>

						<!-- 데이터 테이블 -->
						<CDataTable
							storage-key="growthScmV0.4" v-else :headers="historyHeaders" :items="historyFiltered" itemKey="_id"
							:items-per-page="50" :height="'500px'">

							<template v-slot:날짜="{ item }">
								<small>{{ item.날짜 }}</small>
							</template>
							<template v-slot:유형="{ item }">
								<b-badge :variant="item.유형 === '입고' ? 'success' : item.유형 === '출고' ? 'danger' : 'warning'">
									{{ item.유형 }}
								</b-badge>
							</template>
							<template v-slot:상태변화="{ item }">
								<small>{{ item.fromStatus }} → {{ item.toStatus }}</small>
							</template>
						</CDataTable>

						<div v-if="!historyLoading && historyList.length === 0" class="text-center py-4 text-muted">
							<i class="fas fa-info-circle mr-1"></i>조회 버튼을 눌러 입출고 이력을 확인하세요.
						</div>
					</div>
				</b-tab>
				</b-tabs>
			</div>
		</b-modal>

		<!-- 메모 편집 모달 -->
		<b-modal id="memoModal" title="메모 편집" ok-title="저장" cancel-title="취소"
			@ok="saveMemo" @cancel="cancelMemo" size="sm" modal-class="memo-modal">
			<div class="form-group">
				<label for="memoTextarea" class="small">메모 내용:</label>
				<textarea id="memoTextarea" class="form-control form-control-sm" rows="4"
					v-model="currentMemo"
					placeholder="메모 내용을 입력하세요...&#10;여러 줄로 작성 가능합니다."
					maxlength="500"></textarea>
				<small class="form-text text-muted">
					{{ currentMemo ? currentMemo.length : 0 }}/500자
				</small>
			</div>
		</b-modal>

		<!-- 설정 관리 모달 -->
		<b-modal id="settingsModal" title="설정 관리" hide-footer scrollable
			modal-class="scm-detail-modal" @shown="onSettingsModalShown" @hidden="onModalHidden">
			<div class="container-fluid">
				<!-- 헤더 영역 -->
				<div class="row mb-0">
					<div class="col-8">
						<h5>전체 상품 설정 관리</h5>
						<small class="text-muted">각 상품별로 설정값을 관리할 수 있습니다.</small>

					</div>
					<div class="col-4 text-right">
						<b-button variant="outline-primary" size="sm" class="mr-2" v-b-toggle.settings-collapse>
							<i class="fas fa-edit mr-1"></i>일괄변경
						</b-button>
						<b-button variant="outline-success" size="sm" v-b-modal.excelupload>
							<i class="fas fa-upload mr-1"></i>엑셀업로드
						</b-button>
					</div>
				</div>

				<!-- 일괄변경 collapse -->
				<div class="col-lg-12 d-flex justify-content-end mb-3">
					<b-collapse id="settings-collapse">
						<b-card title="">
							<div class="form-group">
								<input type="number" class="form-control" placeholder="입고기간" v-model="설정일괄변경.입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="배대지입고기간" v-model="설정일괄변경.배대지입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="통관중입고기간" v-model="설정일괄변경.통관중입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="국내입고기간" v-model="설정일괄변경.국내입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="안전재고기간" v-model="설정일괄변경.최소재고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="목표재고기간" v-model="설정일괄변경.최대재고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="MOQ수량" v-model="설정일괄변경.MOQ수량">
							</div>
							<button type="button" class="btn btn-success mr-2 mt-1" @click="applyBulkSettings">적용</button>
						</b-card>
					</b-collapse>
				</div>

				<!-- 개념도 영역 -->
				<div class="concept-diagram mb-0">
					<div class="scm-concept-image">
								<img src="@/assets/images/small/scm개념도.png"
										alt="SCM 입고기간 및 재고기간 개념도"
										class="img-fluid concept-diagram-img">
							</div>
				</div>

				<!-- 설정 테이블 -->
				<CDataTable
					storage-key="growthScmV0.5"
					:key="`settings-${settingsFilteredVendorItemId}`"
					:headers="settingsHeaders"
					:items="filteredSettingsList"
					:items-per-page="100"
					:show-select="true"
					v-model="settingsSelectedItems"
					itemKey="_id"
					:row-class="getRowClass"
					ref="settingsTable"
					class="settings-table">

					<!-- 상품 이미지 -->
					<template v-slot:썸네일="{ item }">
						<div class="text-center">
							<img :src="item.썸네일" style="width: 40px; height: 40px; object-fit: cover;"
								class="rounded" :alt="item.판매상품명">
						</div>
					</template>

					<!-- 상품명 -->
					<template v-slot:판매상품명="{ item }">
						<div style="max-width: 150px;">
							<div class="product-name-multiline font-weight-bold" :title="item.판매상품명">
								{{ item.판매상품명 }}
							</div>
							<small class="text-muted" :title="item.productId">
								{{ item.productId }}
							</small>
						</div>
					</template>

					<!-- 옵션명 -->
					<template v-slot:옵션명="{ item }">
						<div style="max-width: 120px;">
							<div class="text-truncate" :title="item.옵션명">
								{{ item.옵션명 }}
							</div>
							<small class="text-muted" :title="item.vendorItemId">
								{{ item.vendorItemId }}
							</small>
						</div>
					</template>

					<!-- 구매입고기간 -->
					<template v-slot:구매입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="7">
					</template>

					<!-- 배대지입고기간 -->
					<template v-slot:배대지입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.배대지입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="3">
					</template>

					<!-- 통관중입고기간 -->
					<template v-slot:통관중입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.통관중입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="3">
					</template>

					<!-- 국내입고기간 -->
					<template v-slot:국내입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.국내입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="2">
					</template>

					<!-- 목표재고기간 -->
					<template v-slot:목표재고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.최대재고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="30">
					</template>

					<!-- 안전재고기간 -->
					<template v-slot:안전재고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.최소재고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="7">
					</template>

					<!-- MOQ수량 -->
					<template v-slot:MOQ수량="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.MOQ수량" @blur="updateItemSettings(item)"
							style="width: 80px;" placeholder="100">
					</template>

					<!-- 1박스 인입수량 -->
					<template v-slot:박스인입수량="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.박스인입수량" @blur="updateItemSettings(item)"
							style="width: 80px;" placeholder="1">
					</template>

					<!-- 타겟키워드 -->
					<template v-slot:타겟키워드="{ item }">
						<textarea class="form-control form-control-sm" rows="2"
							v-model="item.타겟키워드" @blur="updateItemSettings(item)"
							style="width: 150px;" placeholder="키워드 입력..."></textarea>
					</template>

					<!-- 메모 -->
					<template v-slot:메모="{ item }">
						<div class="text-center">
							<!-- 메모가 있는 경우 -->
							<div v-if="item.메모 && item.메모.toString().trim()">
								<i class="fas fa-sticky-note text-success memo-simple-icon"
									:title="item.메모"
									@click="editMemo(item)"></i>
							</div>
							<!-- 메모가 없는 경우: 빈 공간에 클릭하면 메모 추가 -->
							<div v-else class="memo-add-area" @click="editMemo(item)" title="메모 추가">
								<i class="fas fa-plus text-muted memo-add-icon"></i>
							</div>
						</div>
					</template>

				</CDataTable>
			</div>
		</b-modal>

		<!-- 순서 관리 모달 -->
		<b-modal v-model="showOrderModal" size="xl" title="순서 관리" hide-footer>
			<div class="order-management">
				<p class="text-muted mb-3">노출ID별, 옵션ID별로 순서를 지정할 수 있습니다. 빈값은 기본 정렬(월판매수량 기준) 뒤에 배치됩니다.</p>

				<CDataTable
					storage-key="growthScmV0.6" :headers="orderHeaders" :items="saleslists" itemKey="vendorItemId"
					style="margin-bottom: 10px" :show-select="false">

					<!-- 상품 이미지 -->
					<template v-slot:썸네일="{ item }">
						<img :src="item.썸네일" class="img-thumbnail" style="width: 40px; height: 40px;" />
					</template>

					<!-- 상품명 -->
					<template v-slot:판매상품명="{ item }">
						<div class="text-truncate" style="max-width: 200px;" :title="item.판매상품명">
							{{ item.판매상품명 }}
						</div>
					</template>

					<!-- 옵션명 -->
					<template v-slot:옵션명="{ item }">
						<div class="text-truncate" style="max-width: 150px;" :title="item.옵션명">
							{{ item.옵션명 }}
						</div>
					</template>

					<!-- 노출ID 순서 -->
					<template v-slot:노출ID순서="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.productOrder" @blur="updateProductOrder(item)"
							placeholder="순서" style="width: 80px;">
					</template>

					<!-- 옵션ID 순서 -->
					<template v-slot:옵션ID순서="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.optionOrder" @blur="updateOrder(item)"
							placeholder="순서" style="width: 80px;">
					</template>

				</CDataTable>

				<div class="text-center mt-3">
					<button class="btn btn-primary mr-2" @click="applyCustomSort">순서 적용</button>
					<button class="btn btn-secondary" @click="showOrderModal = false">닫기</button>
				</div>
			</div>
		</b-modal>

		<!-- 목표 일판매수량 입력 모달 -->
		<b-modal v-model="targetSalesModal.show" title="목표 일판매수량 설정" size="sm" @ok="saveTargetSales" @cancel="cancelTargetSales">
			<div v-if="targetSalesModal.item">
				<div class="mb-3">
					<strong>상품:</strong> {{ targetSalesModal.item.판매상품명 }}
				</div>
				<div class="mb-3">
					<strong>옵션:</strong> {{ targetSalesModal.item.옵션명 }}
				</div>
				<div class="mb-3">
					<strong>현재 일판매수량:</strong> {{ targetSalesModal.item.일판매수량.toFixed(2) }}
				</div>
				<div class="form-group">
					<label for="targetSales">목표 일판매수량:</label>
					<input
						type="number"
						id="targetSales"
						class="form-control"
						v-model="targetSalesModal.targetSales"
						step="0.01"
						min="0"
						placeholder="목표 일판매수량을 입력하세요">
				</div>
			</div>
		</b-modal>

		<!-- 구매요청수량 입력 모달 -->
		<b-modal v-model="purchaseRequestModal.show" title="구매요청수량 설정" size="sm"
			ok-title="구매요청추가" cancel-title="취소" @ok="savePurchaseRequest" @cancel="cancelPurchaseRequest"
			:ok-disabled="purchaseRequestModal.isProcessing">
			<div v-if="purchaseRequestModal.item">
				<!-- 처리 중 오버레이 -->
				<div v-if="purchaseRequestModal.isProcessing" class="text-center py-4">
					<div class="spinner-border text-primary mb-3" role="status">
						<span class="sr-only">처리 중...</span>
					</div>
					<div class="h5 text-primary">구매요청에 추가하는 중...</div>
					<div class="text-muted">잠시만 기다려주세요 🛒</div>
				</div>

				<!-- 일반 모달 내용 -->
				<div v-else>
					<!-- 상품 정보 (이미지 포함) -->
					<div class="d-flex align-items-center mb-3">
						<img :src="purchaseRequestModal.item.썸네일" class="img-fluid rounded mr-3"
							style="width: 60px; height: 60px; object-fit: cover; flex-shrink: 0;" alt="상품이미지">
						<div class="flex-grow-1" style="min-width: 0;">
							<div class="font-weight-bold text-truncate" style="font-size: 0.9em; line-height: 1.2;">
								{{ purchaseRequestModal.item.판매상품명 }}
							</div>
							<div class="text-muted small text-truncate">{{ purchaseRequestModal.item.옵션명 }}</div>
						</div>
					</div>

					<!-- 구매 설정 정보 (편집 가능) -->
					<div class="mb-3">
						<div class="row">
							<div class="col-6">
								<label class="small font-weight-bold">1박스 인입수량</label>
								<input
									type="number"
									class="form-control form-control-sm text-center"
									v-model="purchaseRequestModal.item.박스인입수량"
									min="1"
									@blur="updatePurchaseSettings">
							</div>
							<div class="col-6">
								<label class="small font-weight-bold">MOQ수량</label>
								<input
									type="number"
									class="form-control form-control-sm text-center"
									v-model="purchaseRequestModal.item.MOQ수량"
									min="1"
									@blur="updatePurchaseSettings">
							</div>
						</div>
					</div>

					<!-- 구매요청수량 입력 -->
					<div class="form-group mb-3">
						<label for="requestQuantity" class="font-weight-bold">
							구매요청수량
							<span class="text-muted small">(현재 {{ purchaseRequestModal.item.구매필요수량 }}개 필요)</span>
						</label>
						<input
							type="number"
							id="requestQuantity"
							class="form-control text-center"
							v-model="purchaseRequestModal.requestQuantity"
							min="0"
							@input="calculatePurchasePreview"
							placeholder="구매요청수량을 입력하세요">
					</div>

				<!-- 구매 후 예상 재고 정보 (컴팩트) -->
				<div v-if="purchaseRequestModal.requestQuantity > 0" class="mt-3">
					<div class="small font-weight-bold mb-2 text-center text-dark">구매 후 예상 재고</div>

					<!-- 현재 → 예상 블럭 형태 -->
					<div class="d-flex align-items-center justify-content-between">
						<!-- 현재 재고 블럭 -->
						<div class="text-center p-3 rounded shadow-sm" style="flex: 1; background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border: 1px solid #dee2e6;">
							<div class="font-weight-bold text-dark" style="font-size: 1.1em;">{{ getTotalAvailableStock(purchaseRequestModal.item) }}개</div>
							<div class="font-weight-bold text-dark" style="font-size: 1em;">{{ getCurrentStockPeriod() }}일</div>
							<div class="small text-muted mt-1">현재</div>
						</div>

						<!-- 화살표 -->
						<div class="mx-3">
							<i class="fas fa-arrow-right text-success" style="font-size: 1.2em;"></i>
						</div>

						<!-- 예상 재고 블럭 -->
						<div class="text-center p-3 rounded shadow-sm" style="flex: 1; background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border: 1px solid #dee2e6;">
							<div class="font-weight-bold text-secondary" style="font-size: 1.1em;">{{ getPurchasePreviewTotalStock() }}개</div>
							<div class="font-weight-bold text-secondary" style="font-size: 1em;">{{ getPurchasePreviewStockPeriod() }}일</div>
							<div class="small text-muted mt-1" style="opacity: 0.9;">예상</div>
						</div>
					</div>

					<div class="mt-2 small text-success text-center font-weight-bold">
						<i class="fas fa-plus-circle mr-1"></i>{{ purchaseRequestModal.requestQuantity }}개 추가
					</div>
				</div>
				</div>
			</div>
		</b-modal>

		<!-- 쿠패스연동 확인 모달 -->
		<b-modal v-model="coupassSyncConfirmModal.show" title="쿠패스연동 확인" size="md"
			ok-title="연동 시작" cancel-title="취소" @ok="confirmCoupassSync" @cancel="cancelCoupassSync">
			<div class="alert alert-warning">
				<i class="fas fa-exclamation-triangle mr-2"></i>
				<strong>주의사항</strong>
			</div>
			<p>쿠패스연동을 활성화하면 다음 재고 정보가 자동으로 업데이트됩니다:</p>
			<div class="mb-3">
				<h6 class="text-danger"><i class="fas fa-sync-alt mr-1"></i>변경될 재고 항목:</h6>
				<ul class="list-unstyled ml-3">
					<li><i class="fas fa-dot-circle text-danger mr-2"></i>구매완료재고</li>
					<li><i class="fas fa-dot-circle text-danger mr-2"></i>배대지재고</li>
					<li><i class="fas fa-dot-circle text-danger mr-2"></i>통관중재고</li>
				</ul>
			</div>
			<div class="mb-3">
				<h6 class="text-success"><i class="fas fa-lock mr-1"></i>유지될 재고 항목:</h6>
				<ul class="list-unstyled ml-3">
					<li><i class="fas fa-dot-circle text-success mr-2"></i>해외입고중</li>
					<li><i class="fas fa-dot-circle text-success mr-2"></i>국내재고</li>
					<li><i class="fas fa-dot-circle text-success mr-2"></i>국내입고중</li>
				</ul>
			</div>
			<p class="text-muted small">
				<i class="fas fa-info-circle mr-1"></i>
				기존에 수동으로 입력한 재고 정보가 덮어쓰여질 수 있습니다. 계속하시겠습니까?
			</p>
		</b-modal>

		<!-- ✅ 사용자 지정 날짜 범위 수집 모달 -->
		<b-modal id="customDateRangeModal" title="날짜 지정 수집" hide-footer>
			<div class="form-group">
				<label for="customStartDate">시작일:</label>
				<input
					type="date"
					id="customStartDate"
					class="form-control"
					v-model="customStartDate"
					:max="customEndDate || new Date().toISOString().split('T')[0]">
			</div>
			<div class="form-group">
				<label for="customEndDate">종료일:</label>
				<input
					type="date"
					id="customEndDate"
					class="form-control"
					v-model="customEndDate"
					:min="customStartDate"
					:max="new Date().toISOString().split('T')[0]">
			</div>
			<div class="text-center mt-3">
				<b-button variant="secondary" @click="$bvModal.hide('customDateRangeModal')" class="mr-2">
					취소
				</b-button>
				<b-button variant="primary" @click="executeCustomDateCollection">
					<i class="fas fa-download mr-1"></i>
					수집 시작
				</b-button>
			</div>
		</b-modal>

		<!-- 구매요청 상세 모달 (쿠패스연동 시) -->
		<b-modal v-model="showReqpurchaseDetailModal" size="xl" scrollable
			:title="'구매요청 상세 - ' + (reqpurchaseDetailItem?.판매상품명 || '')"
			hide-footer modal-class="reqpurchase-detail-modal">
			<div v-if="reqpurchaseDetailItem">
				<!-- 상품 정보 헤더 -->
				<div class="d-flex align-items-center mb-3 p-3 bg-light rounded">
					<img :src="reqpurchaseDetailItem.썸네일" class="img-fluid rounded mr-3" style="width: 60px; height: 60px; object-fit: cover;" alt="상품이미지">
					<div>
						<h6 class="mb-1">{{ reqpurchaseDetailItem.판매상품명 }}</h6>
						<p class="mb-0 text-muted small">{{ reqpurchaseDetailItem.옵션명 }}</p>
						<p class="mb-0 text-muted small">
							<span class="badge badge-secondary mr-1">vendorItemId: {{ reqpurchaseDetailItem.vendorItemId }}</span>
							<span class="badge badge-info">바코드: {{ getBarcode(reqpurchaseDetailItem) }}</span>
						</p>
					</div>
				</div>

				<!-- 재고 현황 요약 -->
				<div class="row mb-3">
					<div class="col-md-3">
						<div class="card border-primary">
							<div class="card-body text-center py-2">
								<div class="text-primary font-weight-bold">구매완료</div>
								<div class="h4 mb-0">{{ reqpurchaseDetailItem.구매 || 0 }}개</div>
							</div>
						</div>
					</div>
					<div class="col-md-3">
						<div class="card border-warning">
							<div class="card-body text-center py-2">
								<div class="text-warning font-weight-bold">배대지(입고완료)</div>
								<div class="h4 mb-0">{{ reqpurchaseDetailItem.배대지 || 0 }}개</div>
							</div>
						</div>
					</div>
					<div class="col-md-3">
						<div class="card border-info">
							<div class="card-body text-center py-2">
								<div class="text-info font-weight-bold">통관중</div>
								<div class="h4 mb-0">{{ reqpurchaseDetailItem.통관중 || 0 }}개</div>
							</div>
						</div>
					</div>
					<div class="col-md-3">
						<div class="card border-success">
							<div class="card-body text-center py-2">
								<div class="text-success font-weight-bold">전체 가용재고</div>
								<div class="h4 mb-0">{{ getTotalAvailableStock(reqpurchaseDetailItem) }}개</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 구매요청 목록 -->
				<h6 class="font-weight-bold mb-2">
					<i class="fa fa-list mr-1"></i>구매요청 내역 ({{ reqpurchaseDetailList.length }}건)
				</h6>
				<div v-if="reqpurchaseDetailList.length === 0" class="text-center text-muted py-4">
					매칭된 구매요청 데이터가 없습니다.
				</div>
				<div v-else class="table-responsive" style="max-height: 400px; overflow-y: auto;">
					<table class="table table-sm table-bordered table-hover">
						<thead class="thead-light sticky-top">
							<tr>
								<th class="text-center" style="width: 100px;">진행현황</th>
								<th class="text-center" style="width: 80px;">수량</th>
								<th class="text-center" style="width: 120px;">요청일</th>
								<th class="text-center" style="width: 100px;">1688금액</th>
								<th class="text-center" style="width: 100px;">중국물류비</th>
								<th class="text-center" style="width: 100px;">한국물류비</th>
								<th class="text-center">상품명</th>
								<th class="text-center" style="width: 100px;">SKUID</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(req, idx) in reqpurchaseDetailList" :key="idx">
								<td class="text-center">
									<span :class="getProcessStatusBadgeClass(req.processStatus || req.진행현황)">
										{{ req.processStatus || req.진행현황 }}
									</span>
								</td>
								<td class="text-center font-weight-bold">{{ req.구매요청수량 }}개</td>
								<td class="text-center">{{ formatDate(req.요청일) }}</td>
								<td class="text-center">
									<span v-if="req.견적서_1688구매금액" class="text-success">
										₩{{ req.견적서_1688구매금액.최종금액?.toLocaleString() }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center">
									<span v-if="req.견적서_중국물류비" class="text-success">
										₩{{ req.견적서_중국물류비.총금액?.toLocaleString() }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center">
									<span v-if="req.견적서_한국물류비" class="text-success">
										₩{{ req.견적서_한국물류비.총금액?.toLocaleString() }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td>
									<small>{{ req.상품명 }}</small>
								</td>
								<td class="text-center">
									<small class="text-muted">{{ req.SKUID }}</small>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<style scoped>
.inventory-flow {
	background: #f8f9fa;
	padding: 20px;
	border-radius: 10px;
	border: 2px solid #e9ecef;
}

.flow-item {
	flex: 1;
	max-width: 120px;
}

.flow-box {
	padding: 10px;
	border-radius: 8px;
	min-height: 70px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.flow-arrow {
	font-size: 8px;
	color: #6c757d;
	margin: 0 1px;
	flex-shrink: 0;
}

.flow-box input {
	font-weight: bold !important;
	font-size: 14px !important;
}

.flow-box input:focus {
	box-shadow: 0 0 0 0.2rem rgba(255,255,255,0.5) !important;
}

.inventory-box {
	padding: 8px;
	border-radius: 6px;
	font-weight: bold;
	text-align: center;
	min-height: 35px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
}

.inventory-box:hover {
	transform: scale(1.05);
	box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.mini-flow-box {
	padding: 3px;
	border-radius: 3px;
	min-height: 35px;
	width: 65px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	flex-shrink: 0;
}

.mini-flow-box input {
	font-size: 11px !important;
	padding: 2px !important;
	height: 25px !important;
}

.scm-detail-modal .modal-dialog {
	max-width: 98vw !important;
	margin: 1vh auto !important;
}

.scm-detail-modal .modal-content {
	height: 98vh !important;
}

.scm-detail-modal .modal-body {
	max-height: 98vh !important;
	overflow-y: auto !important;
}

.inventory-modal-full .modal-dialog {
	max-width: 99vw !important;
	margin: 0.5vh auto !important;
}

.inventory-modal-full .modal-content {
	height: 98vh !important;
}

.inventory-modal-full .modal-body {
	max-height: 98vh !important;
	overflow-y: auto !important;
}

.summary-flow {
	width: 100%;
}

.summary-item {
	flex: 1;
	min-width: 60px;
}

.summary-label {
	font-size: 11px;
	font-weight: bold;
	color: #6c757d;
	margin-bottom: 2px;
}

.summary-value {
	font-size: 14px;
	font-weight: bold;
	color: #333;
}

/* 범례 스타일 */

.legend-item {
	display: flex;
	align-items: center;
}

.legend-box {
	width: 16px;
	height: 16px;
	border-radius: 3px;
	margin-right: 6px;
	display: inline-block;
}

.legend-box.bg-warning {
	color: #856404 !important;
}

.legend-box.bg-success {
	color: white !important;
}

.legend-box.bg-danger {
	color: white !important;
}

/* 클릭 가능한 종합 데이터 스타일 */
.clickable-summary {
	cursor: pointer;
	text-decoration: underline;
	transition: opacity 0.2s;
}

.clickable-summary:hover {
	opacity: 0.8;
}

/* 입고 수량 셀 스타일 */
.inbound-cell {
	cursor: help;
}

.inbound-cell:hover {
	opacity: 0.9;
}

/* 메모 관련 스타일 - 심플한 디자인 */
.memo-simple-container {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
}

.memo-simple-display {
	display: flex;
	align-items: center;
	gap: 4px;
}

.memo-simple-icon {
	font-size: 14px;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.memo-simple-icon:hover {
	opacity: 0.7;
}

.memo-simple-add {
	font-size: 12px;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.memo-simple-add:hover {
	opacity: 0.7;
}

.memo-simple-delete {
	font-size: 10px;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.memo-simple-delete:hover {
	opacity: 0.7;
}

/* 상품명 두 줄 표시 스타일 */
.product-name-multiline {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	line-height: 1.2;
	max-height: 2.4em; /* line-height * 2 */
	word-break: break-word;
}

/* 커서 포인터 스타일 */
.cursor-pointer {
	cursor: pointer;
}

/* 메모 추가 영역 스타일 */
.memo-add-area {
	cursor: pointer;
	padding: 5px;
	border-radius: 3px;
	transition: background-color 0.2s;
}

.memo-add-area:hover {
	background-color: #f8f9fa;
}

.memo-add-icon {
	font-size: 12px;
	opacity: 0.6;
}

.memo-add-area:hover .memo-add-icon {
	opacity: 1;
}

/* 개념도 스타일 */
.concept-diagram .card {
	border: 1px solid #e3e6f0;
	box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

/* SCM 개념도 이미지 스타일 */
.scm-concept-image {
	text-align: center;
	padding: 10px;
	background: #f8f9fa;
	border-radius: 6px;
}

.concept-diagram-img {
	max-width: 40%;
	height: auto;
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 재고 박스 세로 배치 스타일 */
.inventory-box-vertical {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 8px 4px;
	border-radius: 4px;
	min-height: 50px;
}

.stock-quantity {
	font-size: 14px;
	font-weight: bold;
	line-height: 1.2;
}

/* 재고 기간 텍스트 스타일 */
.stock-period-text {
	font-size: 11px;
	opacity: 0.8;
	margin-top: 2px;
	line-height: 1;
	font-weight: bold;
}

/* 전체가용재고기간 경고 스타일 (보라색) */
.total-stock-danger {
	background: #9f7bc0 !important;  /* 보라색 */
}

/* 쿠팡재고기간과 기타 경고 스타일 (빨간색) */
.stock-danger {
	background: #dc3545 !important;  /* 기본 빨간색 */
}

/* 쿠팡재고기간 60일 초과 경고 스타일 (주황색) */
.stock-warning {
	background: #fd7e14 !important;  /* 주황색 */
}

/* 구매/출고 관련 컬럼 배경색 */
.purchase-outbound-cell {
	background-color: #b4f0c6 !important;  /* 연한 회색 배경 */
	border-radius: 3px;
	padding: 4px 6px;
	margin: 1px;
	font-weight: bolder;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
	.scm-concept-image {
		padding: 5px;
	}

	.concept-diagram-img {
		max-width: 100%;
	}

	.inventory-box-vertical {
		min-height: 45px;
		padding: 6px 3px;
	}

	.stock-quantity {
		font-size: 12px;
	}

	.stock-period-text {
		font-size: 10px;
	}
}

/* 옵션명 자동 개행 스타일 */
.option-name-wrap {
	word-wrap: break-word;
	word-break: keep-all;        /* 단어 중간에서 줄바꿈 방지 */
	white-space: pre-wrap;       /* 띄어쓰기와 줄바꿈 보존 */
	line-height: 1.2;
	overflow-wrap: break-word;
	hyphens: none;               /* 하이픈 자동 추가 비활성화 */
}
.total-stock-danger {
	animation: pulse-total-stock-danger 2s infinite;
	cursor: help;
}
/* 재고 위험 상태 스타일 */
.stock-danger {
	animation: pulse-danger 2s infinite;
	cursor: help;
}

.stock-warning {
	animation: pulse-warning 2s infinite;
	cursor: help;
}

@keyframes pulse-warning {
	0% {
		box-shadow: 0 0 0 0 rgba(255, 189, 68, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
	}
}

@keyframes pulse-danger {
	0% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
	}
}

@keyframes pulse-total-stock-danger {
	0% {
		box-shadow: 0 0 0 0 rgba(220, 53, 184, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
	}
}

/* 전체 종합 플로우 간격 조정 */
.summary-flow {
	gap: 2px;
}

.summary-flow .summary-item {
	flex: 1;
	max-width: 61px;
	min-width: 61px;
}

.summary-flow .flow-arrow {
	font-size: 8px;
	color: #6c757d;
	margin: 0 1px;
}

/* 재고 플로우 input 필드 스타일 */
.mini-flow-box input.bg-primary::placeholder {
	color: rgba(255, 255, 255, 0.7) !important;
}

.mini-flow-box input.bg-info::placeholder {
	color: rgba(255, 255, 255, 0.7) !important;
}

.mini-flow-box input.bg-secondary::placeholder {
	color: rgba(255, 255, 255, 0.7) !important;
}

.mini-flow-box input:focus {
	box-shadow: none !important;
	outline: none !important;
}

/* 큰 모달들 (scm-detail-modal) 스타일 */
::v-deep .scm-detail-modal .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .scm-detail-modal .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .scm-detail-modal .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

::v-deep .scm-detail-modal .modal-header {
	padding: 0.5rem 1rem !important;
	flex-shrink: 0 !important;
}

::v-deep .scm-detail-modal .modal-footer {
	padding: 0.5rem 1rem !important;
	flex-shrink: 0 !important;
}

/* 메모 모달 (memo-modal) 스타일 - 적당한 크기 */
::v-deep .memo-modal .modal-dialog {
	max-width: 450px !important;
	width: 450px !important;
	height: auto !important;
	max-height: none !important;
	margin: 1.75rem auto !important;
}

::v-deep .memo-modal .modal-content {
	height: auto !important;
	display: block !important;
	flex-direction: initial !important;
	border: 1px solid rgba(0,0,0,.2) !important;
	border-radius: 0.3rem !important;
}

::v-deep .memo-modal .modal-body {
	flex: initial !important;
	overflow-y: initial !important;
	padding: 1rem !important;
	max-height: initial !important;
}

::v-deep .memo-modal .modal-header {
	padding: 1rem 1rem 0.5rem 1rem !important;
}

::v-deep .memo-modal .modal-footer {
	padding: 0.5rem 1rem 1rem 1rem !important;
}
</style>

<!-- 메모 모달 전용 전역 스타일 (더 강력한 우선순위) -->
<style>
/* 메모 모달 강제 스타일 */
.memo-modal .modal-dialog {
	max-width: 450px !important;
	width: 450px !important;
	height: auto !important;
	max-height: none !important;
	margin: 1.75rem auto !important;
}

.memo-modal .modal-content {
	height: auto !important;
	display: block !important;
	flex-direction: initial !important;
	border: 1px solid rgba(0,0,0,.2) !important;
	border-radius: 0.3rem !important;
}

.memo-modal .modal-body {
	flex: initial !important;
	overflow-y: initial !important;
	padding: 1rem !important;
	max-height: initial !important;
}

.memo-modal .modal-header {
	padding: 1rem 1rem 0.5rem 1rem !important;
	flex-shrink: initial !important;
}

.memo-modal .modal-footer {
	padding: 0.5rem 1rem 1rem 1rem !important;
	flex-shrink: initial !important;
}

/* ID 기반 더 강력한 선택자 */
#memoModal .modal-dialog {
	max-width: 450px !important;
	width: 450px !important;
	height: auto !important;
	max-height: none !important;
	margin: 1.75rem auto !important;
}

#memoModal .modal-content {
	height: auto !important;
	display: block !important;
	flex-direction: initial !important;
	border: 1px solid rgba(0,0,0,.2) !important;
	border-radius: 0.3rem !important;
}

#memoModal .modal-body {
	flex: initial !important;
	overflow-y: initial !important;
	padding: 1rem !important;
	max-height: initial !important;
}

/* 모달 관련 스타일 (v-deep 사용) - 최대 크기 */
::v-deep .scm-detail-modal .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .scm-detail-modal .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .scm-detail-modal .modal-header {
	padding: 0.5rem 1rem !important;
	border-bottom: 1px solid #dee2e6 !important;
	flex-shrink: 0 !important;
}

::v-deep .scm-detail-modal .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

::v-deep .scm-detail-modal .modal-footer {
	padding: 0.5rem 1rem !important;
	border-top: 1px solid #dee2e6 !important;
	flex-shrink: 0 !important;
}

/* 모든 xl 사이즈 모달에도 적용 */
::v-deep .modal-xl .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .modal-xl .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .modal-xl .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

/* 구매필요수량 모달 전용 스타일 (더 강력한 선택자) */
::v-deep .modal[id*="poQty"] .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .modal[id*="poQty"] .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .modal[id*="poQty"] .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

/* 모든 모달에 강제 적용 (최후 수단) */
::v-deep .modal .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
}

::v-deep .modal .modal-content {
	height: 96vh !important;
	display: flex !important;
	flex-direction: column !important;
}

::v-deep .modal .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	max-height: none !important;
}
</style>

<script>
import { lotStockValue } from '@/utils/lotCost';
import axios from 'axios';
import ApexChart from '../../../components/charts/ApexChart';
import * as XLSX from 'xlsx';
import CDataTable from "@/components/common/CDataTable";
import ScmInboundByCenter from '@/components/growth/ScmInboundByCenter.vue';
import reqVolatileMixin from '@/mixins/reqVolatileMixin'
import keepAliveViewMixin from '@/mixins/keepAliveViewMixin'
export default {
	// keep-alive :include는 컴포넌트 name으로 매칭한다.
	// 'salesstatus'는 다른 화면 14개가 같이 쓰고 있어서 고유 이름으로 바꿨다.
	name: 'GrowthScmV0',
	mixins: [reqVolatileMixin, keepAliveViewMixin],
	components: {
		ApexChart,
		CDataTable,
		ScmInboundByCenter
	},
	data() {
		return {
			// Toast 메시지 기반 수집 상태 관리
			todayCollectionNeeded: false, // Toast 메시지 표시 여부와 동일한 상태
			baseHeaders: [
				{ text: '\n\n상품\n이미지\n\n', value: '썸네일', align: 'center', width: 40, isSlot: true },
				{ text: '\n\n상품명\n노출ID\n\n', value: '판매상품명', align: 'center', width: 150, isSlot: true },
				{ text: '\n\n옵션명\n옵션ID\n\n', value: '옵션명', align: 'center', width: 120, isSlot: true },


				{ text: '\n월판매\n수량\n(목표)', value: '월판매수량', align: 'center', width: 50, isSlot: true },
				{ text: '\n7일판매\n수량\n(목표)', value: '7일판매수량', align: 'center', width: 60, isSlot: true },
				{ text: '\n판매\n트렌드', value: '판매변화', align: 'center', width: 100, isSlot: true },
				{ text: '\n일판매\n수량\n(목표)', value: '일판매수량', align: 'center', width: 50, isSlot: true },


				{ text: '\n구매완료\n재고\n(가용기간)', value: '구매', align: 'center', width: 80, isSlot: true },
				{ text: '\n배대지\n재고\n(가용기간)', value: '배대지', align: 'center', width: 80, isSlot: true },
				{ text: '\n해외\n입고중\n(가용기간)', value: '장기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '\n통관중\n재고\n(가용기간)', value: '통관중', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내\n재고\n(가용기간)', value: '국내재고', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내\n입고중\n(가용기간)', value: '단기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '\n쿠팡재고\n(가용기간)', value: '재고', align: 'center', width: 80, isSlot: true },
				{ text: '\n미확인\n재고\n(경과)', value: '미확인', align: 'center', width: 70, isSlot: true },
				{ text: '\n전체재고\n(가용기간)', value: '남은재고기간', align: 'center', width: 80, isSlot: true },

				{ text: '\n구매\n시점', value: 'dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n구매\n필요수량\n(요청수량)', value: '구매필요수량', align: 'center', width: 80, isSlot: true },
				{ text: '\n해외\n출고\n시점', value: '배대지출고Dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n해외출고\n필요수량\n(인입수량)', value: '배대지출고필요수량', align: 'center', width: 80, isSlot: true },
				{ text: '\n통관중\n출고\n시점', value: '통관중출고Dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n통관중출고\n필요수량\n(인입수량)', value: '통관중출고필요수량', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내\n출고\n시점', value: '국내출고Dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내출고\n필요수량\n(인입수량)', value: '국내출고필요수량', align: 'center', width: 80, isSlot: true },

				{ text: '설정', value: '설정', align: 'center', width: 50, isSlot: true },
				{ text: '메모', value: '메모', align: 'center', width: 50, isSlot: true },

				{ text: '최장\n입고\n재고\n기간', value: '최대입고기간', align: 'center', width: 50, isSlot: true },
				{ text: '보관료', value: '보관료', align: 'center', width: 80, isSlot: true },


			],
			scmData: {},  // vendorItemId를 키로 하는 SCM 데이터 객체
			inboundDates: [],  // 입고 날짜 목록
			originalSaleslistsOrder: [],  // 모달 초기 상태의 saleslists 순서
			tableSelectedItem: [],
			subheaderData: [],
			// 목표 일판매수량 관련
			targetSalesModal: {
				show: false,
				item: null,
				targetSales: 0
			},
			// 구매요청수량 관련
			purchaseRequestModal: {
				show: false,
				item: null,
				requestQuantity: 0,
				isProcessing: false
			},

			// 메모 관련
			currentMemo: '',
			currentItem: null,

			// 입출고이력 관련
			inventoryModalTab: 0,
			historySearch: '',
			historyStartDate: '',
			historyEndDate: '',
			historyLoading: false,
			historyList: [],
			historyHeaders: [
				{ text: '날짜', value: '날짜', align: 'center', width: 130, isSlot: true },
				{ text: '상품명', value: '상품명', align: 'left', width: 200, isSlot: false },
				{ text: '바코드', value: '바코드', align: 'center', width: 120, isSlot: false },
				{ text: '유형', value: '유형', align: 'center', width: 80, isSlot: true },
				{ text: '수량', value: '수량', align: 'center', width: 80, isSlot: false },
				{ text: '상태변화', value: '상태변화', align: 'center', width: 200, isSlot: true },
				{ text: '변경자', value: 'changedBy', align: 'center', width: 100, isSlot: false },
				{ text: '메모', value: 'memo', align: 'left', width: 200, isSlot: false },
			],

			// 설정 관련
			settingsHeaders: [
				{ text: '상품\n이미지', value: '썸네일', align: 'center', width: 60, isSlot: true },
				{ text: '상품명\n노출ID', value: '판매상품명', align: 'center', width: 150, isSlot: true },
				{ text: '옵션명\n옵션ID', value: '옵션명', align: 'center', width: 100, isSlot: true },
				{ text: '구매입고기간', value: '구매입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '배대지입고기간', value: '배대지입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '통관중입고기간', value: '통관중입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '국내입고기간', value: '국내입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '목표재고기간', value: '목표재고기간', align: 'center', width: 100, isSlot: true },
				{ text: '안전재고기간', value: '안전재고기간', align: 'center', width: 100, isSlot: true },
				{ text: 'MOQ수량', value: 'MOQ수량', align: 'center', width: 100, isSlot: true },
				{ text: '1박스\n인입수량', value: '박스인입수량', align: 'center', width: 100, isSlot: true },
				{ text: '타겟키워드', value: '타겟키워드', align: 'center', width: 150, isSlot: true },
				{ text: '메모', value: '메모', align: 'center', width: 150, isSlot: true }
			],
			reqHeaders: [
				{ text: '상품명', value: '상품명', align: 'left', width: 300, isSlot: true },
				{ text: '옵션명', value: '옵션명', align: 'left', width: 150 },
				{ text: '옵션ID', value: 'vendorItemId', align: 'center', width: 100 },
				{ text: '구매', value: '구매', align: 'center', width: 80 },
				{ text: '배대지', value: '배대지', align: 'center', width: 80 },
				{ text: '통관중', value: '통관중', align: 'center', width: 80 },
				{ text: '국내재고', value: '국내재고', align: 'center', width: 80 },
				{ text: '쿠팡재고', value: '재고', align: 'center', width: 80 },
				{ text: 'MOQ수량', value: 'MOQ수량', align: 'center', width: 80, isSlot: true },
				{ text: '구매요청수량', value: '구매요청수량', align: 'center', width: 120, isSlot: true },
				{ text: '예상재고량', value: '예상재고량', align: 'center', width: 100, isSlot: true },
				{ text: '예상재고일', value: '예상재고일', align: 'center', width: 100, isSlot: true }
			],
			reqTableSelectedItem: [],
			purchaseCart: [], // 구매요청 장바구니

			// 헤더 tooltip 정의
			headerTooltips: {
				'월판매수량': '어제부터 이전 30일간의 월 판매수량입니다 (목표 수량 포함) — 반품 차감 기준(취소·반품을 뺀 순판매)',
				'7일판매수량': '어제부터 이전 7일간의 판매수량입니다 (목표 수량 포함) — 반품 차감 기준(취소·반품을 뺀 순판매)',
				'판매변화': '전체 유효일 평균 대비 최근 7유효일 평균의 변화율입니다 (%) - 최근 판매 트렌드',
				'일판매수량': '판매가 있었던 유효일 기준 일평균 판매속도입니다. 최근 7일에 가중치를 둬 추세를 반영합니다 (목표 수량 포함) — 반품 차감 기준(취소·반품을 뺀 순판매)',
				'구매': '구매 완료된 재고 수량과 가용 기간입니다',
				'배대지': '배대지에 있는 재고 수량과 가용 기간입니다',
				'장기입고중': '해외에서 쿠팡으로 입고 중인 재고 수량과 가용 기간입니다',
				'통관중': '통관 중인 재고 수량과 가용 기간입니다',
				'국내재고': '국내 창고에 있는 재고 수량과 가용 기간입니다',
				'단기입고중': '국내에서 쿠팡으로 입고 중인 재고 수량과 가용 기간입니다',
				'재고': '쿠팡 창고에 있는 현재 재고 수량과 가용 기간입니다',
				'남은재고기간': '전체 재고를 합한 총 가용 기간입니다. 일판매수량(반품 차감 기준)으로 나눠 계산합니다',
				'미확인': '입고 − 판매 + 반품 재입고 − 반출·폐기 − 보상 확정 − 현재고. 「0~36」처럼 범위로 보이면 반품의 행방을 아직 몰라서입니다. 숫자를 누르면 흐름을 봅니다',
				'dday': '구매가 필요한 시점까지 남은 일수입니다',
				'구매필요수량': '안전재고 확보를 위해 구매해야 할 수량입니다',
				'배대지출고Dday': '배대지에서 출고해야 할 시점까지 남은 일수입니다',
				'배대지출고필요수량': '배대지에서 출고해야 할 수량입니다',
				'통관중출고Dday': '통관중 재고를 출고해야 할 시점까지 남은 일수입니다',
				'통관중출고필요수량': '통관중에서 출고해야 할 수량입니다',
				'국내출고Dday': '국내 재고를 출고해야 할 시점까지 남은 일수입니다',
				'국내출고필요수량': '국내에서 출고해야 할 수량입니다',
				'입고기간': '구매부터 쿠팡 입고까지 소요되는 기간(일)입니다',
				'배대지입고기간': '배대지부터 쿠팡 입고까지 소요되는 기간(일)입니다',
				'국내입고기간': '국내창고부터 쿠팡 입고까지 소요되는 기간(일)입니다',
				'최대재고기간': '쿠팡 창고 내에서 목표로 하는 재고 보유 기간(일)입니다',
				'최소재고기간': '쿠팡 창고 내에서 안전재고로 유지해야 할 최소 기간(일)입니다',
				'MOQ수량': '최소 주문 수량(Minimum Order Quantity)입니다',
				'최대입고기간': '남아있는 재고 중 가장 오래된 입고 재고의 보관 기간입니다',
				'보관료': '현재 재고에 대한 예상 보관료입니다',
				'타겟키워드': '상품의 주요 타겟 키워드입니다. 이 키워드의 네이버데이터랩 추이에 따라 판매량예측치가 달라집니다',
				'설정': '상품별 개별 설정을 관리합니다',
				'메모': '상품에 대한 메모를 작성할 수 있습니다'
			},
			profitTop10ChartOption: null,
			needPo: 0,
			needOverseasOutbound: 0,
			needDomesticOutbound: 0,
			needPriceAdjust: 0,
			salesAmount: 0,
			marginAmount: 0,
			monthlyCntOver0: 0,
			stockDangerCnt: 0,
			overStockCnt: 0,

			입고기간: "",
			최소재고기간: "",
			최대재고기간: "",
			MOQ수량: "",
			배대지입고기간: "",
			통관중입고기간: "",
			국내입고기간: "",
			// 설정 일괄변경용 변수들
			설정일괄변경: {
				입고기간: null,
				배대지입고기간: null,
				통관중입고기간: null,
				국내입고기간: null,
				최소재고기간: null,
				최대재고기간: null,
				MOQ수량: null
			},
			// 재고 일괄변경용 변수들
			재고일괄변경: {
				구매: null,
				배대지: null,
				통관중: null,
				국내재고: null
			},
			// 모달창 선택된 아이템들
			settingsSelectedItems: [],
			inventorySelectedItems: [],
			// 모달 필터링용 변수
			inventoryFilteredVendorItemId: null, // 재고관리 모달에서 특정 상품만 표시
			settingsFilteredVendorItemId: null, // 설정관리 모달에서 특정 상품만 표시
			// 모달 하이라이트용 변수
			highlightedVendorItemId: null, // 현재 하이라이트된 상품 ID

			reqlists: [],

			loadingtext: '',
			showspinner1: false,

			baseSettings: {
				safetyDays: 7,    // 안전재고일
				targetDays: 27,   // 목표재고일
				inputDays: 17,     // 기본입고기간
				maxOrderDays: 20,  // 최대주문일수 (targetDays - safetyDays)
				moqQuantity: 2,   // MOQ 기본 수량
				overseasInputDays: 10,  // 배대지입고기간 (배대지→국내)
				customsInputDays: 3,    // 통관중입고기간 (통관중→국내)
				domesticInputDays: 3    // 국내입고기간 (국내→쿠팡센터)
			},
			showReturnProducts: false,
			showBundleProducts: false,
			showStockPeriodFirst: false,
			showStockAmount: false,
			showDashboard: false,
			heatmapShowViews: false,
			trendMode: 'all',
			showSalesTrend: false,
			coupassSyncEnabled: false,
			// 쿠패스연동 확인 모달
			coupassSyncConfirmModal: {
				show: false
			},
			// 쿠패스연동 데이터
			coupassData: [],
			// Inventory 컬렉션 데이터 (바코드 → 수량 매핑)
			inventoryMap: {},
			// 재고 원장(InventoryBalance) 잔량. 바코드 → { CN, KR }.
			// 원장이 비어 있는 화주는 이 맵도 비어 있고, 그러면 지금까지 쓰던 값이 그대로 간다.
			ledgerBalanceMap: {},
			// Unipass 실측 입고중 수량. 바코드 → { 해외입고중, 국내입고중, 선적수 }.
			// 붙는 상품이 없으면 비어 있고, 그러면 예정일 추정이 그대로 쓰인다.
			measuredInboundMap: {},
			// 구매요청 상세 모달
			showReqpurchaseDetailModal: false,
			reqpurchaseDetailItem: null,
			reqpurchaseDetailList: [],
			salesChartReady: false,
			returnProducts: 0,
			hiddenProducts: 0,
			isShowingHidden: false,
			// 재고 대사 — 서버(/api/growth/getInventoryRecon)가 계산한 옵션별 미확인 재고
			reconSummary: null,
			reconByVid: {},
			reconDetailVid: null,
			reconCopyMsg: '',
			reconCopyFallback: '',
			reconShowFullHistory: false,
			selectedInboundData: null,
			inventoryMemos: {}, // 재고별 메모 저장
			showOrderModal: false,
			orderModalData: null,
			totalCnt: 0,

			showuploadspinner: false,
			uploadstatus: 'excel file upload',
			uploadstatus2: 'excel file upload',
			currentUploadType: '', // 'vendorItemId' 또는 'barcode'

			salesarr: [],
			importarr: [],
			stockarr: [],

			salescnt: 0,
			importcnt: 0,
			productqty: 0,
			needReturn: 0,


			title: "로켓그로스 공급관리(SCM)",
			desc1: "로켓그로스의 판매현황을 확인하고 수요에 맞는 공급관리(SCM)를 진행하세요",
			desc2: "입고기간 : 입고하는 데까지 걸리는 기간",
			desc3: "최소재고기간 : 최소한의 재고가 남아있어야 하는 기간, 최대재고기간 : 구매 시 필요한 재고기준 기간",
			desc4: "",
			link: { name: 'people.addusers' },
			linktext: "그로스 판매현황 수집",

			SKUID: '',
			showspinner: false,
			startdate: this.getTodaywith(),
			enddate: this.getTodaywith(),
			saleslists: [],
			saleslistsinit: [],
			showlist: false,

			// ✅ 사용자 지정 날짜 범위 수집용 변수들
			customStartDate: '',
			customEndDate: '',

			showChart: false,
			conversionChartOption: null,  // 추가
			maxCpcChartOption: null,      // 추가
			selectedPeriod: 30,
			dailyStats: [],
			revenueChartOption: {
				chart: {
					type: 'line',
					height: 350,
					animations: {
						enabled: false
					},
					toolbar: {
						show: false
					},
					background: 'transparent'
				},
				series: [{
					name: '매출',
					type: 'line',
					data: []
				}, {
					name: '수익',
					type: 'line',
					data: []
				}],
				stroke: {
					curve: 'smooth',
					width: [2, 2]
				},
				colors: ['#008FFB', '#00E396'],
				dataLabels: {
					enabled: false
				},
				grid: {
					show: true,
					borderColor: '#e0e0e0',
					strokeDashArray: 0,
					position: 'back'
				},
				xaxis: {
					type: 'category',
					categories: [],
					labels: {
						rotate: -45,
						rotateAlways: false,
						style: {
							fontSize: '12px'
						}
					},
					axisBorder: {
						show: true
					},
					axisTicks: {
						show: true
					}
				},
				yaxis: {
					labels: {
						formatter: (value) => `￦${this.formatNumber(value)}`,
						style: {
							fontSize: '12px'
						}
					}
				},
				tooltip: {
					enabled: true,
					shared: true,
					intersect: false,
					y: {
						formatter: (value) => `￦${this.formatNumber(value)}`
					}
				},
				legend: {
					position: 'top',
					horizontalAlign: 'right',
					floating: true,
					offsetY: -25,
					offsetX: -5
				}
			}
		}
	},
	computed: {
		// 재고 대사를 볼 수 있나 — 판단은 서버(보는 사람 = 로그인한 본인 기준, utils/reconAccess.js).
		// 계정을 전환해도 본인 권한을 따르도록 화면은 서버 답(요약을 받았는가)만 본다
		canSeeRecon() {
			return !!this.reconSummary;
		},
		// 「미확인만 보기」 뱃지 — 숨김 제외, 확인 안 된 재고가 있는 상품 수
		reconMissingCnt() {
			return this.reconExact.missingProductCount;
		},
		// 이 목록에 보이는 옵션(숨김 제외) — 90일 상품명 고를 때. 서버 요약 범위와 같은 기준
		reconScopeItems() {
			const seen = {};
			return this.visibleInit().filter(item => {
				if (item.hidden || !this.reconOf(item)) return false;
				const k = String(item.vendorItemId);
				if (seen[k]) return false;
				seen[k] = true;
				return true;
			});
		},
		// 90일 넘은 것 중 가장 많이 빈 상품 이름 — 요약 칸 보조줄
		reconOver90TopName() {
			let top = null;
			this.reconScopeItems.forEach(item => {
				const r = this.reconOf(item);
				const miss = this.reconExactMiss(r);
				if (!(miss > 0) || !(r.ageDays >= 90)) return;
				if (!top || miss > top.miss) top = { item, miss };
			});
			return top ? this.reconItemName(top.item) : '';
		},
		// 요약 칸 숫자 — 서버 summary.exact 를 그대로 쓴다(정확 모드 옵션만, 범위 = SCM 목록에 보이는 옵션).
		// 판매장부·다계정 현황도 같은 값을 쓴다
		reconExact() {
			const e = (this.reconSummary && this.reconSummary.exact) || {};
			const n = v => Number(v) || 0;
			return {
				count: n(e.count), preparingCount: n(e.preparingCount), excludedCount: n(e.excludedCount),
				miss: n(e.miss), amount: Math.round(n(e.amount)), missingProductCount: n(e.missingProductCount),
				over90: n(e.over90)
			};
		},
		reconPreparingTitle() {
			return '쿠팡 재고 이동 기록이 수집되면 자동으로 계산됩니다';
		},
		// ⓘ — 타일 본문에서 뺀 설명을 모아 둔다
		reconInfoTitle() {
			const s = this.reconSummary || {};
			const e = this.reconExact;
			const lines = ['입고 − 판매 + 반품 재입고 − 반출·폐기 − 보상 확정 − 현재고. 정확히 계산된 상품만 더했어요.'];
			if (e.excludedCount > 0) lines.push('입고 기록이 시작되기 전부터 있던 ' + e.excludedCount.toLocaleString() + '개 상품은 시작 재고를 몰라 계산에서 뺐어요.');
			if (e.preparingCount > 0) lines.push(e.preparingCount.toLocaleString() + '개 상품은 쿠팡 재고 이동 기록이 수집되면 자동으로 계산됩니다.');
			if (s.pendingSettleQty > 0) lines.push('정산 반영 전 판매 ' + Number(s.pendingSettleQty).toLocaleString() + '개 포함(일별 판매로 채움' + (s.pendingSettleEstimated ? ', 일부 추정' : '') + ').');
			if (s.unfilledSettleDays > 0) lines.push('최근 ' + Number(s.unfilledSettleDays).toLocaleString() + '일 판매 반영 전 — 그만큼 크게 보일 수 있어요. 판매현황을 수집하면 채워집니다.');
			return lines.join('\n');
		},
		// 펼친 옵션 — 이름·이력·막대
		reconDetail() {
			if (!this.reconDetailVid) return null;
			const r = this.reconByVid[this.reconDetailVid];
			if (!r) return null;
			const item = this.saleslistsinit.find(e => String(e.vendorItemId) === this.reconDetailVid) || {};
			const sold = (r.sold || 0) + (r.pendingSold || 0);
			const soldPct = r.inbound > 0 ? Math.max(0, Math.min(100, sold / r.inbound * 100)) : 0;
			const md = d => (d ? String(d).slice(5).replace('-', '/') : '');

			// 같은 날 같은 종류는 한 줄로 — 입고가 여러 건이면 줄이 너무 길어진다
			const rows = [];
			(r.history || []).forEach(h => {
				let text = '';
				if (h.kind === 'inbound') text = '입고 ' + h.qty.toLocaleString() + '개 진열';
				else if (h.kind === 'compensation') {
					text = '재고손실보상 확정' + (h.qty !== null && h.qty !== undefined ? ' ' + h.qty.toLocaleString() + '개' : '') +
						' · ' + Math.round(h.amount || 0).toLocaleString() + '원' + (h.type ? ' (' + h.type + ')' : '');
				} else text = (h.label || '재고 변동') + ' ' + Math.abs(h.qty || 0).toLocaleString() + '개';
				const last = rows[rows.length - 1];
				if (h.kind === 'inbound' && last && last.kind === 'inbound' && last.date === h.date) {
					last.qty += h.qty;
					last.text = '입고 ' + last.qty.toLocaleString() + '개 진열';
					return;
				}
				rows.push({ date: h.date, kind: h.kind, qty: h.qty, text, hl: false });
			});
			const full = rows.map(x => ({ date: md(x.date), text: x.text }));

			// 유형별 요약 — 몇 줄로 전체를 본다. 낱낱은 「전체 이력 보기」
			const hist = r.history || [];
			const summaryLines = [];
			const inb = hist.filter(h => h.kind === 'inbound');
			if (inb.length) {
				const sum = inb.reduce((a, h) => a + (h.qty || 0), 0);
				summaryLines.push('입고 ' + inb.length.toLocaleString() + '회 · 합계 ' + sum.toLocaleString() + '개 (' +
					md(inb[0].date) + ' ~ ' + md(inb[inb.length - 1].date) + ')');
			}
			const comps = hist.filter(h => h.kind === 'compensation');
			if (comps.length) {
				const amt = comps.reduce((a, h) => a + (h.amount || 0), 0);
				const known = comps.every(h => h.qty !== null && h.qty !== undefined);
				const qty = comps.reduce((a, h) => a + (h.qty || 0), 0);
				summaryLines.push('재고손실보상 ' + comps.length.toLocaleString() + '건 · ' + Math.round(amt).toLocaleString() + '원' +
					(known ? ' · ' + qty.toLocaleString() + '개' : ''));
			}
			const moveBy = {};
			hist.filter(h => h.kind === 'movement').forEach(h => {
				const k = h.label || '재고 변동';
				const m = moveBy[k] || (moveBy[k] = { n: 0, q: 0 });
				m.n++; m.q += Math.abs(h.qty || 0);
			});
			Object.keys(moveBy).forEach(k => summaryLines.push(k + ' ' + moveBy[k].n + '건 · ' + moveBy[k].q.toLocaleString() + '개'));

			const tail = [];
			if (this.reconExactMiss(r) > 0) {
				tail.push({
					date: '지금',
					text: '확인 안 된 재고 ' + this.reconExactMiss(r).toLocaleString() + '개' + (r.ageDays !== null ? ' · 마지막 입고 후 ' + r.ageDays + '일' : ''),
					hl: true
				});
				if (r.ageDays >= 90) tail.push({ date: '', text: '쿠팡확인요청 대상', hl: true });
			}
			return { vendorItemId: this.reconDetailVid, r, name: this.reconItemName(item), sold, soldPct, summaryLines, full, tail };
		},
		// 폭포 그래프 좌표 — 입고−판매 → 반품 재입고 → 반출·폐기 → 보상 확정 → 남아야 할 재고 → 실제 현재고 → 미확인
		reconWaterfall() {
			const width = 640, height = 260, top = 24, bottom = 196, gap = 26, bw = 58, x0 = 56;
			const d = this.reconDetail;
			if (!d) return { width, height, bottom, gap, ticks: [], bars: [] };
			const r = d.r;
			// 상세는 정확 모드 옵션만 열린다(openReconDetail) — 범위 표기는 없다
			const base = r.inbound - d.sold;
			const restockHi = r.restock || 0;
			// 누적 리포트의 재출고(D2)·처리중(G) — 서버 계산에 들어간 그대로 반출·폐기 칸에 함께 싣는다
			const other = (r.reshipped || 0) - (r.adjust || 0);
			const out = (r.outbound || 0) + (r.dispose || 0) + other;
			const comp = r.compensated || 0;
			const book = base + restockHi - out - comp;
			const miss = this.reconExactMiss(r);
			const f = n => Math.round(n).toLocaleString();
			const steps = [
				{ l1: '입고 − 판매', l2: f(r.inbound) + ' − ' + f(d.sold), from: 0, to: base, kind: 'sub', lab: f(base),
					l3: this.reconPendingSettle(r) > 0 ? '정산 전 ' + f(this.reconPendingSettle(r)) + (r.pendingSettleEstimated ? '(추정)' : '') + ' 포함' : '' },
				{ l1: '반품 재입고', l2: '', from: base, to: base + restockHi, kind: 'up', lab: '+' + f(restockHi) },
				{ l1: '반출·폐기', l2: other ? '처리중·재출고 포함' : '', from: base + restockHi, to: base + restockHi - out, kind: 'down',
					lab: out > 0 ? '−' + f(out) : out < 0 ? '+' + f(-out) : '0' },
				{ l1: '보상 확정', l2: '', from: base + restockHi - out, to: book, kind: 'down',
					lab: comp ? '−' + f(comp) : (r.flags && r.flags.compQtyUnknown ? '수량 모름' : '0') },
				{ l1: '남아야 할', l2: '재고', from: 0, to: book, kind: 'sub', lab: f(book) },
				{ l1: '실제', l2: '현재고', from: 0, to: r.stock, kind: 'tot', lab: f(r.stock) },
				{ l1: '확인 안 된', l2: '재고', from: r.stock, to: r.stock + miss, kind: 'miss',
					lab: f(miss) }
			];
			const vals = [0];
			steps.forEach(b => { vals.push(b.from, b.to) });
			const maxV = Math.max.apply(null, vals) || 1;
			const minV = Math.min.apply(null, vals);
			const span = (maxV - minV) || 1;
			const step = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000, 2000, 2500, 5000, 10000].find(s => span / s <= 5) || Math.ceil(span / 5);
			const axisMax = Math.ceil(maxV / step) * step;
			const axisMin = Math.floor(minV / step) * step;
			const y = v => bottom - (v - axisMin) / ((axisMax - axisMin) || 1) * (bottom - top);
			const ticks = [];
			for (let t = axisMin; t <= axisMax; t += step) ticks.push({ y: y(t), label: t.toLocaleString() });
			const bars = steps.map((b, i) => {
				const y1 = y(Math.max(b.from, b.to));
				const y2 = y(Math.min(b.from, b.to));
				return {
					x: x0 + i * (bw + gap), w: bw, y: y1, h: Math.max(y2 - y1, 2),
					kind: b.kind, lab: b.lab, l1: b.l1, l2: b.l2, l3: b.l3 || '',
					// 다음 막대로 이어지는 점선 — 실제 현재고 다음(미확인)은 따로 선다
					link: (i < steps.length - 1 && b.kind !== 'tot') ? y(b.to) : null
				};
			});
			return { width, height, bottom, gap, ticks, bars };
		},
		// 쿠패스(수강생 전용) 권한 — 쿠패스 구매대행요청 진입 게이팅용
		showCoupass() {
			return !!(this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.showCoupass);
		},
		// 오늘자 판매현황 수집 상태 (Toast 메시지 로직과 동일)
		todayCollectionStatus() {
			// 공통 함수를 사용해서 오늘 날짜 계산
			const today = this.getTodayString();

			// Toast 메시지 표시 여부와 반대로 수집 상태 결정
			const isCollected = !this.todayCollectionNeeded;

			return {
				isCollected: isCollected,
				buttonText: isCollected ? '판매현황 수집완료' : '판매현황 수집필요',
				tooltip: isCollected
					? `오늘(${today}) 판매현황이 수집되었습니다.`
					: `오늘(${today}) 판매현황을 수집해주세요!\n매일 루틴으로 수집이 필요합니다.`
			};
		},
		headers() {
			let headers = [...this.baseHeaders];
			// 미확인 열은 재고 대사를 볼 수 있는 사람에게만
			if (!this.canSeeRecon) headers = headers.filter(h => h.value !== '미확인');

			// 반품상품보기 또는 번들보기가 ON일 때 상품구분 컬럼 추가
			if (this.showReturnProducts || this.showBundleProducts) {
				console.log('상품구분 컬럼 추가됨 - showReturnProducts:', this.showReturnProducts, 'showBundleProducts:', this.showBundleProducts);
				headers.unshift({ text: '상품\n구분', value: '상품구분', align: 'center', width: 60, isSlot: true });
			} else {
				console.log('상품구분 컬럼 제외됨 - showReturnProducts:', this.showReturnProducts, 'showBundleProducts:', this.showBundleProducts);
			}

			// 재고금액보기가 ON일 때 재고 관련 컬럼들의 width 조정
			if (this.showStockAmount) {
				const stockColumns = ['구매', '배대지', '통관중', '장기입고중', '단기입고중', '국내재고', '재고', '남은재고기간'];
				headers = headers.map(header => {
					if (stockColumns.includes(header.value)) {
						return { ...header, width: Math.max(header.width || 60, 100) };
					}
					return header;
				});
			}
				// 판매트렌드 토글이 OFF이면 관련 컬럼 제거
				// 판매트렌드 토글이 ON이면 최근 7일 날짜 컬럼을 판매트렌드 앞에 추가
				if (this.showSalesTrend) {
					const trendIndex = headers.findIndex(header => header.value === '판매변화');
					if (trendIndex !== -1) {
						const recent7Headers = this.getRecent7DaysHeaders();
						headers.splice(trendIndex, 0, ...recent7Headers);
					}
				}

				if (!this.showSalesTrend) {
					const trendColumns = [
						'월판매수량',
						'7일판매수량',
						'판매변화',
						'recentDay6',
						'recentDay5',
						'recentDay4',
						'recentDay3',
						'recentDay2',
						'recentDay1',
						'recentDay0'
					];
					headers = headers.filter(header => !trendColumns.includes(header.value));
				}


			return headers;
		},
		inboundDateRange() {
			if (!this.selectedInboundData || !this.selectedInboundData.inbounds) {
				return [];
			}

			// 모든 날짜 수집
			const dates = this.selectedInboundData.inbounds
				.map(inbound => inbound.expectedDeliveryDate)
				.filter(date => date);

			if (dates.length === 0) return [];

			// 최소, 최대 날짜 찾기
			const minDate = new Date(Math.min(...dates.map(d => new Date(d))));
			const maxDate = new Date(Math.max(...dates.map(d => new Date(d))));

			// 날짜 범위 생성 (빈 날짜도 포함)
			const dateRange = [];
			const currentDate = new Date(minDate);

			while (currentDate <= maxDate) {
				dateRange.push(currentDate.toISOString().split('T')[0]);
				currentDate.setDate(currentDate.getDate() + 1);
			}

			return dateRange;
		},
		groupedInboundData() {
			if (!this.selectedInboundData || !this.selectedInboundData.inbounds) {
				return [];
			}

			// 쿠팡센터별로 그룹화
			const fcGroups = {};

			this.selectedInboundData.inbounds.forEach(inbound => {
				const fcName = inbound.fcName;
				const date = inbound.expectedDeliveryDate;

				if (!fcGroups[fcName]) {
					fcGroups[fcName] = {
						fcName: fcName,
						dateData: {}
					};
				}

				if (date) {
					fcGroups[fcName].dateData[date] = {
						requestedQuantity: inbound.requestedQuantity || 0,
						receivedQuantity: inbound.receivedQuantity || 0,
						stowedQuantity: inbound.stowedQuantity || 0,
						status: inbound.status
					};
				}
			});

			return Object.values(fcGroups);
		},
		inboundHeaders() {
			if (!this.inboundDateRange || this.inboundDateRange.length === 0) {
				return [];
			}

			const headers = [
				{ text: '쿠팡센터', value: '쿠팡센터', align: 'center', width: 100, isSlot: true },
				{ text: '구분', value: '구분', align: 'center', width: 120, isSlot: true }
			];

			// 날짜별 컬럼 추가
			this.inboundDateRange.forEach(date => {
				headers.push({
					text: this.formatDateShort(date),
					value: date,
					align: 'center',
					width: 80
				});
			});

			return headers;
		},
		inboundTableData() {
			if (!this.groupedInboundData || this.groupedInboundData.length === 0) {
				return [];
			}

			const tableData = [];
			let id = 1;

			this.groupedInboundData.forEach(fcGroup => {
				// 수량 행 (판매개시/입고요청 형태)
				const quantityRow = {
					id: id++,
					쿠팡센터: fcGroup.fcName,
					구분: '수량'
				};
				this.inboundDateRange.forEach(date => {
					const stowed = fcGroup.dateData[date]?.stowedQuantity || 0;
					const requested = fcGroup.dateData[date]?.requestedQuantity || 0;
					quantityRow[date] = requested > 0 ? `${stowed}/${requested}` : '-';
				});
				tableData.push(quantityRow);
			});

			return tableData;
		},
		// 전체 상품의 입고 날짜 (미리 수집된 데이터 사용)
		allInboundDates() {
			return this.inboundDates;
		},
		inventoryModalHeaders() {
			let baseHeaders = [
				{ text: '이미지', value: '썸네일', align: 'center', width: 80, isSlot: true },
				{ text: '상품명/옵션명', value: '판매상품명', align: 'left', width: 150, isSlot: true },
				{ text: '구매재고', value: '구매', align: 'center', width: 120, isSlot: true },
				{ text: '배대지재고', value: '배대지', align: 'center', width: 120, isSlot: true },
				{ text: '해외입고중', value: '장기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '통관중재고', value: '통관중', align: 'center', width: 120, isSlot: true },
				{ text: '국내재고', value: '국내재고', align: 'center', width: 120, isSlot: true },
				{ text: '국내입고중', value: '단기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '쿠팡재고', value: '재고', align: 'center', width: 80, isSlot: true },
				{ text: '메모', value: '메모', align: 'center', width: 60, isSlot: true }
			];

			// 재고금액보기가 ON일 때 재고 관련 컬럼들의 width 조정
			if (this.showStockAmount) {
				const stockColumns = ['구매', '배대지', '통관중', '장기입고중', '단기입고중', '국내재고', '재고'];
				baseHeaders = baseHeaders.map(header => {
					if (stockColumns.includes(header.value)) {
						return { ...header, width: Math.max(header.width || 80, 140) };
					}
					return header;
				});
			}

			// 날짜별 입고 컬럼 추가 (템플릿 슬롯 사용)
			const dateHeaders = this.allInboundDates.map(date => ({
				text: this.formatDateShort(date),
				value: `inbound_${date}`,
				align: 'center',
				width: 80,
				isSlot: true
			}));

			return [...baseHeaders, ...dateHeaders];
		},
		// 날짜별 데이터가 포함된 상품 목록
		enrichedSaleslists() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return [];
			}

			return this.saleslists.map(item => {
				const enrichedItem = { ...item };

				// 각 날짜별 입고 수량을 속성으로 추가
				this.allInboundDates.forEach(date => {
					const key = `inbound_${date}`;
					enrichedItem[key] = this.getInboundQuantityForDate(item, date);
				});

				return enrichedItem;
			});
		},
		// 종합 데이터가 포함된 상품 목록
		enrichedSaleslistsWithSummary() {
			const enrichedList = this.enrichedSaleslists;

			if (enrichedList.length === 0) {
				return [];
			}

			// 종합 데이터 생성
			const summaryItem = {
				vendorItemId: 'SUMMARY_ROW',
				썸네일: '',
				판매상품명: '전체 종합',
				옵션명: '',
				구매: this.totalSummary.구매,
				배대지: this.totalSummary.배대지,
				장기입고중: this.totalSummary.장기입고중,
				국내재고: this.totalSummary.국내재고,
				단기입고중: this.totalSummary.단기입고중,
				재고: this.totalSummary.재고,
				재고메모: '',
				isSummaryRow: true
			};

			// 날짜별 종합 데이터 추가
			this.allInboundDates.forEach(date => {
				const key = `inbound_${date}`;
				summaryItem[key] = this.getSummaryForDate(date);
			});

			// 종합 데이터를 맨 위에 추가
			return [summaryItem, ...enrichedList];
		},
		// 종합 데이터 없이 상품 목록만 반환
		enrichedSaleslistsWithoutSummary() {
			return this.enrichedSaleslists;
		},
		// 재고관리 모달용 필터링된 목록
		filteredInventoryList() {
			if (this.inventoryFilteredVendorItemId) {
				// 특정 상품만 필터링
				return this.enrichedSaleslistsWithoutSummary.filter(
					item => item.vendorItemId === this.inventoryFilteredVendorItemId
				);
			}
			// 전체 목록 반환
			return this.enrichedSaleslistsWithoutSummary;
		},
		// 설정관리 모달용 필터링된 목록
		filteredSettingsList() {
			if (this.settingsFilteredVendorItemId) {
				// 특정 상품만 필터링
				return this.saleslists.filter(
					item => item.vendorItemId === this.settingsFilteredVendorItemId
				);
			}
			// 전체 목록 반환
			return this.saleslists;
		},
		// 입출고이력 필터링
		historyFiltered() {
			if (!this.historySearch) return this.historyList;
			const q = this.historySearch.toLowerCase();
			return this.historyList.filter(e =>
				(e.상품명 || '').toLowerCase().includes(q) ||
				(e.바코드 || '').toLowerCase().includes(q)
			);
		},
		// 재고관리 모달의 subheader 데이터
		inventorySubheaderData() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return [];
			}

			const subheaderData = [];

			// 헤더 순서에 맞춰 subheader 데이터 생성
			this.inventoryModalHeaders.forEach(header => {
				switch (header.value) {
					case '썸네일':
						subheaderData.push({ text: '', isSlot: true });
						break;
					case '판매상품명':
						subheaderData.push({ text: '', isSlot: true });
						break;
					case '구매':
					case '배대지':
					case '장기입고중':
					case '통관중':
					case '국내재고':
					case '단기입고중':
					case '재고':
						subheaderData.push({ text: '', isSlot: true });
						break;
					case '메모':
						subheaderData.push({ text: '', isSlot: true });
						break;
					default:
						// 입고 날짜 컬럼들
						if (header.value.startsWith('inbound_')) {
							subheaderData.push({ text: '', isSlot: true });
						} else {
							subheaderData.push({ text: '' });
						}
						break;
				}
			});

			return subheaderData;
		},
		// 전체 재고 종합 데이터
		totalSummary() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return {
					구매: 0,
					배대지: 0,
					장기입고중: 0,
					통관중: 0,
					국내재고: 0,
					단기입고중: 0,
					재고: 0
				};
			}

			return this.saleslists.reduce((sum, item) => {
				sum.구매 += item.구매 || 0;
				sum.배대지 += item.배대지 || 0;
				sum.장기입고중 += item.장기입고중 || 0;
				sum.통관중 += item.통관중 || 0;
				sum.국내재고 += item.국내재고 || 0;
				sum.단기입고중 += item.단기입고중 || 0;
				sum.재고 += item.재고 || 0;
				return sum;
			}, {
				구매: 0,
				배대지: 0,
				장기입고중: 0,
				통관중: 0,
				국내재고: 0,
				단기입고중: 0,
				재고: 0
			});
		},
		orderHeaders() {
			return [
				{ text: '이미지', value: '썸네일', align: 'center', width: 80, isSlot: true },
				{ text: '상품명', value: '판매상품명', align: 'left', width: 250, isSlot: true },
				{ text: '옵션명', value: '옵션명', align: 'left', width: 200, isSlot: true },
				{ text: '노출ID', value: 'productId', align: 'center', width: 100 },
				{ text: '옵션ID', value: 'vendorItemId', align: 'center', width: 120 },
				{ text: '월판매수량', value: '월판매수량', align: 'center', width: 100 },
				{ text: '노출ID 순서', value: '노출ID순서', align: 'center', width: 120, isSlot: true },
				{ text: '옵션ID 순서', value: '옵션ID순서', align: 'center', width: 120, isSlot: true }
			];
		},
		productCount() {
			return this.saleslistsinit.length;
		},
		monthlyRevenue() {
			return this.dailyStats.reduce((sum, day) => sum + day.revenue, 0);
		},
		monthlyProfit() {
			return this.dailyStats.reduce((sum, day) => sum + day.profit, 0);
		},
		profitRate() {
			return this.monthlyRevenue ?
				((this.monthlyProfit / this.monthlyRevenue) * 100).toFixed(1) : 0;
		},
		bestRevenue() {
			return Math.max(...this.dailyStats.map(day => day.revenue));
		},
		bestProfit() {
			return Math.max(...this.dailyStats.map(day => day.profit));
		},
		bestRevenueDate() {
			const bestDay = this.dailyStats.find(day => day.revenue === this.bestRevenue);
			return bestDay ? this.formatDate(bestDay.date) : '-';
		},
		bestProfitDate() {
			const bestDay = this.dailyStats.find(day => day.profit === this.bestProfit);
			return bestDay ? this.formatDate(bestDay.date) : '-';
		},
		averageDailyRevenue() {
			return this.dailyStats.length ?
				this.monthlyRevenue / this.dailyStats.length : 0;
		},
		revenueChartOptionWithAnnotations() {
			if (!this.revenueChartOption) return null;

			return {
				...this.revenueChartOption,
				annotations: {
					xaxis: [{
						x: this.bestRevenueDate,
						borderColor: '#008FFB',
						label: {
							text: '최고 매출',
							style: {
								background: '#008FFB',
								color: '#fff'
							}
						}
					}, {
						x: this.bestProfitDate,
						borderColor: '#00E396',
						label: {
							text: '최고 수익',
							style: {
								background: '#00E396',
								color: '#fff'
							}
						}
					}]
				}
			};
		},
		// 대시보드 KPI 데이터
		dashboardKPI() {
			const result = { todaySales: 0, yesterdaySales: 0, salesChangeRate: 0, todayViews: 0, yesterdayViews: 0, viewsChangeRate: 0, avgConversion: 0, avg7daySales: 0, avg30daySales: 0 };
			if (!this.saleslists || this.saleslists.length === 0) return result;

			let todaySales = 0, yesterdaySales = 0, todayViews = 0, yesterdayViews = 0;
			let totalPv = 0, totalOrders = 0;
			let sum7 = 0, sum30 = 0;

			this.saleslists.forEach(item => {
				const sh = item.salesHistory || [];
				const pvh = item.pageViewHistory || [];
				const oh = item.orderHistory || [];
				const len = sh.length;
				if (len > 0) {
					todaySales += sh[len - 1] || 0;
					yesterdaySales += len > 1 ? (sh[len - 2] || 0) : 0;
					todayViews += pvh[len - 1] || 0;
					yesterdayViews += len > 1 ? (pvh[len - 2] || 0) : 0;
					totalPv += pvh[len - 1] || 0;
					totalOrders += oh[len - 1] || 0;
					for (let i = Math.max(0, len - 7); i < len; i++) sum7 += sh[i] || 0;
					for (let i = 0; i < len; i++) sum30 += sh[i] || 0;
				}
			});

			result.todaySales = todaySales;
			result.todayViews = todayViews;
			result.salesChangeRate = yesterdaySales > 0 ? ((todaySales - yesterdaySales) / yesterdaySales) * 100 : 0;
			result.viewsChangeRate = yesterdayViews > 0 ? ((todayViews - yesterdayViews) / yesterdayViews) * 100 : 0;
			result.avgConversion = totalPv > 0 ? (totalOrders / totalPv) * 100 : 0;
			result.avg7daySales = sum7 / 7;
			result.avg30daySales = sum30 / 30;
			return result;
		},
		// 판매량 기준 정렬된 상품 목록 (트렌드/히트맵 공용)
		dashboardSortedProducts() {
			if (!this.saleslists || this.saleslists.length === 0) return [];
			return [...this.saleslists]
				.filter(item => (item.salesHistory || []).some(v => v > 0))
				.sort((a, b) => (b.월판매수량 || 0) - (a.월판매수량 || 0));
		},
		// 대시보드 트렌드 차트 옵션
		dashboardTrendChartOption() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return { chart: { type: 'line', height: 250 }, series: [{ name: '판매량', data: [0] }], xaxis: { categories: [''] } };
			}

			const firstItem = this.saleslists.find(item => item.dates && item.dates.length > 0);
			const dates = firstItem ? firstItem.dates : [];
			const len = dates.length || 30;
			const categories = dates.length > 0
				? dates.map(d => { const parts = d.split('-'); return `${parseInt(parts[1])}/${parseInt(parts[2])}`; })
				: Array.from({ length: len }, (_, i) => `${i + 1}`);

			const mode = this.trendMode;
			let series = [];
			let colors = [];
			let strokeWidths = [];
			const palette = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8', '#FF6F00', '#2E93fA'];

			if (mode === 'all') {
				// 전체 합산
				const dailySales = new Array(len).fill(0);
				const dailyViews = new Array(len).fill(0);
				this.saleslists.forEach(item => {
					const sh = item.salesHistory || [];
					const pvh = item.pageViewHistory || [];
					for (let i = 0; i < len; i++) {
						dailySales[i] += sh[i] || 0;
						dailyViews[i] += pvh[i] || 0;
					}
				});
				series = [
					{ name: '전체 판매량', type: 'column', data: dailySales },
					{ name: '전체 조회수', type: 'line', data: dailyViews }
				];
				colors = ['#008FFB', '#00E396'];
				strokeWidths = [0, 2];
			} else {
				// Top N 개별 상품
				const topN = mode === 'top1' ? 1 : 5;
				const topItems = this.dashboardSortedProducts.slice(0, topN);

				topItems.forEach((item, idx) => {
					const label = (item.판매상품명 || '').substring(0, 12) + (item.옵션명 ? `(${(item.옵션명 || '').substring(0, 6)})` : '');
					const sh = item.salesHistory || [];
					const pvh = item.pageViewHistory || [];
					series.push({ name: `${label} 판매`, type: 'column', data: Array.from({ length: len }, (_, i) => sh[i] || 0) });
					series.push({ name: `${label} 조회`, type: 'line', data: Array.from({ length: len }, (_, i) => pvh[i] || 0) });
					colors.push(palette[idx % palette.length], palette[(idx + 5) % palette.length]);
					strokeWidths.push(0, 2);
				});
			}

			const yaxis = [
				{ title: { text: '판매량' }, labels: { formatter: v => Math.round(v).toLocaleString() } },
				{ opposite: true, title: { text: '조회수' }, labels: { formatter: v => Math.round(v).toLocaleString() } }
			];

			return {
				chart: { type: 'line', height: mode === 'all' ? 250 : 300, toolbar: { show: false }, animations: { enabled: false } },
				series,
				stroke: { width: strokeWidths, curve: 'smooth' },
				colors,
				fill: { opacity: strokeWidths.map(w => w === 0 ? 0.8 : 1) },
				xaxis: { categories, labels: { style: { fontSize: '10px' }, rotate: -45, rotateAlways: dates.length > 15 } },
				yaxis,
				dataLabels: { enabled: false },
				tooltip: { shared: true, intersect: false },
				legend: { position: 'top', fontSize: '11px' },
				grid: { borderColor: '#f1f1f1' }
			};
		},
		// 대시보드 히트맵 차트 옵션
		dashboardHeatmapOption() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return { chart: { type: 'heatmap', height: 200 }, series: [{ name: '-', data: [{ x: '-', y: 0 }] }], xaxis: { categories: [''] } };
			}

			const showViews = this.heatmapShowViews;
			const firstItem = this.saleslists.find(item => item.dates && item.dates.length > 0);
			const dates = firstItem ? firstItem.dates : [];
			const categories = dates.map(d => { const parts = d.split('-'); return `${parseInt(parts[1])}/${parseInt(parts[2])}`; });

			const sorted = [...this.saleslists]
				.filter(item => (item.salesHistory || []).some(v => v > 0) || (item.pageViewHistory || []).some(v => v > 0))
				.sort((a, b) => (b.월판매수량 || 0) - (a.월판매수량 || 0))
				.slice(0, 10);

			const series = sorted.map(item => {
				const history = showViews ? (item.pageViewHistory || []) : (item.salesHistory || []);
				const name = (item.판매상품명 || '').substring(0, 15) + (item.옵션명 ? `(${(item.옵션명 || '').substring(0, 8)})` : '');
				return {
					name,
					data: categories.map((cat, i) => ({ x: cat, y: history[i] || 0 }))
				};
			}).reverse();

			const allValues = series.flatMap(s => s.data.map(d => d.y));
			const maxVal = Math.max(...allValues, 1);
			const heatmapHeight = Math.max(200, sorted.length * 28 + 60);

			return {
				chart: { type: 'heatmap', height: heatmapHeight, toolbar: { show: false }, animations: { enabled: false } },
				series,
				dataLabels: { enabled: false },
				colors: [showViews ? '#00E396' : '#008FFB'],
				xaxis: { labels: { style: { fontSize: '10px' }, rotate: -45, rotateAlways: dates.length > 15 } },
				yaxis: { labels: { style: { fontSize: '10px' }, maxWidth: 150 } },
				plotOptions: {
					heatmap: {
						shadeIntensity: 0.5,
						colorScale: {
							ranges: [
								{ from: 0, to: 0, color: '#f5f5f5', name: '0' },
								{ from: 1, to: Math.ceil(maxVal * 0.25), color: showViews ? '#b2dfdb' : '#bbdefb', name: '하' },
								{ from: Math.ceil(maxVal * 0.25) + 1, to: Math.ceil(maxVal * 0.5), color: showViews ? '#4db6ac' : '#64b5f6', name: '중' },
								{ from: Math.ceil(maxVal * 0.5) + 1, to: Math.ceil(maxVal * 0.75), color: showViews ? '#00897b' : '#1e88e5', name: '상' },
								{ from: Math.ceil(maxVal * 0.75) + 1, to: maxVal, color: showViews ? '#004d40' : '#0d47a1', name: '최상' }
							]
						}
					}
				},
				tooltip: {
					y: { formatter: v => `${v.toLocaleString()}${showViews ? '회' : '개'}` }
				},
				legend: { show: false }
			};
		}
	},
	async mounted() {
		try {
			// 쿠패스연동 설정 불러오기
			this.loadCoupassSyncSetting();

			await this.search();
			this.applyDefaultSort();
			this.loadRecon().then(() => this.applyReconQuery());
		} catch (error) {
			console.error('mounted 훅 실행 중 오류:', error);
		}

		this.messageEventHandler = async (event) => {
			// 전체 수집 응답 처리
			if (event.data.msg && event.data.msg === 'growthSales') {
				if (event.data.res === 'success') {
					this.showlist = false;
					this.loadingtext = '수집 상품 저장 중 ...';

					const stockInfo = event.data.stockInfo.filter(e => e?.listingDetails?.skuGrade == 'NEW');
					const returnList = event.data.stockInfo.filter(e => e?.listingDetails && e?.listingDetails?.skuGrade !== 'NEW');
					if(this.$store.state.settings[0].isSaverPack == undefined || this.$store.state.settings[0].isSaverPack != event.data.isSaverPack){
						this.saveSaverPackStatus(event.data.isSaverPack);
					}
					if (stockInfo.length > 0) {
						// ✅ 번들/반품 상품을 포함한 모든 상품의 일별 데이터 저장
						const allProductsForDailyData = [...stockInfo, ...returnList];

						// 번들 상품들도 일별 데이터에 저장하기 위해 추출
						stockInfo.forEach(item => {
							if (item.upBundlingProducts?.length > 0) {
								allProductsForDailyData.push(...item.upBundlingProducts);
							}
						});

						await this.convertAndSaveDailySalesData(allProductsForDailyData);

						// ✅ 기본 상품 정보만 저장 (trafficInfo 제거)
						const sales = [];
						for (const e of stockInfo) {
							const existingItem = this.$store.state.growthSales.find(item => item.vendorItemId === e.vendorItemId);

							// 설정값 초기화 (기존 값 또는 기본값)
							const 입고기간 = existingItem?.입고기간 ? parseInt(existingItem.입고기간) : this.baseSettings.inputDays;
							const 최대재고기간 = existingItem?.최대재고기간 ? parseInt(existingItem.최대재고기간) : this.baseSettings.targetDays;
							const 최소재고기간 = existingItem?.최소재고기간 ? parseInt(existingItem.최소재고기간) : this.baseSettings.safetyDays;
							const MOQ수량 = existingItem?.MOQ수량 !== undefined ? parseInt(existingItem.MOQ수량) : this.baseSettings.moqQuantity;
							e.MOQ수량 = MOQ수량; // 값을 직접 할당

							// ✅ 기본 재고 정보
							const 입고중 = e.inventoryDetails?.inProgressInboundStatistics?.inProgressInboundQuantity || 0;

							// ✅ 반품 상품 연결 (구성 정보만)
							const returnProducts = returnList
							.filter(a => e.skuName && e.skuName.split(' ').every(word => a.skuName && a.skuName.includes(word)))
							.sort((a, b) => b.salePrice - a.salePrice).map(returnItem => ({
								vendorItemId: returnItem.vendorItemId,
								판매상품명: returnItem.listingDetails.vendorInventoryName,
								옵션명: returnItem.listingDetails.vendorInventoryItemName,
								productId: returnItem.listingDetails.productId,
								썸네일: "http://image1.coupangcdn.com/image/" + returnItem.listingDetails.mainImagePath,
								salePrice: returnItem.salePrice,
								skuGrade: returnItem.listingDetails.skuGrade,
								orderableQuantity: returnItem.orderableQuantity || 0,
								inventoryDetails: returnItem.inventoryDetails,
								inboundInfo: returnItem.inboundInfo
							}));

							// ✅ 번들 상품 연결 (구성 정보만)
							const upBundlingProducts = (e.upBundlingProducts || []).map(bundleItem => ({
								vendorItemId: bundleItem.vendorItemId,
								upBundlingSize: bundleItem.upBundlingSize,
								판매상품명: bundleItem.listingDetails?.vendorInventoryName || '',
								옵션명: bundleItem.listingDetails?.vendorInventoryItemName || '',
								productId: bundleItem.listingDetails?.productId || '',
								썸네일: bundleItem.listingDetails?.mainImagePath ?
									"http://image1.coupangcdn.com/image/" + bundleItem.listingDetails.mainImagePath : '',
								salePrice: bundleItem.salePrice || 0
							}));

							// ✅ 기본 상품 정보만 저장 (히스토리 데이터 제거)
							sales.push({
								썸네일: "http://image1.coupangcdn.com/image/" + e.listingDetails.mainImagePath,
								판매상품명: e.listingDetails.vendorInventoryName,
								옵션명: e.listingDetails.vendorInventoryItemName,
								productId: e.listingDetails.productId,
								vendorItemId: e.vendorItemId,
								재고: e.orderableQuantity,
								입고중,
								updateDate: e.updateDate,
								inventoryDetails: e.inventoryDetails,
								inboundInfo: e.inboundInfo,
								returnProducts,
								upBundlingProducts,
								skuGrade: 'NEW',
								입고기간,
								최대재고기간,
								최소재고기간,
								MOQ수량
							});
						}

						try {
							// ✅ 기본 상품 정보 저장 (SCM용)
							const result = await axios.post('/api/updateGrowthSalesV2', sales);
							if (result.data.res === 'success') {
								this.$store.commit('growthSalesUpdate', sales);

								// 수집 완료 후 버튼 상태 업데이트
								this.todayCollectionNeeded = false;

								// ✅ 일별 데이터에서 salesHistory 생성 후 표시
								await this.buildSalesDataFromDailySales(sales);
								this.search();
							} else {
								alert(result.data.alert);
								this.showspinner1 = false;
								this.showlist = true;
							}
						} catch (err) {
							alert(err);
							this.showspinner1 = false;
							this.showlist = true;
						}
					} else {
						alert('업데이트할 내역이 없습니다.');
						this.showspinner1 = false;
						this.showlist = true;
					}
				} else {
					alert(event.data.res);
					this.showspinner1 = false;
					this.showlist = true;
				}
			}
			// 진행 신호가 오는 동안은 수집이 살아있다는 뜻 — 타임아웃 타이머를 다시 건다.
			// (안 걸면 15분 넘는 수집에서 진행 표시가 중간에 멈춘다)
			if (event.data.res === 'growthdbratio' || event.data.type === 'autoCollectStatus') {
				this.touchOwnCollect();
			}
			if (this.ownCollectRunning && event.data.res && event.data.res === 'growthdbratio') {
				if (event.data.ratio == 0) {
					this.loadingtext = event.data.text;
				} else {
					this.loadingtext = event.data.text + event.data.ratio.toFixed(0) + '%';
				}
			}
			// [수집로직 일원화] 수집 완료 시 데이터 재조회
			if (event.data.type === 'manualCollectComplete' && event.data.itemKey === 'rocketGrowthSales') {
				this.endOwnCollection();
				this.showspinner1 = false;
				this.showlist = true;
				if (event.data.success === false) {
					alert(event.data.error || '판매현황 수집에 실패했습니다.');
					return;
				}
				this.todayCollectionNeeded = false;
				this.$store.commit('growthSalesUpdate', []);
				this.search();
			}
			// [수집로직 일원화] 진행 상태 표시
			// 진행 메시지는 itemKey 가 없다 — 내가 건 수집일 때만 반영한다
			if (this.ownCollectRunning && event.data.type === 'autoCollectStatus') {
				this.loadingtext = event.data.message;
			}
		};
		// 리스너 부착/해제는 keepAliveViewMixin이 담당한다 (보이는 동안에만 듣기)
		this.bindExtensionMessages();
	},
	watch: {
		// 다른 화면(요약장부·다계정 현황)에서 미확인 필터를 걸고 들어왔을 때 — 탭이 살아 있어도 따라간다
		'$route.query.recon'(v) {
			if (!v) return;
			if (this.reconSummary) this.applyReconQuery();
			else this.loadRecon().then(() => this.applyReconQuery());
		},
		// "반품상품보기" 는 이제 목록 행 수까지 바꾼다. 토글만 바꿨을 때 화면이 안 따라오면
		// 카운트와 어긋나므로 전체 뷰로 되돌린다.
		showReturnProducts() {
			if (!this.showlist || this.isShowingHidden) return;
			this.showtotal();
			this.updateCounts();
		}
	},
	methods: {
		// 쿠패스연동 스위치 클릭 처리
		async handleCoupassSyncClick(event) {
			// 기본 동작 방지 (체크 상태 변경 방지)
			event.preventDefault();

			if (!this.coupassSyncEnabled) {
				// OFF → ON으로 변경하려는 경우 확인 모달 표시
				this.coupassSyncConfirmModal.show = true;
			} else {
				// ON → OFF로 변경하는 경우 바로 적용
				try {
					// 서버에 설정 저장
					await this.saveCoupassSyncSetting(false);

					// 저장 성공 후 상태 변경
					this.coupassSyncEnabled = false;

					// Vue의 반응성을 위해 강제 업데이트
					this.$forceUpdate();

					this.$bvToast.toast('쿠패스연동이 비활성화되었습니다.', {
						title: '쿠패스연동',
						variant: 'info',
						solid: true,
						autoHideDelay: 2000
					});
				} catch (error) {
					console.error('쿠패스연동 설정 저장 오류:', error);
					// 실패 시 상태는 그대로 유지 (ON 상태)
					this.$bvToast.toast('설정 저장에 실패했습니다.', {
						title: '쿠패스연동 오류',
						variant: 'danger',
						solid: true,
						autoHideDelay: 3000
					});
				}
			}
		},

		// 쿠패스연동 확인
		async confirmCoupassSync() {
			try {
				this.coupassSyncConfirmModal.show = false;

				// 서버에 설정 저장
				await this.saveCoupassSyncSetting(true);

				// 저장 성공 후 상태 변경
				this.coupassSyncEnabled = true;

				// Vue의 반응성을 위해 강제 업데이트
				this.$forceUpdate();

				this.$bvToast.toast('쿠패스연동이 활성화되었습니다. 재고 정보가 자동으로 업데이트됩니다.', {
					title: '쿠패스연동',
					variant: 'success',
					solid: true,
					autoHideDelay: 3000
				});

				// 쿠패스연동 데이터로 재고 업데이트
				await this.search();
			} catch (error) {
				console.error('쿠패스연동 설정 저장 오류:', error);
				// 실패 시 상태는 그대로 유지 (OFF 상태)
				this.$bvToast.toast('설정 저장에 실패했습니다.', {
					title: '쿠패스연동 오류',
					variant: 'danger',
					solid: true,
					autoHideDelay: 3000
				});
			}
		},

		// 쿠패스연동 취소
		cancelCoupassSync() {
			this.coupassSyncConfirmModal.show = false;
			// 스위치 상태를 원래대로 유지 (OFF)
		},

		// 쿠패스연동 설정 불러오기
		loadCoupassSyncSetting() {
			try {
				// store에서 settings 정보 가져오기
				const settings = this.$store.state.settings;
				if (settings && settings.length > 0) {
					// coupassSyncEnabled 설정이 있으면 사용, 없으면 기본값 false
					this.coupassSyncEnabled = settings[0].coupassSyncEnabled || false;
					console.log('쿠패스연동 설정 로드됨:', this.coupassSyncEnabled);
				} else {
					this.coupassSyncEnabled = false;
					console.log('설정 정보가 없어 쿠패스연동 기본값(false) 적용');
				}
			} catch (error) {
				console.error('쿠패스연동 설정 로드 오류:', error);
				this.coupassSyncEnabled = false;
			}
		},
		async savesetting(object){
			try{
				if(object._id){
					delete object._id
				}
				var result = await axios.post('/api/savesetting',object)
				return result
			}catch(e){
				return e
			}
        },
		async saveSaverPackStatus(status){
			this.$store.state.settings[0].isSaverPack = status
			// 바꾼 칸 하나만 보낸다 — 통째로 보내면 서버 흰 목록(SAVESETTING_FIELDS)이 400
			const result = await this.savesetting({ isSaverPack: status })
			if (!(result && result.data && result.data.success)) {
				const msg = (result && result.response && result.response.data && result.response.data.message) || '세이버팩 상태를 저장하지 못했어요 — 화면을 새로고침한 뒤 다시 해 주세요.'
				console.error('세이버팩 상태 저장 실패:', msg)
				this.$bvToast.toast(msg, { title: '설정 저장', variant: 'danger', solid: true })
			}
		},
		async saveCoupassSyncSetting(enabled) {
			try {
				const response = await this.savesetting({
					coupassSyncEnabled: enabled
				})
				if (response.data.success) {
					// store의 settings도 업데이트
					if (this.$store.state.settings && this.$store.state.settings.length > 0) {
						this.$store.state.settings[0].coupassSyncEnabled = enabled;
					}
					console.log('쿠패스연동 설정 저장 완료:', enabled);
				} else {
					throw new Error(response.data.message || '설정 저장 실패');
				}
			} catch (error) {
				console.error('쿠패스연동 설정 저장 오류:', error);
				throw error;
			}
		},

		// 쿠패스연동 실행 (실제 연동 로직)
		async syncWithCoupass() {
			try {
				// TODO: 실제 쿠패스 API 연동 로직 구현
				console.log('쿠패스연동 시작...');

				// 예시: 구매완료재고, 배대지재고, 통관중재고 업데이트
				// await this.updateInventoryFromCoupass();

			} catch (error) {
				console.error('쿠패스연동 오류:', error);
				this.$bvToast.toast('쿠패스연동 중 오류가 발생했습니다.', {
					title: '쿠패스연동 오류',
					variant: 'danger',
					solid: true,
					autoHideDelay: 3000
				});
			}
		},

		// Phase B: 쿠팡 입고 데이터 기반 자동 상태 업데이트
		async autoUpdateReqpurchaseStatus() {
			try {
				console.log('=== autoUpdateReqpurchaseStatus 시작 ===');

				if (!this.saleslists || this.saleslists.length === 0) {
					console.log('saleslists가 비어있어 스킵');
					return;
				}

				const updates = [];
				const 현재날짜 = new Date();

				for (const item of this.saleslists) {
					if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
						continue;
					}

					const growthItem = this.$store.state.growthdb.find(g => g.vendorItemId === item.vendorItemId);
					if (!growthItem || !growthItem.barcode) continue;

					const barcode = growthItem.barcode;
					const inbounds = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds;
					const 국내입고기간 = parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays;

					let totalStowed = 0;
					let totalRequested = 0;
					let has장기 = false;
					let has단기 = false;

					inbounds.forEach(inbound => {
						totalStowed += inbound.stowedQuantity || 0;
						totalRequested += inbound.requestedQuantity || 0;

						// classifyInboundInventory() 로직 적용: 입고예정일 기준 분류
						const 입고처리중수량 = (inbound.receivedQuantity || 0) - (inbound.stowedQuantity || 0);
						const 도착대기중수량 = inbound.inProgressQuantity || 0;
						const 실제입고중수량 = Math.max(입고처리중수량, 도착대기중수량);

						if (실제입고중수량 > 0 && inbound.expectedDeliveryDate) {
							const 입고예정일 = new Date(inbound.expectedDeliveryDate);
							const 남은일수 = Math.ceil((입고예정일 - 현재날짜) / (1000 * 60 * 60 * 24));
							if (남은일수 <= 국내입고기간) {
								has단기 = true;
							} else {
								has장기 = true;
							}
						} else if (실제입고중수량 > 0) {
							has단기 = true; // 입고예정일 없으면 단기로 간주
						}
					});

					let toStatus = null;
					let memo = '';

					if (totalStowed > 0 && totalStowed === totalRequested && totalRequested > 0) {
						toStatus = '쿠팡센터입고완료';
						memo = `growthScm 자동수집 - 입고완료 (${totalStowed}/${totalRequested})`;
					} else if (has장기) {
						// 장기 inbound가 하나라도 있으면 해외입고중
						toStatus = '해외입고중';
						memo = `growthScm 자동수집 - 해외입고중 (${totalStowed}/${totalRequested}, 국내입고기간=${국내입고기간}일)`;
					} else if (has단기) {
						toStatus = '국내입고중';
						memo = `growthScm 자동수집 - 국내입고중 (${totalStowed}/${totalRequested}, 국내입고기간=${국내입고기간}일)`;
					}

					if (toStatus) {
						updates.push({ barcode, toStatus, memo });
						console.log(`상태 업데이트 대상: ${barcode} → ${toStatus}`);
					}
				}

				if (updates.length === 0) {
					console.log('업데이트할 입고 데이터 없음');
					return;
				}

				console.log(`${updates.length}개 바코드 상태 업데이트 요청`);

				const response = await axios.post('/api/reqpurchase/autoUpdateFromInbound', {
					companyid: this.$store.state.user.companyid,
					updates: updates
				});

				if (response.data.요청결과 === '성공') {
					console.log(`자동 상태 업데이트 완료: 성공=${response.data.successCount}, 스킵=${response.data.skipCount}`);

					if (response.data.successCount > 0) {
						this.$bvToast.toast(`${response.data.successCount}건의 구매요청 상태가 자동으로 업데이트되었습니다.`, {
							title: '입고 상태 자동 업데이트',
							variant: 'success',
							solid: true,
							autoHideDelay: 3000
						});
					}
				}
			} catch (error) {
				console.error('autoUpdateReqpurchaseStatus 오류:', error);
			}
		},

		// 기존 trafficInfo와 신규 trafficInfo 병합
		mergeTrafficInfo(existingTrafficInfo, newTrafficInfo) {
			const merged = JSON.parse(JSON.stringify(existingTrafficInfo)); // 깊은 복사

			// 병합할 배열 목록
			const arrayNames = ['saleSummaryByDate', 'trafficSummaryByDate', 'conversionSummaryByDate', 'adSummaryByDate'];

			arrayNames.forEach(arrayName => {
				if (newTrafficInfo[arrayName] && Array.isArray(newTrafficInfo[arrayName])) {
					// 기존 배열이 없으면 새로 생성
					if (!merged[arrayName]) {
						merged[arrayName] = [];
					}

					// 신규 데이터의 각 날짜별 데이터를 처리
					newTrafficInfo[arrayName].forEach(newData => {
						const existingDataIndex = merged[arrayName].findIndex(d => d.date === newData.date);

						if (existingDataIndex >= 0) {
							// 기존 날짜 데이터가 있으면 업데이트 (신규 데이터로 덮어쓰기)
							merged[arrayName][existingDataIndex] = { ...newData };
						} else {
							// 새로운 날짜 데이터면 추가
							merged[arrayName].push({ ...newData });
						}
					});

					// 날짜순으로 정렬
					merged[arrayName].sort((a, b) => new Date(a.date) - new Date(b.date));
				}
			});

			// 기타 trafficInfo 속성들도 업데이트
			Object.keys(newTrafficInfo).forEach(key => {
				if (!arrayNames.includes(key)) {
					merged[key] = newTrafficInfo[key];
				}
			});

			return merged;
		},
		// 30일 완전한 trafficInfo 보장
		ensureComplete30DaysTrafficInfo(trafficInfo) {
			if (!trafficInfo) return null;

			// 최근 30일 날짜 배열 생성
			const today = new Date();
			const dates = [];
			for (let i = 29; i >= 0; i--) {
				const date = new Date(today);
				date.setDate(today.getDate() - i);
				dates.push(date.toISOString().split('T')[0]);
			}

			const arrayNames = ['saleSummaryByDate', 'trafficSummaryByDate', 'conversionSummaryByDate', 'adSummaryByDate'];

			arrayNames.forEach(arrayName => {
				if (!trafficInfo[arrayName]) {
					trafficInfo[arrayName] = [];
				}

				// 각 날짜에 대해 데이터가 없으면 기본값으로 채우기
				dates.forEach(date => {
					const existingData = trafficInfo[arrayName].find(d => d.date === date);
					if (!existingData) {
						// 배열별 기본 구조
						let defaultData = { date: date };

						if (arrayName === 'saleSummaryByDate') {
							defaultData = { ...defaultData, saleCount: 0, salePrice: 0 };
						} else if (arrayName === 'trafficSummaryByDate') {
							defaultData = { ...defaultData, clickCount: 0, impressionCount: 0, viewCount: 0 };
						} else if (arrayName === 'conversionSummaryByDate') {
							defaultData = { ...defaultData, conversionRate: 0, clickRate: 0 };
						}
						// adSummaryByDate 는 다른 배열과 달리 {date, 광고영역명: {지표들}} 모양이다.
						// 여기에 adCost/adSales/adClicks 같은 지표 키를 넣으면 saveAdData 가 date 아닌 키를
						// 전부 광고영역(adType)으로 승격시켜 adType 이 "adCost" 인 빈 문서가 쌓인다.
						// 광고가 없는 날은 날짜만 채운다.

						trafficInfo[arrayName].push(defaultData);
					}
				});

				// 날짜순으로 정렬
				trafficInfo[arrayName].sort((a, b) => new Date(a.date) - new Date(b.date));
			});

			return trafficInfo;
		},
		// 기존 일별판매데이터 조회
		async getExistingDailySalesData(vendorItemIds) {
			try {
				// 공통 함수를 사용해서 어제 기준 30일 날짜 범위 계산
				const todayStr = this.getTodayString();
				const dates = this.generateDatesFromUpdateDate(todayStr);

				const startDateStr = dates[0];
				const endDateStr = dates[dates.length - 1];

				console.log(`getExistingDailySalesData: 어제 기준 30일 범위 ${startDateStr} ~ ${endDateStr}`);

				// 기존 getSalesLedger API 활용
				const response = await axios.post('/api/growth/getSalesLedger', {
					startDate: startDateStr,
					endDate: endDateStr
				});

				if (response.data.res === 'success') {
					const dailySalesMap = new Map();

					// vendorItemId별로 일별 데이터 그룹화
					response.data.dailySalesData
						.filter(data => vendorItemIds.includes(data.vendorItemId))
						.forEach(dailyData => {
							if (!dailySalesMap.has(dailyData.vendorItemId)) {
								dailySalesMap.set(dailyData.vendorItemId, []);
							}
							dailySalesMap.get(dailyData.vendorItemId).push(dailyData);
						});

					return dailySalesMap;
				}
				return new Map();
			} catch (error) {
				console.error('기존 일별판매데이터 조회 중 오류:', error);
				return new Map();
			}
		},
		// 일별 판매 데이터 저장
		async saveDailySalesData(stockInfo) {
			try {
				const dailySalesData = [];
				const today = new Date().toISOString().split('T')[0];

				for (const item of stockInfo) {
					if (!item.trafficInfo) continue;

					// saleSummaryByDate에서 일별 판매 데이터 추출
					if (item.trafficInfo.saleSummaryByDate) {
						for (const saleData of item.trafficInfo.saleSummaryByDate) {
							// trafficSummaryByDate에서 해당 날짜의 트래픽 데이터 찾기
							const trafficData = item.trafficInfo.trafficSummaryByDate?.find(t => t.date === saleData.date);
							// conversionSummaryByDate에서 해당 날짜의 전환 데이터 찾기
							const conversionData = item.trafficInfo.conversionSummaryByDate?.find(c => c.date === saleData.date);

							// 광고 데이터 합계 계산
							const adSummary = this.calculateAdSummaryForDate(item.trafficInfo.adSummaryByDate, saleData.date);

							dailySalesData.push({
								vendorItemId: item.vendorItemId,
								date: saleData.date,
								updateDate: today,
								sales: {
									unitsSold: saleData.unitsSold || 0,
									gmv: saleData.gmv || 0,
									registrationType: saleData.registrationType || 'RFM'
								},
								traffic: {
									pageViews: trafficData?.pageViews || 0,
									uniqueVisitor: trafficData?.uniqueVisitor || 0,
									addToCart: conversionData?.addToCart || 0,
									orders: conversionData?.orders || 0,
									pvToOrder: conversionData?.pvToOrder || 0
								},
								adSummary: adSummary
							});
						}
					}
				}

				if (dailySalesData.length > 0) {
					const result = await axios.post('/api/growth/saveDailySales', dailySalesData);
					if (result.data.res === 'success') {
						console.log('일별 판매 데이터 저장 완료:', result.data);
					} else {
						console.error('일별 판매 데이터 저장 실패:', result.data);
					}
				}
			} catch (error) {
				console.error('일별 판매 데이터 저장 중 오류:', error);
			}
		},

		// 광고 데이터 저장
		async saveAdData(stockInfo) {
			try {
				const adData = [];
				const today = new Date().toISOString().split('T')[0];

				for (const item of stockInfo) {
					if (!item.trafficInfo?.adSummaryByDate) continue;

					for (const adDateData of item.trafficInfo.adSummaryByDate) {
						const adDetails = [];

						// 각 광고 타입별로 데이터 추출 (detail 배열 포함)
						Object.keys(adDateData).forEach(key => {
							// 값이 객체인 키만 실제 광고영역이다. 광고가 없는 날 채워지는 지표 키는 스칼라라
							// 그대로 승격시키면 adType 이 지표 이름이고 값이 전부 0인 빈 문서가 DB 에 쌓인다.
							if (key !== 'date' && adDateData[key] && typeof adDateData[key] === 'object') {
								const adTypeData = adDateData[key];
								adDetails.push({
									adType: key,
									impressions: adTypeData.impressions || 0,
									clicks: adTypeData.clicks || 0,
									cost: adTypeData.cost || 0,
									cpc: adTypeData.cpc || 0,
									detail: adTypeData.detail || [] // 🆕 detail 배열 추가
								});
							}
						});

						if (adDetails.length > 0) {
							adData.push({
								vendorItemId: item.vendorItemId,
								date: adDateData.date,
								updateDate: today,
								adDetails: adDetails
							});
						}
					}
				}

				if (adData.length > 0) {
					const result = await axios.post('/api/growth/saveAdData', adData);
					if (result.data.res === 'success') {
						console.log('광고 데이터 저장 완료:', result.data);
					} else {
						console.error('광고 데이터 저장 실패:', result.data);
					}
				}
			} catch (error) {
				console.error('광고 데이터 저장 중 오류:', error);
			}
		},

		// 광고 데이터를 chunk 단위로 저장
		async saveAdDataInChunks(stockInfo) {
			try {
				const adData = [];
				const today = new Date().toISOString().split('T')[0];

				// 데이터 준비
				for (const item of stockInfo) {
					if (!item.trafficInfo?.adSummaryByDate) continue;

					for (const adDateData of item.trafficInfo.adSummaryByDate) {
						const adDetails = [];

						Object.keys(adDateData).forEach(key => {
							// 값이 객체인 키만 실제 광고영역이다. 광고가 없는 날 채워지는 지표 키는 스칼라라
							// 그대로 승격시키면 adType 이 지표 이름이고 값이 전부 0인 빈 문서가 DB 에 쌓인다.
							if (key !== 'date' && adDateData[key] && typeof adDateData[key] === 'object') {
								const adTypeData = adDateData[key];
								adDetails.push({
									adType: key,
									impressions: adTypeData.impressions || 0,
									clicks: adTypeData.clicks || 0,
									cost: adTypeData.cost || 0,
									cpc: adTypeData.cpc || 0,
									detail: adTypeData.detail || []
								});
							}
						});

						if (adDetails.length > 0) {
							adData.push({
								vendorItemId: item.vendorItemId,
								date: adDateData.date,
								updateDate: today,
								adDetails: adDetails
							});
						}
					}
				}

				if (adData.length > 0) {
					// chunk 단위로 나누기 (50개씩)
					const CHUNK_SIZE = 50;
					const chunks = [];
					for (let i = 0; i < adData.length; i += CHUNK_SIZE) {
						chunks.push(adData.slice(i, i + CHUNK_SIZE));
					}

					// chunk별로 저장
					for (let i = 0; i < chunks.length; i++) {
						this.loadingtext = `광고 데이터 저장 중... (${i + 1}/${chunks.length})`;

						const result = await axios.post('/api/growth/saveAdData', chunks[i]);
						if (result.data.res === 'success') {
							console.log(`광고 데이터 chunk ${i + 1}/${chunks.length} 저장 완료`);
						} else {
							console.error(`광고 데이터 chunk ${i + 1} 저장 실패:`, result.data);
						}
					}

					this.loadingtext = '광고 데이터 저장 완료';
				}
			} catch (error) {
				console.error('광고 데이터 저장 중 오류:', error);
				this.loadingtext = '광고 데이터 저장 오류 발생';
			}
		},

		// ✅ 새로운 메서드: trafficInfo를 일별 데이터로 변환하여 저장
		async convertAndSaveDailySalesData(allProducts) {
			try {
				// 1. 일별 판매 데이터 저장 (개별 상품별)
				await this.saveDailySalesOnly(allProducts);

				// 2. 광고 데이터 별도 저장
				await this.saveAdDataInChunks(allProducts);

				console.log('모든 일별 데이터 저장 완료');
			} catch (error) {
				console.error('일별 데이터 변환/저장 중 오류:', error);
				this.loadingtext = '데이터 저장 오류 발생';
			}
		},

		// ✅ 새로운 메서드: 일별 판매 데이터만 저장 (광고 데이터 제외)
		async saveDailySalesOnly(allProducts) {
			try {
				const dailySalesData = [];
				const today = new Date().toISOString().split('T')[0];

				for (const item of allProducts) {
					if (!item.trafficInfo) continue;

					if (item.trafficInfo.saleSummaryByDate) {
						for (const saleData of item.trafficInfo.saleSummaryByDate) {
							const trafficData = item.trafficInfo.trafficSummaryByDate?.find(t => t.date === saleData.date);
							const conversionData = item.trafficInfo.conversionSummaryByDate?.find(c => c.date === saleData.date);
							const adSummary = this.calculateAdSummaryForDate(item.trafficInfo.adSummaryByDate, saleData.date);

							dailySalesData.push({
								vendorItemId: item.vendorItemId,
								date: saleData.date,
								updateDate: today,
								sales: {
									unitsSold: saleData.unitsSold || 0,
									saleCount: saleData.saleCount || 0,
									salePrice: saleData.salePrice || 0,
									gmv: saleData.gmv || 0,
									registrationType: saleData.registrationType || 'RFM'
								},
								traffic: {
									pageViews: trafficData?.pageViews || 0,
									uniqueVisitor: trafficData?.uniqueVisitor || 0,
									clickCount: trafficData?.clickCount || 0,
									impressionCount: trafficData?.impressionCount || 0
								},
								conversion: {
									addToCart: conversionData?.addToCart || 0,
									orders: conversionData?.orders || 0,
									conversionRate: conversionData?.conversionRate || 0,
									clickRate: conversionData?.clickRate || 0,
									pvToOrder: conversionData?.pvToOrder || 0
								},
								adSummary: adSummary
							});
						}
					}
				}

				if (dailySalesData.length > 0) {
					// chunk 단위로 나누기 (100개씩)
					const CHUNK_SIZE = 100;
					const chunks = [];
					for (let i = 0; i < dailySalesData.length; i += CHUNK_SIZE) {
						chunks.push(dailySalesData.slice(i, i + CHUNK_SIZE));
					}

					// chunk별로 저장
					for (let i = 0; i < chunks.length; i++) {
						this.loadingtext = `일별 판매 데이터 저장 중... (${i + 1}/${chunks.length})`;

						const result = await axios.post('/api/growth/saveDailySales', chunks[i]);
						if (result.data.res === 'success') {
							console.log(`일별 판매 데이터 chunk ${i + 1}/${chunks.length} 저장 완료`);
						} else {
							console.error(`일별 판매 데이터 chunk ${i + 1} 저장 실패:`, result.data);
						}
					}

					this.loadingtext = '일별 판매 데이터 저장 완료';
				}
			} catch (error) {
				console.error('일별 판매 데이터 저장 중 오류:', error);
				this.loadingtext = '일별 판매 데이터 저장 오류 발생';
			}
		},

		// ✅ 새로운 메서드: 일별 데이터에서 salesHistory 등 생성
		async buildSalesDataFromDailySales(arr) {
			try {
				// 공통 함수를 사용해서 어제 기준 30일 날짜 범위 계산
				const todayStr = this.getTodayString();
				const dates = this.generateDatesFromUpdateDate(todayStr);

				const startDateStr = dates[0];
				const endDateStr = dates[dates.length - 1];

				console.log(`buildSalesDataFromDailySales: 어제 기준 30일 범위 ${startDateStr} ~ ${endDateStr}`);

				// 일별 판매 데이터 조회
				const response = await axios.post('/api/growth/getSalesLedger', {
					startDate: startDateStr,
					endDate: endDateStr
				});

				if (response.data.res === 'success') {
					const dailySalesMap = new Map();

					// vendorItemId별로 일별 데이터 그룹화
					response.data.dailySalesData.forEach(dailyData => {
						if (!dailySalesMap.has(dailyData.vendorItemId)) {
							dailySalesMap.set(dailyData.vendorItemId, []);
						}
						dailySalesMap.get(dailyData.vendorItemId).push(dailyData);
					});

					// 각 상품별로 처리
					arr.forEach(item => {
						const mainDailyData = dailySalesMap.get(item.vendorItemId) || [];

						// 메인 상품의 히스토리 데이터 생성
						let salesHistory = dates.map(date => {
							const dayData = mainDailyData.find(d => d.date === date);
							return dayData?.sales?.unitsSold || 0;
						});

						let visitorHistory = dates.map(date => {
							const dayData = mainDailyData.find(d => d.date === date);
							return dayData?.traffic?.uniqueVisitor || 0;
						});

						let pageViewHistory = dates.map(date => {
							const dayData = mainDailyData.find(d => d.date === date);
							return dayData?.traffic?.pageViews || 0;
						});

						let cartHistory = dates.map(date => {
							const dayData = mainDailyData.find(d => d.date === date);
							return dayData?.conversion?.addToCart || 0;
						});

						let orderHistory = dates.map(date => {
							const dayData = mainDailyData.find(d => d.date === date);
							return dayData?.conversion?.orders || 0;
						});

						let pvToOrder = dates.map(date => {
							const dayData = mainDailyData.find(d => d.date === date);
							const value = dayData?.conversion?.pvToOrder || 0;
							return value ? Math.round(value * 1000) / 10 : 0;
						});

						// 번들 상품 합산 처리
						if (item.upBundlingProducts?.length > 0) {
							item.upBundlingProducts.forEach(bundle => {
								const bundleDailyData = dailySalesMap.get(bundle.vendorItemId) || [];
								const bundleSize = bundle.upBundlingSize || 1;

								// 번들 상품의 개별 히스토리도 생성
								bundle.salesHistory = dates.map(date => {
									const dayData = bundleDailyData.find(d => d.date === date);
									return dayData?.sales?.unitsSold || 0;
								});

								bundle.visitorHistory = dates.map(date => {
									const dayData = bundleDailyData.find(d => d.date === date);
									return dayData?.traffic?.uniqueVisitor || 0;
								});

								bundle.pageViewHistory = dates.map(date => {
									const dayData = bundleDailyData.find(d => d.date === date);
									return dayData?.traffic?.pageViews || 0;
								});

								bundle.cartHistory = dates.map(date => {
									const dayData = bundleDailyData.find(d => d.date === date);
									return dayData?.conversion?.addToCart || 0;
								});

								bundle.orderHistory = dates.map(date => {
									const dayData = bundleDailyData.find(d => d.date === date);
									return dayData?.conversion?.orders || 0;
								});

								bundle.pvToOrder = dates.map(date => {
									const dayData = bundleDailyData.find(d => d.date === date);
									const value = dayData?.conversion?.pvToOrder || 0;
									return value ? Math.round(value * 1000) / 10 : 0;
								});

								// 번들 데이터를 메인 상품에 합산
								dates.forEach((date, index) => {
									const dayData = bundleDailyData.find(d => d.date === date);
									if (dayData) {
										salesHistory[index] += (dayData.sales?.unitsSold || 0) * bundleSize;
										visitorHistory[index] += (dayData.traffic?.uniqueVisitor || 0) * bundleSize;
										pageViewHistory[index] += (dayData.traffic?.pageViews || 0) * bundleSize;
										cartHistory[index] += (dayData.conversion?.addToCart || 0) * bundleSize;
										orderHistory[index] += (dayData.conversion?.orders || 0) * bundleSize;
									}
								});

								// 번들 상품의 계산된 값들
								bundle.unitsSoldForLast30Days = bundle.salesHistory.reduce((sum, val) => sum + val, 0) * bundleSize;
								bundle.dailySales = bundle.unitsSoldForLast30Days / 30;

								// 번들 일판매수량(판매속도): 메인과 동일한 다신호 복합 엔진
								const bundleVelocity = this.calcDailyVelocity(
									bundle.orderHistory.slice(0, 30),
									bundle.visitorHistory.slice(0, 30),
									bundle.salesHistory.slice(0, 30)
								);
								bundle.일판매수량 = bundleVelocity.velocity * bundleSize;
								bundle.유효판매일 = bundleVelocity.activeDays;
							});
						}

						// 반품 상품 처리 (연결만 하고 합산하지 않음)
						if (item.returnProducts?.length > 0) {
							item.returnProducts.forEach(returnProduct => {
								const returnDailyData = dailySalesMap.get(returnProduct.vendorItemId) || [];

								// 반품 상품의 개별 히스토리 생성 (표시용)
								returnProduct.salesHistory = dates.map(date => {
									const dayData = returnDailyData.find(d => d.date === date);
									return dayData?.sales?.unitsSold || 0;
								});

								returnProduct.visitorHistory = dates.map(date => {
									const dayData = returnDailyData.find(d => d.date === date);
									return dayData?.traffic?.uniqueVisitor || 0;
								});

								returnProduct.pageViewHistory = dates.map(date => {
									const dayData = returnDailyData.find(d => d.date === date);
									return dayData?.traffic?.pageViews || 0;
								});

								returnProduct.cartHistory = dates.map(date => {
									const dayData = returnDailyData.find(d => d.date === date);
									return dayData?.conversion?.addToCart || 0;
								});

								returnProduct.orderHistory = dates.map(date => {
									const dayData = returnDailyData.find(d => d.date === date);
									return dayData?.conversion?.orders || 0;
								});

								// ❌ 반품 상품은 메인 상품에 합산하지 않음
							});
						}

						// 최종 데이터 설정
						item.dates = dates;
						item.salesHistory = salesHistory;
						item.visitorHistory = visitorHistory;
						item.pageViewHistory = pageViewHistory;
						item.cartHistory = cartHistory;
						item.orderHistory = orderHistory;
						item.pvToOrder = pvToOrder;

						// 계산된 값들 (오늘 데이터 제외하고 어제까지 30일치만 계산)
						const salesForCalculation = salesHistory.length > 30 ? salesHistory.slice(0, 30) : salesHistory;
						const pageViewForCalculation = pageViewHistory.length > 30 ? pageViewHistory.slice(0, 30) : pageViewHistory;
						const orderForCalculation = orderHistory.length > 30 ? orderHistory.slice(0, 30) : orderHistory;
						const visitorForCalculation = visitorHistory.length > 30 ? visitorHistory.slice(0, 30) : visitorHistory;

						item.월판매수량 = salesForCalculation.reduce((sum, val) => sum + val, 0);

						// 7일 판매 데이터 (최근 7일 실제 합계 - 표시용)
						item['7일판매수량'] = salesForCalculation.slice(-7).reduce((sum, val) => sum + val, 0);

						// 일판매수량(판매속도): 다신호 복합 엔진 — 주문건수 주신호 + 방문자 교차검증 + 단위환산
						const mainVelocity = this.calcDailyVelocity(orderForCalculation, visitorForCalculation, salesForCalculation);
						item.일판매수량 = mainVelocity.velocity;
						item.유효판매일 = mainVelocity.activeDays;
						item.판매변화 = mainVelocity.trend;

						item.currentMonthlyClicks = pageViewForCalculation.reduce((sum, val) => sum + val, 0);

						// console.log(`${item.vendorItemId}: 전체 데이터 ${salesHistory.length}일, 계산용 데이터 ${salesForCalculation.length}일`);

						// 이전 달 클릭수 계산 (30일 이전 데이터가 있다면)
						item.prevMonthlyClicks = 0; // 기본값
					});

					console.log('일별 데이터 기반 salesHistory 생성 완료');
				}
			} catch (error) {
				console.error('일별 데이터 기반 salesHistory 생성 중 오류:', error);
			}
		},

		// 특정 날짜의 광고 데이터 합계 계산
		calculateAdSummaryForDate(adSummaryByDate, targetDate) {
			if (!adSummaryByDate) return { totalCost: 0, totalClicks: 0, totalImpressions: 0, totalOrders: 0, totalUnits: 0 };

			const targetDateFormatted = targetDate.replace(/-/g, '');
			const adDataForDate = adSummaryByDate.find(ad => ad.date === targetDateFormatted);

			if (!adDataForDate) return { totalCost: 0, totalClicks: 0, totalImpressions: 0, totalOrders: 0, totalUnits: 0 };

			let totalCost = 0, totalClicks = 0, totalImpressions = 0, totalOrders = 0, totalUnits = 0;

			Object.keys(adDataForDate).forEach(key => {
				if (key !== 'date') {
					const adTypeData = adDataForDate[key];
					totalCost += adTypeData.cost || 0;
					totalClicks += adTypeData.clicks || 0;
					totalImpressions += adTypeData.impressions || 0;
					totalOrders += adTypeData.orders || 0;
					totalUnits += adTypeData.units || 0;
				}
			});

			return { totalCost, totalClicks, totalImpressions, totalOrders, totalUnits };
		},

		// 특정 날짜의 입고 수량 가져오기 (30/30 형태) - 여러 센터 데이터 집계
		getInboundQuantityForDate(item, date) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return '';
			}

			// 같은 날짜의 모든 센터 데이터를 찾아서 집계
			const inbounds = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
				.filter(inb => inb.expectedDeliveryDate === date);

			if (!inbounds || inbounds.length === 0) return '';

			let totalStowed = 0;
			let totalRequested = 0;

			inbounds.forEach(inbound => {
				totalStowed += inbound.stowedQuantity || 0;
				totalRequested += inbound.requestedQuantity || 0;
			});

			// 둘 다 0이면 빈 문자열 반환
			if (totalStowed === 0 && totalRequested === 0) return '';

			const result = `${totalStowed}/${totalRequested}`;
			// console.log(`날짜 ${date}, 상품 ${item.vendorItemId}: ${result} (${inbounds.length}개 센터)`);
			return result;
		},
		// 입고 상태에 따른 색상 클래스 반환
		getInboundStatusClass(item, date) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return '';
			}

			const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
				.find(inb => inb.expectedDeliveryDate === date);

			if (!inbound) return '';

			const stowed = inbound.stowedQuantity || 0;
			const requested = inbound.requestedQuantity || 0;

			// 둘 다 0이면 기본
			if (stowed === 0 && requested === 0) return '';

			// 입고 완료 (10/10)
			if (stowed === requested && requested > 0) {
				return 'bg-success text-white';
			}
			// 부분 입고 (11/12)
			else if (stowed > 0 && stowed < requested) {
				return 'bg-warning text-dark';
			}
			// 입고 전 (0/12)
			else if (stowed === 0 && requested > 0) {
				return 'bg-danger text-white';
			}

			return '';
		},
		// 특정 날짜의 전체 종합 수량 계산
		getSummaryForDate(date) {
			if (!this.saleslists || this.saleslists.length === 0) {
				return '';
			}

			let totalStowed = 0;
			let totalRequested = 0;

			this.saleslists.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
						.find(inb => inb.expectedDeliveryDate === date);

					if (inbound) {
						totalStowed += inbound.stowedQuantity || 0;
						totalRequested += inbound.requestedQuantity || 0;
					}
				}
			});

			// 둘 다 0이면 빈 문자열 반환
			if (totalStowed === 0 && totalRequested === 0) return '';

			return `${totalStowed}/${totalRequested}`;
		},
		// 전체 종합의 특정 날짜 입고 상태 색상 클래스 반환
		getSummaryStatusClass(date) {
			if (!this.saleslists || this.saleslists.length === 0) {
				return '';
			}

			let totalStowed = 0;
			let totalRequested = 0;

			this.saleslists.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
						.find(inb => inb.expectedDeliveryDate === date);

					if (inbound) {
						totalStowed += inbound.stowedQuantity || 0;
						totalRequested += inbound.requestedQuantity || 0;
					}
				}
			});

			// 둘 다 0이면 기본
			if (totalStowed === 0 && totalRequested === 0) return '';

			// 입고 완료
			if (totalStowed === totalRequested && totalRequested > 0) {
				return 'bg-success text-white';
			}
			// 부분 입고
			else if (totalStowed > 0 && totalStowed < totalRequested) {
				return 'bg-warning text-dark';
			}
			// 입고 전
			else if (totalStowed === 0 && totalRequested > 0) {
				return 'bg-danger text-white';
			}

			return '';
		},
		// 행 클래스 설정 (종합 행 강조 + 하이라이트)
		getRowClass(item) {
			const classes = [];

			// 종합 행 스타일
			if (item.isSummaryRow) {
				classes.push('table-warning', 'font-weight-bold');
			}

			// 하이라이트 스타일
			if (this.highlightedVendorItemId && item.vendorItemId === this.highlightedVendorItemId) {
				console.log('하이라이트 클래스 적용:', item.vendorItemId);
				classes.push('highlighted-row');
			}

			return classes.join(' ');
		},
		// 입고 날짜 미리 수집
		collectInboundDates(arr) {
			const allDates = new Set();

			arr.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds.forEach(inbound => {
						if (inbound.expectedDeliveryDate) {
							allDates.add(inbound.expectedDeliveryDate);
						}
					});
				}
			});

			// 날짜 정렬하여 저장
			this.inboundDates = Array.from(allDates).sort((a, b) => new Date(a) - new Date(b));
			console.log('수집된 입고 날짜:', this.inboundDates);
		},
		// 입고 수량 값에 따른 스타일 클래스 반환
		getInboundStyleByValue(value, isSummaryRow) {
			if (!value) return '';

			// 기본 클래스
			let baseClass = isSummaryRow ? 'font-weight-bold' : '';

			// 값이 "숫자/숫자" 형태인지 확인
			const match = value.match(/^(\d+)\/(\d+)$/);
			if (!match) return baseClass;

			const stowed = parseInt(match[1]);
			const requested = parseInt(match[2]);

			// 입고 완료 (12/12)
			if (stowed === requested && requested > 0) {
				return `${baseClass} bg-success text-white`;
			}
			// 부분 입고 (11/12)
			else if (stowed > 0 && stowed < requested) {
				return `${baseClass} bg-warning text-dark`;
			}
			// 입고 전 (0/12)
			else if (stowed === 0 && requested > 0) {
				return `${baseClass} bg-danger text-white`;
			}

			return baseClass;
		},
		// 전체 종합 날짜 클릭 시 해당 날짜 기준으로 정렬
		sortByDateColumn(date) {
			console.log(`날짜 ${date} 클릭됨 - 2단계 정렬 시작`);

			// 해당 날짜의 입고 상태별 우선순위 정의
			const getStatusPriority = (value) => {
				if (!value) return 4; // 빈칸

				const match = value.match(/^(\d+)\/(\d+)$/);
				if (!match) return 4;

				const stowed = parseInt(match[1]);
				const requested = parseInt(match[2]);

				// 부분 입고 (11/12) - 우선순위 1 (가장 높음)
				if (stowed > 0 && stowed < requested) return 1;
				// 입고 완료 (12/12) - 우선순위 2
				if (stowed === requested && requested > 0) return 2;
				// 입고 전 (0/12) - 우선순위 3
				if (stowed === 0 && requested > 0) return 3;

				return 4; // 빈칸 - 우선순위 4 (가장 낮음)
			};

			// 해당 날짜의 총 수량 계산 (정렬용)
			const getTotalQuantity = (value) => {
				if (!value) return 0;
				const match = value.match(/^(\d+)\/(\d+)$/);
				return match ? parseInt(match[2]) : 0; // 요청 수량 기준
			};

			// 1단계: 수량 많은 순으로 정렬
			console.log('1단계: 수량별 정렬');
			this.saleslists.sort((a, b) => {
				const aValue = this.getInboundQuantityForDate(a, date);
				const bValue = this.getInboundQuantityForDate(b, date);

				const aQuantity = getTotalQuantity(aValue);
				const bQuantity = getTotalQuantity(bValue);

				return bQuantity - aQuantity; // 수량 많은 순 (내림차순)
			});

			// 2단계: 색상별로 전체 다시 정렬 (수량 무시)
			console.log('2단계: 색상별 전체 재정렬');
			this.saleslists.sort((a, b) => {
				const aValue = this.getInboundQuantityForDate(a, date);
				const bValue = this.getInboundQuantityForDate(b, date);

				const aPriority = getStatusPriority(aValue);
				const bPriority = getStatusPriority(bValue);

				console.log(`색상 우선순위 비교: A(${aValue}, 우선순위:${aPriority}) vs B(${bValue}, 우선순위:${bPriority})`);

				// 색상 우선순위만으로 정렬 (수량 무시)
				if (aPriority !== bPriority) {
					return aPriority - bPriority; // 1(부분입고) > 2(입고완료) > 3(입고전) > 4(빈칸)
				}

				// 같은 색상 내에서는 수량 많은 순
				const aQuantity = getTotalQuantity(aValue);
				const bQuantity = getTotalQuantity(bValue);

				return bQuantity - aQuantity;
			});

			console.log(`날짜 ${date} 기준 2단계 정렬 완료`);

			// 토스트 메시지로 정렬 완료 알림
			this.$bvToast.toast(`${this.formatDateShort(date)} 기준으로 정렬되었습니다.`, {
				title: '정렬 완료',
				variant: 'info',
				solid: true,
				autoHideDelay: 2000
			});
		},
		// 정렬 초기화 (모달 초기 상태로 복원)
		resetSort() {
			console.log('정렬 초기화 시작');

			// 저장된 초기 순서가 있는지 확인
			if (!this.originalSaleslistsOrder || this.originalSaleslistsOrder.length === 0) {
				console.log('저장된 초기 순서가 없습니다.');
				return;
			}

			// 초기 순서로 복원
			this.saleslists = [...this.originalSaleslistsOrder];

			console.log('정렬 초기화 완료 - 초기 상태로 정렬됨');

			// 토스트 메시지로 초기화 완료 알림
			this.$bvToast.toast('초기 상태로 정렬되었습니다.', {
				title: '정렬 초기화',
				variant: 'success',
				solid: true,
				autoHideDelay: 2000
			});
		},
		// SCM 데이터 로딩
		async loadScmData() {
			try {
				const response = await axios.post('/api/getScmDB');
				if (response.data.scmdb && Array.isArray(response.data.scmdb)) {
					// vendorItemId를 키로 하여 데이터 저장
					this.scmData = response.data.scmdb.reduce((acc, item) => {
						acc[item.vendorItemId] = item;
						return acc;
					}, {});
					console.log('🔍 [DEBUG] loadScmData 완료:', {
						총개수: response.data.scmdb.length,
						샘플데이터: response.data.scmdb.slice(0, 2)
					});
				}
			} catch (error) {
				console.error('SCM 데이터 로딩 실패:', error);
			}
		},

		// 개별 필드 업데이트 (레거시 코드, 호환성을 위해 유지)
		async updateFieldValue(item, fieldName, value) {
			// 한글 필드명을 영어로 변환
			const fieldMapping = {
				'구매': 'purchase',
				'배대지': 'overseas',
				'통관중': 'customs',
				'국내재고': 'domesticStock',
				'입고기간': 'inboundPeriod',
				'최대재고기간': 'targetStockDays',
				'최소재고기간': 'safetyStockDays',
				'MOQ수량': 'moqQuantity',
				'타겟키워드': 'targetKeyword',
				'메모': 'memo'
			};

			const apiFieldName = fieldMapping[fieldName];
			if (!apiFieldName) return;

			try {
				const response = await axios.post('/api/updateScmData', {
					vendorItemId: item.vendorItemId,
					field: apiFieldName,
					value: value
				});

				if (response.data.res === 'success') {
					console.log(`${fieldName} 필드 업데이트 성공:`, response.data);
				} else {
					console.error(`${fieldName} 필드 업데이트 실패:`, response.data);
				}
			} catch (error) {
				console.error(`${fieldName} 필드 업데이트 오류:`, error);
			}
		},

		initReqLists() {
			// 선택된 상품이 있으면 장바구니에 추가
			if (this.tableSelectedItem.length > 0) {
				const newItems = this.tableSelectedItem.map(item => ({
					...item,
					구매요청수량: item.구매필요수량
				}));

				// 기존 장바구니에 없는 상품만 추가
				newItems.forEach(newItem => {
					const existingIndex = this.purchaseCart.findIndex(
						cartItem => cartItem.vendorItemId === newItem.vendorItemId
					);

					if (existingIndex === -1) {
						// 새 상품이면 추가
						this.purchaseCart.push(newItem);
					} else {
						// 이미 있는 상품이면 구매요청수량 업데이트
						this.purchaseCart[existingIndex].구매요청수량 = newItem.구매요청수량;
					}
				});

				// 선택 해제
				this.tableSelectedItem = [];
			}

			// 장바구니 내용을 reqlists에 복사
			this.reqlists = [...this.purchaseCart];
		},
		// 구매요청 장바구니 초기화
		clearPurchaseCart() {
			if (this.purchaseCart.length === 0) {
				alert('장바구니가 이미 비어있습니다.');
				return;
			}

			if (confirm(`장바구니의 ${this.purchaseCart.length}개 상품을 모두 삭제하시겠습니까?`)) {
				this.purchaseCart = [];
				this.reqlists = [];
				this.reqTableSelectedItem = [];

				// 뱃지 사라지는 애니메이션
				this.animateBadgeDisappear();
			}
		},
		// 뱃지 사라지는 애니메이션
		animateBadgeDisappear() {
			const badge = document.querySelector('#purchaseRequestBtn .badge');
			if (badge) {
				badge.style.transition = 'all 0.3s ease-out';
				badge.style.transform = 'scale(0)';
				badge.style.opacity = '0';
			}
		},
		// 구매요청 테이블용 예상재고량 계산
		getPurchasePreviewTotalStockForItem(item) {
			if (!item.구매요청수량 || item.구매요청수량 <= 0) {
				return this.getTotalAvailableStock(item);
			}

			const currentTotalStock = this.getTotalAvailableStock(item);
			const requestQuantity = parseInt(item.구매요청수량) || 0;

			return currentTotalStock + requestQuantity;
		},
		// 구매요청 테이블용 예상재고일 계산
		getPurchasePreviewStockPeriodForItem(item) {
			if (!item.구매요청수량 || item.구매요청수량 <= 0) {
				// 구매요청수량이 없으면 현재 재고기간 표시
				const currentTotalStock = this.getTotalAvailableStock(item);
				const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

				if (계산용일판매수량 <= 0) return 0;
				return Math.floor(currentTotalStock / 계산용일판매수량);
			}

			const totalStockAfterPurchase = this.getPurchasePreviewTotalStockForItem(item);
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			if (계산용일판매수량 <= 0) return 0;

			return Math.floor(totalStockAfterPurchase / 계산용일판매수량);
		},
		// 구매요청수량 변경 시 예상재고 업데이트 (구매요청 테이블용)
		updatePurchasePreview() {
			// 실시간 계산을 위한 함수 (Vue의 반응성으로 자동 업데이트됨)
			this.$forceUpdate();
		},
		async requestpurchase($event) {
			$event.preventDefault();
			this.$bvModal.show('waitreqpurchase');
			var lists = this.reqTableSelectedItem.length > 0 ? this.reqTableSelectedItem : this.reqlists;

			if (lists.length == 0) {
				alert('구매대행요청할 상품이 없습니다.')
				this.$bvModal.hide('waitreqpurchase');
				this.$bvModal.hide('reqpurchase');
				return
			}
			var arr = [];
			console.log(lists)
			for (var i = 0; i < lists.length; i++) {
				var e = lists[i];
				var addlist = await this.addlists(e);
				arr = arr.concat(addlist);
			}
			if (arr.length == 0) {
				alert('구매대행요청할 상품이 없습니다.')
				this.$bvModal.hide('waitreqpurchase');
				this.$bvModal.hide('reqpurchase');
				return
			}
			await this.addreqlist(arr)
		},
		async addreqlist(lists) {
			console.log(lists)
			try {
				var res = await axios.post('/api/reqpurchase/addreqlist', lists)

				if (res.data.요청결과 == "저장완료") {
					if (confirm('저장이 완료되었습니다. 구매요청메뉴로 이동하시겠습니까?')) {
						this.$router.push({ name: 'nomad.nomadreqpo' })
					}
				} else {
					alert(res.data.요청결과);
				}
				console.log(res)
			} catch (e) {
				console.log(e)
			}
			this.$bvModal.hide('waitreqpurchase');
			this.$bvModal.hide('reqpurchase');
		},
		async addlists(e) {
			var ob = this.$store.state.growthdb.find(ele => ele.vendorItemId == e.vendorItemId);
			console.log(ob)
			if (ob && ob.구매정보 && ob.구매정보.length > 0) {
				var arr = [];
				for (var obj of ob.구매정보) {
					var newObj = await this.confirmreq(obj);
					this.resetReqVolatileFields(newObj);
					newObj.reqtype = '제트배송';
					newObj.구매요청수량 = e.구매요청수량;
					arr.push(newObj);
				}
				return arr;
			} else {
				return [{
					checked: false,
					showspinner: false,
					// SKUID : '',
					바코드: ob.barcode,
					상품명: ob.skuName,
					상품명init: ob.skuName,
					구매링크: undefined,
					구매링크init: undefined,
					옵션1_중국어: undefined,
					옵션2_중국어: undefined,
					옵션이미지: undefined,
					매칭상태: '매칭필요',
					상품매칭: {
						옵션1_중국어: [],
						옵션2_중국어: [],
					},
					구매재고: '',
					구매요청수량: e.구매요청수량,
					판매구성수량: 1,
					묶음구성여부: false,
					묶음구성수량: '',
					묶음대상바코드: '',
					신고영문명: '',
					신고가격: '',
					HSCODE: '',
					진행현황: '구매전',
					재고동봉: true,
					등록이미지: ob.imgUrl,
					요청사항: '요청등록',
					reqtype: '제트배송',
					sizeX: ob.skuInfo ? ob.skuInfo.width : 0,
					sizeY: ob.skuInfo ? ob.skuInfo.length : 0,
					sizeZ: ob.skuInfo ? ob.skuInfo.heigth : 0,
					weight: ob.skuInfo ? ob.skuInfo.weight : 0,
					요청내역: {
						default: true,
						poarrange: false,
						한글표시사항: true,
						barcode: true,
						sticker: false,
						stamp: false,
						tag: false,
						reqcontent: '',
						opp: false,
						LDPE: false,
						airpacking: false,
						exportType: 'box',

						masking: false,
						destination: 'coupang',
						auto: true,
					},
					한글표시사항: {
						제품명: ob.skuName,
						'수입원/판매원': '',
						제조원: '',
						제조국: '',
						내용량: '',
						'원료명및성분명(재질)': '',
						상품유형: '',
						사용시주의사항: '',
						사용기준: '',
						custom: '',
					},
					polists: [],
					selectpo: '',
				}]
			}
		},
		async confirmreq(obj) {
			obj.showspinner = true;
			console.log(obj)
			if (!obj.구매링크) {
				obj.showspinner = false;
				return obj
			}
			obj.구매링크init = obj.구매링크;
			obj.매칭상태 = '매칭필요'
			var item = await this.getProductInfo(obj.구매링크);
			item = item.data.result[0].result.result
			console.log(item)
			obj.item = item;

			let option1array = [];
			let option2array = [];

			if (item.productSkuInfos) {
				item.productSkuInfos.forEach((e) => {
					if (!option1array.find(option => option.name === e.skuAttributes[0].value)) {
						option1array.push({
							name: e.skuAttributes[0].value,
							imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
						})
					}

					if (e.skuAttributes[1]) {
						if (!option2array.find(option => option.name === e.skuAttributes[1].value)) {
							option2array.push({
								name: e.skuAttributes[1].value,
								imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
							})
						}
					} else {
						option2array = []
					}
				})
			}

			if (option1array.length === 0) {
				obj.상품매칭.옵션1_중국어 = [];
				obj.상품매칭.옵션2_중국어 = [];
				obj.옵션1_중국어 = '';
				obj.옵션2_중국어 = '';
				obj.구매재고 = item.productSaleInfo.amountOnSale;
				obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.productImage.images[0];
				obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.productImage.images[0];
				obj.매칭상태 = '매칭완료'
			} else {
				var imgUrl = '';
				if (option2array.length == 0) {
					imgUrl = option1array.find(e => e.name == obj.옵션1_중국어) ? imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : "";
					if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
						obj.옵션1_중국어 = undefined;
						obj.옵션이미지 = undefined;
						obj.구매재고 = 0;
					} else {
						obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어).amountOnSale;
						obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : imgUrl;
						obj.매칭상태 = '매칭완료'
					}
					obj.상품매칭.옵션1_중국어 = option1array;
					obj.상품매칭.옵션2_중국어 = [];
					obj.옵션2_중국어 = '';
					obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
				} else {
					if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
						obj.옵션1_중국어 = undefined;
						obj.옵션이미지 = undefined;
						obj.구매재고 = 0;
					} else {
						obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : option1array.find(e => e.name == obj.옵션1_중국어).imageUrl;
						if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
							obj.옵션2_중국어 = undefined;
							obj.구매재고 = 0;
						} else {
							obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어 && f.skuAttributes[1].value == obj.옵션2_중국어).amountOnSale;
							imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : "");
							obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : (option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : ""));
							obj.매칭상태 = '매칭완료'
						}
					}
					obj.상품매칭.옵션1_중국어 = option1array;
					obj.상품매칭.옵션2_중국어 = option2array;
					console.log(option1array)
					console.log(option1array.find(e => e.name == obj.옵션1_중국어))
					console.log(option2array)

					obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
				}

				if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
					obj.등록이미지 = item.productImage.images[0];
				}
			}
			obj.showspinner = false;
			return obj
		},
		async getProductInfo(구매링크) {
			var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
			try {
				var res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }])
				return res
			} catch (e) {
				console.log('err821' + e);
				return false
			}
		},
		formatDownload(matchType = 'vendorItemId') {
			var arr = [];
			var fileName, sheetName;

			// 매칭 타입에 따라 헤더 구성
			var myHeader;
			if (matchType === 'barcode') {
				myHeader = ["이미지링크", "상품명", "옵션명", "바코드"];
				fileName = 'SCM일괄업로드양식_바코드매칭.xlsx';
				sheetName = 'SCM일괄업로드양식_바코드';
			} else {
				myHeader = ["이미지링크", "상품명", "옵션명", "옵션ID"];
				fileName = 'SCM일괄업로드양식_옵션ID매칭.xlsx';
				sheetName = 'SCM일괄업로드양식_옵션ID';
			}

			// 쿠패스연동이 OFF일 때만 해당 재고 열 추가
			if (!this.coupassSyncEnabled) {
				myHeader.push('구매완료재고', '배대지재고', '통관중재고');
			}

			myHeader.push(
				'국내재고',
				'구매입고기간', '배대지입고기간', '통관중입고기간', '국내입고기간',
				'목표재고기간', '안전재고기간',
				'MOQ수량', '목표일판매수량', '타겟키워드', '메모'
			);

			// 수정 불가능한 필드 (회색 배경으로 표시할 필드)
			// 참고: 현재 XLSX 라이브러리에서는 스타일 적용이 제한적이므로 실제로 적용되지 않음

			for (var e of this.saleslistsinit) {
				var rowData = {
					"이미지링크": e.썸네일 || "",
					"상품명": e.판매상품명 || "",
					"옵션명": e.옵션명 || "",
				};

				// 매칭 타입에 따라 다른 키 컬럼 추가
				if (matchType === 'barcode') {
					// growthdb에서 바코드 정보 찾기
					const growthdbItem = this.$store.state.growthdb?.find(item => item.vendorItemId === e.vendorItemId);
					rowData["바코드"] = growthdbItem?.barcode || "";
				} else {
					rowData["옵션ID"] = e.vendorItemId || "";
				}

				// 쿠패스연동이 OFF일 때만 해당 재고 데이터 추가
				if (!this.coupassSyncEnabled) {
					rowData["구매완료재고"] = e.구매 || 0;
					rowData["배대지재고"] = e.배대지 || 0;
					rowData["통관중재고"] = e.통관중 || 0;
				}

				// 나머지 데이터 추가
				Object.assign(rowData, {
					"국내재고": e.국내재고 || 0,
					"구매입고기간": e.입고기간 || 0,
					"배대지입고기간": e.배대지입고기간 || 0,
					"통관중입고기간": e.통관중입고기간 || 0,
					"국내입고기간": e.국내입고기간 || 0,
					"목표재고기간": e.최대재고기간 || 0,
					"안전재고기간": e.최소재고기간 || 0,
					"MOQ수량": e.MOQ수량 || 0,
					"목표일판매수량": e.목표일판매수량 || 0,
					"타겟키워드": e.타겟키워드 || "",
					"메모": e.메모 || ""
				});

				arr.push(rowData);
			}

			var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

			// 셀 스타일 적용
			if (!dataWS['!cols']) dataWS['!cols'] = [];

			// 열 너비 설정
			myHeader.forEach((_, i) => {
				dataWS['!cols'][i] = { width: 15 }; // 기본 너비 설정
			});

			// 특정 열 너비 조정
			dataWS['!cols'][0] = { width: 40 }; // 이미지링크
			dataWS['!cols'][1] = { width: 30 }; // 상품명
			dataWS['!cols'][2] = { width: 30 }; // 옵션명
			dataWS['!cols'][12] = { width: 25 }; // 타겟키워드
			dataWS['!cols'][13] = { width: 30 }; // 메모

			// 스타일 적용을 위한 셀 범위 계산
			const range = XLSX.utils.decode_range(dataWS['!ref']);
			range.e['c'] = myHeader.length - 1;
			dataWS['!ref'] = XLSX.utils.encode_range(range);

			var wb = XLSX.utils.book_new();

			XLSX.utils.book_append_sheet(wb, dataWS, sheetName);
			// 엑셀 파일을 내보낸다.
			XLSX.writeFile(wb, fileName);
		},
		onInputChange(item) {
			item.isModified = true;
		},
		async onInputComplete(item) {
			if (item.isModified) {
				// 모든 관련 필드를 한 번에 업데이트
				const updateData = {
					vendorItemId: item.vendorItemId,
					inboundPeriod: parseInt(item.입고기간) || 0,
					overseasInputDays: parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays,
					customsInputDays: parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays,
					domesticInputDays: parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays,
					targetStockDays: parseInt(item.최대재고기간) || 0,
					safetyStockDays: parseInt(item.최소재고기간) || 0,
					moqQuantity: parseInt(item.MOQ수량) || 0,
					boxQuantity: parseInt(item.박스인입수량) || 1,
					targetKeyword: item.타겟키워드 || '',
					memo: item.메모 || '',
					targetDailySales: parseFloat(item.목표일판매수량) || 0
				};
				// 쿠패스 OFF일 때만 수동 재고 필드 저장
				if (!this.coupassSyncEnabled) {
					updateData.purchase = parseInt(item.구매) || 0;
					updateData.overseas = parseInt(item.배대지) || 0;
					updateData.customs = parseInt(item.통관중) || 0;
					updateData.domesticStock = parseInt(item.국내재고) || 0;
				}

				try {
					// 서버에 한 번의 API 호출로 모든 필드 업데이트
					const response = await axios.post('/api/batchUpdateScmData', [updateData]);

					if (response.data.res === 'success') {
						console.log('🔍 [DEBUG] onInputComplete 저장 성공:', {
							vendorItemId: updateData.vendorItemId,
							저장된값: updateData
						});

						// 🔥 중요: scmData 캐시도 함께 업데이트
						if (!this.scmData[updateData.vendorItemId]) {
							this.scmData[updateData.vendorItemId] = {};
						}
						this.scmData[updateData.vendorItemId] = {
							...this.scmData[updateData.vendorItemId],
							...updateData
						};

						console.log('🔍 [DEBUG] scmData 캐시 업데이트 완료:', this.scmData[updateData.vendorItemId]);

						// 로컬 상태 업데이트 (Vue 반응성 보장)
						this.$set(item, '구매', updateData.purchase);
						this.$set(item, '배대지', updateData.overseas);
						this.$set(item, '통관중', updateData.customs);
						this.$set(item, '국내재고', updateData.domesticStock);
						this.$set(item, '입고기간', updateData.inboundPeriod);
						this.$set(item, '배대지입고기간', updateData.overseasInputDays);
						this.$set(item, '통관중입고기간', updateData.customsInputDays);
						this.$set(item, '국내입고기간', updateData.domesticInputDays);
						this.$set(item, '최대재고기간', updateData.targetStockDays);
						this.$set(item, '최소재고기간', updateData.safetyStockDays);
						this.$set(item, 'MOQ수량', updateData.moqQuantity);
						this.$set(item, '박스인입수량', updateData.boxQuantity);
						this.$set(item, '타겟키워드', updateData.targetKeyword);
						this.$set(item, '메모', updateData.memo);

						// 메트릭 재계산 및 저장
						const metrics = this.calculateInventoryMetrics(item);
						item.남은재고기간 = metrics.남은재고기간;
						item.구매필요수량 = metrics.구매필요수량;
						item.dday = metrics.dday;
						item.배대지출고Dday = metrics.배대지출고Dday;
						item.배대지출고필요수량 = metrics.배대지출고필요수량;
						item.통관중출고Dday = metrics.통관중출고Dday;
						item.통관중출고필요수량 = metrics.통관중출고필요수량;
						item.국내출고Dday = metrics.국내출고Dday;
						item.국내출고필요수량 = metrics.국내출고필요수량;

						// Series 계산값도 갱신
						item.seriesDday = this.calculateSeriesDday(item);
						item.seriesNeededQty = this.calculateSeriesNeededQty(item);
						item.seriesNeededDays = this.calculateSeriesNeededDays(item);

						// 🔥 메인 테이블(saleslists)에도 동일하게 반영
						const mainTableItem = this.saleslists.find(i => i.vendorItemId === updateData.vendorItemId);
						if (mainTableItem && mainTableItem !== item) {
							// 재고관리 모달의 item과 메인 테이블의 item이 다른 객체인 경우
							console.log('🔍 [DEBUG] 메인 테이블 업데이트 시작:', updateData.vendorItemId);
							this.$set(mainTableItem, '구매', updateData.purchase);
							this.$set(mainTableItem, '배대지', updateData.overseas);
							this.$set(mainTableItem, '통관중', updateData.customs);
							this.$set(mainTableItem, '국내재고', updateData.domesticStock);
							this.$set(mainTableItem, '입고기간', updateData.inboundPeriod);
							this.$set(mainTableItem, '배대지입고기간', updateData.overseasInputDays);
							this.$set(mainTableItem, '통관중입고기간', updateData.customsInputDays);
							this.$set(mainTableItem, '국내입고기간', updateData.domesticInputDays);
							this.$set(mainTableItem, '최대재고기간', updateData.targetStockDays);
							this.$set(mainTableItem, '최소재고기간', updateData.safetyStockDays);
							this.$set(mainTableItem, 'MOQ수량', updateData.moqQuantity);
							this.$set(mainTableItem, '박스인입수량', updateData.boxQuantity);
							this.$set(mainTableItem, '타겟키워드', updateData.targetKeyword);
							this.$set(mainTableItem, '메모', updateData.memo);

							// 메인 테이블 아이템도 메트릭 재계산
							const mainMetrics = this.calculateInventoryMetrics(mainTableItem);
							mainTableItem.남은재고기간 = mainMetrics.남은재고기간;
							mainTableItem.구매필요수량 = mainMetrics.구매필요수량;
							mainTableItem.dday = mainMetrics.dday;
							mainTableItem.배대지출고Dday = mainMetrics.배대지출고Dday;
							mainTableItem.배대지출고필요수량 = mainMetrics.배대지출고필요수량;
							mainTableItem.통관중출고Dday = mainMetrics.통관중출고Dday;
							mainTableItem.통관중출고필요수량 = mainMetrics.통관중출고필요수량;
							mainTableItem.국내출고Dday = mainMetrics.국내출고Dday;
							mainTableItem.국내출고필요수량 = mainMetrics.국내출고필요수량;

							mainTableItem.seriesDday = this.calculateSeriesDday(mainTableItem);
							mainTableItem.seriesNeededQty = this.calculateSeriesNeededQty(mainTableItem);
							mainTableItem.seriesNeededDays = this.calculateSeriesNeededDays(mainTableItem);

							console.log('🔍 [DEBUG] 메인 테이블 업데이트 완료:', mainTableItem.vendorItemId);
						}

						// 🔥 saleslistsinit에도 동일하게 반영
						const initItem = this.saleslistsinit.find(i => i.vendorItemId === updateData.vendorItemId);
						if (initItem && initItem !== item) {
							// 재고관리 모달의 item과 saleslistsinit의 item이 다른 객체인 경우
							console.log('🔍 [DEBUG] saleslistsinit 업데이트 시작:', updateData.vendorItemId);
							this.$set(initItem, '구매', updateData.purchase);
							this.$set(initItem, '배대지', updateData.overseas);
							this.$set(initItem, '통관중', updateData.customs);
							this.$set(initItem, '국내재고', updateData.domesticStock);
							this.$set(initItem, '입고기간', updateData.inboundPeriod);
							this.$set(initItem, '배대지입고기간', updateData.overseasInputDays);
							this.$set(initItem, '통관중입고기간', updateData.customsInputDays);
							this.$set(initItem, '국내입고기간', updateData.domesticInputDays);
							this.$set(initItem, '최대재고기간', updateData.targetStockDays);
							this.$set(initItem, '최소재고기간', updateData.safetyStockDays);
							this.$set(initItem, 'MOQ수량', updateData.moqQuantity);
							this.$set(initItem, '박스인입수량', updateData.boxQuantity);
							this.$set(initItem, '타겟키워드', updateData.targetKeyword);
							this.$set(initItem, '메모', updateData.memo);

							// saleslistsinit 아이템도 메트릭 재계산
							const initMetrics = this.calculateInventoryMetrics(initItem);
							initItem.남은재고기간 = initMetrics.남은재고기간;
							initItem.구매필요수량 = initMetrics.구매필요수량;
							initItem.dday = initMetrics.dday;
							initItem.배대지출고Dday = initMetrics.배대지출고Dday;
							initItem.배대지출고필요수량 = initMetrics.배대지출고필요수량;
							initItem.통관중출고Dday = initMetrics.통관중출고Dday;
							initItem.통관중출고필요수량 = initMetrics.통관중출고필요수량;
							initItem.국내출고Dday = initMetrics.국내출고Dday;
							initItem.국내출고필요수량 = initMetrics.국내출고필요수량;

							initItem.seriesDday = this.calculateSeriesDday(initItem);
							initItem.seriesNeededQty = this.calculateSeriesNeededQty(initItem);
							initItem.seriesNeededDays = this.calculateSeriesNeededDays(initItem);

							console.log('🔍 [DEBUG] saleslistsinit 업데이트 완료:', initItem.vendorItemId);
						}
					} else {
						console.error('항목 업데이트 실패:', response.data);
					}
				} catch (error) {
					console.error('항목 업데이트 오류:', error);
				} finally {
					// 처리 완료 플래그
					item.isModified = false;
				}
			}
		},
		markAsModified(item) {
			item.isModified = true;
		},
		calculateInventoryMetrics(item) {
			// 기본 input 값 변환
			item.구매 = parseInt(item.구매) || 0;
			item.배대지 = parseInt(item.배대지) || 0;
			item.통관중 = parseInt(item.통관중) || 0;
			item.국내재고 = parseInt(item.국내재고) || 0;

			// 계산에 사용할 일판매수량 결정 (목표 일판매수량이 있으면 우선 사용)
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			// 일판매수량이 0인 경우 예외 처리
			if (계산용일판매수량 <= 0) {
				return {
					남은재고기간: 0,
					구매필요수량: 0,
					dday: -999,
					배대지출고Dday: -999,
					배대지출고필요수량: 0,
					통관중출고Dday: -999,
					통관중출고필요수량: 0,
					국내출고Dday: -999,
					국내출고필요수량: 0,
					장기입고중: 0,
					단기입고중: 0,
					쿠팡재고기간: 0
				};
			}

			// 입고중 재고 분류
			const { 장기입고중, 단기입고중 } = this.classifyInboundInventory(item);

			// 입력값들 가져오기
			const 목표재고일 = parseInt(item.최대재고기간) || this.baseSettings.targetDays;
			const 안전재고일 = parseInt(item.최소재고기간) || this.baseSettings.safetyDays;
			const 구매입고기간 = parseInt(item.입고기간) || this.baseSettings.inputDays;
			const 배대지입고기간 = parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays;
			const 국내입고기간 = parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays;

			// 전체 가용재고 계산 (구매필요수량 계산용)
			const 전체가용재고 = item.구매 + item.배대지 + item.통관중 + item.국내재고 + 장기입고중 + 단기입고중 + item.재고;

			// 남은재고기간 계산 (전체 가용재고 기준, 예측 기반 — 재고기간 단일 기준 함수 사용)
			const 남은재고기간 = this.calcForecastStockDays(전체가용재고, item);

			// 새로운 공식으로 계산
			// 1. 구매필요수량 = 목표재고일 - 현재가용재고 + 구매입고기간 판매예상량
			const 구매입고기간판매예상 = Math.ceil(계산용일판매수량 * 구매입고기간);
			let 구매필요수량 = 목표재고일 * 계산용일판매수량 - 전체가용재고 + 구매입고기간판매예상;
			구매필요수량 = Math.max(0, Math.round(구매필요수량));

			// 2. 구매 D-Day = (구매입고기간 + 안전재고일) - 전체가용재고일수
			const 전체가용재고일수 = 전체가용재고 / 계산용일판매수량;
			let 구매Dday = Math.ceil((구매입고기간 + 안전재고일) - 전체가용재고일수);

			// 구매필요수량이 0이면 D-Day를 -999로 설정
			if (구매필요수량 === 0) {
				구매Dday = -999;
			}

			// 3. 배대지출고수량 = 목표재고일 - 하위가용재고 + 배대지입고기간 판매예상량
			const 배대지하위가용재고 = item.통관중 + item.국내재고 + 장기입고중 + 단기입고중 + item.재고;
			const 배대지입고기간판매예상 = Math.ceil(계산용일판매수량 * 배대지입고기간);
			let 배대지출고필요수량 = 목표재고일 * 계산용일판매수량 - 배대지하위가용재고 + 배대지입고기간판매예상;
			배대지출고필요수량 = Math.max(0, Math.min(Math.round(배대지출고필요수량), item.배대지));

			// 4. 배대지출고 D-Day = (배대지입고기간 + 안전재고일) - 배대지하위가용재고일수
			const 배대지하위가용재고일수 = 배대지하위가용재고 / 계산용일판매수량;
			let 배대지출고Dday = Math.ceil((배대지입고기간 + 안전재고일) - 배대지하위가용재고일수);

			// 배대지 재고가 없거나 배대지출고필요수량이 0이면 D-Day를 -999로 설정
			if (item.배대지 <= 0 || 배대지출고필요수량 === 0) {
				배대지출고Dday = -999;
			}

			// 5. 통관중출고수량 = 목표재고일 - 통관중하위가용재고 + 통관중입고기간 판매예상량
			const 통관중하위가용재고 = item.국내재고 + 장기입고중 + 단기입고중 + item.재고;
			const 통관중입고기간 = parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays || 3; // 기본 3일
			const 통관중입고기간판매예상 = Math.ceil(계산용일판매수량 * 통관중입고기간);
			let 통관중출고필요수량 = 목표재고일 * 계산용일판매수량 - 통관중하위가용재고 + 통관중입고기간판매예상;
			통관중출고필요수량 = Math.max(0, Math.min(Math.round(통관중출고필요수량), item.통관중));

			// 6. 통관중출고 D-Day = (통관중입고기간 + 안전재고일) - 통관중하위가용재고일수
			const 통관중하위가용재고일수 = 통관중하위가용재고 / 계산용일판매수량;
			let 통관중출고Dday = Math.ceil((통관중입고기간 + 안전재고일) - 통관중하위가용재고일수);

			// 통관중 재고가 없거나 통관중출고필요수량이 0이면 D-Day를 -999로 설정
			if (item.통관중 <= 0 || 통관중출고필요수량 === 0) {
				통관중출고Dday = -999;
			}

			// 8. 국내출고수량 = 목표재고일 - 단기하위가용재고 + 국내입고기간 판매예상량
			const 국내하위가용재고 = 단기입고중 + item.재고;
			const 국내입고기간판매예상 = Math.ceil(계산용일판매수량 * 국내입고기간);
			let 국내출고필요수량 = 목표재고일 * 계산용일판매수량 - 국내하위가용재고 + 국내입고기간판매예상;
			국내출고필요수량 = Math.max(0, Math.min(Math.round(국내출고필요수량), item.국내재고));

			// 9. 국내출고 D-Day = (국내입고기간 + 안전재고일) - 국내하위가용재고일수
			const 국내하위가용재고일수 = 국내하위가용재고 / 계산용일판매수량;
			let 국내출고Dday = Math.ceil((국내입고기간 + 안전재고일) - 국내하위가용재고일수);

			// 국내재고가 없거나 국내출고필요수량이 0이면 D-Day를 -999로 설정
			if (item.국내재고 <= 0 || 국내출고필요수량 === 0) {
				국내출고Dday = -999;
			}

			// 10. 쿠팡재고기간 계산 (예측 기반 — 재고기간 단일 기준 함수 사용)
			const 쿠팡재고기간 = this.calcForecastStockDays(item.재고, item);

			return {
				남은재고기간,
				구매필요수량,
				dday: 구매Dday,
				배대지출고Dday,
				배대지출고필요수량,
				통관중출고Dday,
				통관중출고필요수량,
				국내출고Dday,
				국내출고필요수량,
				장기입고중,
				단기입고중,
				쿠팡재고기간
			};
		},
		// 이 상품에 Unipass 실측이 붙어 있나. 없으면 null → 추정으로 돌아간다
		measuredInboundOf(item) {
			if (!item || !this.measuredInboundMap) return null;
			// 실측이 하나도 없으면(=대다수) growthdb 전체를 훑을 이유가 없다.
			// 이 함수는 행마다 불리므로 상품이 많으면 선형 탐색이 누적된다.
			if (!Object.keys(this.measuredInboundMap).length) return null;
			const g = this.$store.state.growthdb.find(x => x.vendorItemId === item.vendorItemId);
			if (!g || !g.barcode) return null;
			const m = this.measuredInboundMap[g.barcode];
			if (!m || !m.선적수) return null;
			return m;
		},
		// 입고중 재고를 단기/장기로 분류
		//
		// 근거가 둘로 갈린다 (정본 §4 "근거 우선순위", §5 Phase 5-7):
		//   Unipass 실측이 붙은 상품  → 실측이 이긴다. 화물이 실제로 어디 있는지 아는 값이다
		//   안 붙은 상품             → 지금까지 쓰던 예정일 추정 그대로
		//                              (쿠패스를 안 쓰는 화주는 이것 말고 근거가 없다)
		//
		// ⚠ 추정 로직을 지우지 않는다. 실측이 있는 건만 덮는다.
		classifyInboundInventory(item) {
			// ⚠ 실측으로 **통째로 덮지 않는다.** 정본 §4: "쿠패스가 주는 게 있으면 그 입고ID 기준으로
			//   떼어서 실측으로 보여주고, **나머지는 원래 로직으로 둔다**. 반반 이용하는 화주도 마찬가지다."
			//   덮으면 쿠패스 건 1개 + 자체 배대지 9개를 굴리는 화주의 9개분이 화면에서 사라지고,
			//   전체가용재고가 줄어 구매필요수량이 과대 계산된다.
			//   ⇒ 실측분을 더한다. 겹침(같은 물건을 양쪽에서 세는 것)은 입고ID 매칭이 없어 지금 구조로는
			//     가릴 수 없다 — 실데이터가 생기면 그때 판단한다.
			const 실측 = this.measuredInboundOf(item);

			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				if (실측) return { 단기입고중: 실측.국내입고중, 장기입고중: 실측.해외입고중, 근거: 'unipass' };
				return {
					단기입고중: 0,
					장기입고중: 0
				};
			}

			const 현재날짜 = new Date();
			const 국내입고기간 = parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays;
			let 단기입고중 = 0;
			let 장기입고중 = 0;

			item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds.forEach(inbound => {
				if (inbound.expectedDeliveryDate) {
					let 실제입고중수량 = 0;

					// 1. 물건이 도착했지만 아직 입고 처리 중인 경우
					const 입고처리중수량 = (inbound.receivedQuantity || 0) - (inbound.stowedQuantity || 0);

					// 2. 입고 요청했지만 아직 물건이 도착하지 않은 경우
					const 도착대기중수량 = inbound.inProgressQuantity || 0;

					// 둘 중 더 큰 값을 사용 (일반적으로 하나만 0이 아님)
					실제입고중수량 = Math.max(입고처리중수량, 도착대기중수량);

					if (실제입고중수량 > 0) {
						const 입고예정일 = new Date(inbound.expectedDeliveryDate);
						const 남은일수 = Math.ceil((입고예정일 - 현재날짜) / (1000 * 60 * 60 * 24));

						if (남은일수 <= 국내입고기간) {
							단기입고중 += 실제입고중수량;
						} else {
							장기입고중 += 실제입고중수량;
						}
					}
				}
			});

			if (실측) {
				return {
					단기입고중: 단기입고중 + 실측.국내입고중,
					장기입고중: 장기입고중 + 실측.해외입고중,
					근거: 'unipass+추정'
				};
			}
			return {
				단기입고중,
				장기입고중
			};
		},
		calculateMetricsForProduct({
			가용재고,
			일판매수량,
			forecastSeries,
			forecastAI,
			입고기간,
			최대재고기간,
			최소재고기간
		}) {
			const result = {
				남은재고기간: 0,
				구매필요수량: 0,
				dday: -999
			};

			if (!일판매수량 || 일판매수량 <= 0) {
				return result;
			}

			// 예측 데이터를 사용할지 여부 결정 (AI 기반 우선)
			const forecastData = (forecastAI && forecastAI.length > 0) ? forecastAI : forecastSeries;

			// 남은재고기간 계산
			let 남은재고기간 = 0;
			let 잔여가용재고 = 가용재고;

			for (const 예상판매량 of forecastData) {
				if (잔여가용재고 >= 예상판매량) {
					잔여가용재고 -= 예상판매량;
					남은재고기간++;
				} else {
					break;
				}
			}

			result.남은재고기간 = 남은재고기간;

			// D-Day 계산
			result.dday = Math.ceil(입고기간 - (남은재고기간 - 최소재고기간));

			// 구매 필요 수량 계산
			if (남은재고기간 <= 최소재고기간) {
				// 남은재고기간 ≤ safetyDays: 목표재고일을 충족하기 위해 구매
				result.구매필요수량 = Math.ceil(this.baseSettings.targetDays * 일판매수량 - 가용재고);
			} else if (남은재고기간 < 최대재고기간) {
				// safetyDays < 남은재고기간 < targetDays: 목표재고일을 충족하기 위해 부족분 구매
				result.구매필요수량 = Math.ceil(this.baseSettings.targetDays * 일판매수량 - 가용재고);
			} else {
				// 남은재고기간 ≥ targetDays: 구매 필요 없음
				result.구매필요수량 = 0;
			}

			// 구매 필요 수량 최소값 설정 (선택적)
			result.구매필요수량 = Math.max(0, result.구매필요수량);

			return result;
		},
		updateMaxCpcChart() {
			if (!this.saleslistsinit || this.saleslistsinit.length === 0) return;

			const maxCpcData = this.saleslistsinit
				.map(item => {
					const dbItem = this.$store.state.growthdb.find(x => x.vendorItemId === item.vendorItemId);
					const margin = dbItem?.마진 || 0;
					const validPvToOrder = item.pvToOrder.filter(rate => rate > 0);
					const avgConversion = validPvToOrder.length > 0
						? validPvToOrder.reduce((a, b) => a + b, 0) / validPvToOrder.length
						: 0;

					return {
						name: item.판매상품명,
						maxCpc: Math.floor((margin * (avgConversion / 100)) / 10) * 10,
						margin,
						conversion: avgConversion
					};
				})
				.filter(item => item.maxCpc > 0)
				.sort((a, b) => b.maxCpc - a.maxCpc)
				.slice(0, 10);

			this.maxCpcChartOption = {
				chart: {
					type: 'bar',
					height: 280,
					toolbar: {
						show: false
					}
				},
				series: [{
					name: '최대 CPC',
					data: maxCpcData.map(item => parseFloat(item.maxCpc.toFixed(0)))
				}],
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: '70%',
						borderRadius: 4,
						dataLabels: {
							position: 'center'
						}
					}
				},
				colors: ['#775DD0'],
				dataLabels: {
					enabled: true,
					formatter: function (value) {
						return '￦' + value.toLocaleString();
					},
					style: {
						fontSize: '12px',
						colors: ['#fff'],
						fontWeight: 'bold'
					}
				},
				xaxis: {
					categories: maxCpcData.map(item =>
						item.name.length > 20 ? item.name.substring(0, 20) + '...' : item.name
					),
					labels: {
						rotate: -45,
						maxHeight: 150,
						style: {
							fontSize: '11px'
						}
					}
				},
				legend: {
					show: false
				},
				tooltip: {
					custom: function ({ dataPointIndex }) {
						const data = maxCpcData[dataPointIndex];
						return `
							<div class="custom-tooltip" style="padding: 8px; max-width: 300px;">
								<div style="margin-bottom: 8px; word-break: break-word; line-height: 1.4;">${data.name}</div>
								<div>CPC한도: ￦${data.maxCpc.toLocaleString()}</div>
							</div>
						`;
					}
				}
			};
		},
		updateConversionChart() {
			if (!this.saleslistsinit || this.saleslistsinit.length === 0) return;

			const totalVisits = this.saleslistsinit.reduce((sum, item) => sum + item.currentMonthlyClicks, 0);

			const productData = this.saleslistsinit
				.map(item => {
					const validPvToOrder = item.pvToOrder.filter(rate => rate > 0);
					const avgPvToOrder = validPvToOrder.length > 0
						? validPvToOrder.reduce((a, b) => a + b, 0) / validPvToOrder.length
						: 0;

					const trafficShare = (item.currentMonthlyClicks / totalVisits) * 100;

					return {
						name: item.판매상품명,
						conversion: avgPvToOrder,
						traffic: trafficShare
					};
				})
				.sort((a, b) => b.conversion - a.conversion)
				.slice(0, 10);

			this.conversionChartOption = {
				chart: {
					type: 'bar',
					height: 280,
					stacked: false,
					toolbar: {
						show: false
					}
				},
				series: [{
					name: '전환율(%)',
					type: 'column',
					data: productData.map(item => parseFloat(item.conversion.toFixed(2)))
				}, {
					name: '트래픽 점유율(%)',
					type: 'line',
					data: productData.map(item => parseFloat(item.traffic.toFixed(2)))
				}],
				plotOptions: {
					bar: {
						columnWidth: '60%'
					}
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					width: [0, 3],
					curve: 'smooth'
				},
				colors: ['#00E396', '#008FFB'],
				xaxis: {
					categories: productData.map(item =>
						item.name.length > 20 ? item.name.substring(0, 20) + '...' : item.name
					),
					labels: {
						rotate: -45,
						style: {
							fontSize: '11px'
						}
					}
				},
				yaxis: [{
					title: {
						text: '전환율(%)'
					},
					min: 0
				}, {
					opposite: true,
					title: {
						text: '트래픽 점유율(%)'
					},
					min: 0
				}],
				tooltip: {
					custom: function ({ dataPointIndex }) {
						const data = productData[dataPointIndex];
						return `
							<div class="custom-tooltip" style="padding: 8px; max-width: 300px;">
								<div style="margin-bottom: 8px; word-break: break-word; line-height: 1.4;">${data.name}</div>
								<div>전환율: ${data.conversion.toFixed(2)}%</div>
								<div>트래픽 점유율: ${data.traffic.toFixed(2)}%</div>
							</div>
						`;
					}
				},
				legend: {
					position: 'top'
				}
			};
		},
		updateProfitTop10Chart() {
			if (!this.saleslistsinit || this.saleslistsinit.length === 0) return;

			const profitByProduct = this.saleslistsinit.reduce((acc, item) => {
				const dbItem = this.$store.state.growthdb.find(x => x.vendorItemId === item.vendorItemId);
				const monthlyProfit = item.월판매수량 * (dbItem?.마진 || 0);

				if (!acc[item.productId]) {
					acc[item.productId] = {
						name: item.판매상품명.split('[')[0].trim(), // 옵션정보 제거
						profit: 0
					};
				}
				acc[item.productId].profit += monthlyProfit;
				return acc;
			}, {});

			// 객체를 배열로 변환하고 정렬
			const profitData = Object.values(profitByProduct)
				.filter(item => item.profit > 0)
				.sort((a, b) => b.profit - a.profit)
				.slice(0, 10);

			this.profitTop10ChartOption = {
				chart: {
					type: 'bar',
					height: 280,
					toolbar: {
						show: false
					}
				},
				series: [{
					name: '수익',
					data: profitData.map(item => item.profit)
				}],
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: '70%',
						borderRadius: 4,
						dataLabels: {
							position: 'center'
						}
					}
				},
				colors: ['#008FFB'],
				dataLabels: {
					enabled: true,
					formatter: function (value) {
						return '￦' + value.toLocaleString();
					},
					style: {
						fontSize: '12px',
						colors: ['#fff'],
						fontWeight: 'bold'
					}
				},
				xaxis: {
					categories: profitData.map(item =>
						item.name.length > 20 ? item.name.substring(0, 20) + '...' : item.name
					),
					labels: {
						rotate: -45,
						maxHeight: 150,
						style: {
							fontSize: '11px'
						}
					}
				},
				legend: {
					show: false
				},
				tooltip: {
					custom: function ({ dataPointIndex }) {
						const data = profitData[dataPointIndex];
						return `
							<div class="custom-tooltip" style="padding: 8px; max-width: 300px;">
								<div style="margin-bottom: 8px; word-break: break-word; line-height: 1.4;">${data.name}</div>
								<div>수익: ￦${data.profit.toLocaleString()}</div>
							</div>
						`;
					}
				}
			};
		},
		// ===== 재고 대사 =====
		async loadRecon() {
			try {
				// 이 화면이 이미 읽은 현재고(쿠팡재고 + 반품옵션)를 넘긴다 — 서버가 다시 읽지 않고, 열과 숫자가 같다
				const stockByVid = {};
				(this.saleslistsinit || []).forEach(e => {
					if (e.vendorItemId === undefined || e.vendorItemId === null || e.재고 === undefined || e.재고 === null) return;
					stockByVid[String(e.vendorItemId)] = (Number(e.재고) || 0) +
						(e.returnProducts || []).reduce((a, r) => a + (Number(r.orderableQuantity) || 0), 0);
				});
				const res = await axios.post('/api/growth/getInventoryRecon', { stockByVid });
				if (res.data?.res === 'forbidden') {   // 볼 권한 없음 — 오류가 아니다. 아무것도 안 그린다
					this.reconSummary = null;
					this.reconByVid = {};
					return;
				}
				if (res.data?.res !== 'success') {
					console.error('[재고 대사] 조회 실패', res.data?.alert);
					return;
				}
				const map = {};
				(res.data.items || []).forEach(r => { map[String(r.vendorItemId)] = r; });
				this.reconByVid = map;
				this.reconSummary = res.data.summary || null;
			} catch (e) {
				console.error('[재고 대사] 조회 실패', e);
			}
		},
		reconOf(item) {
			if (!item || item.vendorItemId === undefined || item.vendorItemId === null) return null;
			return this.reconByVid[String(item.vendorItemId)] || null;
		},
		reconItemName(item) {
			if (!item) return '';
			return [item.판매상품명, item.옵션명].filter(Boolean).join(' · ');
		},
		// 화면이 쓰는 판정 — 'exact' | 'preparing' | 'excluded'. 옛 응답(calc 없음)은 status·mode 로 가른다
		reconCalcOf(r) {
			if (!r) return '';
			if (r.calc) return r.calc;
			if (r.status !== 'ok') return 'excluded';
			return r.mode === 'exact' ? 'exact' : 'preparing';
		},
		// 정확 모드 옵션의 확인 안 된 재고. 그 밖(계산 준비 중·제외)은 0 — 범위 값은 쓰지 않는다
		reconExactMiss(r) {
			return this.reconCalcOf(r) === 'exact' ? (Number(r.missHi) || 0) : 0;
		},
		// 판매에 포함된 「정산 반영 전 판매」 — 옛 응답(pendingSold)도 읽는다
		reconPendingSettle(r) {
			if (!r) return 0;
			return Number(r.pendingSettleQty !== undefined ? r.pendingSettleQty : r.pendingSold) || 0;
		},
		reconCellTitle(r) {
			const parts = ['입고 ' + r.inbound.toLocaleString(), '판매 ' + ((r.sold || 0) + (r.pendingSold || 0)).toLocaleString(),
				'현재고 ' + r.stock.toLocaleString()];
			let t = parts.join(' · ') + ' — 눌러서 흐름 보기';
			if (r.flags && r.flags.bundleUncertain) t += '\n번들 포함 — 정확하지 않을 수 있어요.';
			return t;
		},
		// 「미확인만 보기」 — over90 이면 90일 넘은 것만. 많이 빈 순서로(정확 모드 옵션만)
		showReconOnly(over90) {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = [];
			this.saleslists = this.visibleInit()
				.filter(e => {
					if (e.hidden) return false;
					const r = this.reconOf(e);
					return this.reconExactMiss(r) > 0 && (!over90 || r.ageDays >= 90);
				})
				.sort((a, b) => this.reconExactMiss(this.reconOf(b)) - this.reconExactMiss(this.reconOf(a)));
			setTimeout(() => { this.showlist = true; }, 10);
		},
		applyReconQuery() {
			const q = this.$route.query.recon;
			if (!q || !this.reconSummary) return;
			this.showReconOnly(q === 'over90');
		},
		openReconDetail(item) {
			if (this.reconCalcOf(this.reconOf(item)) !== 'exact') return;   // 상세는 정확 모드 옵션만
			this.reconCopyMsg = '';
			this.reconCopyFallback = '';
			this.reconShowFullHistory = false;
			this.reconDetailVid = String(item.vendorItemId);
			this.$nextTick(() => {
				const el = this.$refs.reconDetailCard;
				if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			});
		},
		// 쿠팡 판매자 문의에 붙여 넣을 문구. 숫자는 화면에 보이는 그대로다(정확 모드 옵션만)
		reconRequestText() {
			const d = this.reconDetail;
			if (!d || this.reconCalcOf(d.r) !== 'exact') return '';
			const r = d.r;
			const f = n => Math.round(n || 0).toLocaleString();
			const head = '[쿠팡확인요청] ' + d.name + ' (옵션ID ' + d.vendorItemId + ') — ';
			// 이미 확정된 재고손실보상은 빼고 요청한다 — 같은 수량을 두 번 요청하지 않게
			const compQtyKnown = !(r.flags && r.flags.compQtyUnknown);
			const compNote = r.compensationCount > 0
				? ' (이미 보상 확정된 ' + f(r.compensationCount) + '건' + (compQtyKnown && r.compensated ? ' ' + f(r.compensated) + '개' : '') +
					' ' + f(r.compensationAmount) + '원 제외)'
				: '';
			const other = (r.reshipped || 0) - (r.adjust || 0);
			return head + '입고 ' + f(r.inbound) + '개, 판매 ' + f(d.sold) + '개, 반품 재입고 ' + f(r.restock) + '개, 반출·폐기 ' +
				f((r.outbound || 0) + (r.dispose || 0)) + '개, ' + (other ? '처리중·재출고 ' + f(other) + '개, ' : '') +
				'보상 확정 ' + f(r.compensated) + '개, 현재고 ' + f(r.stock) + '개로 ' +
				f(this.reconExactMiss(r)) + '개가 확인되지 않습니다' + compNote + '. 재고 위치 확인 또는 보상을 요청드립니다.';
		},
		async copyReconRequest() {
			const txt = this.reconRequestText();
			this.reconCopyMsg = '';
			this.reconCopyFallback = '';
			try {
				if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('clipboard 사용 불가');
				await navigator.clipboard.writeText(txt);
				this.reconCopyMsg = '복사했습니다';
			} catch (e) {
				console.error('[재고 대사] 문구 복사 실패 — 직접 복사하도록 문구를 보여줍니다', e);
				this.reconCopyFallback = txt;
			}
		},
		showAll() {
			this.showlist = false;
			this.isShowingHidden = false; // 숨김 상태 초기화
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = [...this.saleslistsinit];
			this.applyDefaultSort();
			setTimeout(() => { this.showlist = true; }, 10);
		},
		// Series 기준 D-Day 계산
		calculateSeriesDday(item) {
			if (!item || item.일판매수량 <= 0) return -999;

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let series남은재고기간 = 0;
			let series잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastSeries) {
				if (series잔여가용재고 >= 예상판매량) {
					series잔여가용재고 -= 예상판매량;
					series남은재고기간++;
				} else {
					break;
				}
			}

			const series안전재고도달시점 = series남은재고기간 - item.최소재고기간;
			return parseInt(item.입고기간) - series안전재고도달시점;
		},
		// Series 기준 구매필요수량 계산
		calculateSeriesNeededQty(item) {
			if (!item || item.일판매수량 <= 0) return 0;

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let series남은재고기간 = 0;
			let series잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastSeries) {
				if (series잔여가용재고 >= 예상판매량) {
					series잔여가용재고 -= 예상판매량;
					series남은재고기간++;
				} else {
					break;
				}
			}

			if (series남은재고기간 <= this.baseSettings.safetyDays) {
				// 안전재고 이하면 최대주문일수만큼 구매
				const 최대주문일수 = this.baseSettings.targetDays - this.baseSettings.safetyDays;
				return Math.ceil(
					item.forecastSeries.slice(0, 최대주문일수).reduce((sum, val) => sum + val, 0)
				);
			} else if (series남은재고기간 < this.baseSettings.targetDays) {
				// 목표재고일까지 부족한 만큼 구매
				const 필요일수 = this.baseSettings.targetDays - series남은재고기간;
				const startIndex = series남은재고기간;
				const endIndex = Math.min(startIndex + 필요일수, item.forecastSeries.length);
				return Math.ceil(
					item.forecastSeries.slice(startIndex, endIndex).reduce((sum, val) => sum + val, 0)
				);
			}
			return 0;
		},
		calculateSeriesNeededDays(item) {
			if (!item || item.일판매수량 <= 0) return '0일치';

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let series남은재고기간 = 0;
			let series잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastSeries) {
				if (series잔여가용재고 >= 예상판매량) {
					series잔여가용재고 -= 예상판매량;
					series남은재고기간++;
				} else {
					break;
				}
			}

			if (series남은재고기간 <= this.baseSettings.safetyDays) {
				return `${this.baseSettings.targetDays - this.baseSettings.safetyDays}일치`;
			} else if (series남은재고기간 < this.baseSettings.targetDays) {
				return `${this.baseSettings.targetDays - series남은재고기간}일치`;
			}
			return '0일치';
		},
		calculateNeededStockDays(item) {
			if (!item || !item.forecastAI || item.forecastAI.length === 0 || item.일판매수량 <= 0) {
				return '0일치';
			}

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let ai남은재고기간 = 0;
			let ai잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastAI) {
				if (ai잔여가용재고 >= 예상판매량) {
					ai잔여가용재고 -= 예상판매량;
					ai남은재고기간++;
				} else {
					break;
				}
			}

			if (ai남은재고기간 <= this.baseSettings.safetyDays) {
				return `${this.baseSettings.targetDays - this.baseSettings.safetyDays}일치`;
			} else if (ai남은재고기간 < this.baseSettings.targetDays) {
				return `${this.baseSettings.targetDays - ai남은재고기간}일치`;
			}
			return '0일치';
		},
		calculateForecastQuantities(item) {
			if (item.forecastSeries) {
				item.forecastSeriesQty = item.forecastSeries.slice(0, 30).reduce((pv, cv) => pv + cv, 0);
			}
			if (item.forecastAI) {
				item.forecastAIQty = item.forecastAI.slice(0, 30).reduce((pv, cv) => pv + cv, 0);
			}
			return item;
		},
		extractOfferIdFromUrl(url) {
			const match = url.match(/offer\/(\d+)\.html/);
			return match ? match[1] : null;
		},
		editlists() {
			if (this.tableSelectedItem.length == 0) {
				if (!confirm('전체상품에 변경된 내용을 적용하시겠습니까?'))
					return;
			}

			const itemsToUpdate = this.tableSelectedItem.length > 0 ?
				this.tableSelectedItem : this.saleslists;

			for (const item of itemsToUpdate) {
				if (this.입고기간) {
					item.입고기간 = parseInt(this.입고기간);
				}
				if (this.최소재고기간) {
					item.최소재고기간 = parseInt(this.최소재고기간);
				}
				if (this.최대재고기간) {
					item.최대재고기간 = parseInt(this.최대재고기간);
				}
				if (this.MOQ수량) {
					item.MOQ수량 = parseInt(this.MOQ수량);
				}
				if (this.배대지입고기간) {
					item.배대지입고기간 = parseInt(this.배대지입고기간);
				}
				if (this.통관중입고기간) {
					item.통관중입고기간 = parseInt(this.통관중입고기간);
				}
				if (this.국내입고기간) {
					item.국내입고기간 = parseInt(this.국내입고기간);
				}

				item.isModified = true;

				// 새로운 메트릭 계산
				this.calculateInventoryMetrics(item);
			}

			this.입고기간 = '';
			this.최소재고기간 = '';
			this.최대재고기간 = '';
			this.MOQ수량 = '';
			this.배대지입고기간 = '';
			this.통관중입고기간 = '';
			this.국내입고기간 = '';
		},
		async saveSales() {
			const modifiedItems = this.saleslists.filter(item => item.isModified);
			if (modifiedItems.length === 0) {
				alert('변경된 항목이 없습니다.');
				return;
			}

			try {
				// 각 필드별로 필요한 데이터 추출
				const scmUpdates = modifiedItems.map(item => {
					const update = {
						vendorItemId: item.vendorItemId,
						inboundPeriod: parseInt(item.입고기간) || 0,
						overseasInputDays: parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays,
						customsInputDays: parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays,
						domesticInputDays: parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays,
						targetStockDays: parseInt(item.최대재고기간) || 0,
						safetyStockDays: parseInt(item.최소재고기간) || 0,
						moqQuantity: parseInt(item.MOQ수량) || 0,
						targetKeyword: item.타겟키워드 || '',
						memo: item.메모 || '',
						targetDailySales: parseFloat(item.목표일판매수량) || 0
					};
					// 쿠패스 OFF일 때만 수동 재고 필드 저장 (ON이면 coupass* 필드가 별도 관리됨)
					if (!this.coupassSyncEnabled) {
						update.purchase = parseInt(item.구매) || 0;
						update.overseas = parseInt(item.배대지) || 0;
						update.customs = parseInt(item.통관중) || 0;
						update.domesticStock = parseInt(item.국내재고) || 0;
					}
					return update;
				});

				// 일괄 업데이트 요청
				const response = await axios.post('/api/batchUpdateScmData', scmUpdates);

				if (response.data.res === 'success') {
					// 성공 후 modified 플래그 초기화
					modifiedItems.forEach(item => {
						item.isModified = false;
					});
					alert('저장 완료');
				} else {
					alert(response.data.alert || '저장 실패');
				}
			} catch (error) {
				console.error('저장 오류:', error);
				alert('저장 중 오류가 발생했습니다.');
			}
		},
		async changeMemo(event, saleslist) {
			if (event.keyCode == 13) {
				// 메모 필드 업데이트 ScmDB 형식으로 변경
				await this.updateFieldValue(saleslist, '메모', saleslist.메모);
				alert('저장 완료');
			}
		},
		async updateSaleslist(arr, bool) {
			console.log(arr)
			try {
				// isModified 플래그 제외하고 새로운 배열 생성
				const dataToSend = arr.map((item) => {
					const newItem = { ...item };
					delete newItem.isModified;
					return newItem;
				});

				var result = await axios.post('/api/updateOnlyGrowthSalesV2', dataToSend);
				if (result.data.res == 'success') {
					arr.forEach(item => {
						item.isModified = false;
					});
					if (bool) {
						alert('저장 완료');
					}
					// 저장이 성공한 항목들의 isModified 플래그를 false로 초기화
					return true

				} else {
					if (bool) {
						alert(result.data.alert);
					}
					console.log(result.data)
					return false
				}
			} catch (err) {
				alert('저장 중 오류가 발생했습니다.');
				console.error(err);
				return false
			}
		},
		async getKeywordData(dates, keyword) {
			try {
				const yearlyData = [];
				const currentYear = new Date().getFullYear();

				for (let yearOffset = 1; yearOffset <= 3; yearOffset++) {
					try {
						const offsetDates = dates.map(date => {
							const offsetDate = new Date(date);
							offsetDate.setFullYear(offsetDate.getFullYear() - yearOffset);
							return offsetDate.toISOString().split('T')[0];
						});

						console.log(`Fetching data for year ${currentYear - yearOffset}`);

						// 열쇠는 서버가 세션 회사 것으로 부른다(cpl-x3-naverkeyaes-1)
						const result = await axios.post('/api/getDatalabApi', {
							dates: offsetDates,
							keyword: keyword
						});

						if (result.data.요청결과 === 'success' && result.data.result.results[0].data.length > 0) {
							yearlyData.push({
								year: currentYear - yearOffset,
								data: result.data.result.results[0].data
							});
							console.log(`Successfully fetched ${result.data.result.results[0].data.length} records`);
						} else {
							console.log(`No data available for year ${currentYear - yearOffset}`);
						}

						// API 호출 간 딜레이 추가 (필요한 경우)
						await new Promise(resolve => setTimeout(resolve, 1000));

					} catch (yearError) {
						console.error(`Error fetching data for year ${currentYear - yearOffset}:`, yearError);
						// 개별 연도 실패해도 계속 진행
						continue;
					}
				}

				if (yearlyData.length === 0) {
					console.warn('No data available for any year');
					return [];
				}

				const mergedData = yearlyData.flatMap(yearly =>
					yearly.data.map(item => ({
						...item,
						year: yearly.year
					}))
				);

				console.log(`Total merged records: ${mergedData.length}`);
				return mergedData;

			} catch (e) {
				console.error('Error in getKeywordData:', e);
				return [];
			}
		},
		async getForecastAI(keywordForecast, f) {
			if (!keywordForecast || keywordForecast.length === 0) return [];

			// 1. 날짜별 3개년 데이터 그룹화 (월-일 기준)
			const groupedByDate = {};
			keywordForecast.forEach(data => {
				const date = new Date(data.period);
				const monthDay = `${date.getMonth()}-${date.getDate()}`; // 월-일 형식
				const year = date.getFullYear();

				if (!groupedByDate[monthDay]) {
					groupedByDate[monthDay] = {
						years: {},
						ratios: []
					};
				}

				groupedByDate[monthDay].years[year] = data.ratio;
				groupedByDate[monthDay].ratios.push(data.ratio);
			});

			// 2. 각 날짜별 패턴 분석
			const datePatterns = {};
			Object.entries(groupedByDate).forEach(([monthDay, data]) => {
				const values = Object.values(data.years);
				const mean = values.reduce((a, b) => a + b, 0) / values.length;

				// 연도별 일관성 체크 (표준편차의 변동계수로 판단)
				const stdDev = Math.sqrt(values.reduce((a, b) => a + Math.pow(b - mean, 2), 0) / values.length);
				const cv = stdDev / mean; // 변동계수 (Coefficient of Variation)

				datePatterns[monthDay] = {
					mean,
					stdDev,
					cv,
					values,
					// 연도별로 비슷한 패턴을 보이는지 (변동계수가 0.5 이하면 일관된 패턴으로 판단)
					isConsistent: cv <= 0.5,
					// 전체 평균대비 얼마나 높은지
					relativeStrength: null // 후에 계산
				};
			});

			// 3. 전체 평균 대비 각 날짜의 상대적 강도 계산
			const overallMean = Object.values(datePatterns)
				.reduce((sum, pattern) => sum + pattern.mean, 0) / Object.keys(datePatterns).length;

			Object.keys(datePatterns).forEach(monthDay => {
				datePatterns[monthDay].relativeStrength = datePatterns[monthDay].mean / overallMean;
			});

			// 4. 판매 데이터 분석
			const salesData = f.salesHistory;
			const nonZeroSales = salesData.filter(x => x > 0);
			if (nonZeroSales.length === 0) return [];

			const salesMean = nonZeroSales.reduce((sum, val) => sum + val, 0) / nonZeroSales.length;

			// 5. 예측값 계산
			const forecastAI = [];
			console.log(f)
			console.log(f.dates)
			console.log(salesData)
			const futureDates = f.dates.slice(salesData.length);

			futureDates.forEach(date => {
				const dateObj = new Date(date);
				const monthDay = `${dateObj.getMonth()}-${dateObj.getDate()}`;
				const pattern = datePatterns[monthDay];

				if (pattern) {
					let predictedSales = salesMean;

					if (pattern.isConsistent) {
						// 연도별로 일관된 패턴을 보이는 경우
						predictedSales *= pattern.relativeStrength;

						// 변동성이 큰 경우 신뢰구간 적용
						if (pattern.cv > 0.3) {
							// 변동성이 클수록 보수적으로 예측
							const confidenceFactor = 1 - (pattern.cv * 0.5);
							predictedSales *= confidenceFactor;
						}
					}

					forecastAI.push(Math.max(0, Math.round(predictedSales)));
				} else {
					forecastAI.push(Math.round(salesMean));
				}
			});

			// 6. 이동평균으로 스무딩 처리 (급격한 변동 완화)
			const smoothedForecast = [];
			const windowSize = 7; // 7일 이동평균

			for (let i = 0; i < forecastAI.length; i++) {
				const window = forecastAI.slice(Math.max(0, i - windowSize + 1), i + 1);
				const average = window.reduce((sum, val) => sum + val, 0) / window.length;
				smoothedForecast.push(Math.round(average));
			}

			return smoothedForecast;
		},
		// D-Day 값을 D-7 또는 D+7 형식으로 변환하는 함수
		formatDday(dday) {
			// -999는 특수 값(일판매수량이 0인 경우)
			if (dday === -999) return "-";

			// D-Day를 양수와 음수에 따라 D+ 또는 D- 접두사로 표시
			if (dday > 0) {
				// 양수: 구매시기가 지났음 (구매 필요)
				return `D+${dday}`;
			} else if (dday < 0) {
				// 음수: 구매시기가 아직 안 됨 (구매 불필요)
				return `D-${Math.abs(dday)}`;
			} else {
				// 0: 오늘이 구매시기
				return "D-0";
			}
		},

		// D-Day 스타일 함수
		getDdayStyle(dday, 안전재고일) {
			if (dday > 0) {
				// 구매일이 지났음
				if (dday > 안전재고일) {
					// 안전재고일보다 더 지연됨 (품절 위험)
					return "color: #ff0000; font-weight: bold;"; // 빨간색 + 굵게
				} else {
					// 안전재고일 이내의 지연
					return "color: #ff6600;"; // 주황색
				}
			} else if (dday === 0) {
				// 오늘이 구매일
				return "color: #ff6600;"; // 주황색
			}

			// 구매일이 아직 안 됨 (D-N)
			return ""; // 기본 스타일 (검은색)
		},

		// 기존 스타일 함수 (더 이상 사용하지 않을 수 있으나 호환성을 위해 유지)
		styleDday(dday) {
			if (dday > 0) {
				return "width:80px;overflow:hidden;text-overflow: ellipsis;color:red;font-weight:bold"
			} else {
				return "width:80px;overflow:hidden;text-overflow: ellipsis;"
			}
		},
		changePoEnter(event, saleslist) {
			const index = this.saleslists.findIndex(i => i.vendorItemId === saleslist.vendorItemId);
			if (event.keyCode === 13) {
				this.changePo(saleslist, index);
			}
		},
		async changePo(saleslist, index) {
			try {
				// 1. 기본 input 값 변환
				saleslist.구매 = parseInt(saleslist.구매) || 0;
				saleslist.배대지 = parseInt(saleslist.배대지) || 0;
				saleslist.입고중 = parseInt(saleslist.입고중) || 0;
				saleslist.국내재고 = parseInt(saleslist.국내재고) || 0;

				// 계산 값 저장
				const metrics = this.calculateInventoryMetrics(saleslist);
				saleslist.남은재고기간 = metrics.남은재고기간;
				saleslist.구매필요수량 = metrics.구매필요수량;
				saleslist.dday = metrics.dday;

				// Series 계산 값도 저장
				saleslist.seriesDday = this.calculateSeriesDday(saleslist);
				saleslist.seriesNeededQty = this.calculateSeriesNeededQty(saleslist);
				saleslist.seriesNeededDays = this.calculateSeriesNeededDays(saleslist);

				// 2. 타겟키워드 처리
				if (saleslist.타겟키워드) {
					const sameProductItems = this.saleslists.filter(item =>
						item.productId === saleslist.productId
					);

					if (this.saleslistsinit[index].타겟키워드 !== saleslist.타겟키워드) {
						const keywordForecast = await this.getKeywordData(saleslist.dates, saleslist.타겟키워드);
						if (keywordForecast?.length > 0) {
							for (const item of sameProductItems) {
								item.타겟키워드 = saleslist.타겟키워드;
								item.keywordForecast = keywordForecast;
								item.forecastAI = await this.getForecastAI(keywordForecast, item);

								// 메트릭 재계산 및 값 저장
								const itemMetrics = this.calculateInventoryMetrics(item);
								item.남은재고기간 = itemMetrics.남은재고기간;
								item.구매필요수량 = itemMetrics.구매필요수량;
								item.dday = itemMetrics.dday;

								// Series 계산 값도 저장
								item.seriesDday = this.calculateSeriesDday(item);
								item.seriesNeededQty = this.calculateSeriesNeededQty(item);
								item.seriesNeededDays = this.calculateSeriesNeededDays(item);

								// saleslistsinit 업데이트
								const initIndex = this.saleslistsinit.findIndex(i => i.vendorItemId === item.vendorItemId);
								if (initIndex !== -1) {
									this.saleslistsinit[initIndex].타겟키워드 = item.타겟키워드;
								}
							}
						}
					}
				} else {
					const sameProductItems = this.saleslists.filter(item =>
						item.productId === saleslist.productId
					);

					for (const item of sameProductItems) {
						item.타겟키워드 = '';
						item.keywordForecast = [];
						item.forecastAI = [];

						// 메트릭 재계산 및 값 저장
						const itemMetrics = this.calculateInventoryMetrics(item);
						item.남은재고기간 = itemMetrics.남은재고기간;
						item.구매필요수량 = itemMetrics.구매필요수량;
						item.dday = itemMetrics.dday;

						// Series 계산 값도 저장
						item.seriesDday = this.calculateSeriesDday(item);
						item.seriesNeededQty = this.calculateSeriesNeededQty(item);
						item.seriesNeededDays = this.calculateSeriesNeededDays(item);

						const initIndex = this.saleslistsinit.findIndex(i => i.vendorItemId === item.vendorItemId);
						if (initIndex !== -1) {
							this.saleslistsinit[initIndex].타겟키워드 = '';
						}
					}
				}

				// 3. 동일 구매링크 상품 처리
				const dbItem = this.$store.state.growthdb.find(x => x.vendorItemId === saleslist.vendorItemId);
				if (dbItem?.구매정보?.[0]?.구매링크) {
					const offerId = this.extractOfferIdFromUrl(dbItem.구매정보[0].구매링크);
					if (offerId) {
						const sameGroupItems = this.saleslists.filter(item => {
							const otherDbItem = this.$store.state.growthdb.find(x => x.vendorItemId === item.vendorItemId);
							if (!otherDbItem?.구매정보?.[0]?.구매링크) return false;
							return this.extractOfferIdFromUrl(otherDbItem.구매정보[0].구매링크) === offerId;
						});

						for (const groupItem of sameGroupItems) {
							// 메트릭 재계산 및 값 저장
							const groupMetrics = this.calculateInventoryMetrics(groupItem);
							groupItem.남은재고기간 = groupMetrics.남은재고기간;
							groupItem.구매필요수량 = groupMetrics.구매필요수량;
							groupItem.dday = groupMetrics.dday;

							// Series 계산 값도 저장
							groupItem.seriesDday = this.calculateSeriesDday(groupItem);
							groupItem.seriesNeededQty = this.calculateSeriesNeededQty(groupItem);
							groupItem.seriesNeededDays = this.calculateSeriesNeededDays(groupItem);
						}
					}
				}

				// 4. 차트 업데이트
				this.$nextTick(() => {
					if (this.$refs.mainChart && this.$refs.mainChart.chart) {
						this.$refs.mainChart.chart.updateOptions(saleslist.chart);
					}
				});

			} catch (error) {
				console.error('Error in changePo:', error);
				alert('처리 중 오류가 발생했습니다.');
			}
		},
		generateChartData(item, forecastSeries, forecastAI, dates) {
			// 기본 시리즈 배열
			const series = [
				{
					name: '예상 판매수량(series)',
					data: item.salesHistory.concat(forecastSeries).map(val => val || 0),
					type: 'line',
					yAxisIndex: 0
				},
				{
					name: '예상 판매수량(AI+키워드추세)',
					data: item.salesHistory.concat(forecastAI).map(val => val || 0),
					type: 'line',
					yAxisIndex: 0
				},
				{
					name: '방문자수',
					data: item.visitorHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '페이지뷰',
					data: item.pageViewHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '장바구니',
					data: item.cartHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '주문수',
					data: item.orderHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '전환율(%)',
					data: item.pvToOrder.map(val => val || 0),
					type: 'line',
					yAxisIndex: 2
				}
			];

			// 번들 제품 판매수량 추가
			if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
				// console.log('번들 제품 차트 데이터 추가:', item.upBundlingProducts.length, '개');
				item.upBundlingProducts.forEach((bundle, index) => {
					if (bundle.salesHistory && bundle.salesHistory.length > 0) {
						const bundleSize = bundle.upBundlingSize || 1;
						const bundleName = bundle.옵션명 || bundle.listingDetails?.vendorInventoryItemName || `번들 ${index + 1}`;
						// 번들 제품의 실제 판매량 (번들 사이즈 적용)
						const bundleActualSales = bundle.salesHistory.map(val => (val || 0) * bundleSize);
						const bundleSeries = {
							name: `번들x${bundleSize} (${bundleName})`,
							data: bundleActualSales,
							type: 'line',
							yAxisIndex: 0,
							color: '#FF6B6B'
						};
						// console.log('번들 시리즈 추가:', bundleSeries.name, bundleSeries.data);
						series.push(bundleSeries);
					}
				});
			}

			// 반품상품 판매수량 추가
			if (item.returnProducts && item.returnProducts.length > 0) {
				// console.log('반품 제품 차트 데이터 추가:', item.returnProducts.length, '개');
				item.returnProducts.forEach((returnProduct, index) => {
					if (returnProduct.salesHistory && returnProduct.salesHistory.length > 0) {
						const returnGrade = returnProduct.skuGrade == 'PACKAGE_DAMAGED' ? '미개봉' :
							returnProduct.skuGrade == 'RETURN_BEST' ? '최상' :
								returnProduct.skuGrade == 'RETURN_GOOD' ? '상' : '중';
						const returnName = returnProduct.옵션명 || returnProduct.listingDetails?.vendorInventoryItemName || `반품 ${index + 1}`;
						const returnSeries = {
							name: `반품-${returnGrade} (${returnName})`,
							data: returnProduct.salesHistory.map(val => val || 0),
							type: 'line',
							yAxisIndex: 0,
							color: '#4ECDC4'
						};
						// console.log('반품 시리즈 추가:', returnSeries.name, returnSeries.data);
						series.push(returnSeries);
					}
				});
			}

			// console.log('최종 차트 시리즈:', series.map(s => s.name));

			return {
				series: series,
				chart: {
					type: 'line',
					height: 500,
					width: 1200,
					animations: {
						enabled: false
					}
				},
				colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8'],
				stroke: {
					width: Array(series.length).fill(2),
					curve: 'smooth'
				},
				dataLabels: {
					enabled: false
				},
				markers: {
					size: 3
				},
				xaxis: {
					categories: dates.map(date => date || ''),
					title: {
						text: '날짜'
					}
				},
				yaxis: [
					{
						min: 0,
						max: (() => {
							// 모든 판매 데이터 수집
							let allSalesData = [
								...item.salesHistory,
								...item.salesHistory.concat(forecastSeries),
								...item.salesHistory.concat(forecastAI)
							];

							// 번들 제품 판매량 추가
							if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
								item.upBundlingProducts.forEach(bundle => {
									if (bundle.salesHistory) {
										const bundleSize = bundle.upBundlingSize || 1;
										allSalesData.push(...bundle.salesHistory.map(val => (val || 0) * bundleSize));
									}
								});
							}

							// 반품 제품 판매량 추가
							if (item.returnProducts && item.returnProducts.length > 0) {
								item.returnProducts.forEach(returnProduct => {
									if (returnProduct.salesHistory) {
										allSalesData.push(...returnProduct.salesHistory);
									}
								});
							}

							return Math.max(...allSalesData.map(val => val || 0)) * 1.1 || 100;
						})(),
						title: {
							text: '판매수량'
						},
						labels: {
							formatter: function (val) {
								return val ? Math.round(val).toString() : '0'
							}
						}
					},
					{
						min: 0,
						max: Math.max(...[
							...item.visitorHistory,
							...item.pageViewHistory,
							...item.cartHistory,
							...item.orderHistory
						].map(val => val || 0)) * 1.1 || 100,
						title: {
							text: '트래픽/주문'
						},
						opposite: true,
						labels: {
							formatter: function (val) {
								return val ? Math.round(val).toString() : '0'
							}
						}
					},
					{
						opposite: true,
						min: 0,
						max: Math.max(...item.pvToOrder.map(val => val || 0)) * 1.1 || 1,
						title: {
							text: '전환율(%)',
							offsetX: -20
						},
						labels: {
							formatter: function (val) {
								return typeof val === 'number' ? val.toFixed(2) + '%' : '0%'
							},
							offsetX: -30
						},
						tickAmount: 5,
						forceNiceScale: true,
						decimalsInFloat: 2
					}
				],
				tooltip: {
					shared: true,
					intersect: false,
					y: [{
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? y.toFixed(2) + '%' : '0%'
						}
					}]
				},
				legend: {
					show: true,
					position: 'top',
					horizontalAlign: 'left',
					floating: false,
					fontSize: '12px',
					fontFamily: 'Helvetica, Arial',
					fontWeight: 400,
					formatter: undefined,
					inverseOrder: false,
					width: undefined,
					height: undefined,
					tooltipHoverFormatter: undefined,
					customLegendItems: [],
					offsetX: 0,
					offsetY: 0,
					labels: {
						colors: undefined,
						useSeriesColors: false
					},
					markers: {
						width: 12,
						height: 12,
						strokeWidth: 0,
						strokeColor: '#fff',
						fillColors: undefined,
						radius: 12,
						customHTML: undefined,
						onClick: undefined,
						offsetX: 0,
						offsetY: 0
					},
					itemMargin: {
						horizontal: 5,
						vertical: 0
					},
					onItemClick: {
						toggleDataSeries: true
					},
					onItemHover: {
						highlightDataSeries: true
					}
				}
			};
		},
		// 판매량 전용 차트 생성 (번들/반품 포함)
		getSalesChartOption(item) {
			try {
				// 올바른 데이터 필드 사용
				// salesHistory 사용 (음수 값 처리 중요!)
				const salesHistory = Array.isArray(item.salesHistory) ?
					item.salesHistory.map(val => {
						const num = Number(val);
						// 음수 값 유지 (반품으로 인한 음수 판매량)
						return isNaN(num) ? 0 : num;
					}) :
					Array(30).fill(0);

				// dates 필드 사용
				const dates = Array.isArray(item.dates) ?
					item.dates.slice(0, 30) :
					Array(30).fill('').map((_, i) => `Day ${i + 1}`);

				console.log('getSalesChartOption - 원본 salesHistory:', item.salesHistory);
				console.log('getSalesChartOption - 처리된 salesHistory:', salesHistory);

				// 데이터 길이 맞추기
				const dataLength = Math.min(salesHistory.length, dates.length, 30);
				const alignedSales = salesHistory.slice(0, dataLength);
				const alignedDates = dates.slice(0, dataLength);

				// 간단한 시리즈 생성
				const series = [{
					name: '메인 판매량',
					data: alignedSales,
					type: 'column'
				}];

				// 번들 제품 추가 (간단하게)
				if (item.upBundlingProducts && Array.isArray(item.upBundlingProducts)) {
					item.upBundlingProducts.forEach((bundle, index) => {
						if (bundle && bundle.salesHistory && Array.isArray(bundle.salesHistory)) {
							const bundleSize = Math.max(1, Number(bundle.upBundlingSize) || 1);
							const bundleName = bundle.옵션명 || `번들 ${index + 1}`;
							const bundleData = bundle.salesHistory
								.slice(0, dataLength)
								.map(val => {
									const num = Number(val) || 0;
									return num * bundleSize; // 음수 값 유지
								});

							series.push({
								name: `번들x${bundleSize} (${bundleName})`,
								data: bundleData,
								type: 'column'
							});
						}
					});
				}

				// 반품 제품 추가 (간단하게)
				if (item.returnProducts && Array.isArray(item.returnProducts)) {
					item.returnProducts.forEach((returnProduct, index) => {
						if (returnProduct && returnProduct.salesHistory && Array.isArray(returnProduct.salesHistory)) {
							const returnGrade = returnProduct.skuGrade === 'PACKAGE_DAMAGED' ? '미개봉' :
								returnProduct.skuGrade === 'RETURN_BEST' ? '최상' :
								returnProduct.skuGrade === 'RETURN_GOOD' ? '상' : '중';
							const returnName = returnProduct.옵션명 || `반품 ${index + 1}`;
							const returnData = returnProduct.salesHistory
								.slice(0, dataLength)
								.map(val => {
									const num = Number(val) || 0;
									return num; // 음수 값 유지
								});

							series.push({
								name: `반품-${returnGrade} (${returnName})`,
								data: returnData,
								type: 'column'
							});
						}
					});
				}

				// Y축 범위 계산 (음수 값 포함)
				const allValues = series.reduce((acc, s) => acc.concat(s.data), []);
				const maxValue = Math.max(...allValues, 1);
				const minValue = Math.min(...allValues, 0);

				// 음수가 있으면 최소값을 조정, 없으면 0부터 시작
				const yMin = minValue < 0 ? minValue * 1.2 : 0;
				const yMax = maxValue > 0 ? maxValue * 1.2 : 10;

				console.log('Y축 범위 계산:', { allValues, minValue, maxValue, yMin, yMax });

				return {
					series: series,
					chart: {
						type: 'column',
						height: 300,
						animations: { enabled: false },
						toolbar: { show: false }
					},
					plotOptions: {
						bar: {
							columnWidth: '60%'
						}
					},
					colors: ['#008FFB', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'],
					xaxis: {
						categories: alignedDates
					},
					yaxis: {
						title: { text: '판매수량' },
						min: yMin,
						max: yMax
					},
					legend: {
						show: true,
						position: 'top'
					},
					tooltip: {
						shared: true,
						y: {
							formatter: (val) => Math.round(val) + '개'
						}
					}
				};
			} catch (error) {
				console.error('판매량 차트 생성 오류:', error);
				return this.getEmptySalesChart();
			}
		},
		// 빈 판매량 차트 반환
		getEmptySalesChart() {
			return {
				series: [{
					name: '데이터 없음',
					data: Array(30).fill(0),
					type: 'column'
				}],
				chart: {
					type: 'column',
					height: 300,
					animations: { enabled: false },
					toolbar: { show: false }
				},
				colors: ['#E0E0E0'],
				xaxis: {
					categories: Array(30).fill('').map((_, i) => `Day ${i + 1}`)
				},
				yaxis: {
					title: { text: '판매수량' },
					min: 0,
					max: 10
				},
				legend: { show: false },
				tooltip: { enabled: false }
			};
		},
		// 공통 오늘 날짜 계산 함수
		getTodayString() {
			const today = new Date();
			const year = today.getFullYear();
			const month = ("0" + (1 + today.getMonth())).slice(-2);
			const day = ("0" + today.getDate()).slice(-2);
			return `${year}-${month}-${day}`;
		},

		getMonthDates() {
			// 공통 함수를 사용해서 오늘 날짜 계산
			const todayStr = this.getTodayString();
			// generateDatesFromUpdateDate와 동일한 로직 사용
			return this.generateDatesFromUpdateDate(todayStr);
		},
		async collectGrowthSales() {
			// 공통 함수를 사용해서 오늘 날짜 계산
			var updateDate = this.getTodayString();

			console.log('=== collectGrowthSales 날짜 디버깅 ===');
			console.log('계산된 updateDate:', updateDate);
			console.log('==============================');

			// 수집 날짜 범위 계산
			const dateRange = await this.calculateCollectionDateRange();

			if (this.saleslists.find(e => e.updateDate == updateDate)) {
				// 이미 수집된 경우 30일 재수집 확인
				if (confirm('이미 오늘자 데이터가 수집되었습니다.\n다시 수집하시겠습니까? (재수집 시 30일간 데이터가 재수집됩니다.)')) {
					var fullRange = this.getFullDateRange();
					console.log('30일 강제 재수집 시작:', fullRange);
					// [수집로직 일원화] manualCollect로 통합
					this.beginOwnCollection();
					window.postMessage({
						greeting: "manualCollect",
						itemKey: "rocketGrowthSales",
						companyid: this.$store.state.user.companyid,
						suppliercode: this.$store.state.user.suppliercode,
						options: { dateRange: { startDate: fullRange.startDate, endDate: fullRange.endDate } }
					}, "*");
					this.showspinner1 = true;
					this.showlist = false;
				} else {
					this.showspinner1 = false;
					this.showlist = true;
				}
			} else {
				// [수집로직 일원화] manualCollect로 통합
				this.beginOwnCollection();
				window.postMessage({
					greeting: "manualCollect",
					itemKey: "rocketGrowthSales",
					companyid: this.$store.state.user.companyid,
					suppliercode: this.$store.state.user.suppliercode,
					options: { dateRange: { startDate: dateRange.startDate, endDate: dateRange.endDate } }
				}, "*");
				this.showspinner1 = true;
				this.showlist = false;
			}
		},

		// ✅ 30일 강제 재수집 메서드
		async forceCollect30Days() {
			if (!confirm('30일 전체 데이터를 강제로 재수집하시겠습니까?\n기존 데이터가 덮어씌워집니다.')) {
				return;
			}

			var fullRange = this.getFullDateRange();
			console.log('30일 강제 재수집 시작:', fullRange);

			// [수집로직 일원화] manualCollect로 통합
			this.beginOwnCollection();
			window.postMessage({
				greeting: "manualCollect",
				itemKey: "rocketGrowthSales",
				companyid: this.$store.state.user.companyid,
				suppliercode: this.$store.state.user.suppliercode,
				options: { dateRange: { startDate: fullRange.startDate, endDate: fullRange.endDate } }
			}, "*");

			this.showspinner1 = true;
			this.showlist = false;
		},

		// ✅ 특정 날짜 범위 수집 메서드
		async collectCustomDateRange() {
			// 날짜 입력 모달 표시
			this.$bvModal.show('customDateRangeModal');
		},

		// ✅ 사용자 지정 날짜 범위로 수집 실행
		async executeCustomDateCollection() {
			if (!this.customStartDate || !this.customEndDate) {
				alert('시작일과 종료일을 모두 입력해주세요.');
				return;
			}

			if (new Date(this.customStartDate) > new Date(this.customEndDate)) {
				alert('시작일이 종료일보다 늦을 수 없습니다.');
				return;
			}

			const daysDiff = Math.ceil((new Date(this.customEndDate) - new Date(this.customStartDate)) / (1000 * 60 * 60 * 24)) + 1;

			if (!confirm(`${this.customStartDate} ~ ${this.customEndDate} (${daysDiff}일) 데이터를 수집하시겠습니까?`)) {
				return;
			}

			console.log('사용자 지정 날짜 범위 수집:', this.customStartDate, '~', this.customEndDate);

			// [수집로직 일원화] manualCollect로 통합
			this.beginOwnCollection();
			window.postMessage({
				greeting: "manualCollect",
				itemKey: "rocketGrowthSales",
				companyid: this.$store.state.user.companyid,
				suppliercode: this.$store.state.user.suppliercode,
				options: { dateRange: { startDate: this.customStartDate, endDate: this.customEndDate } }
			}, "*");

			this.showspinner1 = true;
			this.showlist = false;
			this.$bvModal.hide('customDateRangeModal');
		},

		// 수집 날짜 범위 계산
		async calculateCollectionDateRange() {
			try {
				// 기존 일별 판매 데이터 확인
				const result = await axios.post('/api/getLatestSalesData', {
					companyid: this.$store.state.user.companyid
				});

				if (result.data.res === 'success' && result.data.latestDate) {
					// 마지막 수집 날짜부터 어제까지 (공통 함수 사용)
					const latestDate = new Date(result.data.latestDate + 'T00:00:00'); // 로컬 시간으로 파싱
					const todayStr = this.getTodayString();
					const yesterdayStr = this.generateDatesFromUpdateDate(todayStr)[29]; // 마지막 날짜가 어제
					const yesterday = new Date(yesterdayStr + 'T00:00:00');

					// 그저께 날짜 계산 (최소 2일 수집 보장)
					const dayBeforeYesterday = new Date(yesterday);
					dayBeforeYesterday.setDate(yesterday.getDate() - 1);

					// 마지막 수집 날짜 다음날부터 시작
					let startDate = new Date(latestDate);
					startDate.setDate(startDate.getDate() + 1);

					// ✅ 최소 2일(어제, 그저께) 수집 보장: startDate가 그저께보다 늦으면 그저께로 조정
					if (startDate > dayBeforeYesterday) {
						startDate = dayBeforeYesterday;
					}

					console.log('=== 날짜 범위 계산 디버깅 ===');
					console.log('latestDate (마지막 수집):', this.formatDateForCollection(latestDate));
					console.log('dayBeforeYesterday (그저께):', this.formatDateForCollection(dayBeforeYesterday));
					console.log('startDate (시작일):', this.formatDateForCollection(startDate));
					console.log('yesterday (어제):', this.formatDateForCollection(yesterday));

					// 수집 범위 반환 (최소 2일 보장됨)
					const dateRange = {
						startDate: this.formatDateForCollection(startDate),
						endDate: this.formatDateForCollection(yesterday)
					};
					console.log('수집 범위 (최소 2일 보장):', dateRange);
					console.log('==============================');
					return dateRange;
				} else {
					// 기존 데이터가 없으면 전체 30일
					return this.getFullDateRange();
				}
			} catch (error) {
				console.error('날짜 범위 계산 오류:', error);
				// 오류 시 전체 30일
				return this.getFullDateRange();
			}
		},
		// 전체 30일 날짜 범위 반환
		getFullDateRange() {
			// 공통 함수를 사용해서 어제 기준 30일 범위 계산
			const todayStr = this.getTodayString();
			const dates = this.generateDatesFromUpdateDate(todayStr);

			console.log('=== 전체 30일 범위 계산 ===');
			console.log('어제 기준 30일 범위:', `${dates[0]} ~ ${dates[dates.length - 1]}`);
			console.log('==========================');

			return {
				startDate: dates[0],
				endDate: dates[dates.length - 1]
			};
		},
		// 날짜 포맷팅 (YYYY-MM-DD)
		formatDateForCollection(date) {
			const year = date.getFullYear();
			const month = ("0" + (1 + date.getMonth())).slice(-2);
			const day = ("0" + date.getDate()).slice(-2);
			return `${year}-${month}-${day}`;
		},
		changeleadtime(saleslist) {
			var obj = {
				vendorItemId: saleslist.vendorItemId,
				입고리드타임: saleslist.입고리드타임
			}
			if (this.$store.state.user.companyid) {
				axios.post('/api/ai/updateleadtime', { companyid: this.$store.state.user.companyid, vendorItemId: obj.vendorItemId, 입고리드타임: obj.입고리드타임 })
					.then(result => {
						console.log(result);
						if (result.data.요청결과 == 'ok') {
							this.$store.commit('updateleadtime', obj)
						} else {
							alert('저장실패(276)'); console.log(result)
						}
					})
					.catch(e => { alert('저장실패(279)'); console.log(e) })
			}
		},
		clickleadtime(saleslist) {
			if (saleslist.showleadtime) {
				saleslist.showleadtime = false;
			}
		},
		showtotal() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.saleslists = this.visibleInit().filter(item => !item.hidden);
			setTimeout(() => { this.showlist = true; }, 10)
		},
		showReturn() {
			// "반품 보여줘" 는 의도가 명확하니 토글을 켜준다 — 안 켜면 최상위 반품행이 걸러져
			// 카운트와 실제 표시가 어긋난다.
			this.showReturnProducts = true;
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.saleslistsinit.filter(e => this.isReturnRow(e) && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 숨김 상품만 표시
		showHidden() {
			this.showlist = false;
			this.isShowingHidden = true;
			// 숨김상품 필터는 체크를 초기화하지 않음 (복원 기능을 위해)
			this.saleslists = this.saleslistsinit.filter(e => e.hidden);
			setTimeout(() => { this.showlist = true; }, 10);
		},
		// 선택한 상품들 숨김 처리
		async hideSelectedItems() {
			if (this.tableSelectedItem.length === 0) {
				alert('숨길 상품을 선택해주세요.');
				return;
			}

			try {
				// 숨김은 상품관리와 같은 API 를 쓴다. 서버가 GrowthDB·GrowthProductDB·GrowthSales
				// 세 곳에 함께 표시하므로 여기서 숨기면 상품관리에서도 감춰진다(예전에는 GrowthSales 에만
				// 써서 상품관리에 그대로 나왔다).
				const updatedItems = this.tableSelectedItem.map(item => String(item.vendorItemId));
				const response = await axios.post('/api/growthdb/hideProduct', updatedItems);

				if (response.data.res === 'success') {
					// 로컬 상태 업데이트
					this.tableSelectedItem.forEach(item => {
						item.hidden = true;
					});

					// 숨김 상품을 목록에서 제거
					this.saleslists = this.saleslists.filter(item => !item.hidden);
					this.saleslistsinit = this.saleslistsinit.map(item => {
						if (this.tableSelectedItem.some(selected => selected.vendorItemId === item.vendorItemId)) {
							item.hidden = true;
						}
						return item;
					});

					this.updateCounts();
					this.tableSelectedItem = [];
					alert(`${updatedItems.length}개 상품이 숨김 처리되었습니다.`);
				} else {
					alert('숨김 처리에 실패했습니다: ' + response.data.alert);
				}
			} catch (error) {
				console.error('숨김 처리 중 오류:', error);
				alert('숨김 처리 중 오류가 발생했습니다.');
			}
		},
		// 선택한 상품들 복원 처리
		async restoreSelectedItems() {
			if (this.tableSelectedItem.length === 0) {
				alert('복원할 상품을 선택해주세요.');
				return;
			}

			try {
				// 복원도 상품관리와 같은 API. 서버가 세 컬렉션을 모두 풀어준다
				// — 한 곳만 풀면 합집합 판정에서 계속 숨김으로 남는다.
				const updatedItems = this.tableSelectedItem.map(item => String(item.vendorItemId));
				const response = await axios.post('/api/growthdb/showProduct', updatedItems);

				if (response.data.res === 'success') {
					// 로컬 상태 업데이트
					this.tableSelectedItem.forEach(item => {
						item.hidden = false;
					});

					// 복원된 상품을 숨김 목록에서 제거
					this.saleslists = this.saleslists.filter(item => item.hidden);
					this.saleslistsinit = this.saleslistsinit.map(item => {
						if (this.tableSelectedItem.some(selected => selected.vendorItemId === item.vendorItemId)) {
							item.hidden = false;
						}
						return item;
					});

					this.updateCounts();
					this.tableSelectedItem = [];
					alert(`${updatedItems.length}개 상품이 복원되었습니다.`);
				} else {
					alert('복원 처리에 실패했습니다: ' + response.data.alert);
				}
			} catch (error) {
				console.error('복원 처리 중 오류:', error);
				alert('복원 처리 중 오류가 발생했습니다.');
			}
		},
		// 카운트 업데이트
		// 화면에 내보낼 기준 목록. "반품상품보기" 가 꺼져 있으면 최상위로 올라온 반품등급 행도 감춘다.
		// 부모에 매달린 반품 옵션은 각 행 안에서 v-if 로 접히지만, 단독 행은 자기가 한 줄이라
		// 목록에서 빼야 토글 의미가 맞는다. 상품관리(growthdb.vue)와 동일 규칙.
		visibleInit() {
			if (this.showReturnProducts) return this.saleslistsinit;
			return this.saleslistsinit.filter(e => !(e.skuGrade && e.skuGrade !== 'NEW'));
		},
		// 반품 관련 행은 두 모양이다 — ① 반품 옵션을 거느린 부모 ② 자기가 최상위로 올라온 반품등급 행
		isReturnRow(e) {
			return (e.returnProducts && e.returnProducts.length > 0) || (e.skuGrade && e.skuGrade !== 'NEW');
		},
		updateCounts() {
			// 전체 뱃지는 실제로 보이는 행 수와 맞춘다(반품상품보기 OFF 면 최상위 반품행이 빠진다).
			const visibleItems = this.visibleInit().filter(item => !item.hidden);
			// 나머지 카운트는 전체 기준을 유지한다 — 특히 반품 카운트가 토글에 따라 0이 되면
			// 반품이 있다는 사실 자체를 알 수 없어 누를 수가 없다.
			const allItems = this.saleslistsinit.filter(item => !item.hidden);

			this.totalCnt = visibleItems.length;
			this.needPo = allItems.filter(item => item.dday >= 0 || item.구매필요수량 > 0).length;
			this.needOverseasOutbound = allItems.filter(item => item.배대지출고Dday >= 0 || item.배대지출고필요수량 > 0).length;
			this.needDomesticOutbound = allItems.filter(item => item.국내출고Dday >= 0 || item.국내출고필요수량 > 0).length;
			this.monthlyCntOver0 = allItems.filter(item => item.월판매수량 > 0).length;
			this.stockDangerCnt = allItems.filter(item => this.isCoupangStockDanger(item)).length;
			this.overStockCnt = allItems.filter(item => this.isOverStock(item)).length;
			this.returnProducts = allItems.filter(item => this.isReturnRow(item)).length;
			this.hiddenProducts = this.saleslistsinit.filter(item => item.hidden).length;
		},
		showNeedReturn() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.saleslists = this.visibleInit().filter(e => e.판매 > 0 && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		showMonthlyCntOver0() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.visibleInit().filter(e => e.월판매수량 > 0 && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 품절예고 상품 표시 (쿠팡재고기간이 안전재고기간보다 짧은 경우)
		showStockDanger() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.visibleInit().filter(e => this.isCoupangStockDanger(e) && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 과재고위험 상품 표시
		showOverStock() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.visibleInit().filter(e => this.isOverStock(e) && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 재고 위험 판단 (남은재고기간, 쿠팡재고기간, 전체가용재고기간 중 하나라도 위험하면 true)
		isStockDanger(item) {
			if (!item.최소재고기간) return false;

			const safetyDays = parseFloat(item.최소재고기간);

			// 남은재고기간 체크 (기존 로직)
			if (item.남은재고기간) {
				const remainingDays = parseFloat(item.남은재고기간);
				if (remainingDays < safetyDays && remainingDays >= 0) {
					return true;
				}
			}

			// 쿠팡재고기간 체크
			if (this.isCoupangStockDanger(item)) {
				return true;
			}

			// 전체가용재고기간 체크 (새로운 로직)
			if (this.isTotalStockDanger(item)) {
				return true;
			}

			return false;
		},
		// 재고 위험 CSS 클래스
		getStockDangerClass(item) {
			return this.isStockDanger(item) ? 'text-danger font-weight-bold' : '';
		},
		// 재고 위험 툴팁
		getStockDangerTooltip(item) {
			if (this.isStockDanger(item)) {
				return `경고: 남은재고기간(${item.남은재고기간}일)이 안전재고기간(${item.최소재고기간}일)보다 짧습니다!`;
			}
			return '';
		},
		// 반품 상품 재고 위험 판단
		isReturnStockDanger(returnItem, parentItem) {
			if (!returnItem.남은재고기간 || !parentItem.최소재고기간) return false;
			const remainingDays = parseFloat(returnItem.남은재고기간);
			const safetyDays = parseFloat(parentItem.최소재고기간);
			return remainingDays < safetyDays && remainingDays >= 0;
		},
		// 반품 상품 재고 위험 CSS 클래스
		getReturnStockDangerClass(returnItem, parentItem) {
			return this.isReturnStockDanger(returnItem, parentItem) ? 'text-danger font-weight-bold' : '';
		},
		// 반품 상품 재고 위험 툴팁
		getReturnStockDangerTooltip(returnItem, parentItem) {
			if (this.isReturnStockDanger(returnItem, parentItem)) {
				return `경고: 남은재고기간(${returnItem.남은재고기간}일)이 안전재고기간(${parentItem.최소재고기간}일)보다 짧습니다!`;
			}
			return '';
		},
		// 쿠팡재고 위험 판단
		isCoupangStockDanger(item) {
			if (!item.쿠팡재고기간 || !item.최소재고기간) return false;
			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			const safetyDays = parseInt(item.최소재고기간) || 0;
			return stockDays <= safetyDays && stockDays >= 0;
		},
		// 전체가용재고기간 위험 판단
		isTotalStockDanger(item) {
			if (!item.남은재고기간 || !item.입고기간 || !item.최대재고기간) return false;
			const totalStockDays = parseFloat(item.남은재고기간) || 0;
			const inboundDays = parseFloat(item.입고기간) || 0;
			const targetDays = parseFloat(item.최대재고기간) || 0;
			const requiredDays = inboundDays + targetDays;
			return totalStockDays < requiredDays && totalStockDays >= 0;
		},
		// 전체가용재고기간 위험 CSS 클래스
		getTotalStockDangerClass(item) {
			if (this.isTotalStockDanger(item)) {
				return 'total-stock-danger text-white font-weight-bold';
			}
			// 기존 남은재고기간 위험도 체크
			return this.getStockDangerClass(item);
		},
		// 전체가용재고기간 위험 툴팁
		getTotalStockDangerTooltip(item) {
			if (this.isTotalStockDanger(item)) {
				const inboundDays = parseFloat(item.입고기간) || 0;
				const targetDays = parseFloat(item.최대재고기간) || 0;
				const requiredDays = inboundDays + targetDays;
				return `경고: 전체가용재고기간(${item.남은재고기간}일)이 \n구매입고기간+목표재고기간(${requiredDays}일)보다 짧아\n구매진행이 필요합니다!`;
			}
			// 기존 남은재고기간 툴팁 반환
			return this.getStockDangerTooltip(item);
		},
		// 예측 기반 재고 소진 기간(일) — 재고기간 계산의 단일 기준
		// forecast(AI 우선 → 시계열)로 하루씩 차감, 예측 소진 후 잔여는 평균 판매속도로 보완
		// (남은재고기간과 동일 공식. 모든 위치·쿠팡·전체가용 기간을 이 함수로 통일)
		calcForecastStockDays(quantity, item) {
			if (!quantity || quantity <= 0) return 0;

			// 목표 일판매수량이 있으면 우선 사용
			const 계산용일판매수량 = (item && item.목표일판매수량 && item.목표일판매수량 > 0)
				? item.목표일판매수량
				: (item ? item.일판매수량 : 0);
			if (!계산용일판매수량 || 계산용일판매수량 <= 0) return 0;

			const forecastData = (item && item.forecastAI && item.forecastAI.length > 0)
				? item.forecastAI
				: ((item && item.forecastSeries) ? item.forecastSeries : []);

			let 잔여 = quantity;
			let days = 0;
			for (const 예상판매량 of forecastData) {
				if (잔여 >= 예상판매량) {
					잔여 -= 예상판매량;
					days++;
				} else {
					break;
				}
			}
			// 예측 데이터 소진 후 남으면 평균속도로 보완
			if (잔여 > 0) {
				days += Math.floor(잔여 / 계산용일판매수량);
			}
			return days;
		},
		// 재고 기간 계산 (예측 기반, calcForecastStockDays 사용)
		getStockPeriod(stockQuantity, dailySales, item = null) {
			if (!stockQuantity || !dailySales || dailySales <= 0) {
				return '';
			}

			let days;
			if (item) {
				// 예측 기반 소진 기간 (모든 위치·전체재고 셀 통일)
				days = this.calcForecastStockDays(stockQuantity, item);
			} else {
				// item이 없으면 평균속도 단순 계산으로 폴백
				days = Math.floor(stockQuantity / dailySales);
			}

			// 재고가 있지만 1일 이내라면 0일로 표시
			if (stockQuantity > 0 && days < 1) {
				return '0일';
			}

			return days > 0 ? `${days}일` : '';
		},
		// 전체가용재고 계산
		getTotalAvailableStock(item) {
			const { 장기입고중, 단기입고중 } = this.classifyInboundInventory(item);
			return (item.구매 || 0) + (item.배대지 || 0) + (item.통관중 || 0) + (item.국내재고 || 0) + 장기입고중 + 단기입고중 + (item.재고 || 0);
		},
		// 개별 재고금액 계산
		// 재고금액 = 수량 × 원가.
		//
		// lot 이 있으면 lot 잔량 × lot 단가로 계산한다(정본 §4 점검표).
		// 남은 재고는 최근 lot 이라, 대표단가 하나를 곱하면 환율이 움직였을 때 금액이 틀어진다.
		// lot 이 없거나 lot 합이 수량을 못 덮으면 지금까지 쓰던 대표 매입가로 돌아간다.
		getStockAmount(quantity, vendorItemId) {
			if (!quantity || quantity <= 0) return 0;

			const growthItem = this.$store.state.growthdb.find(item => item.vendorItemId === vendorItemId);
			if (!growthItem) return 0;

			const v = lotStockValue(growthItem.매입정보, quantity);
			if (v) return v.금액;

			if (!growthItem.매입가) return 0;
			return Math.round(quantity * growthItem.매입가);
		},
		// 전체 재고금액 계산
		getTotalStockAmount() {
			if (!this.saleslists || this.saleslists.length === 0) return 0;

			let total = 0;
			this.saleslists.forEach(item => {
				if (item.isSummaryRow) return; // 종합 행 제외

				const totalStock = this.getTotalAvailableStock(item);
				const stockAmount = this.getStockAmount(totalStock, item.vendorItemId);
				total += stockAmount;
			});

			return total;
		},
		// 과재고 위험 판단 (쿠팡재고기간이 60일 초과)
		isOverStock(item) {
			if (!item.쿠팡재고기간) return false;
			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			return stockDays > 60;
		},
		// 쿠팡재고 박스 클래스 결정 (경고 스타일 포함)
		getCoupangStockBoxClass(item) {
			const baseClass = 'inventory-box-vertical text-white';

			if (!item.쿠팡재고기간) {
				return `${baseClass} bg-dark`;
			}

			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			const safetyDays = parseInt(item.최소재고기간) || 0;

			// 60일 초과 시 주황색 경고
			if (stockDays > 60) {
				return `${baseClass} stock-warning`;
			}

			// 안전재고기간 이하 시 빨간색 경고
			if (item.최소재고기간 && stockDays <= safetyDays) {
				return `${baseClass} stock-danger`;
			}

			// 정상 상태
			return `${baseClass} bg-dark`;
		},
		showNeedPo() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화

			// 1. D-Day가 0 이상이거나 구매필요수량이 0보다 큰 항목 필터링 (숨김 상품 제외)
			let filteredList = this.saleslistsinit.filter(e =>
				(e.dday >= 0 || e.구매필요수량 > 0) && !e.hidden
			);

			// 2. productId로 그룹화
			const groupedByProduct = {};
			filteredList.forEach(item => {
				if (!groupedByProduct[item.productId]) {
					groupedByProduct[item.productId] = [];
				}
				groupedByProduct[item.productId].push(item);
			});

			// 3. 각 그룹의 최대 D-Day를 기준으로 그룹 정렬
			// D-Day가 음수인 경우는 구매필요수량을 고려
			const sortedList = Object.entries(groupedByProduct)
				.sort(([, groupA], [, groupB]) => {
					// 각 그룹의 최대 D-Day 계산
					const maxDdayA = Math.max(...groupA.map(item => item.dday));
					const maxDdayB = Math.max(...groupB.map(item => item.dday));

					// D-Day가 모두 음수인 경우 구매필요수량으로 비교
					if (maxDdayA < 0 && maxDdayB < 0) {
						const maxNeededQtyA = Math.max(...groupA.map(item => item.구매필요수량));
						const maxNeededQtyB = Math.max(...groupB.map(item => item.구매필요수량));
						return maxNeededQtyB - maxNeededQtyA;
					}
					return maxDdayB - maxDdayA;
				})
				.flatMap(([, group]) => {
					// 각 그룹 내에서 D-Day 순으로 정렬하되,
					// D-Day가 음수인 경우는 구매필요수량으로 정렬
					return group.sort((a, b) => {
						if (a.dday < 0 && b.dday < 0) {
							return b.구매필요수량 - a.구매필요수량;
						}
						return b.dday - a.dday;
					});
				});

			this.saleslists = sortedList;
			setTimeout(() => { this.showlist = true; }, 10);
		},
		showNeedOverseasOutbound() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화

			// 배대지출고 D-Day가 0 이상이거나 배대지출고필요수량이 0보다 큰 항목 필터링 (숨김 상품 제외)
			let filteredList = this.saleslistsinit.filter(e =>
				(e.배대지출고Dday >= 0 || e.배대지출고필요수량 > 0) && !e.hidden
			);

			// productId로 그룹화 및 정렬
			const groupedByProduct = {};
			filteredList.forEach(item => {
				if (!groupedByProduct[item.productId]) {
					groupedByProduct[item.productId] = [];
				}
				groupedByProduct[item.productId].push(item);
			});

			const sortedList = Object.entries(groupedByProduct)
				.sort(([, groupA], [, groupB]) => {
					const maxDdayA = Math.max(...groupA.map(item => item.배대지출고Dday));
					const maxDdayB = Math.max(...groupB.map(item => item.배대지출고Dday));

					if (maxDdayA < 0 && maxDdayB < 0) {
						const maxNeededQtyA = Math.max(...groupA.map(item => item.배대지출고필요수량));
						const maxNeededQtyB = Math.max(...groupB.map(item => item.배대지출고필요수량));
						return maxNeededQtyB - maxNeededQtyA;
					}
					return maxDdayB - maxDdayA;
				})
				.flatMap(([, group]) => {
					return group.sort((a, b) => {
						if (a.배대지출고Dday < 0 && b.배대지출고Dday < 0) {
							return b.배대지출고필요수량 - a.배대지출고필요수량;
						}
						return b.배대지출고Dday - a.배대지출고Dday;
					});
				});

			this.saleslists = sortedList;
			setTimeout(() => { this.showlist = true; }, 10);
		},
		showNeedDomesticOutbound() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화

			// 국내출고 D-Day가 0 이상이거나 국내출고필요수량이 0보다 큰 항목 필터링 (숨김 상품 제외)
			let filteredList = this.saleslistsinit.filter(e =>
				(e.국내출고Dday >= 0 || e.국내출고필요수량 > 0) && !e.hidden
			);

			// productId로 그룹화 및 정렬
			const groupedByProduct = {};
			filteredList.forEach(item => {
				if (!groupedByProduct[item.productId]) {
					groupedByProduct[item.productId] = [];
				}
				groupedByProduct[item.productId].push(item);
			});

			const sortedList = Object.entries(groupedByProduct)
				.sort(([, groupA], [, groupB]) => {
					const maxDdayA = Math.max(...groupA.map(item => item.국내출고Dday));
					const maxDdayB = Math.max(...groupB.map(item => item.국내출고Dday));

					if (maxDdayA < 0 && maxDdayB < 0) {
						const maxNeededQtyA = Math.max(...groupA.map(item => item.국내출고필요수량));
						const maxNeededQtyB = Math.max(...groupB.map(item => item.국내출고필요수량));
						return maxNeededQtyB - maxNeededQtyA;
					}
					return maxDdayB - maxDdayA;
				})
				.flatMap(([, group]) => {
					return group.sort((a, b) => {
						if (a.국내출고Dday < 0 && b.국내출고Dday < 0) {
							return b.국내출고필요수량 - a.국내출고필요수량;
						}
						return b.국내출고Dday - a.국내출고Dday;
					});
				});

			this.saleslists = sortedList;
			setTimeout(() => { this.showlist = true; }, 10);
		},
		showNeedPriceAdjust() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.saleslists = this.visibleInit().filter(e => e.가격조정필요 === true && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		modalID(index) {
			// console.log(index);
			return 'modal' + index
		},
		async search() {
			this.showspinner1 = true;
			this.loadingtext = '로켓그로스 판매현황을 불러오는 중입니다.'
			// 공통 함수를 사용해서 오늘 날짜 계산
			var updateDate = this.getTodayString();

			console.log('=== search 날짜 디버깅 ===');
			console.log('계산된 updateDate:', updateDate);
			console.log('========================');

			// SCM 데이터 로딩
			await this.loadScmData();

			if (this.$store.state.growthSales.length > 0) {
				// console.log(this.$store.state.growthSales)
				// console.log(this.$store.state.growthSales.find(e => e.productId == 8871426961))
				// ✅ 일별 데이터에서 salesHistory 생성 후 표시
				await this.buildSalesDataFromDailySales(this.$store.state.growthSales);
				this.searchresult(this.$store.state.growthSales);

				// 기존 스토어 데이터 사용 시에도 오늘자 확인
				this.$nextTick(() => {
					console.log('=== Toast 디버깅 (기존 데이터) ===');
					console.log('updateDate (오늘):', updateDate);
					console.log('$store.state.growthSales 길이:', this.$store.state.growthSales.length);

					const todayItem = this.$store.state.growthSales.find(e => e.updateDate == updateDate);
					console.log('스토어에서 오늘자 찾음:', !!todayItem);

					if (todayItem) {
						console.log('오늘자 데이터 샘플:', {
							vendorItemId: todayItem.vendorItemId,
							updateDate: todayItem.updateDate
						});
					}

					// 모든 updateDate 확인
					const updateDates = [...new Set(this.$store.state.growthSales.map(e => e.updateDate))];
					console.log('스토어 updateDate 목록:', updateDates);
					console.log('================================');

					if (!todayItem) {
						// Toast 메시지 표시와 함께 버튼 상태 업데이트
						this.todayCollectionNeeded = true;
						this.$bvToast.toast('오늘자 판매현황을 수집해주세요!', {
							title: '데이터 수집 필요',
							variant: 'warning',
							solid: true,
							autoHideDelay: 3000
						});
					} else {
						// 오늘자 데이터가 있으면 수집 완료 상태
						this.todayCollectionNeeded = false;
					}
				});
			} else {
				try {
					if (this.$store.state.growthdb.length == 0) {
						try {
							var result = await axios.post('/api/getGrowthDBV2');
							if (result.data?.growthdb?.length == 0) {
								alert('로켓그로스 판매현황/SCM을 이용하기전에 로켓그로스 상품DB를 먼저 수집해주세요')
								this.$router.push({ name: 'growth.growthdb' })
								return
							}
							this.$store.commit('growthdbupdate', result.data.growthdb);
						} catch (e) {
							console.log('로켓그로스 상품DB 불러오기 실패')
							console.log(e)
						}
					}

					// 쿠패스연동이 ON일 때 processStatus 기반 데이터 가져오기
					this.coupassData = [];
					if (this.coupassSyncEnabled) {
						try {
							console.log('쿠패스연동 데이터 가져오는 중...');
							const coupassResult = await axios.post('/api/reqpurchase/getOngoingList', {
								companyid: this.$store.state.user.companyid,
								status: ['구매완료', '배송중', '배송완료', '입고작업', '출고확인대기', '재고대기', '출고요청', '출고대기', '중국재고', '국내창고입고중']
							});

							if (coupassResult.data.요청결과 === 'success') {
								this.coupassData = coupassResult.data.reqpurchase || [];
								console.log('쿠패스연동 데이터 로드 완료:', this.coupassData.length, '건');
							} else {
								console.warn('쿠패스연동 데이터 로드 실패:', coupassResult.data);
							}
						} catch (error) {
							console.error('쿠패스연동 데이터 가져오기 오류:', error);
						}

						// Inventory 컬렉션에서 바코드별 수량 매핑 로딩
						try {
							const invResult = await axios.post('/api/inventory/getList', {
								companyid: this.$store.state.user.companyid
							});
							if (invResult.data.요청결과 === 'ok' && invResult.data.items) {
								this.inventoryMap = {};
								invResult.data.items.forEach(inv => {
									if (inv.barcode) {
										this.inventoryMap[inv.barcode] = (this.inventoryMap[inv.barcode] || 0) + (inv.수량 || 0);
									}
								});
								console.log('Inventory 데이터 로드 완료:', Object.keys(this.inventoryMap).length, '건');
							}
						} catch (error) {
							console.error('Inventory 데이터 가져오기 오류:', error);
						}

						// 재고 원장 잔량 로딩 (정본 §5 Phase 2-11).
						// 창고 엑셀이 만든 InventoryMovement 에서 파생된 위치별 잔량이다.
						// 원장이 비어 있으면(= 창고가 아직 안 올림) 맵이 비고, 수량 칸은 지금 값 그대로 간다.
						try {
							const balResult = await axios.post('/api/warehouse/balance', {
								companyid: this.$store.state.user.companyid
							});
							if (balResult.data.요청결과 === '성공' && Array.isArray(balResult.data.balance)) {
								// ⚠ 위치가 맞는 행이 있을 때만 칸을 만든다.
								//   /api/warehouse/balance 는 위치를 안 주면 전 위치를 돌려준다 —
								//   운송중 · KR_센터:* · 폐기 · 반품 까지. 출고하면 반드시 '운송중' 행이
								//   생기므로, 먼저 칸부터 만들면 CN/KR 이 없는 상품이 0 으로 덮인다.
								//   "모른다"(칸 없음)와 "0개"(칸 있고 0)를 갈라야 한다.
								const map = {};
								const 넣기 = (바코드, 칸, 수량) => {
									if (!map[바코드]) map[바코드] = { CN: null, KR: null };
									map[바코드][칸] = (map[바코드][칸] || 0) + 수량;
								};
								balResult.data.balance.forEach(b => {
									if (!b.바코드) return;
									const 수량 = parseInt(b.수량) || 0;
									if (b.위치 === 'CN_창고' || b.위치 === 'CN_출고대기') 넣기(b.바코드, 'CN', 수량);
									else if (b.위치 === 'KR_창고') 넣기(b.바코드, 'KR', 수량);
								});
								this.ledgerBalanceMap = map;
								console.log('재고 원장 잔량 로드 완료:', Object.keys(map).length, '건');
							}
						} catch (error) {
							console.error('재고 원장 잔량 가져오기 오류:', error);
						}

						// Unipass 실측 입고중 수량 (정본 §5 Phase 5-7).
						// 해외입고중/국내입고중 칸은 지금 '입고예정일까지 며칠 남았나' 추정으로 가른다.
						// 통관 실측이 있는 상품은 그게 진실이라 실측이 이긴다.
						// 없는 상품은 이 맵에 안 담기고 추정이 그대로 쓰인다.
						try {
							const miResult = await axios.post('/api/warehouse/measuredInbound', {
								companyid: this.$store.state.user.companyid
							});
							if (miResult.data.요청결과 === '성공' && miResult.data.실측) {
								this.measuredInboundMap = miResult.data.실측;
								console.log('통관 실측 입고중 로드 완료:', Object.keys(this.measuredInboundMap).length, '건');
							}
						} catch (error) {
							console.error('통관 실측 입고중 가져오기 오류:', error);
						}
					}

					result = await axios.post('/api/getGrowthSalesV2');

					if (result.data.res == 'success') {
						if (this.$store.state.growthdb.length > 0) {
							// var growthSales = result.data.growthSales.filter(e => this.$store.state.growthdb?.find(f => f.vendorItemId == e.vendorItemId)?.show);
							var growthSales = result.data.growthSales;
						} else {
							growthSales = result.data.growthSales
						}
						// console.log(growthSales)
						// console.log(growthSales.find(e => e.productId == 8871426961))

						this.$store.commit('growthSalesUpdate', growthSales);
						// ✅ 일별 데이터에서 salesHistory 생성 후 표시
						await this.buildSalesDataFromDailySales(growthSales);
						this.searchresult(growthSales);

						// 데이터 로드 후 원본 데이터에서 오늘자 데이터 확인 (숨김 상품 필터링 영향 없음)
						this.$nextTick(() => {
							if (!growthSales.find(e => e.updateDate == updateDate)) {
								// Toast 메시지 표시와 함께 버튼 상태 업데이트
								this.todayCollectionNeeded = true;
								this.$bvToast.toast('오늘자 판매현황을 수집해주세요!', {
									title: '데이터 수집 필요',
									variant: 'warning',
									solid: true,
									autoHideDelay: 3000
								});
							} else {
								// 오늘자 데이터가 있으면 수집 완료 상태
								this.todayCollectionNeeded = false;
							}
						});
					} else {
						alert('로켓그로스 판매현황 가져오기 실패')
						console.log(result.data)
						this.showlist = false;
						this.showspinner = false;
						this.showspinner1 = false;
					}
				} catch (e) {
					alert('로켓그로스 판매현황 가져오기 실패')
					console.log(e)
					this.showlist = false;
					this.showspinner = false;
					this.showspinner1 = false;
				}
			}
		},
		generateDatesFromUpdateDate(updateDate) {
			if (!updateDate) return [];
			const baseDate = new Date(updateDate);
			// 어제를 기준으로 설정 (오늘 데이터 제외)
			baseDate.setDate(baseDate.getDate() - 1); // 하루 빼서 어제로 설정
			const dates = [];
			// 어제부터 30일 전까지 생성 (오름차순 정렬)
			for (let i = 29; i >= 0; i--) {
				const d = new Date(baseDate);
				d.setDate(baseDate.getDate() - i);
				dates.push(d.toISOString().split('T')[0]);
			}

			// console.log(`generateDatesFromUpdateDate: updateDate=${updateDate}, 어제=${baseDate.toISOString().split('T')[0]}, 생성된 날짜 범위=${dates[0]} ~ ${dates[dates.length-1]}`);
			return dates;
		},
		datetotimestamp(a) {
			var date = new Date(a);
			return date.getTime();
		},
		async searchresult(arr) {
			console.log(arr)
			if (arr.length === 0) {
				alert('로켓그로스 판매현황이 없습니다.');
				this.showlist = false;
				this.showspinner = false;
				this.showspinner1 = false;
				return;
			}

			this.needPo = 0;
			this.saleslists = [];
			this.saleslistsinit = [];

			// 입고 날짜 미리 수집
			this.collectInboundDates(arr);

			// 쿠패스연동 데이터 적용 함수 (processStatus 기반)
			const coupassScmUpdates = []; // ScmDB에 coupass* 필드 일괄 저장용
			const applyCoupassData = (item) => {
				if (!this.coupassSyncEnabled) return item;

				// growthdb에서 해당 vendorItemId의 barcode 찾기
				const growthItem = this.$store.state.growthdb.find(g => g.vendorItemId === item.vendorItemId);
				if (!growthItem || !growthItem.barcode) return item;

				// processStatus별로 재고 합산 (coupassData가 있을 때만)
				let 구매완료재고 = 0;
				let 배대지재고 = 0;
				let 통관중재고 = 0;

				if (this.coupassData.length) {
					const matchedItems = this.coupassData.filter(c => c.바코드 === growthItem.barcode);
					matchedItems.forEach(matched => {
						const 수량 = parseInt(matched.구매요청수량) || 0;
						switch(matched.processStatus) {
							case '구매완료':
							case '배송중':
								구매완료재고 += 수량;
								break;
							case '배송완료':
							case '입고작업':
							case '출고확인대기':
							case '재고대기':
							case '출고요청':
							case '출고대기':
							case '중국재고':
								배대지재고 += 수량;
								break;
							case '국내창고입고중':
								통관중재고 += 수량;
								break;
						}
					});

					item.구매 = 구매완료재고;
					item.배대지 = 배대지재고;
					item.통관중 = 통관중재고;
				}

				// Inventory 컬렉션에서 바코드 매칭하여 국내재고 자동 계산
				let 국내재고 = this.inventoryMap[growthItem.barcode] || 0;

				// 재고 원장이 있으면 그게 이긴다 (정본 §4 "근거 우선순위", §5 Phase 2-11).
				// 위의 배대지 합산은 processStatus 별 '구매요청수량' 을 더한 것이라
				// "얼마를 요청했나" 지 "지금 창고에 얼마 있나" 가 아니다. 부분출고가 있으면 어긋난다.
				// 원장은 창고 엑셀에서 나온 실측 잔량이다.
				// ⚠ 원장이 없는 화주는 이 블록을 통째로 건너뛰고 위 값이 그대로 간다.
				// 칸이 null 이면 원장이 그 위치를 모른다는 뜻이다 — 기존 값을 그대로 둔다.
				// (원장 도입 2026-08-28 이전 재고는 원장에 없고 Inventory 컬렉션에만 있다)
				const 원장 = this.ledgerBalanceMap[growthItem.barcode];
				if (원장 && 원장.CN !== null) item.배대지 = 원장.CN;
				if (원장 && 원장.KR !== null) 국내재고 = 원장.KR;
				item.국내재고 = 국내재고;

				// ScmDB에 coupass* 필드로 저장할 데이터 수집.
				// 화면에 보이는 값과 같은 것을 저장한다 — 원장이 있으면 원장 값이다.
				// 다르게 저장하면 다음 로드 때 캐시와 화면이 어긋난다.
				coupassScmUpdates.push({
					vendorItemId: item.vendorItemId,
					coupassPurchase: 구매완료재고,
					coupassOverseas: (원장 && 원장.CN !== null) ? 원장.CN : 배대지재고,
					coupassCustoms: 통관중재고,
					coupassDomesticStock: 국내재고
				});

				console.log(`쿠패스연동 재고 업데이트 - ${item.vendorItemId}: 구매=${구매완료재고}, 배대지=${item.배대지}${(원장 && 원장.CN !== null) ? '(원장)' : ''}, 통관중=${통관중재고}, 국내재고=${국내재고}${(원장 && 원장.KR !== null) ? '(원장)' : ''}`);

				return item;
			};

			// SCM 데이터와 판매 데이터 병합
			const applyScmData = (item) => {
				const scmItem = this.scmData[item.vendorItemId];
				if (scmItem) {
					// 재고 필드: 쿠패스 ON이면 coupass* 필드, OFF이면 기존 수동 입력 필드 사용
					if (this.coupassSyncEnabled) {
						item.구매 = scmItem.coupassPurchase || 0;
						item.배대지 = scmItem.coupassOverseas || 0;
						item.통관중 = scmItem.coupassCustoms || 0;
					} else {
						item.구매 = scmItem.purchase || 0;
						item.배대지 = scmItem.overseas || 0;
						item.통관중 = scmItem.customs || 0;
					}
					// 국내재고도 쿠패스 ON/OFF에 따라 스위칭
					if (this.coupassSyncEnabled) {
						item.국내재고 = scmItem.coupassDomesticStock || 0;
					} else {
						item.국내재고 = scmItem.domesticStock || 0;
					}
					item.입고기간 = scmItem.inboundPeriod || item.입고기간 || 0;
						// ➕ ScmDB의 단계별 입고기간 필드도 적용
						item.배대지입고기간 = scmItem.overseasInputDays || item.배대지입고기간 || this.baseSettings.overseasInputDays;
						item.통관중입고기간 = scmItem.customsInputDays || item.통관중입고기간 || this.baseSettings.customsInputDays;
						item.국내입고기간 = scmItem.domesticInputDays || item.국내입고기간 || this.baseSettings.domesticInputDays;

					item.최대재고기간 = scmItem.targetStockDays || item.최대재고기간 || 0;
					item.최소재고기간 = scmItem.safetyStockDays || item.최소재고기간 || 0;
					item.MOQ수량 = scmItem.moqQuantity !== undefined ? scmItem.moqQuantity : 2;
					item.타겟키워드 = scmItem.targetKeyword || '';
					item.메모 = scmItem.memo || '';
					item.목표일판매수량 = scmItem.targetDailySales || 0;
				} else {
					// SCM 데이터가 없는 경우에도 기본값 설정
					item.MOQ수량 = item.MOQ수량 || 2;
					item.목표일판매수량 = 0;
				}
				return item;
			};

			arr.sort((a, b) => b.월판매수량 - a.월판매수량);

			// SCM 데이터 먼저 적용, 그 다음 쿠패스연동 데이터 적용 (쿠패스 ON이면 실시간 데이터가 우선)
			arr = arr.map(e => applyScmData(e));
			arr = arr.map(e => applyCoupassData(e));

			// 쿠패스 계산 결과를 ScmDB에 coupass* 필드로 일괄 저장
			if (coupassScmUpdates.length > 0) {
				try {
					await axios.post('/api/batchUpdateScmData', coupassScmUpdates);
					console.log(`쿠패스 재고 ScmDB 저장 완료: ${coupassScmUpdates.length}건`);
				} catch (error) {
					console.error('쿠패스 재고 ScmDB 저장 오류:', error);
				}
			}

			// ✅ 일별 데이터는 이미 buildSalesDataFromDailySales에서 처리됨

			for (const e of arr) {
				// 최대입고기간과 보관료 계산
				var today = new Date();

				// 메인 상품
				if (e.inboundInfo?.cfsStowedDetailList?.length > 0) {
					var oldestDate = new Date(e.inboundInfo.cfsStowedDetailList[0].inboundDate);
					var daysAgo = Math.floor((today - oldestDate) / (1000 * 60 * 60 * 24));
					e.최대입고기간 = daysAgo;
				} else {
					e.최대입고기간 = 0;
				}
				e.보관료 = parseFloat(e.inventoryDetails?.storageFee?.monthlyStorageFeeAmount?.amount || 0);

				// 반품상품
				if (e.returnProducts?.length > 0) {
					for (var a of e.returnProducts) {
						if (a.inboundInfo?.cfsStowedDetailList?.length > 0) {
							oldestDate = new Date(a.inboundInfo.cfsStowedDetailList[0].inboundDate);
							daysAgo = Math.floor((today - oldestDate) / (1000 * 60 * 60 * 24));
							a.최대입고기간 = daysAgo;
						} else {
							a.최대입고기간 = 0;
						}
						a.보관료 = parseFloat(a.inventoryDetails?.storageFee?.monthlyStorageFeeAmount?.amount || 0);
					}
				}

				// 번들 상품 처리
				if (e.upBundlingProducts?.length > 0) {
					for (var bundle of e.upBundlingProducts) {
						if (bundle.inboundInfo?.cfsStowedDetailList?.length > 0) {
							oldestDate = new Date(bundle.inboundInfo.cfsStowedDetailList[0].inboundDate);
							daysAgo = Math.floor((today - oldestDate) / (1000 * 60 * 60 * 24));
							bundle.최대입고기간 = daysAgo;
						} else {
							bundle.최대입고기간 = 0;
						}
						bundle.보관료 = parseFloat(bundle.inventoryDetails?.storageFee?.monthlyStorageFeeAmount?.amount || 0);
					}
				}

				// mean과 forecastSeries 계산
				let startIndex = e.salesHistory.findIndex(element => element !== 0);
				let mean;
				if (startIndex === -1) {
					mean = 0;
				} else {
					let sum = 0;
					for (let i = startIndex; i < e.salesHistory.length; i++) {
						sum += e.salesHistory[i];
					}
					mean = sum / (e.salesHistory.length - startIndex);
				}

				// console.log(e)
				const maxDays = Math.max(parseInt(e.입고기간 ? e.입고기간 : this.baseSettings.inputDays) + (e.최대재고기간 ? e.최대재고기간 : this.baseSettings.targetDays), 30);
				// console.log(maxDays)
				const forecastSeries = Array(maxDays).fill(mean);
				// console.log(forecastSeries)

				// 기존 데이터 확인 및 설정값 적용
				if (this.$store.state.growthSales.length > 0 &&
					this.$store.state.growthSales.find(f => f.vendorItemId == e.vendorItemId)) {
					const f = this.$store.state.growthSales.find(f => f.vendorItemId == e.vendorItemId);
					var 최대재고기간 = f.최대재고기간 ? parseInt(f.최대재고기간) : this.baseSettings.targetDays;
					var 최소재고기간 = f.최소재고기간 ? parseInt(f.최소재고기간) : this.baseSettings.safetyDays;
					var 입고기간 = f.입고기간 ? parseInt(f.입고기간) : this.baseSettings.inputDays;
					var MOQ수량 = f.MOQ수량 !== undefined ? parseInt(f.MOQ수량) : this.baseSettings.moqQuantity;
					var 배대지입고기간 = f.배대지입고기간 ? parseInt(f.배대지입고기간) : this.baseSettings.overseasInputDays;
					var 국내입고기간 = f.국내입고기간 ? parseInt(f.국내입고기간) : this.baseSettings.domesticInputDays;
					var 구매 = parseInt(f.구매);
					var 배대지 = parseInt(f.배대지);
					var 국내재고 = f.국내재고 ? parseInt(f.국내재고) : 0;
					var 메모 = f.메모;


					// 날짜 관련 처리
					var dates = this.getMonthDates();

					if (f.타겟키워드) {
						var 타겟키워드 = f.타겟키워드;
						if (dates !== f.dates && this.$store.state.settings?.[0]?.hasDatalabKey) {
							var keywordForecast = await this.getKeywordData(dates, 타겟키워드);
							var forecastAI = await this.getForecastAI(keywordForecast, f);
						} else {
							keywordForecast = f.keywordForecast;
							forecastAI = f.forecastAI;
						}
					} else {
						타겟키워드 = '';
						keywordForecast = [];
						forecastAI = [];
					}
				} else {
					타겟키워드 = '';
					입고기간 = this.baseSettings.inputDays;
					최대재고기간 = this.baseSettings.targetDays;
					최소재고기간 = this.baseSettings.safetyDays;
					MOQ수량 = this.baseSettings.moqQuantity; // var 제거, 기존 변수 재사용
					배대지입고기간 = this.baseSettings.overseasInputDays;
					국내입고기간 = this.baseSettings.domesticInputDays;
					keywordForecast = [];
					forecastAI = [];
					구매 = 0;
					배대지 = 0;
					국내재고 = 0;
					메모 = '';
					e.MOQ수량 = MOQ수량; // 값을 직접 할당

				}

				dates = e.updateDate ? this.generateDatesFromUpdateDate(e.updateDate) : this.getMonthDates();

				// 번들 상품의 판매 히스토리 처리
				if (e.upBundlingProducts?.length > 0) {
					e.upBundlingProducts.forEach(bundle => {
						// 번들 상품의 판매 히스토리가 없으면 기본값으로 설정
						if (!bundle.salesHistory || bundle.salesHistory.length === 0) {
							bundle.salesHistory = Array(e.salesHistory.length).fill(0);
						}
						// 번들 상품의 기타 히스토리 데이터도 기본값 설정
						bundle.visitorHistory = bundle.visitorHistory || Array(e.salesHistory.length).fill(0);
						bundle.pageViewHistory = bundle.pageViewHistory || Array(e.salesHistory.length).fill(0);
						bundle.cartHistory = bundle.cartHistory || Array(e.salesHistory.length).fill(0);
						bundle.orderHistory = bundle.orderHistory || Array(e.salesHistory.length).fill(0);
						bundle.pvToOrder = bundle.pvToOrder || Array(e.salesHistory.length).fill(0);
					});
				}

				// 반품 상품의 판매 히스토리 처리
				if (e.returnProducts?.length > 0) {
					e.returnProducts.forEach(returnProduct => {
						// 반품 상품의 판매 히스토리가 없으면 기본값으로 설정
						if (!returnProduct.salesHistory || returnProduct.salesHistory.length === 0) {
							returnProduct.salesHistory = Array(e.salesHistory.length).fill(0);
						}
						// 반품 상품의 기타 히스토리 데이터도 기본값 설정
						returnProduct.visitorHistory = returnProduct.visitorHistory || Array(e.salesHistory.length).fill(0);
						returnProduct.pageViewHistory = returnProduct.pageViewHistory || Array(e.salesHistory.length).fill(0);
						returnProduct.cartHistory = returnProduct.cartHistory || Array(e.salesHistory.length).fill(0);
						returnProduct.orderHistory = returnProduct.orderHistory || Array(e.salesHistory.length).fill(0);
						returnProduct.pvToOrder = returnProduct.pvToOrder || Array(e.salesHistory.length).fill(0);
					});
				}

				// 임시 데이터 객체 생성
				const itemData = {
					...e,
					dates,
					구매,
					배대지,
					국내재고,
					입고기간,
					최대재고기간,
					최소재고기간,
					MOQ수량,
					배대지입고기간,
					국내입고기간,
					chart: null,
					forecastSeries,
					forecastAI,
					keywordForecast,
					타겟키워드,
					메모,
					일판매수량: e.일판매수량,
					isModified: false,
					장기입고중: 0,  // 계산으로 설정됨
					단기입고중: 0   // 계산으로 설정됨
				};

				// calculateInventoryMetrics를 사용하여 계산
				const calculatedMetrics = this.calculateInventoryMetrics(itemData);

				// 차트 데이터 생성
				const chart = this.generateChartData(itemData, forecastSeries, forecastAI, dates);

				// 최종 데이터 객체 생성
				const finalItemData = {
					...itemData,
					...calculatedMetrics,
					chart,
					forecastSeriesQty: forecastSeries.slice(0, 30).reduce((pv, cv) => pv + cv, 0),
					forecastAIQty: (forecastAI && forecastAI.length > 0) ? forecastAI.reduce((pv, cv) => pv + cv, 0) : 0
				};

				this.saleslistsinit.push(this.deepClone(finalItemData));
				// 숨김 상품이 아닌 경우에만 표시 목록에 추가
				if (!finalItemData.hidden) {
					this.saleslists.push(finalItemData);
				}
			}

			// 재고커버리지(C-store) 영속화 — 광고대시보드 R_cov 입력 (theory §16)
			try {
				const coveragePayload = this.saleslistsinit.map(item => {
					// 판매장부용 재고 스냅샷 (화면 계산값 그대로) — 쿠팡재고/전체가용재고 각 수량·기간·금액
					const 전체가용재고 = this.getTotalAvailableStock(item);
					const growthItem = this.$store.state.growthdb.find(g => g.vendorItemId === item.vendorItemId);
					return {
						vendorItemId: item.vendorItemId,
						deliveryType: '로켓그로스',
						stockDays: item.남은재고기간,
						dailySales: item.일판매수량,
						leadTime: item.입고기간,
						coupangStock: item.재고 || 0,
						coupangStockDays: item.쿠팡재고기간 || 0,
						coupangStockAmount: this.getStockAmount(item.재고, item.vendorItemId),
						totalStock: 전체가용재고,
						totalStockAmount: this.getStockAmount(전체가용재고, item.vendorItemId),
						purchasePrice: (growthItem && growthItem.매입가) ? growthItem.매입가 : 0
					};
				});
				await axios.post('/api/saveInventoryCoverage', coveragePayload);
			} catch (err) {
				console.error('saveInventoryCoverage 오류:', err);
			}

			// 통계 업데이트 (updateCounts 메서드 사용)
			this.updateCounts();

			// 정렬: 저장된 순서가 있으면 우선 적용, 없으면 기본 정렬
			this.applyDefaultSort();

			// Phase B: 쿠팡 입고 데이터 기반 자동 상태 업데이트
			await this.autoUpdateReqpurchaseStatus();

			// UI 업데이트
			this.$nextTick(() => {
				this.showlist = true;
				this.showspinner = false;
				this.showspinner1 = false;
				this.loadingtext = '';
			});
		},
		calculateOldestAndTotalQty(data) {
			const today = new Date(); // 오늘 날짜 설정
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(today.getDate() - 30);

			let totalQty = 0;
			let oldestDate = null;
			let daysAgo = null;

			data.forEach(item => {
				const inboundDate = new Date(item.inboundDate);

				// 30일 이상 지난 항목 처리
				if (inboundDate < thirtyDaysAgo) {
					totalQty += item.remainingSkuQty; // 합산
					if (!oldestDate || inboundDate < oldestDate) {
						oldestDate = inboundDate; // 가장 오래된 날짜 업데이트
					}
				}
			});

			// 가장 오래된 날짜와 오늘의 차이를 계산
			if (oldestDate) {
				daysAgo = Math.floor((today - oldestDate) / (1000 * 60 * 60 * 24)); // 날짜 차이 계산
			}

			return {
				totalQty,
				oldestDaysAgo: daysAgo // 며칠 전인지 반환
			};
		},
		deepClone(obj) {
			if (obj === null || typeof obj !== "object") {
				return obj
			}

			const result = Array.isArray(obj) ? [] : {}

			for (let key of Object.keys(obj)) {
				result[key] = this.deepClone(obj[key])
			}

			return result
		},
		todate(date) {
			var today = new Date(date);
			today.setHours(today.getHours() + 9);
			return today.toISOString().replace('T', ' ').substring(0, 19);
		},
		timestamp(date) {
			//inputdate = "yyyy-mm-dd"
			return new Date(date).getTime()
		},
		getTodaywith() {
			var date = new Date();
			var year = date.getFullYear();
			var month = ("0" + (1 + date.getMonth())).slice(-2);
			var day = ("0" + date.getDate()).slice(-2);

			return year + "-" + month + "-" + day;
		},
		timestamptodate(timestamp) {
			var date = new Date(timestamp);
			var year = date.getFullYear();
			var month = ("0" + (1 + date.getMonth())).slice(-2);
			var day = ("0" + date.getDate()).slice(-2);

			return year + "-" + month + "-" + day;
		},
		downloadsales() {
			function getToday() {
				var date = new Date();
				var year = date.getFullYear();
				var month = ("0" + (1 + date.getMonth())).slice(-2);
				var day = ("0" + date.getDate()).slice(-2);

				return year + month + day;
			}
			var arr = [];
			var obj = {};
			console.log(this.saleslists)
			this.saleslists.forEach(e => {
				obj = {
					SKUID: e.SKUID,
					옵션ID: e.vendorItemId,
					상품명: e.판매상품명,
					옵션명: e.옵션명,
					발주가능상태: e.발주가능상태,
					구매필요수량: e.구매필요수량,
					안전재고: e.안전재고,
					쿠팡내재고: e.재고,
					출고: e.판매,
					입고리드타임: e.입고리드타임,
					// 재고기준일 : e.재고기준일,
					일판매수량: e.일판매수량
				}
				arr.push(obj)
			})
			const workBook = XLSX.utils.book_new()
			const workSheet1 = XLSX.utils.json_to_sheet(arr)
			XLSX.utils.book_append_sheet(workBook, workSheet1, '발주수요예측')
			XLSX.writeFile(workBook, '발주수요예측' + '_' + getToday() + '.xlsx')
		},
		// 현재 화면에 보이는 목록(필터된 행) + 보이는 컬럼(토글 반영)을 그대로 엑셀로 내보낸다
		exportVisibleToExcel() {
			try {
				// 데이터가 아닌 컬럼(이미지/액션 버튼)은 제외
				const skipValues = ['썸네일', '설정', '메모'];
				// 화면에서 노출ID/옵션ID는 상품명·옵션명 칸 안의 작은 글씨로 붙어 나오는데(슬롯),
				// 엑셀은 셀 하나에 한 값만 담으므로 각각 뒤에 별도 컬럼으로 펼쳐서 내보낸다.
				const exportHeaders = this.headers
					.filter(h => !skipValues.includes(h.value))
					.flatMap(h => {
						if (h.value === '판매상품명') return [{ ...h, text: '상품명' }, { text: '노출ID', value: 'productId' }];
						if (h.value === '옵션명') return [{ ...h, text: '옵션명' }, { text: '옵션ID', value: 'vendorItemId' }];
						return [h];
					});

				if (this.saleslists.length === 0) {
					alert('내보낼 데이터가 없습니다.');
					return;
				}

				// 헤더 텍스트의 줄바꿈을 공백으로 정리해 엑셀 컬럼명으로 사용
				const cleanLabel = (text) => String(text || '').replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim();

				const buildRow = (getValue) => {
					const row = {};
					exportHeaders.forEach(h => {
						row[cleanLabel(h.text) || h.value] = getValue(h.value);
					});
					return row;
				};

				// 화면에서 반품/번들은 별도 행이 아니라 부모 행 셀 안의 덧줄로 그려진다(템플릿 v-for).
				// 엑셀은 셀 안에 줄을 못 쌓으므로 부모 행 아래에 하위 행으로 펼쳐서 내보낸다.
				const arr = this.saleslists.flatMap(item => {
					const rows = [buildRow(v => this.getExportCellValue(item, v))];
					if (this.showReturnProducts && item.returnProducts && item.returnProducts.length > 0) {
						item.returnProducts.forEach(sub => {
							rows.push(buildRow(v => this.getExportSubCellValue(item, sub, v, 'return')));
						});
					}
					if (this.showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0) {
						item.upBundlingProducts.forEach(sub => {
							rows.push(buildRow(v => this.getExportSubCellValue(item, sub, v, 'bundle')));
						});
					}
					return rows;
				});

				const headerLabels = exportHeaders.map(h => cleanLabel(h.text) || h.value);
				const dataWS = XLSX.utils.json_to_sheet(arr, { header: headerLabels });
				const wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, dataWS, '재고관리');
				XLSX.writeFile(wb, '재고관리_' + this.getTodaywith() + '.xlsx');
			} catch (e) {
				console.error('엑셀다운로드 실패:', e);
				alert('엑셀 다운로드 중 오류가 발생했습니다.');
			}
		},
		// 반품/번들 하위행의 엑셀 셀값. 화면 셀 계산식을 그대로 쓰되, 엑셀은 행이 분리되므로
		// 상품명/옵션명은 부모 값을 채워 어느 상품의 하위행인지 알 수 있게 하고 옵션ID만 하위 것으로 붙인다.
		// 화면에 값이 없는 칸(구매/배대지/필요수량 등)은 빈칸으로 둔다.
		getExportSubCellValue(parent, sub, value, kind) {
			const isReturn = kind === 'return';
			switch (value) {
				case '상품구분':
				case '상품등급':
					return isReturn ? this.getSkuGradeLabel(sub.skuGrade) : '번들x' + (sub.upBundlingSize || 1);
				case '판매상품명':
					return isReturn ? parent.판매상품명 : (sub.판매상품명 || parent.판매상품명);
				case 'productId':
					return sub.productId || parent.productId;
				case '옵션명':
					return isReturn ? parent.옵션명 : (sub.옵션명 || parent.옵션명);
				case 'vendorItemId':
					return sub.vendorItemId;
				case '재고':
					return sub.orderableQuantity || 0;
				case '남은재고기간':
					return isReturn ? sub.남은재고기간 : '';
				case '월판매수량':
					return isReturn ? this.getReturnProductMonthlySales(sub) : this.getBundleProductMonthlySales(sub);
				case '7일판매수량':
					return isReturn ? this.getReturnProduct7DaySales(sub) : this.getBundleProduct7DaySales(sub);
				case 'recentDay6':
				case 'recentDay5':
				case 'recentDay4':
				case 'recentDay3':
				case 'recentDay2':
				case 'recentDay1':
				case 'recentDay0': {
					const offset = Number(value.replace('recentDay', ''));
					return isReturn ? this.getReturnProductDailySales(sub, offset) : this.getBundleProductDailySales(sub, offset);
				}
				case '판매변화': {
					const rate = isReturn ? this.getReturnProductChangeRate(sub) : this.getBundleProductChangeRate(sub);
					return Number(rate || 0).toFixed(1) + '%';
				}
				case '일판매수량': {
					const daily = isReturn ? this.getReturnProductMonthlySales(sub) / 30 : (sub.일판매수량 || 0);
					return Number(daily || 0).toFixed(2);
				}
				case '최대입고기간':
					return isReturn && sub.최대입고기간 !== undefined && sub.최대입고기간 !== null ? sub.최대입고기간 : '';
				case '보관료':
					return isReturn && sub.보관료 !== undefined && sub.보관료 !== null ? sub.보관료 : '';
				default:
					return '';
			}
		},
		// 재고 컬럼: 현재 토글 상태(재고금액/재고기간/수량)에 맞춰 화면에 찍히는 값을 반환
		resolveStockCell(qty, item) {
			if (this.showStockAmount) return this.getStockAmount(qty, item.vendorItemId);
			if (this.showStockPeriodFirst) return this.getStockPeriod(qty, item.일판매수량, item);
			return qty;
		},
		// 상품등급 라벨. 수집이 NEW 부모에 흡수시키지 못한 반품등급 상품을 최상위 문서로 보존하므로
		// (background.js `_orphanReturns`) 최상위 행에도 '새제품' 을 하드코딩하면 안 된다.
		// 라벨 문구는 판매장부(growthSalesLedger.vue getSkuGradeLabel)와 맞춘다.
		getSkuGradeLabel(skuGrade) {
			if (!skuGrade || skuGrade === 'NEW') return '새제품';
			if (skuGrade === 'PACKAGE_DAMAGED') return '반품-미개봉';
			if (skuGrade === 'RETURN_BEST') return '반품-최상';
			if (skuGrade === 'RETURN_GOOD') return '반품-상';
			if (skuGrade === 'RETURN_NORMAL') return '반품-중';
			return skuGrade;
		},
		// 컬럼 value별로 화면 표시 로직을 그대로 재사용해 셀 값을 추출
		getExportCellValue(item, value) {
			const isBundle = this.showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0;
			switch (value) {
				case '상품구분':
					return this.getSkuGradeLabel(item.skuGrade);
				case '판매상품명':
					return item.판매상품명;
				case 'productId':
					return item.productId;
				case '옵션명':
					return item.옵션명;
				case 'vendorItemId':
					return item.vendorItemId;
				case '월판매수량':
					return isBundle ? this.getMainProductMonthlySales(item) : item.월판매수량;
				case '7일판매수량':
					return isBundle ? this.getMainProduct7DaySales(item) : item['7일판매수량'];
				case '판매변화': {
					const rate = isBundle ? this.getSalesChangeRate(item) : item.판매변화;
					return Number(rate || 0).toFixed(1) + '%';
				}
				case '일판매수량': {
					const daily = isBundle ? this.getMainProductDailySales(item) : item.일판매수량;
					return Number(daily || 0).toFixed(2);
				}
				case 'recentDay6':
				case 'recentDay5':
				case 'recentDay4':
				case 'recentDay3':
				case 'recentDay2':
				case 'recentDay1':
				case 'recentDay0':
					return this.getMainProductDailySalesAtOffset(item, Number(value.replace('recentDay', '')));
				case '구매':
				case '배대지':
				case '통관중':
				case '장기입고중':
				case '단기입고중':
				case '국내재고':
				case '재고':
					return this.resolveStockCell(item[value], item);
				case '남은재고기간':
					return this.resolveStockCell(this.getTotalAvailableStock(item), item);
				case 'dday':
				case '배대지출고Dday':
				case '통관중출고Dday':
				case '국내출고Dday':
					return this.formatDday(item[value]);
				case '구매필요수량':
					return item.구매필요수량 === 0 ? '-' : item.구매필요수량;
				case '배대지출고필요수량':
					return item.배대지 <= 0 ? '-' : (item.배대지출고필요수량 === 0 ? '-' : item.배대지출고필요수량);
				case '통관중출고필요수량':
					return item.통관중 <= 0 ? '-' : (item.통관중출고필요수량 === 0 ? '-' : item.통관중출고필요수량);
				case '국내출고필요수량':
					return item.국내재고 <= 0 ? '-' : (item.국내출고필요수량 === 0 ? '-' : item.국내출고필요수량);
				default:
					return item[value] !== undefined && item[value] !== null ? item[value] : '';
			}
		},
		// 메소드를 호출하는 곳에서도 async/await 사용
		async setDateRange(item, days) {
			// 데이터 범위 확인
			const maxAvailableDays = item.salesHistory.length;

			// 요청 일수가 가용 데이터보다 크면 조정
			const adjustedDays = Math.min(days, maxAvailableDays);
			if (adjustedDays !== days) {
				console.log(`요청된 ${days}일이 가용 데이터 ${maxAvailableDays}일보다 커서 ${adjustedDays}일로 조정됨`);
			}
			// 공통 함수를 사용해서 어제까지 날짜 범위 계산
			const todayStr = this.getTodayString();
			const allDates = this.generateDatesFromUpdateDate(todayStr);

			// 요청된 일수만큼 뒤에서부터 가져오기
			const requestedDates = allDates.slice(-days);

			item.startDate = requestedDates[0];
			item.endDate = requestedDates[requestedDates.length - 1];
			console.log(item.startDate, item.endDate)

			// updateDateRange 호출하여 데이터 업데이트
			await this.updateDateRange(item);
		},
		formatDateYMD(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},

		async updateDateRange(item) {
			if (item.startDate && item.endDate) {
				// 선택된 날짜 범위가 데이터에 있는지 확인
				const startIndex = item.dates.findIndex(d => d >= item.startDate);
				const endIndex = item.dates.findIndex(d => d >= item.endDate);

				// 유효한 범위인지 확인
				if (startIndex !== -1 && (endIndex !== -1 || item.endDate > item.dates[item.dates.length - 1])) {
					const endIdx = endIndex !== -1 ? endIndex : item.dates.length - 1;

					// 해당 기간의 판매 이력 추출
					const filteredSalesHistory = item.salesHistory.slice(startIndex, endIdx + 1);

					if (filteredSalesHistory.length > 0) {
						// 일평균 판매량 재계산
						const customDailySales = filteredSalesHistory.reduce((sum, val) => sum + val, 0) / filteredSalesHistory.length;

						// 원래 값 백업
						const originalDailySales = item.일판매수량;

						// 임시로 변경
						item.일판매수량 = customDailySales;

						// 선택된 기간에 대한 메트릭 계산
						const customMetrics = this.calculateInventoryMetrics(item);

						// 원래 값으로 복원
						item.일판매수량 = originalDailySales;

						// 계산된 메트릭 저장
						item.customPeriodMetrics = {
							dday: customMetrics.dday,
							구매필요수량: customMetrics.구매필요수량,
							neededStockDays: this.calculateNeededStockDays({
								...item,
								일판매수량: customDailySales
							}),
							일판매수량: customDailySales
						};

						// 차트에 선택된 기간 표시
						if (this.$refs.mainChart && this.$refs.mainChart.chart) {
							const chart = this.$refs.mainChart.chart;

							// 기존 주석 제거
							if (chart.opts.annotations && chart.opts.annotations.xaxis) {
								chart.clearAnnotations();
							}

							// 선택된 범위에 주석 추가
							const annotations = {
								xaxis: [{
									x: item.dates[startIndex],
									x2: item.dates[endIdx],
									borderColor: '#77B6EA',
									fillColor: '#77B6EA',
									opacity: 0.2,
									label: {
										borderColor: '#77B6EA',
										style: {
											color: '#fff',
											background: '#77B6EA'
										},
										text: '선택된 기간'
									}
								}]
							};

							chart.updateOptions({ annotations }, false, true);
						}

						// 판매량 차트도 업데이트
						this.$nextTick(() => {
							if (this.$refs.salesChart && this.$refs.salesChart.chart) {
								try {
									const salesChart = this.$refs.salesChart.chart;
									const salesChartOption = this.getSalesChartOption(item);
									if (salesChartOption && salesChartOption.series) {
										salesChart.updateOptions(salesChartOption, true, true);
									}
								} catch (error) {
									console.error('판매량 차트 업데이트 오류:', error);
								}
							}
						});
					}
				}
			}
		},
		updateItemValues(item) {
			return this.calculateInventoryMetrics(item);
		},
		getUpdatedChartOption(item) {
			// console.log(item)
			const validateData = (data) => {
				if (!Array.isArray(data)) return Array(30).fill(0);
				return data.map(val => {
					const num = Number(val);
					return isNaN(num) ? 0 : num;
				});
			};

			const salesHistory = validateData(item.salesHistory);
			const visitorHistory = validateData(item.visitorHistory);
			const pageViewHistory = validateData(item.pageViewHistory);
			const cartHistory = validateData(item.cartHistory);
			const orderHistory = validateData(item.orderHistory);
			const pvToOrder = validateData(item.pvToOrder);
			// const forecastSeries = validateData(item.forecastSeries);
			// const forecastAI = validateData(item.forecastAI);

			// X축 범위 수정
			const displayDays = Math.max(30, parseInt(item.입고기간) + this.baseSettings.targetDays);
			const dates = item.dates.slice(0, displayDays);

			const salesMax = Math.max(
				...salesHistory,
				// ...forecastSeries,
				// ...forecastAI,
				1
			) * 1.1;

			const trafficMax = Math.max(
				...visitorHistory,
				...pageViewHistory,
				...cartHistory,
				...orderHistory,
				1
			) * 1.1;

			const conversionMax = Math.max(
				...pvToOrder,
				0.1
			) * 1.1;

			// 입고 이벤트 annotations 생성
			const inboundAnnotations = this.createInboundAnnotations(item, dates);

			// 기본 시리즈 배열 (번들/반품 제외)
			const series = [
				{
					name: '판매량',
					data: salesHistory.map(val => val || 0),
					type: 'column'
				},
				{
					name: '방문자수',
					type: 'line',
					data: visitorHistory.map(val => val || 0)
				},
				{
					name: '페이지뷰',
					type: 'line',
					data: pageViewHistory.map(val => val || 0)
				},
				{
					name: '장바구니',
					type: 'line',
					data: cartHistory.map(val => val || 0)
				},
				{
					name: '주문건수',
					type: 'line',
					data: orderHistory.map(val => val || 0)
				},
				{
					name: '전환율(%)',
					type: 'line',
					data: pvToOrder.map(val => val || 0)
				}
			];

			return {
				series: series,
				annotations: {
					xaxis: inboundAnnotations
				},
				chart: {
					height: 500,
					animations: { enabled: false },
					toolbar: {
						show: true
					},
					parentHeightOffset: 0,   // 부모 컨테이너와의 간격 제거
					offsetY: 0
				},
				plotOptions: {
					bar: {
						columnWidth: '30%',  // bar 너비 조절
						opacity: 0.4         // bar 투명도 조절
					}
				},
				stroke: {
					width: [0, 3, 3, 3, 3, 3],  // line 그래프 두께 증가
					curve: 'smooth'
				},
				colors: [
					'rgba(0, 143, 251, 0.5)',   // bar 차트 색상 (투명도 포함)
					'#00E396',
					'#FEB019',
					'#FF4560',
					'#775DD0',
					'#26a69a'
				],
				markers: {
					size: [0, 0, 0, 0, 0, 6],   // 전환율만 마커 표시
					colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#26a69a'],
					strokeColors: '#fff',
					strokeWidth: 2,
					hover: {
						size: 8
					}
				},
				xaxis: {
					categories: dates,
					labels: {
						style: { fontSize: '12px' }
					}
				},
				yaxis: [
					{
						seriesName: '판매량',
						title: {
							text: '판매수량',
							offsetX: 0,
							offsetY: -10
						},
						min: 0,
						max: salesMax,
						labels: {
							formatter: (val) => Math.round(val).toString()
						}
					},
					{
						seriesName: ['방문자수', '페이지뷰', '장바구니', '주문건수'],
						title: { text: '트래픽/주문' },
						min: 0,
						max: trafficMax,
						opposite: true,
						labels: {
							formatter: (val) => Math.round(val).toString()
						},
						show: true
					},
					{
						seriesName: '전환율(%)',
						title: {
							text: '전환율(%)',
							offsetX: -20
						},
						min: 0,
						max: conversionMax,
						opposite: true,
						labels: {
							formatter: (val) => val.toFixed(2) + '%',
							offsetX: -30
						},
						tickAmount: 5
					}
				],
				tooltip: {
					enabled: true,
					shared: true,
					intersect: false,
					followCursor: true,
					x: {
						show: true
					},
					custom: ({ series, dataPointIndex, w }) => {
						const date = w.globals.categoryLabels[dataPointIndex];

						// 기본 tooltip 내용
						let tooltipContent = `<div class="custom-tooltip" style="padding: 10px; background: #fff; border: 1px solid #ccc; border-radius: 4px;">`;
						tooltipContent += `<div style="font-weight: bold; margin-bottom: 5px;">${date}</div>`;

						// 각 시리즈 데이터 표시
						const seriesNames = ['판매량', '방문자수', '페이지뷰', '장바구니', '주문건수', '전환율(%)'];
						series.forEach((seriesData, index) => {
							const value = seriesData[dataPointIndex];
							if (value !== undefined && value !== null) {
								const formattedValue = index === 5 ? `${value.toFixed(2)}%` : Math.round(value).toString();
								tooltipContent += `<div>${seriesNames[index]}: ${formattedValue}</div>`;
							}
						});

						// 입고 정보 추가
						const inboundInfo = this.getInboundInfoForDate(item, date);
						if (inboundInfo) {
							tooltipContent += `<div style="border-top: 1px solid #eee; margin-top: 5px; padding-top: 5px; color: #00E396; font-weight: bold;">`;
							tooltipContent += `입고재고: ${inboundInfo.remainingSkuQty}개</div>`;
						}

						tooltipContent += `</div>`;
						return tooltipContent;
					},
					marker: {
						show: true
					},
					fixed: {
						enabled: false,
						position: 'topRight'
					}
				},
				dataLabels: { enabled: false },
				legend: {
					position: 'top',           // legend 위치를 상단으로
					horizontalAlign: 'center', // 가운데 정렬
					offsetY: 0,               // 상단 여백
					offsetX: 0,               // 좌우 여백
					floating: true,           // legend를 차트 영역 위에 띄움
					itemMargin: {
						horizontal: 15,
						vertical: 5
					},
					height: 30,              // legend 영역 높이
					fontSize: '13px',
					markers: {
						width: 12,
						height: 12,
						strokeWidth: 0,
						radius: 12
					}
				},
				grid: {
					padding: {
						top: 30,    // 상단 여백 추가
						bottom: 10   // 하단 여백
					}
				},
			};
		},
		createInboundAnnotations(item, dates) {
			// 입고상세내역이 없으면 빈 배열 반환
			if (!item.inboundInfo || !item.inboundInfo.cfsStowedDetailList || !Array.isArray(item.inboundInfo.cfsStowedDetailList)) {
				return [];
			}

			const annotations = [];
			let labelOffsetY = 10; // 라벨 위치를 위아래로 조정하기 위한 변수

			// 날짜순으로 정렬하여 겹침 방지
			const sortedInboundList = [...item.inboundInfo.cfsStowedDetailList]
				.filter(detail => detail.remainingSkuQty > 0)
				.sort((a, b) => new Date(a.inboundDate) - new Date(b.inboundDate));

			sortedInboundList.forEach((inboundDetail, index) => {
				// 입고일자를 YYYY-MM-DD 형식으로 변환
				const inboundDate = new Date(inboundDetail.inboundDate).toISOString().split('T')[0];

				// 차트의 dates 배열에서 해당 날짜의 인덱스 찾기
				const dateIndex = dates.findIndex(date => date === inboundDate);

				// 해당 날짜가 차트 범위에 있는 경우에만 annotation 추가
				if (dateIndex >= 0) {
					// 라벨 위치를 번갈아가며 조정하여 겹침 방지
					const currentOffsetY = index % 2 === 0 ? labelOffsetY : labelOffsetY + 25;

					annotations.push({
						x: inboundDate,
						strokeDashArray: 0,
						borderColor: '#00E396',
						borderWidth: 2,
						label: {
							borderColor: '#00E396',
							style: {
								color: '#fff',
								background: '#00E396',
								fontSize: '10px',
								fontWeight: 'bold'
							},
							orientation: 'horizontal',
							offsetY: currentOffsetY,
							text: `입고재고:${inboundDetail.remainingSkuQty}개`
						}
					});
				}
			});

			return annotations;
		},
		getInboundInfoForDate(item, date) {
			// 입고상세내역이 없으면 null 반환
			if (!item.inboundInfo || !item.inboundInfo.cfsStowedDetailList || !Array.isArray(item.inboundInfo.cfsStowedDetailList)) {
				return null;
			}

			// 해당 날짜의 입고 정보 찾기
			const inboundDetail = item.inboundInfo.cfsStowedDetailList.find(detail => {
				const inboundDate = new Date(detail.inboundDate).toISOString().split('T')[0];
				return inboundDate === date && detail.remainingSkuQty > 0;
			});

			return inboundDetail || null;
		},
		resetChartData(item) {
			if (!item || !item.chart) return;

			// 모달에서 사용할 계산값 미리 저장
			const metrics = this.calculateInventoryMetrics(item);
			item.남은재고기간 = metrics.남은재고기간;
			item.구매필요수량 = metrics.구매필요수량;
			item.dday = metrics.dday;

			// 커스텀 기간 메트릭 초기화
			item.customPeriodMetrics = null;

			const chartOption = this.getUpdatedChartOption(item);

			this.$nextTick(() => {
				if (this.$refs.mainChart && this.$refs.mainChart.chart) {
					this.$refs.mainChart.chart.updateOptions(chartOption, true, true);
				}
			});
		},
		calculateForecast(salesHistory, days) {
			const avgSales = salesHistory.reduce((sum, val) => sum + val, 0) / salesHistory.length;
			return Array(days).fill(avgSales);
		},
		closeModal(event, item) {
			event.preventDefault();
			if (this.$refs.mainChart && this.$refs.mainChart.chart) {
				this.$refs.mainChart.chart.destroy();
			}
			this.$nextTick(() => {
				this.$bvModal.hide('poQty' + item.vendorItemId)
			});
		},
		async calculateDailyStats() {
			try {
				const endDate = new Date();
				const startDate = new Date();
				startDate.setDate(startDate.getDate() - this.selectedPeriod);

				const dailyStats = [];
				for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
					const formattedDate = this.formatDate(d.toISOString().split('T')[0]);
					let revenue = 0;
					let profit = 0;

					if (this.saleslistsinit && Array.isArray(this.saleslistsinit)) {
						this.saleslistsinit.forEach(sale => {
							if (!sale || !sale.salesHistory || !Array.isArray(sale.salesHistory)) {
								return;
							}

							const dayIndex = sale.dates.indexOf(d.toISOString().split('T')[0]);
							if (dayIndex >= 0) {
								const quantity = sale.salesHistory[dayIndex] || 0;
								const dbItem = this.$store.state.growthdb.find(x => x.vendorItemId === sale.vendorItemId);

								if (dbItem && typeof dbItem.salePrice === 'number' && typeof dbItem.마진 === 'number') {
									revenue += quantity * (dbItem.salePrice - dbItem.coupon);
									profit += quantity * dbItem.마진;
								}
							}
						});
					}

					dailyStats.push({
						date: formattedDate,
						revenue: Math.round(revenue),
						profit: Math.round(profit)
					});
				}

				this.dailyStats = dailyStats;
				await this.$nextTick();
				await this.updateRevenueChart();
				this.updateProfitTop10Chart();
				this.updateConversionChart(); // 전환율 차트 업데이트 추가
				this.updateMaxCpcChart();
			} catch (error) {
				console.error('Error calculating daily stats:', error);
				this.dailyStats = [];
			}
		},

		async updateRevenueChart() {
			try {
				if (!this.dailyStats || this.dailyStats.length === 0) {
					console.warn("일일 통계 데이터가 없습니다.");
					return;
				}

				// 데이터 준비
				const revenueData = this.dailyStats.map(day => ({
					x: day.date,
					y: day.revenue || 0
				}));

				const profitData = this.dailyStats.map(day => ({
					x: day.date,
					y: day.profit || 0
				}));

				const categories = this.dailyStats.map(day => day.date);

				// 새로운 옵션 설정
				const newOptions = {
					series: [{
						name: '매출',
						type: 'line',
						data: revenueData
					}, {
						name: '수익',
						type: 'line',
						data: profitData
					}],
					xaxis: {
						...this.revenueChartOption.xaxis,
						categories: categories
					}
				};

				// 차트 업데이트
				this.revenueChartOption = {
					...this.revenueChartOption,
					...newOptions
				};

				await this.$nextTick();
				const chartElement = document.querySelector('#revenue-chart');
				if (chartElement && chartElement.__vue__ && chartElement.__vue__.chart) {
					chartElement.__vue__.chart.updateOptions(this.revenueChartOption, false, true);
				}
			} catch (error) {
				console.error('차트 업데이트 중 오류 발생:', error);
			}
		},

		changePeriod(days) {
			this.selectedPeriod = days;
			this.calculateDailyStats();
		},

		// formatNumber(value) {
		// return new Intl.NumberFormat('ko-KR').format(Math.round(value));
		// },
		async uploadfile(event, matchType = 'vendorItemId') {
			try {
				this.showlist = false;
				this.showuploadspinner = true;
				this.currentUploadType = matchType;

				// 업로드 상태 업데이트
				if (matchType === 'barcode') {
					this.uploadstatus2 = '업로드 중...';
				} else {
					this.uploadstatus = '업로드 중...';
				}

				const file = event.target.files[0];
				const data = await this.readFileAsync(file);
				const workbook = XLSX.read(data, { type: 'binary' });

				// 매칭 타입에 따라 특정 시트만 처리
				let targetSheetName;
				if (matchType === 'barcode') {
					// "SCM일괄업로드양식_바코드" 시트 찾기
					targetSheetName = workbook.SheetNames.find(name => name.includes('바코드') || name === 'SCM일괄업로드양식_바코드');
					if (!targetSheetName) {
						alert('바코드 매칭용 시트를 찾을 수 없습니다. "SCM일괄업로드양식_바코드" 시트가 있는지 확인해주세요.');
						this.showuploadspinner = false;
						this.uploadstatus2 = 'excel file upload';
						return;
					}
				} else {
					// "SCM일괄업로드양식_옵션ID" 시트 찾기
					targetSheetName = workbook.SheetNames.find(name => name.includes('옵션ID') || name === 'SCM일괄업로드양식_옵션ID');
					if (!targetSheetName) {
						alert('옵션ID 매칭용 시트를 찾을 수 없습니다. "SCM일괄업로드양식_옵션ID" 시트가 있는지 확인해주세요.');
						this.showuploadspinner = false;
						this.uploadstatus = 'excel file upload';
						return;
					}
				}

				// 처리할 시트 목록 결정 (항상 특정 시트만 처리)
				const sheetsToProcess = [targetSheetName];

				for (const sheetName of sheetsToProcess) {
					const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

					// 매칭 타입에 따른 유효성 검사
					let invalidOption;
					if (matchType === 'barcode') {
						// 바코드로 매칭 - growthdb에서 바코드 확인 후 vendorItemId로 growthSales 확인
						invalidOption = roa.find(e => {
							const growthdbItem = this.$store.state.growthdb?.find(item => item.barcode === e.바코드);
							if (!growthdbItem) return true;
							return !this.$store.state.growthSales.find(ele => ele.vendorItemId === growthdbItem.vendorItemId);
						});
						if (invalidOption) {
							alert(`상품DB에 ${invalidOption.바코드} 바코드가 존재하지 않거나 해당하는 판매 데이터가 없습니다. 상품DB를 다시 수집해주세요.`);
							continue;
						}
					} else {
						// 옵션ID로 매칭
						invalidOption = roa.find(e => !this.$store.state.growthSales.find(ele => ele.vendorItemId === e.옵션ID));
						if (invalidOption) {
							alert(`상품DB에 ${invalidOption.옵션ID} 옵션ID가 존재하지 않습니다. 로켓그로스 상품DB를 다시 수집해주세요.`);
							continue;
						}
					}

					const scmUpdates = []; // ScmDB 업데이트를 위한 배열
					const updatedItems = []; // 로컬에서 업데이트된 항목들

					// 수정된 항목만 업데이트하고 메트릭 재계산
					for (const e of roa) {
						let vendorItemId, ob, item;

						if (matchType === 'barcode') {
							// 바코드로 매칭
							if (!e.바코드) continue;

							// growthdb에서 바코드로 vendorItemId 찾기
							const growthdbItem = this.$store.state.growthdb?.find(item => item.barcode === e.바코드);
							if (!growthdbItem) continue;

							vendorItemId = growthdbItem.vendorItemId;
						} else {
							// 옵션ID로 매칭
							if (!e.옵션ID) continue;
							vendorItemId = e.옵션ID;
						}

						// 기존 항목 찾기
						ob = this.deepClone(
							this.$store.state.growthSales.find(ele => ele.vendorItemId === vendorItemId)
						);

						if (!ob) continue; // 항목이 없으면 건너뛰기

						// 로컬 항목 찾기
						item = this.saleslistsinit.find(i => i.vendorItemId === vendorItemId);
						if (!item) continue; // 로컬 항목이 없으면 건너뛰기

						// 변경 여부 확인을 위한 원본 값 저장
						const original = {
							구매: item.구매,
							배대지: item.배대지,
							통관중: item.통관중,
							국내재고: item.국내재고,
							입고기간: item.입고기간,
							배대지입고기간: item.배대지입고기간,
							통관중입고기간: item.통관중입고기간,
							국내입고기간: item.국내입고기간,
							최대재고기간: item.최대재고기간,
							최소재고기간: item.최소재고기간,
							MOQ수량: item.MOQ수량,
							타겟키워드: item.타겟키워드,
							메모: item.메모
						};

						// 새 값 준비 (쿠패스연동 상태에 따라 재고 필드 처리)
						const newValues = {
							// 쿠패스연동이 ON이면 기존 값 유지, OFF이면 엑셀 값 적용
							구매: this.coupassSyncEnabled ? original.구매 : (parseInt(e.구매완료재고) || parseInt(e.구매) || 0),
							배대지: this.coupassSyncEnabled ? original.배대지 : (parseInt(e.배대지재고) || parseInt(e.배대지) || 0),
							통관중: this.coupassSyncEnabled ? original.통관중 : (parseInt(e.통관중재고) || parseInt(e.통관중) || 0),
							국내재고: this.coupassSyncEnabled ? original.국내재고 : (parseInt(e.국내재고) || 0),
							입고기간: parseInt(e.구매입고기간) || parseInt(e.입고기간) || ob.입고기간 || 0,
							배대지입고기간: parseInt(e.배대지입고기간) || ob.배대지입고기간 || 0,
							통관중입고기간: parseInt(e.통관중입고기간) || ob.통관중입고기간 || 0,
							국내입고기간: parseInt(e.국내입고기간) || ob.국내입고기간 || 0,
							최대재고기간: parseInt(e.목표재고기간) || parseInt(e.최대재고기간) || ob.최대재고기간 || 0,
							최소재고기간: parseInt(e.안전재고기간) || parseInt(e.최소재고기간) || ob.최소재고기간 || 0,
							MOQ수량: parseInt(e.MOQ수량) || ob.MOQ수량 || 0,
							타겟키워드: e.타겟키워드 || ob.타겟키워드 || '',
							메모: e.메모 || ob.메모 || ''
						};

						// 변경 여부 확인
						let isChanged = false;
						for (const key in newValues) {
							if (newValues[key] !== original[key]) {
								isChanged = true;
								break;
							}
						}

						// 변경된 항목만 처리
						if (isChanged) {
							// 필드 값 업데이트
							item.구매 = newValues.구매;
							item.배대지 = newValues.배대지;
							item.통관중 = newValues.통관중;
							item.국내재고 = newValues.국내재고;
							item.입고기간 = newValues.입고기간;
							item.배대지입고기간 = newValues.배대지입고기간;
							item.통관중입고기간 = newValues.통관중입고기간;
							item.국내입고기간 = newValues.국내입고기간;
							item.최대재고기간 = newValues.최대재고기간;
							item.최소재고기간 = newValues.최소재고기간;
							item.MOQ수량 = newValues.MOQ수량;
							item.타겟키워드 = newValues.타겟키워드;
							item.메모 = newValues.메모;

							// 메트릭 재계산
							const metrics = this.calculateInventoryMetrics(item);
							item.남은재고기간 = metrics.남은재고기간;
							item.구매필요수량 = metrics.구매필요수량;
							item.dday = metrics.dday;
							item.배대지출고Dday = metrics.배대지출고Dday;
							item.배대지출고필요수량 = metrics.배대지출고필요수량;
							item.통관중출고Dday = metrics.통관중출고Dday;
							item.통관중출고필요수량 = metrics.통관중출고필요수량;
							item.국내출고Dday = metrics.국내출고Dday;
							item.국내출고필요수량 = metrics.국내출고필요수량;

							// Series 계산값도 갱신
							item.seriesDday = this.calculateSeriesDday(item);
							item.seriesNeededQty = this.calculateSeriesNeededQty(item);
							item.seriesNeededDays = this.calculateSeriesNeededDays(item);

							// ScmDB 형식으로 데이터 변환 (모든 필드 포함)
							const scmItem = {
								vendorItemId: vendorItemId,
								inboundPeriod: item.입고기간,
								overseasInputDays: item.배대지입고기간,
								customsInputDays: item.통관중입고기간,
								domesticInputDays: item.국내입고기간,
								targetStockDays: item.최대재고기간,
								safetyStockDays: item.최소재고기간,
								moqQuantity: item.MOQ수량,
								targetKeyword: item.타겟키워드,
								memo: item.메모,
								targetDailySales: parseFloat(item.목표일판매수량) || 0,
								// 계산된 필드도 포함
								remainingStockDays: item.남은재고기간,
								neededPurchaseQty: item.구매필요수량,
								dday: item.dday
							};
							// 쿠패스 OFF일 때만 수동 재고 필드 저장
							if (!this.coupassSyncEnabled) {
								scmItem.purchase = item.구매;
								scmItem.overseas = item.배대지;
								scmItem.customs = item.통관중;
								scmItem.domesticStock = item.국내재고;
							}

							scmUpdates.push(scmItem);
							updatedItems.push(item);
						}
					}

					try {
						// 변경된 항목이 없는 경우
						if (scmUpdates.length === 0) {
							alert('변경된 항목이 없습니다.');
							this.showuploadspinner = false;
							this.$bvModal.hide('excelupload');
							return;
						}

						// ScmDB에 일괄 업데이트
						const response = await axios.post('/api/batchUpdateScmData', scmUpdates);

						if (response.data.res === 'success') {
							// 결과 메시지 생성
							const matchTypeText = matchType === 'barcode' ? '바코드' : '옵션ID';
							alert(`${matchTypeText} 매칭 업로드 완료: 총 ${roa.length}개 항목 중 ${scmUpdates.length}개 데이터가 성공적으로 업데이트되었습니다.`);
						} else {
							alert(response.data.alert || '일부 데이터 업데이트에 실패했습니다.');
						}
					} catch (error) {
						console.error('데이터 업데이트 오류:', error);
						alert('데이터 업데이트 중 오류가 발생했습니다.');
					}

					this.showuploadspinner = false;
					this.currentUploadType = '';

					// 업로드 상태 초기화
					if (matchType === 'barcode') {
						this.uploadstatus2 = 'excel file upload';
					} else {
						this.uploadstatus = 'excel file upload';
					}

					// ScmDB 데이터를 다시 로드하고 페이지 새로고침
					await this.loadScmData();
					this.search()
				}
			} catch (error) {
				alert(error.message);
				this.showuploadspinner = false;
				this.currentUploadType = '';

				// 업로드 상태 초기화
				if (matchType === 'barcode') {
					this.uploadstatus2 = 'excel file upload';
				} else {
					this.uploadstatus = 'excel file upload';
				}

				this.$store.commit('growthSalesUpdate', []);
				this.search()
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => resolve(e.target.result);
				reader.onerror = (error) => reject(error);
				reader.readAsBinaryString(file);
			});
		},
		// 날짜 포맷팅
		formatDate(dateString) {
			if (!dateString) return '-';
			const date = new Date(dateString);
			return date.toLocaleDateString('ko-KR', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			});
		},
		// 짧은 날짜 포맷팅 (MM/DD)
		formatDateShort(dateString) {
			if (!dateString) return '-';
			const date = new Date(dateString);
			return date.toLocaleDateString('ko-KR', {
				month: '2-digit',
				day: '2-digit'
			});
		},
		// 재고 관리 모달 열기 (공통)
		showInventoryModal(item = null) {
			// 모달을 열 때 현재 saleslists 순서를 초기 상태로 저장
			this.originalSaleslistsOrder = [...this.saleslists];
			console.log('재고 관리 모달 열림 - 초기 순서 저장됨');

			// 선택 상태 초기화
			this.inventorySelectedItems = [];

			// 필터링 해제 (전체 상품 표시)
			this.inventoryFilteredVendorItemId = null;

			// 하이라이트 설정 (shown 이벤트에서 사용)
			if (item && !item.isSummaryRow) {
				this.highlightedVendorItemId = item.vendorItemId;
				console.log('재고관리 모달 - 상품 하이라이트 예약:', item.vendorItemId);
			} else {
				this.highlightedVendorItemId = null;
				console.log('재고관리 모달 - 전체 상품 표시');
			}

			this.$bvModal.show('inventoryModal');

			// 모달 스타일 강제 적용
			this.$nextTick(() => {
				this.forceModalStyle('inventoryModal');
			});
		},
		// 재고 관리 모달이 완전히 열린 후 실행
		onInventoryModalShown() {
			console.log('재고 관리 모달 shown 이벤트 발생');
			if (this.highlightedVendorItemId) {
				this.scrollToItemInModal('inventoryTable', this.highlightedVendorItemId);
			}
			// 입출고이력 날짜 범위 초기화
			if (!this.historyStartDate) {
				this.initHistoryDateRange();
			}
		},
		// 모달 스타일 강제 적용 함수
		forceModalStyle(modalId) {
			setTimeout(() => {
				const modal = document.getElementById(modalId);
				if (modal) {
					const modalDialog = modal.querySelector('.modal-dialog');
					const modalContent = modal.querySelector('.modal-content');
					const modalBody = modal.querySelector('.modal-body');

					if (modalDialog) {
						modalDialog.style.maxWidth = '98vw';
						modalDialog.style.width = '98vw';
						modalDialog.style.height = '96vh';
						modalDialog.style.maxHeight = '96vh';
						modalDialog.style.margin = '1vh auto';
					}

					if (modalContent) {
						modalContent.style.height = '100%';
						modalContent.style.display = 'flex';
						modalContent.style.flexDirection = 'column';
						modalContent.style.border = 'none';
						modalContent.style.borderRadius = '0';
					}

					if (modalBody) {
						modalBody.style.flex = '1';
						modalBody.style.overflowY = 'auto';
						modalBody.style.padding = '0.5rem';
						modalBody.style.maxHeight = 'none';
					}

					console.log(`모달 ${modalId} 스타일 강제 적용 완료`);
				}
			}, 100);
		},
		// 구매필요수량 모달 열릴 때
		onPoQtyModalShow(item) {
			// 기존 resetChartData 호출
			this.resetChartData(item);

			// 판매량 차트 준비
			this.salesChartReady = false;

			// 데이터 검증 후 차트 준비
			this.$nextTick(() => {
				if (item && item.salesHistory && item.dates) {
					// 약간의 지연 후 차트 렌더링
					setTimeout(() => {
						this.salesChartReady = true;
					}, 100);
				}

				// 모달 스타일 강제 적용
				this.forceModalStyle('poQty' + item.vendorItemId);
			});
		},
		// 입고 수량 tooltip 생성 - 모든 센터 정보 표시
		getInboundTooltip(item, date) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return '';
			}

			// 같은 날짜의 모든 센터 데이터를 찾기
			const inbounds = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
				.filter(inb => inb.expectedDeliveryDate === date);

			if (!inbounds || inbounds.length === 0) return '';

			const productName = item.판매상품명 || item.productName || '상품명 없음';
			const optionName = item.옵션명 || item.optionName || '';

			let tooltip = `상품: ${productName}`;
			if (optionName) {
				tooltip += `\n옵션: ${optionName}`;
			}
			tooltip += `\n입고예정일: ${date}`;

			// 여러 센터가 있는 경우 각각 표시
			if (inbounds.length > 1) {
				tooltip += `\n\n📦 센터별 입고 현황 (${inbounds.length}개 센터):`;
				let totalStowed = 0;
				let totalRequested = 0;

				inbounds.forEach((inbound, index) => {
					const stowed = inbound.stowedQuantity || 0;
					const requested = inbound.requestedQuantity || 0;
					const fcName = inbound.fcName || `센터${index + 1}`;

					totalStowed += stowed;
					totalRequested += requested;

					let status = '';
					if (stowed === requested && requested > 0) {
						status = ' ✅완료';
					} else if (stowed > 0 && stowed < requested) {
						status = ' 🟡부분입고';
					} else if (stowed === 0 && requested > 0) {
						status = ' 🔴대기중';
					}

					tooltip += `\n  • ${fcName}: ${stowed}/${requested}${status}`;
				});

				tooltip += `\n\n📊 전체 합계: ${totalStowed}/${totalRequested}`;
			} else {
				// 단일 센터인 경우
				const inbound = inbounds[0];
				const stowed = inbound.stowedQuantity || 0;
				const requested = inbound.requestedQuantity || 0;
				const fcName = inbound.fcName || '센터 정보 없음';

				tooltip += `\n센터: ${fcName}`;
				tooltip += `\n입고 상태: ${stowed}/${requested}`;

				if (stowed === requested && requested > 0) {
					tooltip += ' (입고완료)';
				} else if (stowed > 0 && stowed < requested) {
					tooltip += ' (부분입고)';
				} else if (stowed === 0 && requested > 0) {
					tooltip += ' (입고대기)';
				}
			}

			return tooltip;
		},
		// 전체 종합 tooltip 생성
		getSummaryTooltip(date) {
			if (!this.saleslists || this.saleslists.length === 0) {
				return '';
			}

			let totalStowed = 0;
			let totalRequested = 0;
			let partialInbounds = []; // 부분입고 상품들
			let completeInbounds = []; // 완료입고 상품들
			let pendingInbounds = []; // 입고전 상품들

			this.saleslists.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
						.find(inb => inb.expectedDeliveryDate === date);

					if (inbound) {
						const stowed = inbound.stowedQuantity || 0;
						const requested = inbound.requestedQuantity || 0;

						totalStowed += stowed;
						totalRequested += requested;

						const productName = item.판매상품명 || item.productName || '상품명 없음';
						const optionName = item.옵션명 || item.optionName || '';
						const fcName = inbound.fcName || '센터 정보 없음';

						const productInfo = {
							name: productName,
							option: optionName,
							center: fcName,
							stowed: stowed,
							requested: requested,
							ratio: `${stowed}/${requested}`
						};

						// 상태별로 분류
						if (stowed > 0 && stowed < requested) {
							partialInbounds.push(productInfo); // 부분입고
						} else if (stowed === requested && requested > 0) {
							completeInbounds.push(productInfo); // 입고완료
						} else if (stowed === 0 && requested > 0) {
							pendingInbounds.push(productInfo); // 입고전
						}
					}
				}
			});

			if (totalStowed === 0 && totalRequested === 0) return '';

			// tooltip 구성
			let tooltip = `전체 입고 현황 (${date})\n`;
			tooltip += `총 입고 상태: ${totalStowed}/${totalRequested}\n\n`;

			// 부분입고 상품들 (우선 표시)
			if (partialInbounds.length > 0) {
				tooltip += `🟡 부분입고 (${partialInbounds.length}개):\n`;
				partialInbounds.slice(0, 5).forEach(item => { // 최대 5개만 표시
					tooltip += `  • ${item.name}`;
					if (item.option) tooltip += ` (${item.option})`;
					tooltip += ` - ${item.center}: ${item.ratio}\n`;
				});
				if (partialInbounds.length > 5) {
					tooltip += `  ... 외 ${partialInbounds.length - 5}개\n`;
				}
				tooltip += '\n';
			}

			// 입고완료 상품들
			if (completeInbounds.length > 0) {
				tooltip += `🟢 입고완료 (${completeInbounds.length}개)\n`;
				if (completeInbounds.length <= 3) {
					completeInbounds.forEach(item => {
						tooltip += `  • ${item.name}`;
						if (item.option) tooltip += ` (${item.option})`;
						tooltip += ` - ${item.center}: ${item.ratio}\n`;
					});
				} else {
					tooltip += `  • 총 ${completeInbounds.length}개 상품 입고완료\n`;
				}
				tooltip += '\n';
			}

			// 입고전 상품들
			if (pendingInbounds.length > 0) {
				tooltip += `🔴 입고전 (${pendingInbounds.length}개)\n`;
				if (pendingInbounds.length <= 3) {
					pendingInbounds.forEach(item => {
						tooltip += `  • ${item.name}`;
						if (item.option) tooltip += ` (${item.option})`;
						tooltip += ` - ${item.center}: ${item.ratio}\n`;
					});
				} else {
					tooltip += `  • 총 ${pendingInbounds.length}개 상품 입고대기\n`;
				}
			}

			return tooltip.trim();
		},
		// 메모 추가
		addMemo(item) {
			this.currentItem = item;
			this.currentMemo = '';
			this.$bvModal.show('memoModal');
		},
		// 메모 편집
		editMemo(item) {
			this.currentItem = item;
			this.currentMemo = item.메모 || '';
			this.$bvModal.show('memoModal');
		},
		// 메모 삭제
		async deleteMemo(item) {
			if (confirm('메모를 삭제하시겠습니까?')) {
				this.$set(item, '메모', '');
				this.$set(item, 'isModified', true);

				try {
					await this.onInputComplete(item);
					console.log('메모가 삭제되었습니다.');
				} catch (error) {
					console.error('메모 삭제 오류:', error);
					this.$bvToast.toast('메모 삭제에 실패했습니다.', {
						title: '삭제 오류',
						variant: 'danger',
						solid: true
					});
				}
			}
		},
		// 메모 저장
		async saveMemo() {
			if (this.currentItem) {
				// 메모 내용을 trim하고, 빈 문자열이면 null 또는 빈 문자열로 설정
				const trimmedMemo = this.currentMemo.trim();
				this.$set(this.currentItem, '메모', trimmedMemo || '');

				// 수정 플래그 설정
				this.$set(this.currentItem, 'isModified', true);

				// 자동 저장 (빈 문자열도 저장되도록)
				try {
					await this.onInputComplete(this.currentItem);
					console.log('메모가 저장되었습니다:', trimmedMemo || '(빈 메모)');
					console.log('저장된 아이템 메모:', this.currentItem.메모);

					// saleslists 배열에서 해당 아이템을 찾아서 직접 업데이트
					const itemIndex = this.saleslists.findIndex(item =>
						item.vendorItemId === this.currentItem.vendorItemId
					);

					if (itemIndex !== -1) {
						this.$set(this.saleslists, itemIndex, { ...this.currentItem });
						console.log('saleslists 업데이트 완료');
					}

					// Vue의 반응성을 위해 강제 업데이트
					this.$forceUpdate();
				} catch (error) {
					console.error('메모 저장 오류:', error);
					this.$bvToast.toast('메모 저장에 실패했습니다.', {
						title: '저장 오류',
						variant: 'danger',
						solid: true
					});
				}
			}
			this.currentItem = null;
			this.currentMemo = '';
		},
		// 메모 취소
		cancelMemo() {
			this.currentItem = null;
			this.currentMemo = '';
		},
		// === 입출고이력 관련 메서드 ===
		async loadProcessHistory() {
			this.historyLoading = true;
			try {
				const companyid = this.$store.state.settings[0].companyid;
				const startTs = new Date(this.historyStartDate).getTime();
				const endTs = new Date(this.historyEndDate).getTime() + (24 * 60 * 60 * 1000) - 1;

				const result = await axios.post('/api/reqpurchase/getstockmanagement', {
					start: startTs,
					end: endTs,
					companyid: companyid
				});

				this.buildHistoryList(result.data.reqpurchase || []);
			} catch (e) {
				console.error('입출고이력 로드 실패:', e);
				this.historyList = [];
			}
			this.historyLoading = false;
		},
		buildHistoryList(reqList) {
			const result = [];
			const startDate = this.historyStartDate ? new Date(this.historyStartDate).getTime() : 0;
			const endDate = this.historyEndDate ? new Date(this.historyEndDate).getTime() + (24 * 60 * 60 * 1000) - 1 : Infinity;

			reqList.forEach(req => {
				if (!req.processHistory || req.processHistory.length === 0) return;

				req.processHistory.forEach(h => {
					const ts = h.changedAt ? new Date(h.changedAt).getTime() : 0;
					// processHistory의 changedAt 기준으로 날짜 범위 재필터링
					if (ts < startDate || ts > endDate) return;

					// 유형 판별 (입고/출고/이동)
					let 유형 = '이동';
					const inStatuses = ['해외재고', '국내재고', '쿠팡입고완료', '입고완료'];
					const outStatuses = ['통관중', '배송중'];
					if (inStatuses.includes(h.toStatus)) 유형 = '입고';
					else if (outStatuses.includes(h.toStatus) || inStatuses.includes(h.fromStatus)) 유형 = '출고';

					result.push({
						_id: `${req._id}_${ts}`,
						날짜: this.formatHistoryDateTime(h.changedAt),
						상품명: req.상품명 || '',
						바코드: req.바코드 || '',
						유형: 유형,
						수량: req.구매요청수량 || 0,
						fromStatus: h.fromStatus || '',
						toStatus: h.toStatus || '',
						상태변화: `${h.fromStatus || ''} → ${h.toStatus || ''}`,
						changedBy: h.changedByName || h.changedBy || '',
						memo: h.memo || ''
					});
				});
			});

			result.sort((a, b) => {
				const da = new Date(a.날짜).getTime() || 0;
				const db = new Date(b.날짜).getTime() || 0;
				return db - da;
			});
			this.historyList = result;
		},
		formatHistoryDateTime(dateVal) {
			if (!dateVal) return '';
			const d = new Date(dateVal);
			if (isNaN(d.getTime())) return '';
			const y = d.getFullYear();
			const m = String(d.getMonth() + 1).padStart(2, '0');
			const day = String(d.getDate()).padStart(2, '0');
			const h = String(d.getHours()).padStart(2, '0');
			const min = String(d.getMinutes()).padStart(2, '0');
			return `${y}-${m}-${day} ${h}:${min}`;
		},
		initHistoryDateRange() {
			const today = new Date();
			const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
			this.historyEndDate = today.toISOString().split('T')[0];
			this.historyStartDate = thirtyDaysAgo.toISOString().split('T')[0];
		},
		// 설정 모달 열기
		showSettingsModal(item = null) {
			// 선택 상태 초기화
			this.settingsSelectedItems = [];

			// 필터링 해제 (전체 상품 표시)
			this.settingsFilteredVendorItemId = null;

			// 하이라이트 설정 (shown 이벤트에서 사용)
			if (item && !item.isSummaryRow) {
				this.highlightedVendorItemId = item.vendorItemId;
				console.log('설정관리 모달 - 상품 하이라이트 예약:', item.vendorItemId);
			} else {
				this.highlightedVendorItemId = null;
				console.log('설정관리 모달 - 전체 상품 표시');
			}

			this.$bvModal.show('settingsModal');
		},
		// 설정 관리 모달이 완전히 열린 후 실행
		onSettingsModalShown() {
			console.log('설정 관리 모달 shown 이벤트 발생');
			if (this.highlightedVendorItemId) {
				this.scrollToItemInModal('settingsTable', this.highlightedVendorItemId);
			}
		},
		// 모달 내에서 특정 상품으로 스크롤 및 하이라이트
		scrollToItemInModal(tableRef, vendorItemId) {
			console.log('scrollToItemInModal 시작:', tableRef, vendorItemId);

			// 모달이 완전히 렌더링될 때까지 대기
			this.$nextTick(() => {
				setTimeout(() => {
					const table = this.$refs[tableRef];
					if (!table) {
						console.log('테이블 ref를 찾을 수 없습니다:', tableRef);
						return;
					}

					// 전체 아이템 목록 가져오기
					const items = tableRef === 'inventoryTable'
						? this.filteredInventoryList
						: this.filteredSettingsList;

					// 아이템 인덱스 찾기
					const itemIndex = items.findIndex(item => item.vendorItemId === vendorItemId);
					if (itemIndex === -1) {
						console.log('아이템을 찾을 수 없습니다:', vendorItemId);
						return;
					}

					console.log(`아이템 인덱스: ${itemIndex}, 전체 아이템 수: ${items.length}`);

					// 페이지당 아이템 수 (CDataTable의 items-per-page와 동일)
					const itemsPerPage = 100;

					// 해당 아이템이 있는 페이지 계산
					const targetPage = Math.floor(itemIndex / itemsPerPage) + 1;
					console.log(`목표 페이지: ${targetPage}, 현재 페이지: ${table.currentPage}`);

					// CDataTable의 currentPage 업데이트
					if (table.currentPage !== targetPage) {
						table.currentPage = targetPage;
						console.log('페이지 변경됨:', targetPage);
					}

					// 페이지 변경 및 렌더링 완료 후 스크롤
					this.$nextTick(() => {
						setTimeout(() => {
							// 테이블 wrapper 찾기
							const mainTable = table.$refs.mainTable;
							if (!mainTable || !mainTable.$el) {
								console.log('메인 테이블을 찾을 수 없습니다');
								return;
							}

							const tableWrapper = mainTable.$el.querySelector('.v-data-table__wrapper');
							if (!tableWrapper) {
								console.log('테이블 wrapper를 찾을 수 없습니다');
								return;
							}

							// 현재 페이지 내에서의 인덱스
							const indexInPage = itemIndex % itemsPerPage;

							// 각 행의 높이 (대략적인 값, 실제 높이에 맞게 조정 필요)
							const rowHeight = 60;

							// 스크롤 위치 계산 (중간에 오도록)
							const scrollTop = (indexInPage * rowHeight) - (tableWrapper.clientHeight / 2) + (rowHeight / 2);

							// 스크롤 실행 (부드러운 스크롤)
							tableWrapper.scrollTo({
								top: Math.max(0, scrollTop),
								behavior: 'smooth'
							});
							console.log(`스크롤 위치: ${scrollTop}, indexInPage: ${indexInPage}`);

							// 스크롤 완료 후 하이라이트 애니메이션 시작
							setTimeout(() => {
								console.log('하이라이트 애니메이션 시작');
								this.startHighlightAnimation();
							}, 800); // 스크롤 애니메이션 완료 대기 (smooth scroll 시간)
						}, 500); // 페이지 변경 후 충분한 딜레이
					});
				}, 300); // 모달 렌더링 후 약간의 딜레이
			});
		},
		// 하이라이트 애니메이션 시작
		startHighlightAnimation() {
			console.log('startHighlightAnimation 호출됨, highlightedVendorItemId:', this.highlightedVendorItemId);

			// Vue 리렌더링 강제 트리거
			this.$forceUpdate();

			// 하이라이트는 모달을 닫을 때까지 계속 유지됨
		},
		// 모달이 닫힐 때 하이라이트 제거
		onModalHidden() {
			console.log('모달 닫힘 - 하이라이트 제거');
			this.highlightedVendorItemId = null;
		},
		// 설정 툴팁 생성
		getSettingsTooltip(item) {
			let tooltip = '현재 설정값:\n';
			tooltip += `구매입고기간: ${item.입고기간 || '-'}일\n`;
			tooltip += `배대지입고기간: ${item.배대지입고기간 || '-'}일\n`;
			tooltip += `통관중입고기간: ${item.통관중입고기간 || '-'}일\n`;
			tooltip += `국내입고기간: ${item.국내입고기간 || '-'}일\n`;
			tooltip += `목표재고기간: ${item.최대재고기간 || '-'}일\n`;
			tooltip += `안전재고기간: ${item.최소재고기간 || '-'}일\n`;
			tooltip += `MOQ수량: ${item.MOQ수량 || '-'}개\n`;
			tooltip += `1박스 인입수량: ${item.박스인입수량 || '-'}개\n`;
			tooltip += `타겟키워드: ${item.타겟키워드 || '-'}`;
			return tooltip;
		},
		// 목표 일판매수량 모달 열기
		openTargetSalesModal(item) {
			this.targetSalesModal.item = item;
			this.targetSalesModal.targetSales = item.목표일판매수량 || 0;
			this.targetSalesModal.show = true;
		},
		// 목표 일판매수량 저장
		async saveTargetSales() {
			if (!this.targetSalesModal.item) return;

			const item = this.targetSalesModal.item;
			const targetSales = parseFloat(this.targetSalesModal.targetSales) || 0;

			try {
				// 로컬 상태 업데이트
				this.$set(item, '목표일판매수량', targetSales);

				// 재계산 트리거
				const metrics = this.calculateInventoryMetrics(item);
				item.남은재고기간 = metrics.남은재고기간;
				item.구매필요수량 = metrics.구매필요수량;
				item.dday = metrics.dday;
				item.배대지출고Dday = metrics.배대지출고Dday;
				item.배대지출고필요수량 = metrics.배대지출고필요수량;
				item.통관중출고Dday = metrics.통관중출고Dday;
				item.통관중출고필요수량 = metrics.통관중출고필요수량;
				item.국내출고Dday = metrics.국내출고Dday;
				item.국내출고필요수량 = metrics.국내출고필요수량;

				// 서버에 저장
				const updateData = {
					vendorItemId: item.vendorItemId,
					targetDailySales: targetSales
				};
				const response = await axios.post('/api/batchUpdateScmData', [updateData]);

				if (response.data.res === 'success') {
					this.$bvToast.toast('목표 일판매수량이 저장되었습니다.', {
						title: '저장 완료',
						variant: 'success',
						solid: true
					});
				} else {
					throw new Error(response.data.alert || '서버 저장 실패');
				}

			} catch (error) {
				console.error('목표 일판매수량 저장 실패:', error);
				this.$bvToast.toast('저장에 실패했습니다: ' + error.message, {
					title: '오류',
					variant: 'danger',
					solid: true
				});
			}

			this.targetSalesModal.show = false;
		},
		// 목표 일판매수량 모달 취소
		cancelTargetSales() {
			this.targetSalesModal.show = false;
			this.targetSalesModal.item = null;
			this.targetSalesModal.targetSales = 0;
		},
		// 구매요청수량 모달 열기
		openPurchaseRequestModal(item) {
			// 기본값 설정
			if (!item.박스인입수량) item.박스인입수량 = 1;
			if (!item.MOQ수량) item.MOQ수량 = 2;

			this.purchaseRequestModal.item = item;
			this.purchaseRequestModal.requestQuantity = item.구매필요수량 || 0;
			this.purchaseRequestModal.show = true;
		},
		// 구매요청수량 저장
		async savePurchaseRequest() {
			if (!this.purchaseRequestModal.item) return;

			const item = this.purchaseRequestModal.item;
			const requestQuantity = parseInt(this.purchaseRequestModal.requestQuantity) || 0;

			if (requestQuantity <= 0) {
				this.$bvToast.toast('구매요청수량을 입력해주세요.', {
					title: '입력 오류',
					variant: 'warning',
					solid: true
				});
				return false; // 모달이 닫히지 않도록 false 반환
			}

			try {
				// 처리 중 상태 시작
				this.purchaseRequestModal.isProcessing = true;

				// 애니메이션 효과 (날아가는 애니메이션)
				this.showPurchaseAnimation();

				// 애니메이션이 완료될 때까지 대기
				await new Promise(resolve => setTimeout(resolve, 1200));

				// 장바구니에 추가 (기존 로직 활용)
				const newItem = {
					...item,
					구매요청수량: requestQuantity
				};

				const existingIndex = this.purchaseCart.findIndex(
					cartItem => cartItem.vendorItemId === newItem.vendorItemId
				);

				if (existingIndex === -1) {
					// 새 상품이면 추가
					this.purchaseCart.push(newItem);
				} else {
					// 이미 있는 상품이면 구매요청수량 업데이트
					this.purchaseCart[existingIndex].구매요청수량 = requestQuantity;
				}

				// 성공 메시지 표시
				this.$bvToast.toast(`구매요청수량 ${requestQuantity}개가 장바구니에 추가되었습니다! 🛒`, {
					title: '구매요청 추가 완료',
					variant: 'success',
					solid: true,
					autoHideDelay: 3000,
					toastClass: 'success-message'
				});

			} catch (error) {
				console.error('구매요청수량 저장 실패:', error);
				this.$bvToast.toast('저장에 실패했습니다.', {
					title: '오류',
					variant: 'danger',
					solid: true
				});
			} finally {
				// 처리 완료 후 상태 초기화 및 모달 닫기
				setTimeout(() => {
					this.purchaseRequestModal.isProcessing = false;
					this.purchaseRequestModal.show = false;
				}, 500);
			}
		},
		// 구매요청수량 모달 취소
		cancelPurchaseRequest() {
			this.purchaseRequestModal.show = false;
			this.purchaseRequestModal.item = null;
			this.purchaseRequestModal.requestQuantity = 0;
			this.purchaseRequestModal.isProcessing = false;
		},
		// 구매요청 상세 모달 열기 (쿠패스연동 시)
		openReqpurchaseDetailModal(item) {
			if (!item || !this.coupassSyncEnabled) return;

			this.reqpurchaseDetailItem = item;

			// growthdb에서 barcode 찾기
			const growthItem = this.$store.state.growthdb.find(g => g.vendorItemId === item.vendorItemId);
			const barcode = growthItem?.barcode || '';

			if (!barcode) {
				this.reqpurchaseDetailList = [];
				this.showReqpurchaseDetailModal = true;
				return;
			}

			// coupassData에서 바코드로 매칭된 구매요청 목록 가져오기
			this.reqpurchaseDetailList = this.coupassData
				.filter(c => c.바코드 === barcode)
				.sort((a, b) => new Date(b.요청일) - new Date(a.요청일));

			this.showReqpurchaseDetailModal = true;
		},
		// 바코드 조회 헬퍼
		getBarcode(item) {
			if (!item) return '';
			const growthItem = this.$store.state.growthdb.find(g => g.vendorItemId === item.vendorItemId);
			return growthItem?.barcode || '-';
		},
		// 진행현황 뱃지 클래스
		getProcessStatusBadgeClass(status) {
			const statusMap = {
				'구매전': 'badge badge-secondary',
				'협상중': 'badge badge-info',
				'입금요청': 'badge badge-warning',
				'입금완료': 'badge badge-primary',
				'구매완료': 'badge badge-success',
				'배송중': 'badge badge-info',
				'입고완료': 'badge badge-success',
				'입고작업': 'badge badge-warning',
				'출고대기': 'badge badge-primary',
				'해외입고중': 'badge badge-info',
				'국내입고중': 'badge badge-info',
				'쿠팡센터입고완료': 'badge badge-success',
				'국내창고입고중': 'badge badge-info',
				'국내창고입고완료': 'badge badge-success',
				'구매보류': 'badge badge-danger',
				'구매취소': 'badge badge-dark',
				'입고오류처리': 'badge badge-danger',
				'해외재고': 'badge badge-warning',
				'통관중': 'badge badge-info'
			};
			return statusMap[status] || 'badge badge-secondary';
		},
		// 구매 후 예상 전체재고수량 계산
		getPurchasePreviewTotalStock() {
			if (!this.purchaseRequestModal.item || !this.purchaseRequestModal.requestQuantity) return 0;

			const item = this.purchaseRequestModal.item;
			const requestQuantity = parseInt(this.purchaseRequestModal.requestQuantity) || 0;
			const currentTotalStock = this.getTotalAvailableStock(item);

			return currentTotalStock + requestQuantity;
		},
		// 구매 후 예상 전체재고기간 계산
		getPurchasePreviewStockPeriod() {
			if (!this.purchaseRequestModal.item || !this.purchaseRequestModal.requestQuantity) return 0;

			const item = this.purchaseRequestModal.item;
			const totalStockAfterPurchase = this.getPurchasePreviewTotalStock();

			// 목표 일판매수량이 있으면 우선 사용
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			if (계산용일판매수량 <= 0) return 0;

			return Math.floor(totalStockAfterPurchase / 계산용일판매수량);
		},
		// 구매 예상 정보 계산 (입력값 변경 시 호출)
		calculatePurchasePreview() {
			// 실시간 계산을 위한 함수 (현재는 computed로 처리되므로 빈 함수)
		},
		// 현재 전체재고기간 계산
		getCurrentStockPeriod() {
			if (!this.purchaseRequestModal.item) return 0;

			const item = this.purchaseRequestModal.item;
			const currentTotalStock = this.getTotalAvailableStock(item);

			// 목표 일판매수량이 있으면 우선 사용
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			if (계산용일판매수량 <= 0) return 0;

			return Math.floor(currentTotalStock / 계산용일판매수량);
		},
		// 구매요청 추가 애니메이션 효과
		showPurchaseAnimation() {
			// 상품 이미지 복제하여 날아가는 애니메이션 생성
			this.createFlyingProductAnimation();

			// 모달 내용에 애니메이션 클래스 추가
			const modalContent = document.querySelector('.modal-content');
			if (modalContent) {
				modalContent.classList.add('cart-animation');

				// 애니메이션 완료 후 클래스 제거
				setTimeout(() => {
					modalContent.classList.remove('cart-animation');
				}, 600);
			}
		},
		// 상품이 구매요청 버튼으로 날아가는 애니메이션
		createFlyingProductAnimation() {
			const modalImg = document.querySelector('.modal-content img');
			const purchaseBtn = document.getElementById('purchaseRequestBtn');

			if (!modalImg || !purchaseBtn) return;

			// 상품 이미지 복제
			const flyingImg = modalImg.cloneNode(true);
			flyingImg.style.position = 'fixed';
			flyingImg.style.width = '60px';
			flyingImg.style.height = '60px';
			flyingImg.style.zIndex = '9999';
			flyingImg.style.pointerEvents = 'none';
			flyingImg.style.borderRadius = '8px';
			flyingImg.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';

			// 시작 위치 설정 (모달 이미지 위치)
			const modalRect = modalImg.getBoundingClientRect();
			flyingImg.style.left = modalRect.left + 'px';
			flyingImg.style.top = modalRect.top + 'px';

			// DOM에 추가
			document.body.appendChild(flyingImg);

			// 목표 위치 계산 (구매요청 버튼 위치)
			const btnRect = purchaseBtn.getBoundingClientRect();
			const targetX = btnRect.left + btnRect.width / 2 - 30; // 중앙 정렬
			const targetY = btnRect.top + btnRect.height / 2 - 30;

			// 애니메이션 실행
			setTimeout(() => {
				flyingImg.style.transition = 'all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
				flyingImg.style.transform = `translate(${targetX - modalRect.left}px, ${targetY - modalRect.top}px) scale(0.3)`;
				flyingImg.style.opacity = '0';
			}, 100);

			// 애니메이션 완료 후 정리 및 뱃지 애니메이션
			setTimeout(() => {
				document.body.removeChild(flyingImg);
				this.animateBadge();
			}, 1100);
		},
		// 뱃지 펄스 애니메이션
		animateBadge() {
			const badge = document.querySelector('#purchaseRequestBtn .badge');
			if (badge) {
				badge.classList.add('badge-pulse');
				setTimeout(() => {
					badge.classList.remove('badge-pulse');
				}, 600);
			}
		},
		// 구매요청수량이 있는지 확인
		getPurchaseRequestQuantity(item) {
			const cartItem = this.purchaseCart.find(cartItem => cartItem.vendorItemId === item.vendorItemId);
			return cartItem ? cartItem.구매요청수량 : 0;
		},
		// 구매요청수량이 있는 항목인지 확인
		hasPurchaseRequest(item) {
			return this.getPurchaseRequestQuantity(item) > 0;
		},
		// 구매 설정 업데이트 (박스인입수량, MOQ수량)
		async updatePurchaseSettings() {
			if (!this.purchaseRequestModal.item) return;

			const item = this.purchaseRequestModal.item;

			try {
				// 메인 리스트에서 동일한 상품 찾아서 업데이트
				const mainItem = this.saleslists.find(listItem => listItem.vendorItemId === item.vendorItemId);
				if (mainItem) {
					mainItem.박스인입수량 = parseInt(item.박스인입수량) || 1;
					mainItem.MOQ수량 = parseInt(item.MOQ수량) || 2;
				}

				// 서버에 저장 (기존 설정 저장 로직과 동일)
				const updateData = {
					vendorItemId: item.vendorItemId,
					박스인입수량: parseInt(item.박스인입수량) || 1,
					MOQ수량: parseInt(item.MOQ수량) || 2
				};

				// 실제 서버 저장은 추후 구현
				// await axios.post('/api/growth/updatePurchaseSettings', updateData);

				console.log('구매 설정 업데이트:', updateData);

			} catch (error) {
				console.error('구매 설정 업데이트 실패:', error);
			}
		},
		// 아이템 설정 업데이트 (서버 저장)
		async updateItemSettings(item) {
			try {
				// 기존 onInputComplete와 동일한 로직 사용
				this.$set(item, 'isModified', true);
				await this.onInputComplete(item);

				console.log('설정이 자동 저장되었습니다:', item);

				// Vue의 반응성을 위해 강제 업데이트
				this.$forceUpdate();
			} catch (error) {
				console.error('설정 저장 오류:', error);
				// 오류 토스트 표시
				this.$bvToast.toast('설정 저장에 실패했습니다.', {
					title: '저장 오류',
					variant: 'danger',
					solid: true
				});
			}
		},

		// 재고 일괄변경 적용
		async applyBulkInventory() {
			const inventory = this.재고일괄변경;
			let updatedCount = 0;

			// 선택된 아이템이 없으면 전체 적용, 있으면 선택된 아이템만 적용
			const targetItems = this.inventorySelectedItems.length > 0 ? this.inventorySelectedItems : this.saleslists;

			// confirm창으로 확인
			const confirmMessage = this.inventorySelectedItems.length > 0
				? `선택한 ${this.inventorySelectedItems.length}개 상품에 재고 변경을 적용하시겠습니까?`
				: `전체 ${this.saleslists.length}개 상품에 재고 변경을 적용하시겠습니까?`;

			if (!confirm(confirmMessage)) {
				return;
			}

			// 변경할 항목들을 수집하고 테이블 데이터 직접 변경
			const itemsToUpdate = [];

			targetItems.forEach(item => {
				let updated = false;

				// 쿠패스 OFF일 때만 구매/배대지/통관중/국내재고 수동 변경 허용
				if (!this.coupassSyncEnabled) {
					if (inventory.구매 !== null && inventory.구매 !== '') {
						item.구매 = inventory.구매;
						updated = true;
					}
					if (inventory.배대지 !== null && inventory.배대지 !== '') {
						item.배대지 = inventory.배대지;
						updated = true;
					}
					if (inventory.통관중 !== null && inventory.통관중 !== '') {
						item.통관중 = inventory.통관중;
						updated = true;
					}
					if (inventory.국내재고 !== null && inventory.국내재고 !== '') {
						item.국내재고 = inventory.국내재고;
						updated = true;
					}
				}

				if (updated) {
					updatedCount++;
					itemsToUpdate.push(item);
				}
			});

			// 변경된 항목들을 일괄 저장 (한 번의 API 호출)
			if (updatedCount > 0) {
				const scmUpdates = itemsToUpdate.map(item => {
					const update = { vendorItemId: item.vendorItemId };
					if (!this.coupassSyncEnabled) {
						update.purchase = parseInt(item.구매) || 0;
						update.overseas = parseInt(item.배대지) || 0;
						update.customs = parseInt(item.통관중) || 0;
						update.domesticStock = parseInt(item.국내재고) || 0;
					}
					return update;
				});
				try {
					const response = await axios.post('/api/batchUpdateScmData', scmUpdates);
					if (response.data.res === 'success') {
						const message = this.inventorySelectedItems.length > 0
							? `선택한 ${updatedCount}개 상품의 재고가 일괄 변경되었습니다.`
							: `전체 ${updatedCount}개 상품의 재고가 일괄 변경되었습니다.`;
						this.$bvToast.toast(message, { title: '일괄변경 완료', variant: 'success', solid: true });
					} else {
						this.$bvToast.toast(response.data.alert || '저장 실패', { title: '오류', variant: 'danger', solid: true });
					}
				} catch (error) {
					console.error('재고 일괄 저장 오류:', error);
					this.$bvToast.toast('재고 저장 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
				}
			}

			// 입력값만 초기화 (선택 상태는 유지)
			this.재고일괄변경 = {
				구매: null,
				배대지: null,
				통관중: null,
				국내재고: null
			};
			// this.inventorySelectedItems = []; // 선택 상태 유지
		},
		// 설정 일괄변경 적용
		async applyBulkSettings() {
			const settings = this.설정일괄변경;
			let updatedCount = 0;

			// 선택된 아이템이 없으면 전체 적용, 있으면 선택된 아이템만 적용
			const targetItems = this.settingsSelectedItems.length > 0 ? this.settingsSelectedItems : this.saleslists;

			// confirm창으로 확인
			const confirmMessage = this.settingsSelectedItems.length > 0
				? `선택한 ${this.settingsSelectedItems.length}개 상품에 설정 변경을 적용하시겠습니까?`
				: `전체 ${this.saleslists.length}개 상품에 설정 변경을 적용하시겠습니까?`;

			if (!confirm(confirmMessage)) {
				return;
			}

			// 변경할 항목들을 수집하고 테이블 데이터 직접 변경
			const itemsToUpdate = [];

			targetItems.forEach(item => {
				let updated = false;

				if (settings.입고기간 !== null && settings.입고기간 !== '') {
					item.입고기간 = settings.입고기간;
					updated = true;
				}
				if (settings.배대지입고기간 !== null && settings.배대지입고기간 !== '') {
					item.배대지입고기간 = settings.배대지입고기간;
					updated = true;
				}
				if (settings.통관중입고기간 !== null && settings.통관중입고기간 !== '') {
					item.통관중입고기간 = settings.통관중입고기간;
					updated = true;
				}
				if (settings.국내입고기간 !== null && settings.국내입고기간 !== '') {
					item.국내입고기간 = settings.국내입고기간;
					updated = true;
				}
				if (settings.최소재고기간 !== null && settings.최소재고기간 !== '') {
					item.최소재고기간 = settings.최소재고기간;
					updated = true;
				}
				if (settings.최대재고기간 !== null && settings.최대재고기간 !== '') {
					item.최대재고기간 = settings.최대재고기간;
					updated = true;
				}
				if (settings.MOQ수량 !== null && settings.MOQ수량 !== '') {
					item.MOQ수량 = settings.MOQ수량;
					updated = true;
				}

				if (updated) {
					updatedCount++;
					itemsToUpdate.push(item);
				}
			});

			// 변경된 항목들을 일괄 저장 (한 번의 API 호출)
			if (updatedCount > 0) {
				const scmUpdates = itemsToUpdate.map(item => ({
					vendorItemId: item.vendorItemId,
					inboundPeriod: parseInt(item.입고기간) || 0,
					overseasInputDays: parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays,
					customsInputDays: parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays,
					domesticInputDays: parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays,
					targetStockDays: parseInt(item.최대재고기간) || 0,
					safetyStockDays: parseInt(item.최소재고기간) || 0,
					moqQuantity: parseInt(item.MOQ수량) || 0
				}));
				try {
					const response = await axios.post('/api/batchUpdateScmData', scmUpdates);
					if (response.data.res === 'success') {
						const message = this.settingsSelectedItems.length > 0
							? `선택한 ${updatedCount}개 상품의 설정이 일괄 변경되었습니다.`
							: `전체 ${updatedCount}개 상품의 설정이 일괄 변경되었습니다.`;
						this.$bvToast.toast(message, { title: '일괄변경 완료', variant: 'success', solid: true });
					} else {
						this.$bvToast.toast(response.data.alert || '저장 실패', { title: '오류', variant: 'danger', solid: true });
					}
				} catch (error) {
					console.error('설정 일괄 저장 오류:', error);
					this.$bvToast.toast('설정 저장 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
				}
			}

			// 입력값만 초기화 (선택 상태는 유지)
			this.설정일괄변경 = {
				입고기간: null,
				배대지입고기간: null,
				통관중입고기간: null,
				국내입고기간: null,
				최소재고기간: null,
				최대재고기간: null,
				MOQ수량: null
			};
			// this.settingsSelectedItems = []; // 선택 상태 유지
		},
		// 아이템들 중에 메모가 있는지 확인
		hasMemoInItems() {
			return this.saleslists && this.saleslists.some(item =>
				item.메모 && item.메모.trim()
			);
		},
		// 메모가 있는 아이템 개수 반환
		getMemoCount() {
			if (!this.saleslists) return 0;
			return this.saleslists.filter(item =>
				item.메모 && item.메모.trim()
			).length;
		},
		// 종합 메모 tooltip 생성
		getSummaryMemoTooltip() {
			if (!this.saleslists) return '';

			const itemsWithMemo = this.saleslists.filter(item =>
				item.메모 && item.메모.trim()
			);

			if (itemsWithMemo.length === 0) return '';

			let tooltip = `메모가 있는 상품 (${itemsWithMemo.length}개):\n\n`;

			itemsWithMemo.slice(0, 5).forEach(item => { // 최대 5개만 표시
				const productName = item.판매상품명 || item.productName || '상품명 없음';
				const optionName = item.옵션명 || item.optionName || '';

				tooltip += `• ${productName}`;
				if (optionName) tooltip += ` (${optionName})`;
				tooltip += `\n  메모: ${item.메모}\n\n`;
			});

			if (itemsWithMemo.length > 5) {
				tooltip += `... 외 ${itemsWithMemo.length - 5}개 상품에 메모 있음`;
			}

			return tooltip.trim();
		},

		// 쿠팡재고기간 위험 상태 툴팁 반환
		getCoupangStockDangerTooltip(item) {
			if (!item.쿠팡재고기간) return '';

			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			const safetyDays = parseInt(item.최소재고기간) || 0;
			const dailySales = parseFloat(item.일평균판매량) || 0;

			let tooltip = `현재 쿠팡재고기간: ${stockDays}일\n`;
			tooltip += `최소재고기간: ${safetyDays}일\n`;

			if (dailySales > 0) {
				tooltip += `일평균 판매량: ${dailySales.toFixed(2)}개\n`;

				if (stockDays > 0) {
					const daysToStockOut = Math.ceil(stockDays);
					const stockOutDate = new Date();
					stockOutDate.setDate(stockOutDate.getDate() + daysToStockOut);

					tooltip += `예상 품절일: ${stockOutDate.getMonth() + 1}/${stockOutDate.getDate()} (${daysToStockOut}일 후)\n`;
				}
			}

			// 60일 초과 경고
			if (stockDays > 60) {
				tooltip += `\n⚠️ 주의: 재고기간이 60일을 초과합니다!`;
				tooltip += `\n💰 과재고로 인한 보관료 증가 위험`;
			}
			// 안전재고기간 이하 경고
			else if (item.최소재고기간 && stockDays <= safetyDays) {
				tooltip += `\n⚠️ 위험: 안전재고기간 이하입니다!`;
				if (stockDays <= 3) {
					tooltip += `\n🚨 긴급: 3일 이내 품절 위험!`;
				}
			}

			return tooltip.trim();
		},
		// 반품상품 위험 상태 클래스 반환
		getReturnProductDangerClass(returnProduct, item) {
			if (!returnProduct.orderableQuantity || !item.일평균판매량 || !item.안전재고기간) return '';

			const stockDays = Math.floor((returnProduct.orderableQuantity || 0) / item.일평균판매량);
			const safetyDays = parseInt(item.안전재고기간) || 0;

			if (stockDays <= safetyDays) {
				return 'bg-danger text-white font-weight-bold stock-danger';
			}

			return '';
		},
		// 반품상품 위험 상태 툴팁 반환
		getReturnProductDangerTooltip(returnProduct, item) {
			if (!returnProduct.orderableQuantity || !item.일평균판매량 || !item.안전재고기간) return '';

			const stockDays = Math.floor((returnProduct.orderableQuantity || 0) / item.일평균판매량);
			const safetyDays = parseInt(item.안전재고기간) || 0;
			const dailySales = parseFloat(item.일평균판매량) || 0;

			let tooltip = `반품상품 재고기간: ${stockDays}일\n`;
			tooltip += `안전재고기간: ${safetyDays}일\n`;

			if (dailySales > 0) {
				tooltip += `일평균 판매량: ${dailySales.toFixed(2)}개\n`;

				if (stockDays > 0) {
					const daysToStockOut = Math.ceil(stockDays);
					const stockOutDate = new Date();
					stockOutDate.setDate(stockOutDate.getDate() + daysToStockOut);

					tooltip += `예상 품절일: ${stockOutDate.getMonth() + 1}/${stockOutDate.getDate()} (${daysToStockOut}일 후)\n`;
				}
			}

			if (stockDays <= safetyDays) {
				tooltip += `\n⚠️ 위험: 안전재고기간 이하입니다!`;
				if (stockDays <= 3) {
					tooltip += `\n🚨 긴급: 3일 이내 품절 위험!`;
				}
			}

			return tooltip.trim();
		},
		// 입고중 상태 모달 열기 (기존 함수 유지)
		showInboundStatus(item) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				this.$bvToast.toast('입고중 데이터가 없습니다.', {
					title: '알림',
					variant: 'warning',
					solid: true
				});
				return;
			}

			this.selectedInboundData = {
				vendorItemId: item.vendorItemId,
				productName: item.판매상품명,
				optionName: item.옵션명,
				thumbnail: item.썸네일,
				재고: item.재고,
				구매: item.구매,
				배대지: item.배대지,
				장기입고중: item.장기입고중,
				국내재고: item.국내재고,
				단기입고중: item.단기입고중,
				inbounds: item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
			};

			this.$bvModal.show('inboundStatusModal');
		},
		// 모달 내에서 재고 업데이트
		async updateInventoryInModal(item, field, value) {
			try {
				const newValue = parseInt(value) || 0;
				let oldValue;

				// 기존 값 확인
				if (field === '구매') oldValue = item.구매 || 0;
				else if (field === '배대지') oldValue = item.배대지 || 0;
				else if (field === '국내재고') oldValue = item.국내재고 || 0;

				// 값이 실제로 변경된 경우에만 업데이트
				if (oldValue !== newValue) {
					// 값 업데이트
					if (field === '구매') item.구매 = newValue;
					else if (field === '배대지') item.배대지 = newValue;
					else if (field === '국내재고') item.국내재고 = newValue;

					// 수정 플래그 설정
					item.isModified = true;

					// 자동 저장
					await this.onInputComplete(item);

					console.log(`${field} 값이 ${oldValue}에서 ${newValue}로 변경되어 서버에 저장되었습니다.`);
				} else {
					console.log(`${field} 값이 변경되지 않아 서버 업데이트를 생략합니다.`);
				}
			} catch (error) {
				console.error('재고 업데이트 오류:', error);
			}
		},
		// 입고 상세 보기
		showInboundDetail(item) {
			// 기존 입고중 상태 모달 로직 사용
			this.showInboundStatus(item);
		},
		// 재고 메모 업데이트
		async updateInventoryMemo(item) {
			try {
				item.isModified = true;
				await this.onInputComplete(item);
			} catch (error) {
				console.error('메모 업데이트 오류:', error);
			}
		},
		// 기본 정렬 적용
		applyDefaultSort() {
			if (!this.saleslists || this.saleslists.length === 0) return;

			// productId별 월판매수량 합계 계산 (기본 정렬용)
			const productSales = {};
			this.saleslists.forEach(item => {
				const productId = item.productId;
				if (!productSales[productId]) productSales[productId] = 0;
				productSales[productId] += item.월판매수량 || 0;
			});

			// 저장된 순서가 있으면 우선 적용, 없으면 기본 정렬
			this.saleslists.sort((a, b) => {
				const aProd = parseInt(a.productOrder);
				const bProd = parseInt(b.productOrder);
				const aOpt = parseInt(a.optionOrder);
				const bOpt = parseInt(b.optionOrder);
				const aHasOrder = Number.isFinite(aProd) || Number.isFinite(aOpt);
				const bHasOrder = Number.isFinite(bProd) || Number.isFinite(bOpt);

				// 하나라도 순서가 설정된 경우, 순서가 있는 항목을 앞에 배치
				if (aHasOrder || bHasOrder) {
					if (aHasOrder && !bHasOrder) return -1;
					if (!aHasOrder && bHasOrder) return 1;
					// 둘 다 순서가 있으면 productOrder -> optionOrder 기준 오름차순
					const aProductOrder = Number.isFinite(aProd) ? aProd : 999999;
					const bProductOrder = Number.isFinite(bProd) ? bProd : 999999;
					if (aProductOrder !== bProductOrder) return aProductOrder - bProductOrder;
					const aOptionOrder = Number.isFinite(aOpt) ? aOpt : 999999;
					const bOptionOrder = Number.isFinite(bOpt) ? bOpt : 999999;
					if (aOptionOrder !== bOptionOrder) return aOptionOrder - bOptionOrder;
					// 순서가 동일하면 기본 정렬 보조 기준
					const aItemSales2 = a.월판매수량 || 0;
					const bItemSales2 = b.월판매수량 || 0;
					return bItemSales2 - aItemSales2;
				}

				// 기본 정렬: productId별 월판매수량 합계 내림차순 -> 개별 월판매수량 내림차순
				const aSales = productSales[a.productId] || 0;
				const bSales = productSales[b.productId] || 0;
				if (aSales !== bSales) return bSales - aSales;
				const aItemSales = a.월판매수량 || 0;
				const bItemSales = b.월판매수량 || 0;
				return bItemSales - aItemSales;
			});
		},
		// 노출ID 순서 업데이트 (같은 productId 모두 적용)
		async updateProductOrder(item) {
			try {
				const productId = item.productId;
				const orderValue = item.productOrder;

				// 같은 productId를 가진 모든 항목에 순서 적용
				this.saleslists.forEach(listItem => {
					if (listItem.productId === productId) {
						listItem.productOrder = orderValue;
						listItem.isModified = true;
					}
				});

				// 모든 수정된 항목 저장
				const modifiedItems = this.saleslists.filter(listItem =>
					listItem.productId === productId && listItem.isModified
				);

				for (const modifiedItem of modifiedItems) {
					await this.onInputComplete(modifiedItem);
				}
			} catch (error) {
				console.error('노출ID 순서 업데이트 오류:', error);
			}
		},
		// 옵션ID 순서 업데이트
		async updateOrder(item) {
			try {
				// 🆕 GrowthSales에 순서 정보 저장
				const response = await axios.post('/api/updateOnlyGrowthSalesV2', [item]);

				if (response.data.res === 'success') {
					console.log('순서가 저장되었습니다:', item.vendorItemId);
				} else {
					console.error('순서 저장 실패:', response.data.alert);
				}
			} catch (error) {
				console.error('순서 업데이트 오류:', error);
			}
		},
		// 커스텀 정렬 적용
		async applyCustomSort() {
			if (!this.saleslists || this.saleslists.length === 0) return;

			// 1. 기존 정렬 로직 유지
			this.saleslists.sort((a, b) => {
				// 1. 노출ID 순서 우선 (빈값은 뒤로)
				const aProductOrder = parseInt(a.productOrder) || 999999;
				const bProductOrder = parseInt(b.productOrder) || 999999;

				if (aProductOrder !== bProductOrder) {
					return aProductOrder - bProductOrder;
				}

				// 2. 같은 노출ID 순서 내에서 옵션ID 순서 (빈값은 뒤로)
				const aOptionOrder = parseInt(a.optionOrder) || 999999;
				const bOptionOrder = parseInt(b.optionOrder) || 999999;

				if (aOptionOrder !== bOptionOrder) {
					return aOptionOrder - bOptionOrder;
				}

				// 3. 순서가 모두 같으면 기본 정렬 (월판매수량 기준)
				const aSales = a.월판매수량 || 0;
				const bSales = b.월판매수량 || 0;

				return bSales - aSales;
			});

			// 🆕 2. 순서가 설정된 아이템들을 GrowthSales에 저장
			const itemsWithOrder = this.saleslists.filter(item =>
				(item.productOrder && item.productOrder !== '') ||
				(item.optionOrder && item.optionOrder !== '')
			);

			if (itemsWithOrder.length > 0) {
				try {
					// GrowthSales 컬렉션에 저장 (순서 정보 포함)
					const response = await axios.post('/api/updateOnlyGrowthSalesV2', itemsWithOrder);

					if (response.data.res === 'success') {
						console.log(`${itemsWithOrder.length}개 아이템의 순서가 저장되었습니다.`);
						this.showOrderModal = false;
						this.$bvToast.toast('순서가 적용되고 저장되었습니다.', {
							title: '알림',
							variant: 'success',
							solid: true
						});
					} else {
						alert('순서 저장에 실패했습니다: ' + response.data.alert);
					}
				} catch (error) {
					console.error('순서 저장 오류:', error);
					alert('순서 저장 중 오류가 발생했습니다.');
				}
			} else {
				// 순서 설정이 없어도 정렬은 적용
				this.showOrderModal = false;
				this.$bvToast.toast('순서가 적용되었습니다.', {
					title: '알림',
					variant: 'success',
					solid: true
				});
			}
		},
		// 재고 업데이트 (기존 함수)
		async updateInventory(field, value) {
			try {
				const item = this.saleslists.find(item => item.vendorItemId === this.selectedInboundData.vendorItemId);
				if (item) {
					// 기본 테이블의 값도 업데이트
					if (field === '구매') item.구매 = parseInt(value) || 0;
					else if (field === '배대지') item.배대지 = parseInt(value) || 0;
					else if (field === '국내재고') item.국내재고 = parseInt(value) || 0;

					// 수정 플래그 설정
					item.isModified = true;

					// 자동 저장
					await this.onInputComplete(item);
				}
			} catch (error) {
				console.error('재고 업데이트 오류:', error);
			}
		},
		// 상태 텍스트 변환
		getStatusText(status) {
			const statusMap = {
				'INIT_COMPLETED': '입고 대기',
				'STOWING': '입고 중',
				'COMPLETED': '입고 완료',
				'CANCELLED': '취소됨'
			};
			return statusMap[status] || status;
		},
		// 상태별 CSS 클래스
		getStatusClass(status) {
			const classMap = {
				'INIT_COMPLETED': 'badge badge-warning',
				'STOWING': 'badge badge-info',
				'COMPLETED': 'badge badge-success',
				'CANCELLED': 'badge badge-danger'
			};
			return classMap[status] || 'badge badge-secondary';
		},

		// 숫자 포맷팅
		formatNumber(number) {
			return new Intl.NumberFormat('ko-KR').format(number);
		},

		// 통화 포맷팅
		formatCurrency(amount) {
			return new Intl.NumberFormat('ko-KR', {
				style: 'currency',
				currency: 'KRW'
			}).format(amount);
		},

		// 입고 경과일 계산
		calculateDaysAgo(inboundDate) {
			const today = new Date();
			const date = new Date(inboundDate);
			return Math.floor((today - date) / (1000 * 60 * 60 * 24));
		},

		// 보관료 계산
		calculateStorageFee(inboundDate, quantity, storageFeeRates) {
			const daysStored = this.calculateDaysAgo(inboundDate);
			const rates = storageFeeRates.feeRatesAfterPromotion;

			const applicableRate = rates.find(rate =>
				daysStored >= rate.startDay && daysStored <= rate.endDay
			);

			return applicableRate ? (applicableRate.feeRate * quantity) : 0;
		},

		// 입고 리스트 정렬
		sortedInboundList(inboundInfo) {
			if (!inboundInfo?.cfsStowedDetailList) return [];
			return [...inboundInfo.cfsStowedDetailList].sort((a, b) =>
				new Date(a.inboundDate) - new Date(b.inboundDate)
			);
		},

		// 총 수량 계산
		getTotalQuantity(inboundInfo) {
			return inboundInfo?.cfsStowedDetailList?.reduce((sum, detail) =>
				sum + detail.remainingSkuQty, 0
			) || 0;
		},

		// 총 보관료 계산
		getTotalStorageFee(inboundInfo) {
			if (!inboundInfo?.cfsStowedDetailList) return 0;
			return inboundInfo.cfsStowedDetailList.reduce((sum, detail) =>
				sum + this.calculateStorageFee(
					detail.inboundDate,
					detail.remainingSkuQty,
					inboundInfo.storageFeeRates
				), 0
			);
		},
		// 메인 제품의 월판매수량 계산 (번들 제품 제외)
		// 유효판매일(판매 또는 노출이 있던 날) 기준 일판매속도 계산
		// 판매 0 + 노출 0 인 날은 미등록/품절로 보고 분모에서 제외, 스파이크는 캡, 최근 7유효일 가중 블렌드
		// ─────────────────────────────────────────────────────────────
		// 일판매속도(velocity) 계산 — 다신호 복합 엔진 (2026-06)
		//   신호: 주문건수(orders)=주 수요신호 / 방문자(visitor)=선행 교차검증
		//         판매단위(units)=발주 환산용. ※PV·장바구니는 단일행위자에 부풀려져 제외
		//         (units:orders = PV:visitor 와 같은 관계 — '깨끗한 이벤트'는 orders·visitor)
		//   층별 역할(서로 다른 실패모드, 중복차감 없음):
		//     [0] provisional 마지막날: 방문자 미수집(2시 지연)인 날은 트렌드서 제외 → "어제만 급등"·지연
		//     [1] Hampel ±2 캡: 주 신호의 고립 하루 스파이크 제거
		//     [2] 단기/장기 블렌드: 유효일≥7 이면 0.65·최근7 + 0.35·전체
		//     [3] 방문자 교차검증: 주문 상승 시 방문자 동반상승해야 상향 인정(가짜 차단)
		//     [4] shrinkage(empirical Bayes): 저신뢰 신상은 prior(현재 run-rate)쪽으로 보수적
		//     [5] 주문→단위 환산: × median(주문당 단위수) → 묶음구매 단위부풀림 분리
		//     [6] fallback: 주문데이터 없으면 판매단위 기반(위 층 그대로 units에 적용)
		// 시그니처: (ordersArr, visitorArr, unitsArr)
		// ─────────────────────────────────────────────────────────────
		calcDailyVelocity(ordersArr, visitorArr, unitsArr) {
			const mean = a => a.length ? a.reduce((x, y) => x + y, 0) / a.length : 0;
			const median = a => {
				if (!a.length) return 0;
				const s = [...a].sort((x, y) => x - y);
				return s[Math.floor(s.length / 2)];
			};

			const orders = (ordersArr || []).map(v => v || 0);
			const visitors = (visitorArr || []).map(v => v || 0);
			const units = (unitsArr || []).map(v => v || 0);
			const len = Math.max(orders.length, units.length, visitors.length);

			// ── [0] provisional 마지막날: 방문자 미수집(지연)인데 거래는 있는 날 → 트렌드서 제외
			let cut = len;
			if (len > 0) {
				const li = len - 1;
				if ((visitors[li] || 0) === 0 && ((orders[li] || 0) + (units[li] || 0)) > 0) {
					cut = len - 1;
				}
			}
			const ordersC = orders.slice(0, cut);
			const visitorsC = visitors.slice(0, cut);
			const unitsC = units.slice(0, cut);

			// 주문 데이터 보유 여부 → 없으면 판매단위 fallback([6])
			const hasOrders = ordersC.some(v => v > 0);
			const hasVisitors = visitorsC.some(v => v > 0);
			const primary = hasOrders ? ordersC : unitsC;   // 주 신호
			const traffic = visitorsC;                       // 트래픽 신호(방문자)

			// ── 유효일: 방문자>0 또는 주 신호>0
			const active = [];
			primary.forEach((s, i) => {
				if (s > 0 || (traffic[i] || 0) > 0) active.push(s);
			});
			const activeDays = active.length;
			if (activeDays === 0) return { velocity: 0, activeDays: 0, trend: 0 };

			// ── [1] Hampel ±2 스파이크 캡 (이웃 로컬 중앙값 대비 고립 급증만 캡)
			let baseline = active;
			if (activeDays >= 5) {
				baseline = active.map((v, i) => {
					const lo = Math.max(0, i - 2);
					const hi = Math.min(activeDays - 1, i + 2);
					const win = active.slice(lo, hi + 1).sort((a, b) => a - b);
					const med = win[Math.floor(win.length / 2)];
					const mad = win.map(x => Math.abs(x - med)).sort((a, b) => a - b)[Math.floor(win.length / 2)];
					return v > med + 3 * 1.4826 * mad ? med : v;
				});
			}

			// ── [2] 단기/장기 블렌드 → 주 신호의 일별 rate
			const allAvg = baseline.reduce((a, b) => a + b, 0) / activeDays;
			const recent7Avg = baseline.slice(-7).reduce((a, b) => a + b, 0) / Math.min(7, activeDays);
			let rate = activeDays < 7 ? allAvg : (0.65 * recent7Avg + 0.35 * allAvg);
			const trend = (activeDays >= 7 && allAvg > 0) ? ((recent7Avg - allAvg) / allAvg) * 100 : 0;

			// ── [3]+[4] 방문자 교차검증 + shrinkage(상향 보정)
			const last3 = baseline.slice(-3);
			const prev3 = baseline.slice(-6, -3);
			const level = mean(last3);
			const slope = prev3.length ? (mean(last3) - mean(prev3)) / 3 : 0;
			const peak = Math.max(...baseline);
			const 지속상승 = last3.length === 3 && last3.every(v => v > 0);
			// 방문자 동반상승(최근3일 평균 > 직전3일 평균). 방문자 데이터 없으면 주 신호만으로.
			const 방문자동반상승 = !hasVisitors || mean(visitorsC.slice(-3)) > mean(visitorsC.slice(-6, -3));
			const SHRINK_K = 14;
			if (slope > 0 && 지속상승 && 방문자동반상승 && peak > rate) {
				const w = activeDays / (activeDays + SHRINK_K);
				rate = level + (peak - level) * w;
			}
			if (rate < 0) rate = 0;

			// ── [5] 주문 → 단위 환산 (주문 기반일 때만; 묶음구매 1일 왜곡은 median이 흡수)
			let velocity;
			if (hasOrders) {
				const upo = [];
				ordersC.forEach((o, i) => { if (o > 0) upo.push((unitsC[i] || 0) / o); });
				const medianUPO = upo.length ? (median(upo) || 1) : 1;
				velocity = rate * medianUPO;
			} else {
				velocity = rate; // [6] fallback: 주 신호가 이미 판매단위
			}
			if (velocity < 0) velocity = 0;

			return { velocity, activeDays, trend };
		},
		getMainProductMonthlySales(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item.월판매수량;
			}

			// 번들 제품들의 실제 판매수량 합계 계산 (번들 사이즈 적용)
			const bundleSales = item.upBundlingProducts.reduce((sum, bundle) => {
				const bundleActualSales = this.getBundleProductMonthlySales(bundle);
				return sum + bundleActualSales;
			}, 0);

			// 전체 월판매수량에서 번들 실제 판매수량을 뺀 메인 제품 판매수량
			return Math.max(0, item.월판매수량 - bundleSales);
		},
		// 메인 제품의 일판매수량 계산 (번들 제품 제외)
		getMainProductDailySales(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item.일판매수량;
			}

			// 번들 제품들의 일판매수량(블렌드 속도) 합계
			const bundleDailySales = item.upBundlingProducts.reduce((sum, bundle) => {
				return sum + (bundle.일판매수량 || 0);
			}, 0);

			// 전체 일판매수량에서 번들 실제 판매수량을 뺀 메인 제품 판매수량
			return Math.max(0, item.일판매수량 - bundleDailySales);
		},
		// 반품상품의 월판매수량 계산 (salesHistory 배열 합계)
		getReturnProductMonthlySales(returnProduct) {
			if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
				return 0;
			}
			// salesHistory 배열의 모든 값을 합계하여 월판매수량 계산
			return returnProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0);
		},
		// 번들상품의 월판매수량 계산 (salesHistory 우선, 없으면 unitsSoldForLast30Days 사용)
		getBundleProductMonthlySales(bundleProduct) {
			if (!bundleProduct) {
				return 0;
			}

			// salesHistory 배열이 있으면 우선 사용 (묶음크기 환산 → 실물 수량)
			if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
				const size = bundleProduct.upBundlingSize || 1;
				return bundleProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0) * size;
			}

			// salesHistory가 없으면 unitsSoldForLast30Days 사용 (이미 환산됨)
			return bundleProduct.unitsSoldForLast30Days || 0;
		},
		// 메인 제품의 7일판매수량 계산 (번들 제품 제외)
		getMainProduct7DaySales(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item['7일판매수량'];
			}

			// 번들 제품들의 실제 7일판매수량 합계 계산
			const bundle7DaySales = item.upBundlingProducts.reduce((sum, bundle) => {
				const bundleActual7DaySales = this.getBundleProduct7DaySales(bundle);
				return sum + bundleActual7DaySales;
			}, 0);

			// 전체 7일판매수량에서 번들 실제 판매수량을 뺀 메인 제품 판매수량
			return Math.max(0, item['7일판매수량'] - bundle7DaySales);
		},
		// 반품상품의 7일판매수량 계산 (salesHistory 배열의 최근 7일 합계)
		getReturnProduct7DaySales(returnProduct) {
			if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
				return 0;
			}
			// salesHistory 배열의 최근 7일 값을 합계하여 7일판매수량 계산
			const recent7Days = returnProduct.salesHistory.slice(-7);
			return recent7Days.reduce((sum, sales) => sum + (sales || 0), 0);
		},
		// 번들상품의 7일판매수량 계산 (salesHistory 우선, 없으면 unitsSoldForLast30Days/30*7 사용)
		getBundleProduct7DaySales(bundleProduct) {
			if (!bundleProduct) {
				return 0;
			}

			// salesHistory 배열이 있으면 우선 사용 (최근 7일, 묶음크기 환산 → 실물 수량)
			if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
				const size = bundleProduct.upBundlingSize || 1;
				const recent7Days = bundleProduct.salesHistory.slice(-7);
				return recent7Days.reduce((sum, sales) => sum + (sales || 0), 0) * size;
			}

			// salesHistory가 없으면 unitsSoldForLast30Days를 기준으로 7일치 추정
			const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
			return Math.round(monthlySales * 7 / 30);
		},
			getRecent7DaysHeaders() {
				const headers = [];
				const today = new Date();
				const baseDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
				for (let offset = 6; offset >= 0; offset--) {
					const d = new Date(baseDate);
					d.setDate(baseDate.getDate() - offset);
					const month = String(d.getMonth() + 1).padStart(2, '0');
					const day = String(d.getDate()).padStart(2, '0');
					const label = `${month}/${day}`;
					const value = `recentDay${offset}`;
					headers.push({
						text: label,
						value,
						align: 'center',
						width: 60,
						isSlot: true
					});
				}
				return headers;
			},
			getMainProductDailySalesAtOffset(item, daysAgo) {
				if (!item || !item.salesHistory || !Array.isArray(item.salesHistory) || item.salesHistory.length === 0) {
					return 0;
				}
				const index = item.salesHistory.length - 1 - daysAgo;
				if (index < 0) {
					return 0;
				}
				const total = item.salesHistory[index] || 0;

				if (!this.showBundleProducts || !item.upBundlingProducts || item.upBundlingProducts.length === 0) {
					return total;
				}

				const bundleDailySales = item.upBundlingProducts.reduce((sum, bundle) => {
					return sum + this.getBundleProductDailySales(bundle, daysAgo);
				}, 0);

				return Math.max(0, total - bundleDailySales);
			},
			getReturnProductDailySales(returnProduct, daysAgo) {
				if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory) || returnProduct.salesHistory.length === 0) {
					return 0;
				}
				const index = returnProduct.salesHistory.length - 1 - daysAgo;
				if (index < 0) {
					return 0;
				}
				return returnProduct.salesHistory[index] || 0;
			},
			getBundleProductDailySales(bundleProduct, daysAgo) {
				if (!bundleProduct) {
					return 0;
				}

				if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory) && bundleProduct.salesHistory.length > 0) {
					const size = bundleProduct.upBundlingSize || 1;
					const index = bundleProduct.salesHistory.length - 1 - daysAgo;
					if (index < 0) {
						return 0;
					}
					return (bundleProduct.salesHistory[index] || 0) * size;
				}

				const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
				return Math.round(monthlySales / 30);
			},

			// 메인 제품의 3일판매수량 계산 (번들 제품 고려)
			getMainProduct3DaySales(item) {
				if (!item || !item.salesHistory || !Array.isArray(item.salesHistory)) {
					return 0;
				}

				// salesHistory 배열의 최근 3일 합계
				const recent3Days = item.salesHistory.slice(-3);
				const total3Days = recent3Days.reduce((sum, sales) => sum + (sales || 0), 0);

				// 번들 보기 OFF이거나 번들 상품이 없으면 전체 3일 판매수량 반환
				if (!this.showBundleProducts || !item.upBundlingProducts || item.upBundlingProducts.length === 0) {
					return total3Days;
				}

				// 번들 상품들의 3일판매수량 합계
				const bundle3DaySales = item.upBundlingProducts.reduce((sum, bundle) => {
					return sum + this.getBundleProduct3DaySales(bundle);
				}, 0);

				return Math.max(0, total3Days - bundle3DaySales);
			},
			// 반품상품의 3일판매수량 계산 (salesHistory 배열의 최근 3일 합계)
			getReturnProduct3DaySales(returnProduct) {
				if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
					return 0;
				}
				const recent3Days = returnProduct.salesHistory.slice(-3);
				return recent3Days.reduce((sum, sales) => sum + (sales || 0), 0);
			},
			// 번들상품의 3일판매수량 계산 (salesHistory 우선, 없으면 unitsSoldForLast30Days/30*3 사용)
			getBundleProduct3DaySales(bundleProduct) {
				if (!bundleProduct) {
					return 0;
				}

				if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
					const recent3Days = bundleProduct.salesHistory.slice(-3);
					return recent3Days.reduce((sum, sales) => sum + (sales || 0), 0);
				}

				const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
				return Math.round(monthlySales * 3 / 30);
			},
			// 메인 제품의 어제 판매수량 계산 (번들 제품 고려)
			getMainProductYesterdaySales(item) {
				if (!item || !item.salesHistory || !Array.isArray(item.salesHistory) || item.salesHistory.length === 0) {
					return 0;
				}

				const totalYesterday = item.salesHistory[item.salesHistory.length - 1] || 0;

				if (!this.showBundleProducts || !item.upBundlingProducts || item.upBundlingProducts.length === 0) {
					return totalYesterday;
				}

				const bundleYesterdaySales = item.upBundlingProducts.reduce((sum, bundle) => {
					return sum + this.getBundleProductYesterdaySales(bundle);
				}, 0);

				return Math.max(0, totalYesterday - bundleYesterdaySales);
			},
			// 반품상품의 어제 판매수량 계산
			getReturnProductYesterdaySales(returnProduct) {
				if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory) || returnProduct.salesHistory.length === 0) {
					return 0;
				}
				return returnProduct.salesHistory[returnProduct.salesHistory.length - 1] || 0;
			},
			// 번들상품의 어제 판매수량 계산
			getBundleProductYesterdaySales(bundleProduct) {
				if (!bundleProduct) {
					return 0;
				}

				if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
					if (!bundleProduct.salesHistory.length) {
						return 0;
					}
					return bundleProduct.salesHistory[bundleProduct.salesHistory.length - 1] || 0;
				}

				const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
				return Math.round(monthlySales / 30);
			},

		// 판매변화율 계산 (번들 상품 고려)
		getSalesChangeRate(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item.판매변화;
			}

			// 메인 제품의 7일 및 30일 평균 계산
			const main7DaySales = this.getMainProduct7DaySales(item);
			const main30DaySales = this.getMainProductMonthlySales(item);
			const main7DayAvg = main7DaySales / 7;
			const main30DayAvg = main30DaySales / 30;

			if (main30DayAvg > 0) {
				return ((main7DayAvg - main30DayAvg) / main30DayAvg) * 100;
			}
			return 0;
		},
		// 판매변화 스타일 계산 (색상과 화살표)
		getSalesChangeStyle(changeRate) {
			if (changeRate > 0) {
				return {
					color: '#28a745', // 초록색
					icon: '↗'
				};
			} else if (changeRate < 0) {
				return {
					color: '#dc3545', // 빨간색
					icon: '↘'
				};
			} else {
				return {
					color: '#6c757d', // 회색
					icon: '→'
				};
			}
		},
		// 반품상품의 판매변화율 계산
		getReturnProductChangeRate(returnProduct) {
			if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
				return 0;
			}

			const recent7Days = returnProduct.salesHistory.slice(-7);
			const avg7Days = recent7Days.reduce((sum, sales) => sum + (sales || 0), 0) / 7;
			const avg30Days = returnProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0) / 30;

			if (avg30Days > 0) {
				return ((avg7Days - avg30Days) / avg30Days) * 100;
			}
			return 0;
		},
		// 번들상품의 판매변화율 계산
		getBundleProductChangeRate(bundleProduct) {
			if (!bundleProduct) {
				return 0;
			}

			// salesHistory 배열이 있으면 사용
			if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
				const recent7Days = bundleProduct.salesHistory.slice(-7);
				const avg7Days = recent7Days.reduce((sum, sales) => sum + (sales || 0), 0) / 7;
				const avg30Days = bundleProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0) / 30;

				if (avg30Days > 0) {
					return ((avg7Days - avg30Days) / avg30Days) * 100;
				}
			}

			// salesHistory가 없으면 변화율 계산 불가
			return 0;
		}
	}
}
</script>

<style scoped>
/* 구매요청 추가 애니메이션 */
@keyframes addToCart {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.2);
		opacity: 0.8;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

@keyframes fadeInSuccess {
	0% {
		opacity: 0;
		transform: translateY(-10px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.cart-animation {
	animation: addToCart 0.6s ease-in-out;
}

.success-message {
	animation: fadeInSuccess 0.5s ease-out;
}

/* 구매요청 버튼 호버 효과 */
.btn-primary:hover {
	transform: translateY(-1px);
	box-shadow: 0 4px 8px rgba(0,123,255,0.3);
	transition: all 0.2s ease;
}

/* 구매요청이 있는 항목 스타일 */
.purchase-requested {
	background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
	border: 2px solid #2196f3 !important;
	box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3) !important;
	position: relative;
}

.purchase-requested::before {
	content: "🛒";
	position: absolute;
	top: -5px;
	right: -5px;
	font-size: 12px;
	background: #2196f3;
	color: white;
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.purchase-requested:hover {
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4) !important;
	transition: all 0.2s ease;
}

/* 장바구니 담기 애니메이션 */
@keyframes flyToCart {
	0% {
		transform: scale(1) translate(0, 0);
		opacity: 1;
	}
	50% {
		transform: scale(0.8) translate(50px, -20px);
		opacity: 0.8;
	}
	100% {
		transform: scale(0.3) translate(200px, -100px);
		opacity: 0;
	}
}

.fly-to-cart {
	animation: flyToCart 1s ease-out forwards;
	z-index: 9999;
	pointer-events: none;
}

/* 뱃지 펄스 애니메이션 */
@keyframes badgePulse {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.3);
	}
	100% {
		transform: scale(1);
	}
}

.badge-pulse {
	animation: badgePulse 0.6s ease-in-out;
}

/* 구매요청 버튼 뱃지 스타일 */
#purchaseRequestBtn .badge {
	min-width: 18px;
	height: 18px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

/* 하이라이트 행 애니메이션 (무한 반복) - success 색상 */
@keyframes pulse-success {
	0% {
		box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
	}
}

::v-deep .highlighted-row {
	animation: pulse-success 2s infinite !important;
	background-color: rgba(40, 167, 69, 0.15) !important;
}

::v-deep .highlighted-row td {
	background-color: inherit !important;
}

::v-deep .highlighted-row:hover {
	background-color: rgba(40, 167, 69, 0.25) !important;
}

/* v-data-table 행에 직접 적용 */
::v-deep tbody tr.highlighted-row {
	animation: pulse-success 2s infinite !important;
	background-color: rgba(40, 167, 69, 0.15) !important;
}

/* 쿠패스 구매요청 상세보기 아이콘 */
.coupass-detail-icon {
	position: absolute;
	top: 1px;
	right: 1px;
	font-size: 10px;
	cursor: pointer;
	opacity: 0.4;
	transition: opacity 0.2s;
	z-index: 1;
}
.coupass-detail-icon:hover {
	opacity: 1;
	transform: scale(1.2);
}

</style>

<style lang="scss" scoped>
// 재고 대사 — 요약 칸 · 미확인 열 · 펼친 상세
.recon-tile {
	cursor: default;
	&[role="button"] { cursor: pointer; }
	&__value { font-variant-numeric: tabular-nums; }
	&__note { font-size: 11.5px; color: #7f8c9a; margin-top: 2px; }
	&__info { cursor: help; color: #9aa5b1; margin-left: 2px; }
	&__value--muted { color: #7f8c9a !important; font-size: 1.15rem; }
	&__name { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	&--crit { border-left: 4px solid #d9534f; .recon-tile__value { color: #c0392b; } }
	&--warn { border-left: 4px solid #e67e22; .recon-tile__value { color: #b45309; } }
}
.recon-pill {
	display: inline-block;
	min-width: 34px;
	padding: 1px 8px;
	border: 0;
	border-radius: 999px;
	font-size: 12.5px;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	cursor: pointer;
	&--crit { background: #fbe8df; color: #c0392b; }
	&--warn { background: #fdf1e3; color: #b45309; }
}
.recon-age {
	font-size: 11px;
	color: #7f8c9a;
	&--over { color: #c0392b; font-weight: 600; }
}
.recon-detail {
	margin-bottom: 12px;
	&__strip {
		display: flex;
		height: 12px;
		border-radius: 3px;
		overflow: hidden;
		margin: 4px 0;
	}
	&__strip-sold { background: #9aa6b4; }
	&__strip-left { background: #2196c4; }
	&__svg { max-width: 680px; }
	&__note { color: #b45309; margin-top: 4px; }
}
.recon-bar {
	&--sub { fill: #5a6b7b; }
	&--up { fill: #2f9e4f; }
	&--down { fill: #9aa6b4; }
	&--tot { fill: #2196c4; }
	&--miss { fill: #d9534f; fill-opacity: 0.35; stroke: #d9534f; stroke-width: 1.5; stroke-dasharray: 4 3; }
}
.recon-text { fill: #2c3e50; }
.recon-text--sub { fill: #7f8c9a; }
.recon-text--miss { fill: #c0392b; font-weight: 600; }
.recon-summary {
	margin: 0 0 6px;
	padding-left: 18px;
	font-size: 13px;
}
.recon-timeline {
	list-style: none;
	margin: 0;
	padding: 0;
	font-size: 13px;
	li { display: grid; grid-template-columns: 52px 1fr; gap: 8px; padding: 3px 0; }
	&__date { color: #7f8c9a; font-variant-numeric: tabular-nums; }
	&__hl { color: #c0392b; font-weight: 600; }
	&--full { max-height: 240px; overflow-y: auto; }
}
</style>
